// ── Facturación — Inicialización por Rol ─────────────────────────────────────
async function initFacturacionView() {
    const _facRol = (CURRENT_USER?.rol || '').toLowerCase().replace(/ /g, '_').trim();
    const isMaster = ['master', 'contabilidad'].includes(_facRol === 'administrador' ? 'admin' : _facRol);

    // Inicializar filtros con mes y año actual
    const mesEl = document.getElementById('facFilterMes');
    const anioEl = document.getElementById('facFilterAnio');
    if (mesEl) mesEl.value = String(new Date().getMonth() + 1);
    if (anioEl) anioEl.value = String(new Date().getFullYear());

    // ── Migración silenciosa: asegurar columnas cfdi_id y cfdi_uuid ──
    try {
        await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
            sql: `ALTER TABLE facturas_solicitadas
                  ADD COLUMN IF NOT EXISTS cfdi_id   TEXT,
                  ADD COLUMN IF NOT EXISTS cfdi_uuid TEXT,
                  ADD COLUMN IF NOT EXISTS moneda TEXT DEFAULT 'MXN',
                  ADD COLUMN IF NOT EXISTS tipo_cambio NUMERIC(12,4)`
        });
    } catch(_) { /* columnas ya existen o sin permisos DDL → ignorar */ }


    // 1. Buscador de líder: solo admin/master
    const buscarWrapper = document.getElementById('fac-buscar-wrapper');
    if (buscarWrapper) buscarWrapper.style.display = isMaster ? 'block' : 'none';

    // 2. Botón "Marcar Facturada (Externa)": solo admin/master
    const btnExterna = document.getElementById('btnMarcarExterna');
    if (btnExterna) btnExterna.style.display = isMaster ? 'inline-flex' : 'none';

    // 3. Borrador de Factura Global: solo admin/master
    const panelGlobal = document.getElementById('panelFacturaGlobal');
    if (panelGlobal) panelGlobal.style.display = isMaster ? 'block' : 'none';

    // 3b. Botón Exportar CSV Global: solo contabilidad y master
    _actualizarVisibilidadBotonCsvGlobal();

    // 4. Cargar notas según rol
    if (isMaster) {
        // Admin/Master: carga todas las notas del mes (sin filtro)
        _facClienteIdFilter = null;
        await cargarNotasSinFacturar(null);
    } else {
        // Líder: buscar su cliente.id (UUID) via su número de registro
        // porque venta.cliente_id → cliente.id, NO usuarios.id
        try {
            const regNum = CURRENT_USER?.registro || 0;
            const res = await BO_API.post('/bo/sql-relay', {
                secret: 'duletia_relay_2026',
                sql: `SELECT id FROM cliente WHERE registro = ${regNum} LIMIT 1`
            });
            const clienteUUID = res.rows?.[0]?.id || null;
            _facClienteIdFilter = clienteUUID;
            await cargarNotasSinFacturar(clienteUUID);
        } catch(e) {
            console.error('initFacturacionView: error buscando cliente UUID', e);
            _facClienteIdFilter = null;
            await cargarNotasSinFacturar(null);
        }
    }

    // 5. Cargar historial (ya filtra internamente por rol)
    loadHistorialFacturas();

    // 6. Cargar borrador global solo si es admin/master
    if (isMaster && typeof loadFacturaGlobal === 'function') loadFacturaGlobal();
}

// ── Facturación — Notas sin Facturar (dropdown dinámico) ─────────────────────
let _notasSinFacturar = []; // cache local
let _facClienteIdFilter = null; // UUID del cliente (buyer) para filtrar
let _facRegistroFilter  = null; // Número de registro del líder para filtrar

async function cargarNotasSinFacturar(clienteId) {
    const sel = document.getElementById('fac-nota');
    if (!sel) return;
    sel.innerHTML = '<option value="">⏳ Cargando notas…</option>';

    try {
        const now = new Date();
        const mesActual = `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}-01`;

        // Prioridad: filtro por registro del líder > filtro por cliente UUID
        let filtroCliente = '';
        if (_facRegistroFilter) {
            filtroCliente = ` AND v.registro_id::text = '${_facRegistroFilter}'`;
        } else if (clienteId) {
            filtroCliente = ` AND v.cliente_id::text = '${clienteId}'`;
        }

        const sql = `
            SELECT v.id, v.fecha_venta, v.total, v.registro_id, v.cliente_id,
                   v.cedis_id,
                   CASE
                     WHEN v.moneda IS NOT NULL AND v.moneda <> '' THEN v.moneda
                     WHEN v.cedis_id::text = '4'              THEN 'USD'
                     WHEN EXISTS (
                       SELECT 1 FROM pais p
                       WHERE p.id = c.pais_id
                       AND p.codigo IN ('USA','SLV')
                     )                                        THEN 'USD'
                     WHEN EXISTS (
                       SELECT 1 FROM pais p
                       WHERE p.id = c.pais_id
                       AND p.codigo IN ('GTM','GUA')
                     )                                        THEN 'GTQ'
                     WHEN EXISTS (
                       SELECT 1 FROM pais p
                       WHERE p.id = c.pais_id
                       AND p.codigo = 'CAN'
                     )                                        THEN 'CAD'
                     ELSE 'MXN'
                   END AS moneda,
                   COALESCE(v.monto_facturable, v.total) AS monto_facturable,
                   COALESCE(c.nombre || ' ' || COALESCE(c.ape_p,''), 'Público General') AS cliente_nombre,
                   v.comentario, v.piezas
            FROM venta v
            LEFT JOIN cliente c ON c.id::text = v.cliente_id::text
            WHERE v.approved = 1
              AND (v.requiere_factura = false OR v.requiere_factura IS NULL)
              AND (v.factura_emitida = false OR v.factura_emitida IS NULL)
              AND v.id::text NOT IN (
                  SELECT jsonb_array_elements_text(ventas_ids::jsonb)
                  FROM facturas_solicitadas
                  WHERE estado IN ('solicitada','en_proceso')
                    AND ventas_ids IS NOT NULL AND ventas_ids <> '[]' AND ventas_ids <> 'null'
              )
              AND v.id::text NOT IN (
                  SELECT numero_nota::text FROM facturas_solicitadas
                  WHERE estado IN ('solicitada','en_proceso')
                    AND numero_nota IS NOT NULL
              )
              AND v.id::text NOT IN (
                  SELECT jsonb_array_elements_text(ventas_ids::jsonb)
                  FROM facturas_solicitadas
                  WHERE estado = 'facturada'
                    AND ventas_ids IS NOT NULL AND ventas_ids <> '[]' AND ventas_ids <> 'null'
              )
              AND v.fecha_venta >= '${mesActual}'
              ${filtroCliente}
            ORDER BY v.fecha_venta DESC
            LIMIT 200
        `;
        const res = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql });
        _notasSinFacturar = res.rows || [];

        if (!_notasSinFacturar.length) {
            sel.innerHTML = '<option value="">✅ Sin notas pendientes de facturar</option>';
            return;
        }

        let html = '<option value="">— Selecciona una nota (' + _notasSinFacturar.length + ' pendientes) —</option>';
        _notasSinFacturar.forEach(n => {
            const fecha = new Date(n.fecha_venta).toLocaleDateString('es-MX');
            const total = Number(n.total||0).toLocaleString('es-MX', {minimumFractionDigits:2});
            const _vTmp = { comentarioRaw: n.comentario || '', totalNum: Number(n.total || 0) };
            const _cred = _calcularCreditoVenta(_vTmp);
            const creditTag = _cred > 0 ? ' ⚠️ CRÉDITO $' + _cred.toLocaleString('es-MX',{minimumFractionDigits:0}) : '';
            html += `<option value="${n.id}">#${n.id.substring(0,8)}… — ${fecha} — ${n.cliente_nombre} — $${total}${creditTag}</option>`;
        });
        sel.innerHTML = html;

        // Auto-seleccionar si solo hay 1 nota pendiente
        if (_notasSinFacturar.length === 1) {
            sel.value = _notasSinFacturar[0].id;
            sel.dispatchEvent(new Event('change'));
        }
    } catch(e) {
        sel.innerHTML = '<option value="">❌ Error cargando notas</option>';
        console.error('cargarNotasSinFacturar:', e);
    }
}



// ── Autocomplete: debounce + búsqueda mientras escribe ───────────────────────
let _facLiderDebounce = null;
function _facLiderAutocomplete(val) {
    clearTimeout(_facLiderDebounce);
    const dd = document.getElementById('fac-lider-dropdown');
    if (!val || val.trim().length < 2) {
        if (dd) dd.style.display = 'none';
        // Limpiar filtro si borra el campo
        if (!val) {
            _facClienteIdFilter = null; _facRegistroFilter = null;
            _aplicarRFCGenerico();
            cargarNotasSinFacturar(null);
            const infoEl = document.getElementById('fac-lider-info');
            if (infoEl) infoEl.style.display = 'none';
        }
        return;
    }
    _facLiderDebounce = setTimeout(() => _facLiderBuscarYMostrar(val.trim()), 280);
}

async function _facLiderBuscarYMostrar(q) {
    const dd = document.getElementById('fac-lider-dropdown');
    const spin = document.getElementById('fac-lider-spinner');
    if (!dd) return;
    if (spin) spin.style.display = 'inline';
    try {
        const safeQ = q.replace(/'/g, "''");
        // Buscar simultáneamente en usuarios y cliente (y por ID de nota en venta)
        const [resU, resC, resV] = await Promise.all([
            BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                sql: `SELECT 'usuario' AS tipo, id, registro, nombre, COALESCE(apellido,'') AS ape_p, COALESCE(rfc,'') AS rfc FROM usuarios WHERE registro::text = '${safeQ}' OR LOWER(nombre || ' ' || COALESCE(apellido,'')) LIKE LOWER('%${safeQ}%') LIMIT 6` }),
            BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                sql: `SELECT 'cliente' AS tipo, id, registro, nombre, COALESCE(ape_p,'') AS ape_p, COALESCE(rfc,'') AS rfc FROM cliente WHERE registro::text = '${safeQ}' OR LOWER(nombre || ' ' || COALESCE(ape_p,'')) LIKE LOWER('%${safeQ}%') LIMIT 6` }),
            BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                sql: `SELECT 'cliente' AS tipo, c.id, c.registro, c.nombre, COALESCE(c.ape_p,'') AS ape_p, COALESCE(c.rfc,'') AS rfc, v.id AS nota_match FROM venta v JOIN cliente c ON c.id::text = v.cliente_id::text WHERE v.id::text ILIKE '%${safeQ}%' LIMIT 3` })
        ]);
        const cRows = resC.rows || [];
        const vRows = (resV.rows || []).filter(vRow => !cRows.some(c => c.id === vRow.id));
        const rows = [...(resU.rows||[]), ...cRows, ...vRows].slice(0, 8);
        if (!rows.length) {
            dd.innerHTML = '<div style="padding:.6rem 1rem;color:var(--text-dim);font-size:.8rem;">Sin resultados para "' + q + '"</div>';
            dd.style.display = 'block';
            return;
        }
        dd.innerHTML = rows.map(r => {
            const nombre = (r.nombre + ' ' + r.ape_p).trim();
            const rfcTag = r.rfc && r.rfc.length >= 12
                ? `<span style="color:var(--success);font-size:.68rem;margin-left:6px;">${r.rfc}</span>`
                : `<span style="color:var(--accent-gold);font-size:.68rem;margin-left:6px;">Sin RFC</span>`;
            const tipoTag = r.tipo === 'usuario'
                ? '<span style="font-size:.65rem;background:rgba(99,102,241,.2);color:#a5b4fc;padding:1px 5px;border-radius:4px;">Líder</span>'
                : '<span style="font-size:.65rem;background:rgba(16,185,129,.15);color:#6ee7b7;padding:1px 5px;border-radius:4px;">Cliente</span>';
            const notaTag = r.nota_match ? `<span style="font-size:.65rem;color:var(--accent-gold);margin-left:6px;">(Nota: #${String(r.nota_match).substring(0,8)})</span>` : '';
            const rJson = JSON.stringify(r).replace(/"/g, '&quot;');
            return `<div class="fac-lider-opt" onclick="_facLiderSeleccionar(${rJson})"
                style="padding:.55rem 1rem;cursor:pointer;display:flex;align-items:center;gap:.6rem;border-bottom:1px solid rgba(255,255,255,.04);transition:background .12s;"
                onmouseover="this.style.background='rgba(255,255,255,.06)'" onmouseout="this.style.background=''">
                <div style="flex:1;min-width:0;">
                    <div style="font-weight:600;font-size:.85rem;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">${nombre} ${rfcTag}</div>
                    <div style="font-size:.7rem;color:var(--text-dim);">Reg. #${r.registro} &nbsp;${tipoTag} ${notaTag}</div>
                </div>
            </div>`;
        }).join('');
        dd.style.display = 'block';
    } catch(e) {
        dd.innerHTML = '<div style="padding:.6rem 1rem;color:var(--danger);font-size:.8rem;">Error: ' + e.message + '</div>';
        dd.style.display = 'block';
    } finally {
        if (spin) spin.style.display = 'none';
    }
}

async function _facLiderSeleccionar(r) {
    // Cerrar dropdown
    const dd = document.getElementById('fac-lider-dropdown');
    if (dd) dd.style.display = 'none';
    const searchInput = document.getElementById('fac-lider-search');
    const nombre = (r.nombre + ' ' + r.ape_p).trim();
    if (searchInput) searchInput.value = nombre + '  #' + r.registro;
    // Llamar buscar con el registro exacto
    await buscarLiderFacturacion(String(r.registro));
}

// Cerrar dropdown al hacer click fuera
document.addEventListener('click', function(e) {
    const wrap = document.getElementById('fac-buscar-wrapper');
    if (wrap && !wrap.contains(e.target)) {
        const dd = document.getElementById('fac-lider-dropdown');
        if (dd) dd.style.display = 'none';
    }
});

// ── buscarLiderFacturacion — ahora acepta registro directo o lee el campo ─────
async function buscarLiderFacturacion(registroOverride) {
    const infoEl = document.getElementById('fac-lider-info');
    // Si hay override (llamado programático), usar registro directo
    const searchVal = registroOverride
        ? String(registroOverride)
        : (document.getElementById('fac-lider-search')?.value?.trim() || '');

    if (!searchVal) {
        _facClienteIdFilter = null;
        _facRegistroFilter  = null;
        _aplicarRFCGenerico();
        if (infoEl) { infoEl.style.display = 'block'; infoEl.innerHTML = '📋 Mostrando <b>todas</b> las notas del mes'; infoEl.style.color = 'var(--text-dim)'; }
        await cargarNotasSinFacturar(null);
        return;
    }

    try {
        const safeQ = searchVal.replace(/'/g, "''");
        // ── Buscar PRIMERO en usuarios (líderes/vendedores) por registro o nombre ──
        const sqlU = `SELECT id, registro, nombre, apellido AS ape_p, rfc FROM usuarios WHERE registro::text = '${safeQ}' OR LOWER(nombre || ' ' || COALESCE(apellido,'')) LIKE LOWER('%${safeQ}%') LIMIT 5`;
        const resU = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlU });
        const rowsU = resU.rows || [];

        if (rowsU.length) {
            const lider = rowsU[0];
            _facRegistroFilter  = String(lider.registro);
            _facClienteIdFilter = null;
            const rfcLider = (lider.rfc || '').trim().toUpperCase();
            if (rfcLider && rfcLider.length >= 12) {
                _setFieldVal('fac-rfc', rfcLider);
                _setFieldVal('fac-razon', (lider.nombre + ' ' + (lider.ape_p||'')).trim());
                _setFieldVal('fac-cp', lider.cp || '45050');
                validarRFC(rfcLider);
                if (infoEl) { infoEl.style.display = 'block'; infoEl.innerHTML = `✅ Líder: <b>${lider.nombre} ${lider.ape_p||''}</b> (Reg. #${lider.registro}) — RFC: <b style="color:var(--success)">${rfcLider}</b>`; infoEl.style.color = 'var(--success)'; }
            } else {
                _aplicarRFCGenerico();
                if (infoEl) { infoEl.style.display = 'block'; infoEl.innerHTML = `✅ Líder: <b>${lider.nombre} ${lider.ape_p||''}</b> (Reg. #${lider.registro}) — <span style="color:var(--accent-gold)">Sin RFC → usando genérico</span>`; infoEl.style.color = 'var(--success)'; }
            }
            await cargarNotasSinFacturar(null);
            return;
        }

        // ── Si no está en usuarios, buscar en cliente (compradores) ──
        const sqlC = `SELECT id, registro, nombre, ape_p, rfc FROM cliente WHERE registro::text = '${safeQ}' OR LOWER(nombre || ' ' || COALESCE(ape_p,'')) LIKE LOWER('%${safeQ}%') LIMIT 5`;
        const resC = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlC });
        const rowsC = resC.rows || [];

        if (rowsC.length) {
            const cli = rowsC[0];
            _facClienteIdFilter = cli.id;
            _facRegistroFilter  = null;
            const rfcCli = (cli.rfc || '').trim().toUpperCase();
            if (rfcCli && rfcCli.length >= 12) {
                _setFieldVal('fac-rfc', rfcCli);
                _setFieldVal('fac-razon', (cli.nombre + ' ' + (cli.ape_p||'')).trim());
                validarRFC(rfcCli);
                if (infoEl) { infoEl.style.display = 'block'; infoEl.innerHTML = `✅ Cliente: <b>${cli.nombre} ${cli.ape_p||''}</b> — RFC: <b style="color:var(--success)">${rfcCli}</b>`; infoEl.style.color = 'var(--success)'; }
            } else {
                _aplicarRFCGenerico();
                if (infoEl) { infoEl.style.display = 'block'; infoEl.innerHTML = `✅ Cliente: <b>${cli.nombre} ${cli.ape_p||''}</b> — <span style="color:var(--accent-gold)">Sin RFC → genérico</span>`; infoEl.style.color = 'var(--success)'; }
            }
            await cargarNotasSinFacturar(cli.id);
            return;
        }

        // ── No encontrado ──
        _facClienteIdFilter = null; _facRegistroFilter = null;
        if (infoEl) { infoEl.style.display = 'block'; infoEl.innerHTML = `❌ No encontrado: "${searchVal}"<br><small style="color:var(--text-dim)">Intenta con nombre completo o # de registro</small>`; infoEl.style.color = 'var(--danger)'; }
    } catch(e) {
        if (infoEl) { infoEl.style.display = 'block'; infoEl.innerHTML = '❌ Error: ' + e.message; infoEl.style.color = 'var(--danger)'; }
        console.error('buscarLiderFacturacion:', e);
    }
}

// ── Helpers RFC ───────────────────────────────────────────────────────────────
function _setFieldVal(id, val) {
    const el = document.getElementById(id);
    if (el) el.value = val;
}

function _aplicarRFCGenerico() {
    _setFieldVal('fac-rfc', 'XAXX010101000');
    _setFieldVal('fac-razon', 'PUBLICO EN GENERAL');
    _setFieldVal('fac-cp', '45050');
    const selReg = document.getElementById('fac-regimen');
    if (selReg) selReg.value = '616';
    const selCfdi = document.getElementById('fac-cfdi');
    if (selCfdi) selCfdi.value = 'S01';
    const fb = document.getElementById('rfcFeedback');
    if (fb) { fb.style.display = 'block'; fb.textContent = '✅ RFC genérico (Público en General)'; fb.style.color = 'var(--accent-gold)'; }
}

function onNotaSeleccionada() {
    const sel = document.getElementById('fac-nota');
    const infoEl = document.getElementById('fac-nota-info');
    const notaId = sel?.value;
    if (!notaId || !infoEl) { if (infoEl) infoEl.style.display = 'none'; return; }

    const nota = _notasSinFacturar.find(n => String(n.id) === String(notaId));
    if (!nota) return;

    const total = Number(nota.total||0).toLocaleString('es-MX', {minimumFractionDigits:2});
    infoEl.style.display = 'block';
    infoEl.innerHTML = `📎 Total: <b style="color:var(--success)">$${total}</b> — Cliente: ${nota.cliente_nombre || 'Público General'}`;

    // ── Auto-seleccionar Forma de Pago usando lógica de porcentajes (excluyendo activos) ──
    const selFP = document.getElementById('fac-forma-pago');
    if (selFP) {
        if (typeof _detectFormaPagoMayoria === 'function') {
            const fp = _detectFormaPagoMayoria([nota]);
            if (fp && fp.code) {
                selFP.value = fp.code;
            }
        } else {
            // Fallback en caso de que la función no esté disponible
            selFP.value = '01';
        }
    }
}

async function marcarFacturadaExterna() {
    const notaId = document.getElementById('fac-nota')?.value;
    if (!notaId) { BO_AUTH.showAlert('Selecciona primero una nota de venta del dropdown', 'warning'); return; }

    const nota = _notasSinFacturar.find(n => String(n.id) === String(notaId));
    const label = nota ? `Nota #${nota.id} — $${Number(nota.total||0).toLocaleString('es-MX',{minimumFractionDigits:2})}` : `Nota #${notaId}`;

    if (!confirm(`¿Confirmas marcar ${label} como FACTURADA EXTERNAMENTE?\n\nEsto indica que la factura se emitió por fuera de Facturama.`)) return;

    try {
        const sql = `UPDATE venta SET factura_emitida = true, factura_uuid = 'EXT-${new Date().toISOString().substring(0,10)}' WHERE id = '${notaId}'`;
        await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql });
        BO_AUTH.showAlert(`✅ Nota #${notaId} marcada como facturada (externa). Ya no aparecerá en el borrador global.`, 'success');
        
        // Recargar dropdown y borrador
        await cargarNotasSinFacturar(_facClienteIdFilter);
        if (typeof loadFacturaGlobal === 'function') loadFacturaGlobal();
    } catch(e) {
        BO_AUTH.showAlert('Error marcando factura: ' + e.message, 'error');
    }
}

// ── Facturación — Helper: obtener CP de expedición desde CEDIS de la nota ──
async function _getExpeditionPlace(notaId) {
    try {
        // Primero obtener cedis_id de la venta
        const rv = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
            sql: `SELECT cedis_id FROM venta WHERE id = '${notaId}' LIMIT 1`
        });
        const cedisId = rv.rows?.[0]?.cedis_id;
        // Solo intentar consulta si cedis_id es numérico y > 0
        if (cedisId && !isNaN(Number(cedisId)) && Number(cedisId) > 0) {
            const rc = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                sql: `SELECT cp FROM cedis WHERE id = ${Number(cedisId)} LIMIT 1`
            });
            const cp = rc.rows?.[0]?.cp;
            if (cp) return cp;
        }
    } catch(_) {}
    return '45050'; // Fallback: Guadalajara/Matriz
}

// ── Facturación — Helper: detectar PUE o PPD del comentario ──
function _detectPaymentMethod(comentario) {
    if (!comentario) return { method: 'PUE', form: null };
    const parts = comentario.split('||').map(s => s.trim()).filter(Boolean);
    // Detectar si hay ACTIVOS (propios o terceros)
    const hasActivos = parts.some(p => /(?:^|[^A-Z_])ACTIVOS/i.test(p));
    // Pagos bancarios reales (excluir ACTIVOS, ACTIVOS_TERCEROS, ENVIO_EXTRA, CREDITO y texto libre sin $)
    const pagosBancarios = parts.filter(p => /(?:\$|Q|C\$)[0-9.,]+/.test(p) && !/^ACTIVOS/i.test(p) && !/^ENVIO_EXTRA/i.test(p) && !/^CREDITO/i.test(p));
    // 100% activos (sin pagos bancarios reales) → PPD
    if (hasActivos && pagosBancarios.length === 0) return { method: 'PPD', form: '99' };
    // Mixto (activos + banco) o solo banco → PUE
    return { method: 'PUE', form: null };
}

// ── Facturación — Helper: Parsear errores de Facturama/N8N a mensajes legibles ──
function _parseFacturamaError(respObj) {
    try {
        // El motor n8n ahora devuelve el error anidado como:
        // { error: 'mensaje', facturamaError: { Message: '...', ModelState: {...} } }
        // o bien el objeto bruto de Facturama directamente.
        const fe = respObj?.facturamaError || respObj;
        const modelState = fe?.ModelState || respObj?.ModelState || null;
        const mainMsg = fe?.Message || respObj?.Message || null;

        if (modelState && typeof modelState === 'object') {
            const errores = Object.values(modelState).flat();
            const legibles = errores.map(e => {
                if (/total.*incorrecto/i.test(e))  return '• Error de cálculo en un producto';
                if (/base.*rate.*total/i.test(e))  return '• Impuesto mal calculado en un producto';
                if (/rfc/i.test(e))                return '• RFC inválido o no registrado: ' + e;
                if (/zip|postal/i.test(e))          return '• Código postal incorrecto';
                if (/nombre|name|razón/i.test(e))  return '• Razón social inválida';
                if (/régimen|regimen/i.test(e))     return '• Régimen Fiscal inválido: ' + e;
                if (/uso.*cfdi|usocfdi/i.test(e))  return '• Uso de CFDI inválido: ' + e;
                return '• ' + e;
            });
            let msg = '⚠️ Facturama rechazó la factura:\n' + legibles.join('\n');
            if (mainMsg && !legibles.some(l => l.includes(mainMsg.substring(0, 20)))) {
                msg += '\n• ' + mainMsg;
            }
            return msg + '\n\nSolicitud revertida a pendiente.';
        }

        // Error genérico (string o objeto plano de n8n)
        const errMsg = respObj?.error || respObj?.errorMessage || mainMsg || respObj?.message || '';
        if (/bad request/i.test(errMsg)) return '⚠️ Parámetros inválidos. Verifica RFC, CP y datos fiscales.\nSolicitud revertida a pendiente.';
        if (/timeout/i.test(errMsg))    return '⚠️ Tiempo de espera agotado al conectar con el SAT.\nIntenta de nuevo.';
        if (errMsg) return '⚠️ Error al timbrar: ' + errMsg.substring(0, 200) + '\nSolicitud revertida a pendiente.';
        return '⚠️ Error desconocido al timbrar.\nSolicitud revertida a pendiente.';
    } catch(_) {
        return '⚠️ Error al procesar la factura.\nSolicitud revertida a pendiente.';
    }
}

// ── Facturación — Helper: Redondeo CFDI 4.0 compatible ──
// Usa Math.round (siempre redondea 0.5 ARRIBA) para consistencia con SAT/Facturama
function _cfdiRound(value, decimals = 2) {
    if (typeof value !== 'number' || !isFinite(value)) return 0;
    const factor = Math.pow(10, decimals);
    return Math.round(value * factor) / factor;
}

// ── Facturación — Helper: Truncamiento CFDI (sin redondeo) ──
// Facturama (.NET) usa truncamiento para Subtotal y Taxes.Total.
// Ejemplo: 1234.567 truncado a 2 decimales → 1234.56 (NO 1234.57)
function _cfdiTrunc(value, decimals = 2) {
    if (typeof value !== 'number' || !isFinite(value)) return 0;
    const factor = Math.pow(10, decimals);
    return Math.trunc(value * factor) / factor;
}

// ── Facturación — Helper: construir Items[] de Facturama con nombres reales ──
async function _buildFacturamaItems(notaId, montoBase) {
    let items = [];
    let isActivo = false;
    let montoActivos = 0; // monto pagado con activos (parseado del comentario)

    // ── CENTRO-* prefix: consolidar piezas de TODAS las ventas vinculadas ──
    const _isCentroNote = String(notaId).startsWith('CENTRO-');
    if (_isCentroNote) {
        const _centroIdMatch = String(notaId).match(/^CENTRO-(\d+)/);
        const _centroId = _centroIdMatch ? _centroIdMatch[1] : '0';
        
        let _periodoSql = '';
        const rangoMatch = String(notaId).match(/CENTRO-[^-]*-(\d{4}-\d{2}-\d{2})_(\d{4}-\d{2}-\d{2})/);
        if (rangoMatch) {
            _periodoSql = `AND fecha_venta >= '${rangoMatch[1]} 00:00:00' AND fecha_venta <= '${rangoMatch[2]} 23:59:59'`;
        } else {
            const dateMatch = String(notaId).match(/CENTRO-[^-]*-(\d{4}-\d{2}-\d{2})/);
            if (dateMatch) {
                // If the batch has a single date, it usually implies all sales up to that date,
                // but for safety, if we want to restrict it to that exact day:
                // Actually, wait, the Centro generation creates a batch for ALL pending up to that moment.
                // Let's filter by the exact day? No, if we filter by the exact day, previous days might be missed.
                // It's safer to just include all pending without date restriction, OR up to the date.
                // The Global/Centro logic in the dashboard queries *all* pending. We'll leave it as all pending for now to match the UI behavior unless a strict range is provided.
                if (notaId.includes('_')) {
                   // Range handled above
                }
            }
        }

        try {
            // Extraer mes del numero_nota: CENTRO-1-2026-06 → '2026-06'
            const _mesMatch = String(notaId).match(/^CENTRO-\d+-((\d{4})-(\d{2}))$/);
            const _mesFiltro = _mesMatch 
                ? ` AND TO_CHAR(fecha_venta,'YYYY-MM') = '${_mesMatch[1]}'`
                : '';
            // Solo cargar notas que pertenecen a ESTA solicitud (requiere_factura=true)
            const rCentro = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                sql: `SELECT piezas, comentario, total::float AS total,
                       COALESCE(monto_facturable::float, 0) AS monto_facturable
                FROM venta WHERE centro_apoyo_id = '${_centroId}'
                  AND (factura_emitida = false OR factura_emitida IS NULL)
                  AND approved = 1
                  AND requiere_factura = false${_mesFiltro} ${_periodoSql}`
            });

            const centroVentas = rCentro.rows || [];
            for (const cv of centroVentas) {
                let pz = [];
                try { pz = typeof cv.piezas === 'string' ? JSON.parse(cv.piezas) : (cv.piezas || []); } catch(_) {}
                if (Array.isArray(pz)) items.push(...pz);
                // Detectar activos en cada nota
                const com = cv.comentario || '';
                // Regex acumulativo: suma TODOS los ACTIVOS (propios + TERCEROS)
                const mActAll = [...(com.matchAll(/(?:^|[^A-Z_])(?:ACTIVOS(?:_[A-Z_]+)?(?:\/[A-Z0-9_-]+)?)[^$]*\$([0-9,]+(?:\.[0-9]+)?)/gi))];
                if (mActAll.length > 0) {
                    isActivo = true;
                    montoActivos += mActAll.reduce((s, m) => s + parseFloat(m[1].replace(/,/g, '')), 0);
                }
            }
            // Recalcular montoBase como suma de todas las ventas vinculadas
            if (!montoBase || montoBase <= 0) {
                montoBase = centroVentas.reduce((s, v) => s + Number(v.monto_facturable || v.total || 0), 0);
            }
        } catch(e) { console.error('[CENTRO items]', e); }
    }

    // Intentar obtener piezas desde BD (solo para notas individuales, no CENTRO-)
    if (!_isCentroNote) {
    try {
        const rp = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
            sql: `SELECT piezas, comentario, total::float AS total,
                   COALESCE(monto_facturable::float, 0) AS monto_facturable
            FROM venta WHERE id = '${notaId}'`
        });
        const row = rp.rows?.[0];
        if (row) {
            const raw = row.piezas;
            try { items = typeof raw === 'string' ? JSON.parse(raw) : (raw || []); } catch(_) {}
            if (!Array.isArray(items)) items = [];
            const comentario = row.comentario || '';
            // Regex acumulativo: captura ACTIVOS propios Y ACTIVOS_TERCEROS
            const allActivosMatches = [...(comentario.matchAll(
                /(?:^|[^A-Z_])(?:ACTIVOS(?:_[A-Z_]+)?(?:\/[A-Z0-9_-]+)?)[^$]*\$([0-9,]+(?:\.[0-9]+)?)/gi
            ))];
            isActivo = allActivosMatches.length > 0;
            if (isActivo) {
                montoActivos = allActivosMatches.reduce(
                    (s, m) => s + parseFloat(m[1].replace(/,/g, '')), 0
                );
            }
        }
    } catch(_) {}
    // Fallback: _ventasData en memoria
    if (!items.length) {
        const vMem = (_ventasData || []).find(v => v.notaFull === notaId);
        if (vMem && vMem.piezas && vMem.piezas.length) {
            items = vMem.piezas;
            const comentMem = vMem.comentario || '';
            const allMemMatches = [...(comentMem.matchAll(
                /(?:^|[^A-Z_])(?:ACTIVOS(?:_[A-Z_]+)?(?:\/[A-Z0-9_-]+)?)[^$]*\$([0-9,]+(?:\.[0-9]+)?)/gi
            ))];
            isActivo = allMemMatches.length > 0;
            if (isActivo) {
                montoActivos = allMemMatches.reduce(
                    (s, m) => s + parseFloat(m[1].replace(/,/g, '')), 0
                );
            }
        }
    }
    } // end !_isCentroNote

    // Asegurar que PRODUCTOS_CAT esté cargado (es la fuente del nombre legible y claves SAT)
    let catalogo = window.PRODUCTOS_CAT || [];
    let compData = window.PRODUCTOS_COMP || [];
    if (!catalogo.length || !compData.length) {
        try {
            const [rCat, rComp] = await Promise.all([
                BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                    // Bug #5 fix: incluir tasa_iva para no hardcodear por clave SAT
                    sql: `SELECT id, sku, nombre, clave_sat, unidad_sat, unidad_nombre, categoria, COALESCE(tasa_iva, 0) AS tasa_iva FROM productos` }),
                BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                    sql: `SELECT pc.paquete_id, pc.componente_id, pc.cantidad, p.nombre AS comp_nombre, p.clave_sat AS comp_clave_sat, p.unidad_sat AS comp_unidad_sat
                          FROM producto_componente pc JOIN productos p ON p.id = pc.componente_id` })
            ]);
            catalogo = (rCat.rows || []).map(r => ({ ...r, claveSat: r.clave_sat, unidadSat: r.unidad_sat, unidadNombre: r.unidad_nombre, tasaIva: parseFloat(r.tasa_iva || 0) }));
            compData = rComp.rows || [];
            window.PRODUCTOS_CAT = catalogo;
            window.PRODUCTOS_COMP = compData;
        } catch(_) {}
    }

    if (items.length) {
        // Expandir paquetes a componentes
        const expandedItems = [];
        for (const p of items) {
            const prodId = String(p.producto_id || '');
            const catProd = catalogo.find(c => String(c.id) === prodId || c.sku === p.sku);
            if (catProd && catProd.categoria === 'paquete') {
                const comps = compData.filter(c => c.paquete_id === catProd.id);
                if (comps.length > 0) {
                    const qty = Number(p.cantidad || p.qty || 1);
                    const totalPzs = comps.reduce((s, c) => s + (parseInt(c.cantidad) || 0), 0);
                    const precioOrig = Number(p.precio_unitario || p.precio || p.price || 0);
                    const precioXPieza = totalPzs > 0 ? precioOrig / totalPzs : 0;
                    for (const comp of comps) {
                        expandedItems.push({
                            producto_id: String(comp.componente_id),
                            sku: comp.sku,
                            nombre: (comp.comp_nombre || '').replace(/\s+(Pub|MC|Dist)$/i, '').trim(),
                            cantidad: (parseInt(comp.cantidad) || 1) * qty,
                            precio_unitario: precioXPieza,
                            clave_sat: comp.comp_clave_sat || '50131705',
                            unidad_sat: comp.comp_unidad_sat || 'H87'
                        });
                    }
                    continue;
                }
            }
            expandedItems.push(p);
        }

        // Paso 1: Mapear productos iniciales
        let mappedItems = expandedItems.map(p => {
            const catProd = catalogo.find(c => c.sku === p.sku || String(c.id) === String(p.producto_id));
            const rawNom = p.nombre || catProd?.nombre || p.name || p.descripcion || p.sku || 'Producto';
            const nom = typeof limpiarSufijos === 'function' ? limpiarSufijos(rawNom) : rawNom;
            let productCode = catProd?.claveSat || catProd?.clave_sat || '50131705';
            let unitCode = catProd?.unidadSat || catProd?.unidad_sat || 'H87';
            let unitName = catProd?.unidadNombre || catProd?.unidad_nombre || 'Pieza';
            
            if (/env[íi]o|flete|shipping/i.test(nom)) {
                productCode = '78102200';
                unitCode = 'E48';
                unitName = 'Servicio';
            }
            const qty = Number(p.cantidad || p.qty || 1);
            let prc = Number(p.precio_unitario || p.precio || p.price || 0);
            if (!prc && catProd) prc = Number(catProd.mx || catProd.eu || 0);
            if (!prc && montoBase) prc = montoBase / qty;
            // Bug #5: tasa_iva desde BD (0 o 16), no hardcodeada por clave SAT
            const tasaIva = catProd ? (catProd.tasaIva ?? null) : null;
            
            return { productCode, nom, unitCode, unitName, qty, prc, tasaIva };
        });

        // Paso 2: Aplicar lógica de activos — prioridad: productos 16% IVA, luego 0% IVA
        // Lógica: montoActivos se toma del comentario → se divide entre precio unitario
        // de productos con IVA → esas piezas van a simbólico. Si sobra activo,
        // se continúa con los productos 0% IVA.
        
        // Fix: Verificar si el monto base de la venta (el efectivo recibido) ya equivale
        // a la suma de los items. Si el usuario registró las piezas al costo de distribuidor,
        // la suma de las piezas ya dará el montoBase (ej. 4750). En ese caso NO debemos
        // descontar de nuevo los activos porque provocaría un doble descuento.
        const sumBase = mappedItems.reduce((acc, p) => acc + (p.prc * p.qty), 0);
        const yaEstaDescontado = (montoBase > 0 && Math.abs(sumBase - montoBase) < 2);

        if (isActivo && montoActivos > 0 && !yaEstaDescontado) {
            let activosRestante = montoActivos;
            const finalItems = [];
            // Separar: productos con IVA (16%) vs sin IVA (0%)
            const ivaItems   = mappedItems.filter(p => !['50131705','50131700'].includes(p.productCode));
            const noIvaItems  = mappedItems.filter(p => ['50131705','50131700'].includes(p.productCode));
            // Primero: subsidiar productos con IVA 16%
            ivaItems.sort((a,b) => b.prc - a.prc);
            for (const p of ivaItems) {
                if (p.prc <= 0) { finalItems.push(p); continue; }
                const possibleSubsidized = Math.floor(activosRestante / p.prc);
                const toSubsidize = Math.min(p.qty, possibleSubsidized);
                if (toSubsidize > 0) {
                    // Fase 1: piezas completas cubiertas por activos → precio simbólico
                    finalItems.push({ ...p, qty: toSubsidize, prc: 0.000001 });
                    activosRestante = +(activosRestante - (toSubsidize * p.prc)).toFixed(2);
                }
                const remaining = p.qty - toSubsidize;
                if (remaining > 0) {
                    if (activosRestante > 0 && activosRestante < p.prc) {
                        // Fase 2: 1 pieza a precio con descuento para absorber el residual exacto
                        const precioDescuento = +(p.prc - activosRestante).toFixed(2);
                        finalItems.push({ ...p, qty: 1, prc: precioDescuento > 0 ? precioDescuento : 0.000001 });
                        activosRestante = 0;
                        if (remaining - 1 > 0) {
                            // Fase 3: resto de piezas al precio regular
                            finalItems.push({ ...p, qty: remaining - 1 });
                        }
                    } else {
                        // Fase 3: precio regular
                        finalItems.push({ ...p, qty: remaining });
                    }
                }
            }
            // Segundo: si queda activo, continuar con productos 0% IVA
            if (activosRestante > 0) {
                noIvaItems.sort((a,b) => b.prc - a.prc);
                for (const p of noIvaItems) {
                    if (p.prc <= 0) { finalItems.push(p); continue; }
                    const possibleSubsidized = Math.floor(activosRestante / p.prc);
                    const toSubsidize = Math.min(p.qty, possibleSubsidized);
                    if (toSubsidize > 0) {
                        finalItems.push({ ...p, qty: toSubsidize, prc: 0.000001 });
                        activosRestante = +(activosRestante - (toSubsidize * p.prc)).toFixed(2);
                    }
                    const remaining = p.qty - toSubsidize;
                    if (remaining > 0) {
                        if (activosRestante > 0 && activosRestante < p.prc) {
                            // Fase 2: 1 pieza con descuento residual
                            const precioDescuento = +(p.prc - activosRestante).toFixed(2);
                            finalItems.push({ ...p, qty: 1, prc: precioDescuento > 0 ? precioDescuento : 0.000001 });
                            activosRestante = 0;
                            if (remaining - 1 > 0) {
                                finalItems.push({ ...p, qty: remaining - 1 });
                            }
                        } else {
                            finalItems.push({ ...p, qty: remaining });
                        }
                    }
                }
            } else {
                // No sobró activo: productos 0% IVA pasan intactos
                finalItems.push(...noIvaItems);
            }
            mappedItems = finalItems;

            // ── Bug #4 fix: Aterrizaje exacto del regulador ──────────────────
            // Los centavos simbólicos ($0.01 × N piezas) inflan el total.
            // Ajustar el precio del item regulador para que el CFDI = montoBase exacto.
            if (montoBase > 0 && mappedItems.length > 0) {
                const totalGenerado = mappedItems.reduce((s, p) => {
                    const unitP = p.prc < 0.01 ? 0.01 : p.prc;
                    return s + _cfdiRound(unitP * p.qty, 2);
                }, 0);
                const diferencia = _cfdiRound(totalGenerado - montoBase, 2);
                if (Math.abs(diferencia) >= 0.01) {
                    // Buscar regulador: qty=1 y precio > $0.01 con hermanos simbólicos del mismo nombre
                    const regIdx = mappedItems.findIndex(p =>
                        p.qty === 1 && p.prc > 0.01 &&
                        mappedItems.some(o => o !== p && o.nom === p.nom && o.prc < 0.01)
                    );
                    if (regIdx >= 0) {
                        mappedItems[regIdx].prc = _cfdiRound(mappedItems[regIdx].prc - diferencia, 6);
                        if (mappedItems[regIdx].prc <= 0) mappedItems[regIdx].prc = 0.000001;
                    } else {
                        // Fallback: ajustar última pieza con precio > $0.01
                        const lastNormIdx = [...mappedItems].map((p,i)=>({p,i})).reverse()
                            .find(({p}) => p.prc > 0.01)?.i;
                        if (lastNormIdx !== undefined) {
                            const adj = _cfdiRound(diferencia / mappedItems[lastNormIdx].qty, 6);
                            mappedItems[lastNormIdx].prc = _cfdiRound(mappedItems[lastNormIdx].prc - adj, 6);
                        }
                    }
                }
            }
        }

        // Paso 3: Convertir a formato Facturama
        // ESTRATEGIA: Facturama EXIGE Subtotal, Total, Base y Taxes.Total.
        // Usamos truncamiento (floor) en lugar de Math.round para alinearnos
        // con la aritmética .NET de Facturama y garantizar:
        //   Subtotal = truncar(UnitPrice * Qty, 2)
        //   Taxes.Total = truncar(Base * Rate, 2)
        //   Total = Subtotal + Taxes.Total
        const facItems = mappedItems.map(p => {
            // ── Determinar tasa de IVA desde BD (tasa_iva), fallback por clave SAT ──
            let ivaRate;
            if (p.tasaIva !== null && p.tasaIva !== undefined) {
                ivaRate = p.tasaIva / 100; // BD guarda 0 o 16, Facturama necesita 0.00 o 0.16
            } else {
                // Fallback legacy: clave SAT 50131705/50131700 = alimentos = 0%
                ivaRate = ['50131705', '50131700'].includes(p.productCode) ? 0.00 : 0.16;
            }

            const isSymbolic = p.prc < 0.01;

            // ── Ítems simbólicos (cubiertos 100% por activos) ──────────────
            if (isSymbolic) {
                const subSym = _cfdiRound(0.01 * p.qty, 2);
                return {
                    ProductCode: p.productCode, Description: p.nom,
                    Unit: p.unitName, UnitCode: p.unitCode,
                    UnitPrice: 0.01, Quantity: p.qty,
                    Subtotal: subSym,
                    Total: subSym,
                    TaxObject: '02',
                    Taxes: [{ Name: 'IVA', Rate: 0.000000, Total: 0.00, Base: subSym, IsRetention: false }]
                };
            }

            // ── Productos EXENTOS (0% IVA) ─────────────────────────────────
            if (ivaRate === 0) {
                const sub0 = _cfdiRound(p.prc * p.qty, 2);
                return {
                    ProductCode: p.productCode, Description: p.nom,
                    Unit: p.unitName, UnitCode: p.unitCode,
                    UnitPrice: _cfdiRound(p.prc, 6), Quantity: p.qty,
                    Subtotal: sub0, Total: sub0, TaxObject: '02',
                    Taxes: [{ Name: 'IVA', Rate: 0.000000, Total: 0.00, Base: sub0, IsRetention: false }]
                };
            }

            // ── Productos con IVA 16% ──────────────────────────────────────
            // Precio unitario a 6 decimales (solo para Facturama, no afecta el cálculo del total)
            const unitPrice = _cfdiRound(p.prc / (1 + ivaRate), 6);
            // Subtotal = redondear TOTAL DE LÍNEA / (1+iva)
            // FIX: _cfdiRound en lugar de _cfdiTrunc — evita pérdida de centavos acumulativa
            // Ejemplo: $4,750 / 1.16 = $4,094.8275... → $4,094.83 ✅ (antes: $4,094.82 ❌ → total $4,749.99)
            const lineTotal = p.prc * p.qty;
            const sub = _cfdiRound(lineTotal / (1 + ivaRate), 2);
            // IVA = redondear(sub * rate, 2)
            const ivaTax = _cfdiRound(sub * ivaRate, 2);
            // Total = sub + iva (exacto)
            const totalItem = _cfdiRound(sub + ivaTax, 2);

            return {
                ProductCode: p.productCode, Description: p.nom,
                Unit: p.unitName, UnitCode: p.unitCode,
                UnitPrice: unitPrice, Quantity: p.qty,
                Subtotal: sub, Total: totalItem, TaxObject: '02',
                Taxes: [{ Name: 'IVA', Rate: ivaRate, Total: ivaTax, Base: sub, IsRetention: false }]
            };
        });

        console.log('[CFDI ITEMS]', JSON.stringify(facItems, null, 2));
        return facItems;
    }
    // Fallback: 1 item genérico
    const subFB = _cfdiRound(Number(montoBase) / 1.16, 2);
    const ivaFB = _cfdiRound(subFB * 0.16, 2);
    const totalFB = _cfdiRound(subFB + ivaFB, 2);
    return [{
        ProductCode: '50131705', Description: 'Venta de alimentos naturales',
        Unit: 'Pieza', UnitCode: 'H87', UnitPrice: subFB, Quantity: 1,
        Subtotal: subFB, Total: totalFB, TaxObject: '02',
        Taxes: [{ Name: 'IVA', Rate: 0.16, Total: ivaFB, Base: subFB, IsRetention: false }]
    }];
}

// ── Facturación — DB Migration: agregar columnas SAT si no existen ──
async function _runSatMigration() {
    try {
        await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
            sql: `ALTER TABLE productos ADD COLUMN IF NOT EXISTS clave_sat VARCHAR(10) DEFAULT '50131705'; ALTER TABLE productos ADD COLUMN IF NOT EXISTS unidad_sat VARCHAR(5) DEFAULT 'H87'; ALTER TABLE productos ADD COLUMN IF NOT EXISTS unidad_nombre VARCHAR(20) DEFAULT 'Pieza';`
        });
        // Asignar claves por categoría
        await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
            sql: `UPDATE productos SET clave_sat = '53131644' WHERE categoria = 'esencia' AND (clave_sat IS NULL OR clave_sat = '50131705');`
        });
        await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
            sql: `UPDATE productos SET clave_sat = '80141605' WHERE (categoria = 'promo' OR es_promo = true) AND (clave_sat IS NULL OR clave_sat = '50131705');`
        });
        await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
            sql: `UPDATE productos SET clave_sat = '78102200', unidad_sat = 'E48', unidad_nombre = 'Servicio' WHERE sku LIKE '%REENVIO%' AND (clave_sat IS NULL OR clave_sat = '50131705');`
        });
        // CEDIS: agregar columna cp
        await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
            sql: `ALTER TABLE cedis ADD COLUMN IF NOT EXISTS cp VARCHAR(5); UPDATE cedis SET cp = '45050' WHERE id = 1 AND cp IS NULL; UPDATE cedis SET cp = '77509' WHERE id = 2 AND cp IS NULL; UPDATE cedis SET cp = '30700' WHERE id = 3 AND cp IS NULL;`
        });
        // Facturas: columnas para notas USD (moneda + tipo de cambio)
        await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
            sql: `ALTER TABLE facturas_solicitadas ADD COLUMN IF NOT EXISTS moneda VARCHAR(3) DEFAULT 'MXN'; ALTER TABLE facturas_solicitadas ADD COLUMN IF NOT EXISTS tipo_cambio NUMERIC(10,4) DEFAULT NULL;`
        });
        await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
            sql: `ALTER TABLE venta ADD COLUMN IF NOT EXISTS moneda VARCHAR(3) DEFAULT 'MXN';`
        });
        // ── Backfill moneda para notas legacy (moneda IS NULL) ──────────────
        // Prioridad: campo ya guardado > cedis_id 4 (LLC USA) > pais del cliente
        try {
            await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                sql: `UPDATE venta v SET moneda =
                    CASE
                      WHEN v.cedis_id::text = '4' THEN 'USD'
                      WHEN EXISTS (
                        SELECT 1 FROM cliente c JOIN pais p ON p.id = c.pais_id
                        WHERE c.id::text = v.cliente_id::text
                        AND p.codigo IN ('USA','SLV')
                      ) THEN 'USD'
                      WHEN EXISTS (
                        SELECT 1 FROM cliente c JOIN pais p ON p.id = c.pais_id
                        WHERE c.id::text = v.cliente_id::text
                        AND p.codigo IN ('GTM','GUA')
                      ) THEN 'GTQ'
                      WHEN EXISTS (
                        SELECT 1 FROM cliente c JOIN pais p ON p.id = c.pais_id
                        WHERE c.id::text = v.cliente_id::text
                        AND p.codigo = 'CAN'
                      ) THEN 'CAD'
                      ELSE 'MXN'
                    END
                  WHERE v.moneda IS NULL OR v.moneda = ''`
            });
            console.log('✅ Backfill moneda venta completado');
        } catch(eBf) { console.warn('⚠️ Backfill moneda (puede ser normal):', eBf.message); }
        // Rescate: tabla de seguimiento para acercamientos
        await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
            sql: `CREATE TABLE IF NOT EXISTS rescate_seguimiento (
                id SERIAL PRIMARY KEY,
                cliente_id INTEGER NOT NULL,
                resultado VARCHAR(50) NOT NULL,
                comentario TEXT,
                usuario_nombre VARCHAR(100),
                created_at TIMESTAMP DEFAULT NOW()
            );`
        });
        // ── Fix masivo Bug #1+: ventas con monto_facturable ≠ total por doble substracción de activos ──
        // IMPORTANTE: Solo corregir notas SIN activos. Las notas con activos deben conservar
        // su monto_facturable = montoEfectivo (total - activos), para que el CFDI no incluya
        // el monto pagado con producto.
        try {
            const fixRes = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                sql: `UPDATE venta SET monto_facturable = total
                      WHERE monto_facturable IS NOT NULL
                        AND monto_facturable::float != total::float
                        AND total::float > 0
                        AND (factura_emitida = false OR factura_emitida IS NULL)
                        AND (comentario IS NULL OR UPPER(comentario) NOT LIKE '%ACTIVOS%')`
            });
            const fixCount = fixRes.rowCount ?? fixRes.rows?.[0]?.count ?? '?';
            console.log('✅ Fix monto_facturable (sin activos): ' + fixCount + ' ventas corregidas');
        } catch(eFix) { console.warn('⚠️ Fix monto_facturable (puede ser normal):', eFix.message); }
        // ── Agregar columna monto_activos para almacenar directamente (sin parsear comentario) ──
        await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
            sql: `ALTER TABLE venta ADD COLUMN IF NOT EXISTS monto_activos NUMERIC(14,2) DEFAULT 0`
        }).catch(_=>{});
        // Backfill monto_activos desde comentario para notas existentes con activos
        await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
            sql: `UPDATE venta
                  SET monto_activos = (
                      SELECT COALESCE(SUM(REPLACE(m[1],',','')::numeric), 0)
                      FROM regexp_matches(comentario, '(?:^|[^A-Z_])(?:ACTIVOS(?:_[A-Z_]+)?(?:/[A-Z0-9_-]+)?)[^$]*\$([0-9,]+(\.[0-9]+)?)', 'gi') AS t(m)
                  )
                  WHERE comentario ILIKE '%ACTIVOS%'
                    AND (monto_activos IS NULL OR monto_activos = 0)
                    AND (factura_emitida = false OR factura_emitida IS NULL)`
        }).catch(_=>{});

        // ── Exportador Contable: fecha_certificacion en facturas_solicitadas ──
        await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
            sql: `ALTER TABLE facturas_solicitadas ADD COLUMN IF NOT EXISTS fecha_certificacion TIMESTAMP`
        }).catch(_=>{});

        // ── Exportador Contable: tabla de mapeo Serie ↔ Banco ──
        await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
            sql: `CREATE TABLE IF NOT EXISTS config_series_banco (
                id SERIAL PRIMARY KEY,
                banco TEXT NOT NULL,
                series TEXT[] NOT NULL,
                grupo_contable TEXT NOT NULL
            )`
        }).catch(_=>{});
        // Insertar datos iniciales solo si la tabla está vacía
        await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
            sql: `INSERT INTO config_series_banco (banco, series, grupo_contable)
                  SELECT * FROM (VALUES
                    ('BBVA', ARRAY['BBVA','BBVAT','BBVAC'], 'BBVA'),
                    ('SANTANDER', ARRAY['SANTANDER','SANTANDERC','SANTANDERT'], 'Santander'),
                    ('TERMINAL_SANTANDER', ARRAY['TS','TSGDL'], 'Terminal Santander'),
                    ('MERCADOPAGO', ARRAY['MERCADOPAG','MPC','MPT'], 'Mercado'),
                    ('CLIP', ARRAY['CLIPT'], 'Clip'),
                    ('PAYPAL_DLS', ARRAY['PAYPALDLS','PAYPALDLST'], 'PAYPALDLS'),
                    ('PAYPAL_MX', ARRAY['PAYPALMX','PAYPALMXT'], 'PAYPALMX'),
                    ('SHOPIFY', ARRAY['SPF'], 'Shopify'),
                    ('EFECTIVO', ARRAY['EFECTIVO'], 'Efectivo'),
                    ('STRIPE', ARRAY['STRIPE','STRIPE_USA'], 'Stripe')
                  ) AS t(banco, series, grupo_contable)
                  WHERE NOT EXISTS (SELECT 1 FROM config_series_banco LIMIT 1)`
        }).catch(_=>{});

        // ── Exportador Contable: tabla de valores reales de activos ──
        await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
            sql: `CREATE TABLE IF NOT EXISTS config_activos_valor (
                producto_key TEXT PRIMARY KEY,
                valor_real NUMERIC(10,2) NOT NULL
            )`
        }).catch(_=>{});
        await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
            sql: `INSERT INTO config_activos_valor (producto_key, valor_real)
                  SELECT * FROM (VALUES
                    ('natural', 187.50), ('chocolate', 187.50),
                    ('vainilla', 187.50), ('fresa', 187.50),
                    ('eucament', 93.75)
                  ) AS t(producto_key, valor_real)
                  WHERE NOT EXISTS (SELECT 1 FROM config_activos_valor LIMIT 1)`
        }).catch(_=>{});

        console.log('✅ SAT migration completada');
    } catch(e) { console.warn('⚠️ SAT migration (puede ser normal si ya existe):', e); }
}
// Ejecutar migración al cargar
_runSatMigration();

// ── Facturación — Facturama Integration ──────────────────────────────────────
// Reemplaza solicitarFactura con versión interna BD (Pipeline: Solicitada -> En Proceso -> Facturada)
async function solicitarFacturaFacturama() {
    const rfc       = document.getElementById('fac-rfc')?.value?.trim().toUpperCase();
    const razon     = document.getElementById('fac-razon')?.value?.trim();
    const cp        = document.getElementById('fac-cp')?.value?.trim();
    const regimen   = document.getElementById('fac-regimen')?.value;
    const cfdiUse   = document.getElementById('fac-cfdi')?.value;
    const formaPago = document.getElementById('fac-forma-pago')?.value;
    const nota      = document.getElementById('fac-nota')?.value?.trim();

    if (!rfc || !razon || !cp || !nota) { BO_AUTH.showAlert('Completa todos los campos requeridos (RFC, Razón Social, CP, Nota)', 'warning'); return; }
    const rfcOk = /^[A-Z&Ñ]{3,4}[0-9]{6}[A-Z0-9]{3}$/.test(rfc);
    if (!rfcOk) { BO_AUTH.showAlert('RFC inválido — revisa el formato', 'error'); return; }

    const notaData  = _notasSinFacturar.find(n => String(n.id) === String(nota));
    const totalVenta = Number(notaData?.total || notaData?.monto_real || 0);
    if (!totalVenta) { BO_AUTH.showAlert('No se pudo obtener el monto de la nota seleccionada', 'error'); return; }

    // ── Fix 4: Verificar crédito pendiente antes de facturar ──
    if (notaData?.comentario) {
        const _v = { comentarioRaw: notaData.comentario, totalNum: totalVenta };
        const _cred = _calcularCreditoVenta(_v);
        if (_cred > 0) {
            BO_AUTH.showAlert('⚠️ Esta nota tiene un saldo pendiente de $' + _cred.toLocaleString('es-MX',{minimumFractionDigits:2}) + ' (crédito). No se puede facturar hasta liquidar el pago completo.', 'error');
            return;
        }
    }

// ── Helper global anti-duplicados ──────────────────────────────────────────
async function _verificarNotaDisponibleParaFacturar(notaId) {
    if (!notaId) return null;
    try {
        const sql = `
            SELECT f.id, f.numero_nota, f.estado 
            FROM facturas_solicitadas f 
            WHERE f.estado IN ('solicitada', 'en_proceso', 'facturada')
              AND (
                f.numero_nota = '${notaId}'
                OR (f.ventas_ids IS NOT NULL AND f.ventas_ids::text LIKE '%"${notaId}"%')
              )
            LIMIT 1
        `;
        const res = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql });
        return (res.rows && res.rows.length > 0) ? res.rows[0] : null;
    } catch(e) {
        console.warn('Error verificando duplicidad de nota:', e);
        return null;
    }
}

    const razonSafe = razon.replace(/'/g, "''");
    const _solRol = (CURRENT_USER?.rol || '').toLowerCase().replace(/ /g, '_').trim();
    const isMaster  = ['master', 'contabilidad'].includes(_solRol === 'administrador' ? 'admin' : _solRol);

    try {
        // Validar si la nota ya cuenta con una solicitud activa (individual o dentro de una global)
        const existente = await _verificarNotaDisponibleParaFacturar(nota);
        if (existente) {
            BO_AUTH.showAlert(`⚠️ La nota #${nota.substring(0,8)}… ya cuenta con una solicitud de factura activa (#${existente.id} - ${existente.estado}).`, 'warning');
            return;
        }

        // ── PASO 1: Guardar en BD siempre ──
        const sqlInsert = `
            INSERT INTO facturas_solicitadas
                (usuario_id, rfc, razon_social, cp, regimen, uso_cfdi, forma_pago, numero_nota, estado)
            VALUES
                ('${CURRENT_USER.id}', '${rfc}', '${razonSafe}', '${cp}', '${regimen}',
                 '${cfdiUse}', '${formaPago}', '${nota}', 'solicitada')
            RETURNING id
        `;
        const insRes = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlInsert });
        const solicitudId = insRes.rows?.[0]?.id;

        // Marcar la venta para que salga del dropdown y del borrador
        await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
            sql: `UPDATE venta SET requiere_factura = false WHERE id = '${nota}'`
        });

        // ── SIEMPRE mandar a pendiente para revisión manual ──
        BO_AUTH.showAlert('📋 Solicitud enviada a la lista de pendientes para su revisión.', 'success');
        loadHistorialFacturas();
        cargarNotasSinFacturar(_facClienteIdFilter);
        if (typeof loadFacturaGlobal === 'function') loadFacturaGlobal();

        // ── Limpiar formulario ──
        ['fac-rfc','fac-razon','fac-cp'].forEach(i => { const el = document.getElementById(i); if(el) el.value=''; });
        const notaSel = document.getElementById('fac-nota'); if (notaSel) notaSel.selectedIndex = 0;
        const infoEl  = document.getElementById('fac-nota-info'); if (infoEl) infoEl.style.display = 'none';
        const fb = document.getElementById('rfcFeedback'); if (fb) fb.style.display = 'none';
        loadHistorialFacturas();

    } catch(e) {
        BO_AUTH.showAlert('Error al procesar la solicitud: ' + e.message, 'error');
        console.error('solicitarFacturaFacturama:', e);
    }
}

// ── Facturación — Tab switching ──────────────────────────────────────────────
function switchHistorialTab(tab) {
    const tabPend = document.getElementById('tabPendientes');
    const tabFact = document.getElementById('tabFacturasDelMes');
    const tabCanc = document.getElementById('tabCanceladas');
    const contentPend = document.getElementById('tabContentPendientes');
    const contentFact = document.getElementById('tabContentFacturasDelMes');
    const contentCanc = document.getElementById('tabContentCanceladas');
    if (!tabPend || !tabFact || !contentPend || !contentFact) return;
    
    // Reset all tabs
    [tabPend, tabFact, tabCanc].forEach(t => { if (t) { t.style.background = 'transparent'; t.style.color = 'var(--text-dim)'; } });
    [contentPend, contentFact, contentCanc].forEach(c => { if (c) c.style.display = 'none'; });
    
    if (tab === 'pendientes') {
        tabPend.style.background = 'rgba(234,179,8,.12)';
        tabPend.style.color = 'var(--accent-gold)';
        contentPend.style.display = 'block';
    } else if (tab === 'canceladas') {
        if (tabCanc) { tabCanc.style.background = 'rgba(239,68,68,.12)'; tabCanc.style.color = 'var(--danger)'; }
        if (contentCanc) contentCanc.style.display = 'block';
    } else {
        tabFact.style.background = 'rgba(16,185,129,.12)';
        tabFact.style.color = 'var(--success)';
        contentFact.style.display = 'block';
    }
}

// ── Facturación — Historial con Tabs ─────────────────────────────────────────
// formato de fecha robusto para historial de facturas
function _fmtFechaFac(f) {
    const raw = f.creado_en || f.created_at || null;
    if (!raw) return `#${f.id}`;
    try { return new Date(raw).toLocaleDateString('es-MX'); } catch(_) { return raw; }
}

async function loadHistorialFacturas() {
    // ── Leer filtros de mes/año del UI ──
    const mesEl  = document.getElementById('facFilterMes');
    const anioEl = document.getElementById('facFilterAnio');
    // No forzar valor por defecto — permitir "0" (Todos)
    if (mesEl && !mesEl.value) mesEl.value = String(new Date().getMonth() + 1);
    if (anioEl && !anioEl.value) anioEl.value = String(new Date().getFullYear());
    const mesFiltro  = parseInt(mesEl?.value ?? new Date().getMonth() + 1);
    const anioFiltro = parseInt(anioEl?.value || new Date().getFullYear());
    const todosLosMeses = mesFiltro === 0; // "Todos" seleccionado
    const pendBody = document.getElementById('facturasPendientesBody');
    const factBody = document.getElementById('facturasBody');
    const _cfRol = (CURRENT_USER?.rol || '').toLowerCase().replace(/ /g, '_').trim();
    const isMaster = ['master', 'contabilidad', 'admin', 'administrador', 'callcenter', 'atencion', 'operativo', 'almacen', 'supervisor_almacen'].includes(_cfRol === 'administrador' ? 'admin' : _cfRol);
    
    if(isMaster) {
        document.getElementById('btnDescargaCSVFacturas').style.display = 'inline-block';
        const searchInput = document.getElementById('facSearchInput');
        if (searchInput) searchInput.style.display = 'inline-block';
        // ── Botón Diagnóstico de Duplicados (solo master) ──
        let btnDiag = document.getElementById('btnDiagnosticoDuplicados');
        if (!btnDiag) {
            btnDiag = document.createElement('button');
            btnDiag.id = 'btnDiagnosticoDuplicados';
            btnDiag.className = 'btn btn-outline btn-sm';
            btnDiag.style.cssText = 'font-size:.72rem;border-color:rgba(245,158,11,.5);color:#fbbf24;margin-left:.5rem;';
            btnDiag.innerHTML = '🔍 Diagnóstico Duplicados';
            btnDiag.onclick = () => diagnosticoDuplicadosPendientes();
            const refBtn = document.getElementById('btnDescargaCSVFacturas');
            if (refBtn && refBtn.parentNode) refBtn.parentNode.insertBefore(btnDiag, refBtn.nextSibling);
        }
        btnDiag.style.display = 'inline-block';
        // Mostrar tab Canceladas (solo master/contabilidad)
        const tabCancEl = document.getElementById('tabCanceladas');
        if (tabCancEl) tabCancEl.style.display = 'inline-block';
    } else {
        document.getElementById('btnDescargaCSVFacturas').style.display = 'none';
        const searchInput = document.getElementById('facSearchInput');
        if (searchInput) searchInput.style.display = 'none';
        const btnDiag = document.getElementById('btnDiagnosticoDuplicados');
        if (btnDiag) btnDiag.style.display = 'none';
        const tabCancEl = document.getElementById('tabCanceladas');
        if (tabCancEl) tabCancEl.style.display = 'none';
    }

    // ── Construir cláusula de fecha (vacía cuando "Todos") ──
    const fechaClause = todosLosMeses
        ? `AND (f.creado_en IS NULL OR EXTRACT(YEAR FROM f.creado_en) = ${anioFiltro})`
        : `AND (f.creado_en IS NULL OR (EXTRACT(MONTH FROM f.creado_en) = ${mesFiltro} AND EXTRACT(YEAR FROM f.creado_en) = ${anioFiltro}))`;

    // ── TAB 1: Pendientes de Aprobación ──
    try {
        let sqlPend = '';
        if (isMaster) {
            sqlPend = `SELECT f.*,
                              c.nombre AS usuario_nombre, c.ape_p AS usuario_apellido,
                              v.centro_apoyo_id AS _centro_id,
                              cv.nombre AS _cli_venta_nombre
                       FROM facturas_solicitadas f
                       LEFT JOIN cliente c ON f.usuario_id::text = c.id::text
                       LEFT JOIN venta v ON v.id::text = f.numero_nota::text
                       LEFT JOIN cliente cv ON cv.id::text = v.cliente_id::text
                       WHERE f.estado IN ('solicitada','en_proceso')
                       ORDER BY f.id DESC LIMIT 50`;
        } else {
            sqlPend = `SELECT f.*,
                              v.centro_apoyo_id AS _centro_id,
                              cv.nombre AS _cli_venta_nombre
                       FROM facturas_solicitadas f
                       LEFT JOIN venta v ON v.id::text = f.numero_nota::text
                       LEFT JOIN cliente cv ON cv.id::text = v.cliente_id::text
                       WHERE f.usuario_id::text = '${CURRENT_USER?.id || 0}'
                         AND f.estado IN ('solicitada','en_proceso')
                       ORDER BY f.id DESC`;
        }
        
        const resPend = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlPend });
        const pendItems = resPend.rows || [];
        
        const pendCount = document.getElementById('pendientesCount');
        if (pendCount) pendCount.textContent = pendItems.length;
        
        if (!pendItems.length) {
            if (pendBody) pendBody.innerHTML = '<tr><td colspan="5" style="text-align:center;color:var(--text-dim);padding:1.5rem">✅ Sin solicitudes pendientes</td></tr>';
        } else if (pendBody) {
            window._factPendItems  = pendItems;
            window._factPendMaster = isMaster;
            window._factPendPage   = 0;
            renderFactPendPage();
        }
    } catch(e) {
        if (pendBody) pendBody.innerHTML = `<tr><td colspan="5" style="text-align:center;color:var(--danger);padding:1.5rem">Error: ${e.message}</td></tr>`;
    }

    // ── TAB 2: Facturas (completadas / facturadas) ──
    try {
        // Query 1: registros en facturas_solicitadas con estado facturada/aprobada/timbrada/emitida
        let sqlFact = '';
        if (isMaster) {
            sqlFact = `SELECT f.*, 
                              COALESCE(c.nombre, cv.nombre, '') AS usuario_nombre, 
                              COALESCE(c.ape_p, cv.ape_p, '') AS usuario_apellido,
                              CASE 
                                  WHEN (f.numero_nota LIKE 'GLOBAL-%' OR f.numero_nota LIKE 'CENTRO-%') AND f.ventas_ids IS NOT NULL AND f.ventas_ids LIKE '[%' THEN
                                      COALESCE((
                                          SELECT SUM(v2.total) 
                                          FROM venta v2 
                                          WHERE v2.id::text IN (
                                              SELECT json_array_elements_text(f.ventas_ids::json)
                                          )
                                      ), 0)
                                  ELSE COALESCE(v.total, 0)
                              END AS total,
                              CASE 
                                  WHEN (f.numero_nota LIKE 'GLOBAL-%' OR f.numero_nota LIKE 'CENTRO-%') AND f.ventas_ids IS NOT NULL AND f.ventas_ids LIKE '[%' THEN
                                      COALESCE((
                                          SELECT SUM(v2.total) 
                                          FROM venta v2 
                                          WHERE v2.id::text IN (
                                              SELECT json_array_elements_text(f.ventas_ids::json)
                                          )
                                      ), 0)
                                  ELSE COALESCE(v.monto_facturable, v.total, 0)
                              END AS monto_facturable,
                              COALESCE(NULLIF(f.rfc, ''), cv.rfc, c.rfc, 'XAXX010101000') AS rfc,
                              COALESCE(NULLIF(f.razon_social, ''), NULLIF(TRIM(COALESCE(cv.nombre,'') || ' ' || COALESCE(cv.ape_p,'')), ''), NULLIF(TRIM(COALESCE(c.nombre,'') || ' ' || COALESCE(c.ape_p,'')), ''), 'Público en General') AS razon_social,
                              COALESCE(NULLIF(f.cp, ''), cv.cp, c.cp, '') AS cp,
                              COALESCE(NULLIF(f.regimen, ''), '612') AS regimen
                       FROM facturas_solicitadas f
                       LEFT JOIN cliente c ON f.usuario_id::text = c.id::text
                       LEFT JOIN venta v ON v.id::text = f.numero_nota::text
                       LEFT JOIN cliente cv ON cv.id::text = v.cliente_id::text
                       WHERE f.estado IN ('facturada','aprobada','timbrada','emitida')
                         ${fechaClause}
                       ORDER BY f.id DESC`;
        } else {
            sqlFact = `SELECT f.*,
                              CASE 
                                  WHEN (f.numero_nota LIKE 'GLOBAL-%' OR f.numero_nota LIKE 'CENTRO-%') AND f.ventas_ids IS NOT NULL AND f.ventas_ids LIKE '[%' THEN
                                      COALESCE((
                                          SELECT SUM(v2.total) 
                                          FROM venta v2 
                                          WHERE v2.id::text IN (
                                              SELECT json_array_elements_text(f.ventas_ids::json)
                                          )
                                      ), 0)
                                  ELSE COALESCE(v.total, 0)
                              END AS total,
                              CASE 
                                  WHEN (f.numero_nota LIKE 'GLOBAL-%' OR f.numero_nota LIKE 'CENTRO-%') AND f.ventas_ids IS NOT NULL AND f.ventas_ids LIKE '[%' THEN
                                      COALESCE((
                                          SELECT SUM(v2.total) 
                                          FROM venta v2 
                                          WHERE v2.id::text IN (
                                              SELECT json_array_elements_text(f.ventas_ids::json)
                                          )
                                      ), 0)
                                  ELSE COALESCE(v.monto_facturable, v.total, 0)
                              END AS monto_facturable,
                              COALESCE(NULLIF(f.rfc, ''), cv.rfc, c.rfc, 'XAXX010101000') AS rfc,
                              COALESCE(NULLIF(f.razon_social, ''), NULLIF(TRIM(COALESCE(cv.nombre,'') || ' ' || COALESCE(cv.ape_p,'')), ''), NULLIF(TRIM(COALESCE(c.nombre,'') || ' ' || COALESCE(c.ape_p,'')), ''), 'Público en General') AS razon_social,
                              COALESCE(NULLIF(f.cp, ''), cv.cp, c.cp, '') AS cp,
                              COALESCE(NULLIF(f.regimen, ''), '612') AS regimen
                       FROM facturas_solicitadas f
                       LEFT JOIN cliente c ON f.usuario_id::text = c.id::text
                       LEFT JOIN venta v ON v.id::text = f.numero_nota::text
                       LEFT JOIN cliente cv ON cv.id::text = v.cliente_id::text
                       WHERE f.usuario_id::text = '${CURRENT_USER?.id || 0}'
                         AND f.estado IN ('facturada','aprobada','timbrada','emitida')
                         ${fechaClause}
                       ORDER BY f.id DESC`;
        }
        
        // Query 2 (solo master): ventas marcadas como factura_emitida=true que NO tienen
        // registro en facturas_solicitadas (notas marcadas manualmente por fuera del flujo)
        const sqlHuerfanas = isMaster ? `
            SELECT NULL::int AS id,
                   v.id::text AS numero_nota,
                   COALESCE(cl.rfc, 'XAXX010101000') AS rfc,
                   COALESCE(NULLIF(TRIM(COALESCE(cl.nombre,'') || ' ' || COALESCE(cl.ape_p,'')), ''), 'Público en General') AS razon_social,
                   COALESCE(cl.cp, '') AS cp,
                   '612' AS regimen,
                   'G01' AS uso_cfdi,
                   '03' AS forma_pago,
                   'facturada' AS estado,
                   COALESCE(v.factura_uuid,'—') AS cfdi_id,
                   COALESCE(v.factura_uuid,'') AS cfdi_uuid,
                   COALESCE(v.total, 0) AS total,
                   COALESCE(v.monto_facturable, 0) AS monto_facturable,
                   v.fecha_venta AS creado_en,
                   COALESCE(cl.nombre, '(sin solicitud)') AS usuario_nombre,
                   COALESCE(cl.ape_p, '') AS usuario_apellido
            FROM venta v
            LEFT JOIN cliente cl ON cl.id::text = v.cliente_id::text
            WHERE v.factura_emitida = true
              AND NOT EXISTS (
                  SELECT 1 FROM facturas_solicitadas fs WHERE fs.numero_nota = v.id::text
              )
            ${todosLosMeses
                ? `AND (v.fecha_venta IS NULL OR EXTRACT(YEAR FROM v.fecha_venta) = ${anioFiltro})`
                : `AND (v.fecha_venta IS NULL OR (EXTRACT(MONTH FROM v.fecha_venta) = ${mesFiltro} AND EXTRACT(YEAR FROM v.fecha_venta) = ${anioFiltro}))`
            }
            ORDER BY v.fecha_venta DESC
            LIMIT 50
        ` : null;

        const [resFact, resHuerfanas] = await Promise.all([
            BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlFact }),
            sqlHuerfanas ? BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlHuerfanas }) : Promise.resolve({ rows: [] })
        ]);

        // Combinar resultados: primero facturas_solicitadas, luego huérfanas
        const factItems = [
            ...(resFact.rows || []),
            ...(resHuerfanas.rows || []).map(r => ({ ...r, _huerfana: true }))
        ];
        
        // Update counter badge
        const factCount = document.getElementById('facturasMesCount');
        if (factCount) factCount.textContent = factItems.length;
        
        if (!factItems.length) {
            const label = todosLosMeses ? 'Sin facturas en este año' : 'Sin facturas generadas este mes';
            if (factBody) factBody.innerHTML = `<tr><td colspan="5" style="text-align:center;color:var(--text-dim);padding:1.5rem">${label}</td></tr>`;
        } else if (factBody) {
            window._factFactItems  = factItems;
            window._factFactMaster = isMaster;
            window._factFactPage   = 0;
            renderFactFactPage();
        }
    } catch(e) {
        if (factBody) factBody.innerHTML = `<tr><td colspan="5" style="text-align:center;color:var(--danger);padding:1.5rem">Error al cargar facturas: ${e.message}</td></tr>`;
    }

    // ── TAB 3: Canceladas (solo master/contabilidad) ──
    if (isMaster) {
        const cancBody = document.getElementById('facturasCanceladasBody');
        try {
            const fechaClauseCanc = todosLosMeses
                ? `AND EXTRACT(YEAR FROM f.creado_en) = ${anioFiltro}`
                : `AND (f.creado_en IS NULL OR (EXTRACT(MONTH FROM f.creado_en) = ${mesFiltro} AND EXTRACT(YEAR FROM f.creado_en) = ${anioFiltro}))`;
            const sqlCanc = `SELECT f.* FROM facturas_solicitadas f WHERE f.estado = 'cancelada' ${fechaClauseCanc} ORDER BY f.id DESC LIMIT 500`;
            const resCanc = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlCanc });
            window._cancItems = resCanc.rows || [];
            window._cancPage = 0;
            _renderCanceladasPage();
        } catch(e) {
            if (cancBody) cancBody.innerHTML = `<tr><td colspan="4" style="text-align:center;color:var(--danger);padding:1.5rem">Error: ${e.message}</td></tr>`;
        }
    }
}

function _renderCanceladasPage() {
    const PAGE_SIZE = 7;
    const cancItems = window._cancItems || [];
    const page = window._cancPage || 0;
    const totalPages = Math.ceil(cancItems.length / PAGE_SIZE) || 1;
    const start = page * PAGE_SIZE;
    const pageItems = cancItems.slice(start, start + PAGE_SIZE);

    const cancCount = document.getElementById('canceladasCount');
    if (cancCount) cancCount.textContent = cancItems.length;

    const cancBody = document.getElementById('facturasCanceladasBody');
    if (!cancBody) return;

    if (!cancItems.length) {
        const label = 'Sin facturas canceladas';
        cancBody.innerHTML = `<tr><td colspan="4" style="text-align:center;color:var(--text-dim);padding:1.5rem">${label}</td></tr>`;
        const pag = document.getElementById('cancPagination');
        if (pag) pag.innerHTML = '';
        return;
    }

    const isGlobalNote = (n) => String(n || '').startsWith('GLOBAL-');
    const isCentroNote = (n) => String(n || '').startsWith('CENTRO-');
    cancBody.innerHTML = pageItems.map(f => {
        const nota = f.numero_nota || '';
        const _isGlob = isGlobalNote(nota);
        const _isCentro = isCentroNote(nota);
        const tipoTag = _isGlob ? '<span style="background:rgba(99,102,241,.15);color:#a5b4fc;font-size:.6rem;padding:1px 5px;border-radius:4px;">GLOBAL</span>'
            : _isCentro ? '<span style="background:rgba(168,85,247,.15);color:#c084fc;font-size:.6rem;padding:1px 5px;border-radius:4px;">CENTRO</span>'
            : '<span style="background:rgba(59,130,246,.15);color:#93c5fd;font-size:.6rem;padding:1px 5px;border-radius:4px;">INDIVIDUAL</span>';
        const verFn = (_isGlob || _isCentro) ? 'verSolicitudGlobal' : 'verSolicitudFactura';
        return `<tr>
            <td><b>#${f.id}</b><br><span style="font-size:.7rem;color:var(--text-dim)">${nota}</span><br>${tipoTag}</td>
            <td>${f.rfc || '—'}<br><span style="font-size:.7rem;color:var(--text-dim)">${f.razon_social || ''}</span></td>
            <td style="font-size:.8rem">${_fmtFechaFac(f)}<br><span style="color:var(--danger);font-size:.7rem">Cancelada</span></td>
            <td>
                <div style="display:flex;gap:.4rem;flex-wrap:wrap">
                    <button class="btn btn-outline btn-sm" style="font-size:.68rem" onclick="${verFn}(${f.id})">👁 Ver</button>
                    <button class="btn btn-sm" style="font-size:.68rem;background:linear-gradient(135deg,#f59e0b,#d97706);color:#000;font-weight:600" onclick="restaurarSolicitud(${f.id})">♻️ Restaurar</button>
                </div>
            </td>
        </tr>`;
    }).join('');

    // Pagination controls
    let pagEl = document.getElementById('cancPagination');
    if (!pagEl) {
        pagEl = document.createElement('div');
        pagEl.id = 'cancPagination';
        const tbl = cancBody.closest('table');
        if (tbl) tbl.parentNode.insertBefore(pagEl, tbl.nextSibling);
    }
    if (totalPages > 1) {
        pagEl.innerHTML = `<div style="display:flex;justify-content:space-between;align-items:center;margin-top:.5rem;font-size:.75rem;">
            <button onclick="_cancChangePage(-1)" ${page === 0 ? 'disabled' : ''} class="btn btn-outline btn-sm" style="font-size:.7rem;padding:.2rem .6rem;">◀ Anterior</button>
            <span style="color:var(--text-dim);">Página ${page+1} de ${totalPages} — ${cancItems.length} registros</span>
            <button onclick="_cancChangePage(1)" ${page >= totalPages-1 ? 'disabled' : ''} class="btn btn-outline btn-sm" style="font-size:.7rem;padding:.2rem .6rem;">Siguiente ▶</button>
        </div>`;
    } else {
        pagEl.innerHTML = `<div style="text-align:center;font-size:.72rem;color:var(--text-dim);margin-top:.3rem;">${cancItems.length} registros</div>`;
    }
}

function _cancChangePage(delta) {
    const PAGE_SIZE = 7;
    const totalPages = Math.ceil((window._cancItems || []).length / PAGE_SIZE) || 1;
    let page = (window._cancPage || 0) + delta;
    if (page < 0) page = 0;
    if (page >= totalPages) page = totalPages - 1;
    window._cancPage = page;
    _renderCanceladasPage();
}

// ── Restaurar solicitud cancelada → pendiente ──
async function restaurarSolicitud(id) {
    if (!confirm('¿Restaurar esta solicitud a estado PENDIENTE?\n\nLa solicitud volverá a aparecer en la pestaña de Pendientes para poder re-timbrar.')) return;
    try {
        await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
            sql: `UPDATE facturas_solicitadas SET estado = 'solicitada' WHERE id = ${id}`
        });
        BO_AUTH.showAlert('✅ Solicitud #' + id + ' restaurada a pendientes.', 'success');
        loadHistorialFacturas();
        switchHistorialTab('pendientes');
    } catch(e) {
        BO_AUTH.showAlert('❌ Error al restaurar: ' + e.message, 'error');
    }
}


// ── Facturación — Aprobar solicitud (Admin/Master) ───────────────────────────


async function aprobarSolicitudFactura(id, excludedIds = [], fallbackAllIds = null) {
    // La confirmación ya fue hecha en confirmarTimbrado() — no re-preguntar

    try {
        // 1. Obtener datos completos: solicitud + monto de la venta
        const resSol = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
            sql: `SELECT f.*, v.centro_apoyo_id AS _centro_id, cv.nombre AS _cli_venta_nombre
                  FROM facturas_solicitadas f
                  LEFT JOIN venta v ON v.id::text = f.numero_nota
                  LEFT JOIN cliente cv ON cv.id::text = v.cliente_id::text
                  WHERE f.id = ${id}` });
        const solBase = resSol.rows?.[0];
        if (!solBase) { BO_AUTH.showAlert('No se encontró la solicitud en la base de datos.', 'error'); return; }
        if (!solBase.rfc || !solBase.razon_social || !solBase.cp) {
            BO_AUTH.showAlert('⚠️ La solicitud no tiene RFC o Razón Social completos para timbrar.', 'warning'); return;
        }

        // Detecta Centro Batch (CENTRO-{id}-...) o Centro UUID (nota con centro_apoyo_id o cliente 'Centro%')
        const _isCentroBatch = String(solBase.numero_nota||'').startsWith('CENTRO-');
        const _cliVentaNombreApr = String(solBase._cli_venta_nombre || '').toLowerCase();
        const _isCentroUUID  = !_isCentroBatch && (window._forceCentro || !!(solBase._centro_id) || _cliVentaNombreApr.startsWith('centro'));
        const _isCentroAprobar = _isCentroBatch || _isCentroUUID;
        console.log('[TIMBRADO DEBUG] id:', id, 'numero_nota:', solBase.numero_nota, '_centro_id:', solBase._centro_id, '_cli_venta_nombre:', solBase._cli_venta_nombre, '_isCentroBatch:', _isCentroBatch, '_isCentroUUID:', _isCentroUUID, '_isCentroAprobar:', _isCentroAprobar, '_forceCentro:', window._forceCentro);
        let sol;

        if (_isCentroBatch) {
            if (excludedIds && excludedIds.length > 0 && typeof window._persistirExclusionesSolicitud === 'function') {
                const rExcl = await window._persistirExclusionesSolicitud(id, excludedIds, true, fallbackAllIds);
                if (!rExcl.ok) return;
            }
            // ── CENTRO BATCH: delegar al flujo dedicado de N8N ──
            // N8N construye los items del lado del servidor (misma lógica que Global)
            // para evitar problemas de redondeo de JS con Facturama.
            const centroIdM = String(solBase.numero_nota).match(/^CENTRO-(\d+)/);
            const centroId = centroIdM ? centroIdM[1] : '0';

            // Extraer mesFacturacion de la referencia CENTRO-{id}-YYYY-MM
            const mesMatch = String(solBase.numero_nota).match(/^CENTRO-\d+-(\d{4}-\d{2})/);
            const mesFacturacion = mesMatch ? mesMatch[1] : '';

            // Leer metadata del comentario (soporta tanto formato key=val; como JSON)
            let totalActivosCobrados = 0;
            let esPublicoGeneral = false;
            const mActCom = String(solBase.comentario || '').match(/act=([0-9.]+)/);
            if (mActCom) {
                totalActivosCobrados = parseFloat(mActCom[1]) || 0;
                esPublicoGeneral = String(solBase.comentario || '').includes('pg=1');
            } else {
                try {
                    const metadata = JSON.parse(solBase.comentario || '{}');
                    totalActivosCobrados = parseFloat(metadata.totalActivosCobrados || metadata.act) || 0;
                    esPublicoGeneral = metadata.esPublicoGeneral === true || metadata.pg === true;
                } catch(_) {
                    // Si el comentario no es JSON válido, consultar centro_apoyo_pago directamente
                    if (mesFacturacion) {
                        try {
                            const rAct = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                                // ILIKE para que no falle por mayúsculas/minúsculas del tipo_pago
                                sql: `SELECT COALESCE(SUM(monto),0) as total FROM centro_apoyo_pago WHERE centro_id=${centroId} AND LOWER(tipo_pago) LIKE '%activo%' AND TO_CHAR(creado_en,'YYYY-MM')='${mesFacturacion}'`
                            });
                            totalActivosCobrados = Number(rAct.rows?.[0]?.total || 0);
                        } catch(__) {}
                    }
                }
            }
            // Fallback: usar el valor calculado en el desglose (window._centroActivosCobrados)
            if (totalActivosCobrados === 0 && (window._centroActivosCobrados || 0) > 0) {
                totalActivosCobrados = window._centroActivosCobrados;
                console.log('[TIMBRADO] Usando _centroActivosCobrados del desglose:', totalActivosCobrados);
            }


            // 2. Apartar como en_proceso
            await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                sql: `UPDATE facturas_solicitadas SET estado = 'en_proceso' WHERE id = ${id}`
            });
            loadHistorialFacturas();
            BO_AUTH.showAlert('⏳ Timbrando factura de Centro de Apoyo…', 'info');

            const _pmInfoCentro = _detectPaymentMethod(solBase.comentario || '');
            const _solMonedaCentro = (solBase.moneda || 'MXN').toUpperCase();
            const _solTCCentro = parseFloat(solBase.tipo_cambio) || 0;

            // Retroactivo: usar el último día del mes de facturación solo si es mes pasado y el usuario activó retroactivo
            const _ahoraC = new Date();
            const _mesActualC = _ahoraC.getFullYear() + '-' + String(_ahoraC.getMonth() + 1).padStart(2, '0');
            const _esMesPasadoC = mesFacturacion && mesFacturacion < _mesActualC;
            const _retroFechaCentro = (window._timbradoRetroactivo && _esMesPasadoC)
                ? (()=>{ const [y,m]=mesFacturacion.split('-').map(Number); const d=new Date(y,m,0); return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}T23:50:00`; })()
                : null;
            const _periodicidadCentro = window._fgPeriodicidad || solBase.periodicidad || '04';
            if (window._fgPeriodicidad) {
                await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                    sql: `UPDATE facturas_solicitadas SET periodicidad = '${_periodicidadCentro}' WHERE id = ${id}`
                }).catch(() => {});
            }
            const resCentro = await fetch(BO_API.BASE + '/bo/facturacion/centro/timbrar', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    centroId,
                    solicitudId: id,
                    ventaId: null,
                    mesFacturacion,
                    periodicidad: _periodicidadCentro,
                    totalActivosCobrados,
                    esPublicoGeneral,
                    rfc: solBase.rfc,
                    razonSocial: solBase.razon_social,
                    regimenFiscal: solBase.regimen || '616',
                    usoCfdi: solBase.uso_cfdi || 'G03',
                    cp: solBase.cp || '45050',
                    expeditionPlace: solBase.cp || '45050',
                    formaPago: _pmInfoCentro.form || solBase.forma_pago || '01',
                    moneda: _solMonedaCentro,
                    tipoCambio: _solTCCentro,
                    ...(_retroFechaCentro ? { fechaRetroactivo: _retroFechaCentro } : {})
                })
            });
            const facCentro = await resCentro.json().catch(() => ({}));
            console.log('[CENTRO RESP]', JSON.stringify(facCentro));

            const centroOk = resCentro.ok && (facCentro.ok || facCentro.success) && (facCentro.cfdiId || facCentro.Id || facCentro.id || '').length > 3;

            if (centroOk) {
                const cfdiId = facCentro.cfdiId || facCentro.Id || facCentro.id || '';
                const cfdiUuid = facCentro.uuid || facCentro.Complement?.TaxStamp?.Uuid || '';
                BO_AUTH.showAlert(`✅ CFDI de Centro timbrado exitosamente\nUUID: ${cfdiUuid||cfdiId}`, 'success');
                loadHistorialFacturas();
                if (typeof loadFacturaGlobal === 'function') loadFacturaGlobal();
                setTimeout(() => switchHistorialTab('facturas'), 600);
            } else {
                await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                    sql: `UPDATE facturas_solicitadas SET estado='solicitada' WHERE id=${id}`
                });
                BO_AUTH.showAlert(_parseFacturamaError(facCentro), 'warning');
                loadHistorialFacturas();
            }
            return;
        } else if (_isCentroUUID) {
            // ── CENTRO UUID: también delegar al flujo dedicado de N8N ──
            const centroId = String(solBase._centro_id || '0');
            console.log('[TIMBRADO] ✅ Entrando a branch CENTRO UUID. centroId:', centroId, 'URL:', BO_API.BASE + '/bo/facturacion/centro/timbrar');

            // Leer metadata del comentario (soporta act=XXXX; y JSON)
            let totalActivosCobrados = 0;
            let esPublicoGeneral = false;
            const mActCom = String(solBase.comentario || '').match(/act=([0-9.]+)/);
            if (mActCom) {
                totalActivosCobrados = parseFloat(mActCom[1]) || 0;
                esPublicoGeneral = String(solBase.comentario || '').includes('pg=1');
            } else {
                try {
                    const metadata = JSON.parse(solBase.comentario || '{}');
                    totalActivosCobrados = parseFloat(metadata.totalActivosCobrados || metadata.act) || 0;
                    esPublicoGeneral = metadata.esPublicoGeneral === true || metadata.pg === true;
                } catch(_) {}
            }
            if (totalActivosCobrados === 0 && (window._fgTotalActivos || window._centroActivosCobrados || 0) > 0) {
                totalActivosCobrados = window._fgTotalActivos || window._centroActivosCobrados;
            }

            const _fpModal = window._fgFormaPago;
            const _formaPagoFinal = _fpModal || solBase.forma_pago || _pmInfoCU.form || '01';

            await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                sql: `UPDATE facturas_solicitadas SET estado = 'en_proceso' WHERE id = ${id}`
            });
            loadHistorialFacturas();
            BO_AUTH.showAlert('⏳ Timbrando factura de Centro de Apoyo…', 'info');

            const _pmInfoCU = _detectPaymentMethod(solBase.comentario || '');
            const _solMonedaCU = (solBase.moneda || 'MXN').toUpperCase();
            const _solTCCU = parseFloat(solBase.tipo_cambio) || 0;

            // Retroactivo: usar el último día del mes de facturación (no fecha_venta)
            // mesFacturacion para UUID: inferir del mes anterior (retroactivo) o mes actual
            const _ahoraCU = new Date();
            const _refMesCU = window._timbradoRetroactivo
                ? new Date(_ahoraCU.getFullYear(), _ahoraCU.getMonth() - 1, 1)
                : _ahoraCU;
            const mesFacturacion = _refMesCU.getFullYear() + '-' + String(_refMesCU.getMonth()+1).padStart(2,'0');
            const _retroFechaCU = window._timbradoRetroactivo
                ? (()=>{ const [y,m]=mesFacturacion.split('-').map(Number); const d=new Date(y,m,0); return d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0')+'-'+String(d.getDate()).padStart(2,'0')+'T23:50:00'; })()
                : null;

            const resCU = await fetch(BO_API.BASE + '/bo/facturacion/centro/timbrar', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    centroId,
                    solicitudId: id,
                    ventaId: solBase.numero_nota,
                    mesFacturacion,
                    periodicidad: window._fgPeriodicidad || solBase.periodicidad || '04',
                    totalActivosCobrados,
                    esPublicoGeneral,
                    rfc: solBase.rfc,
                    razonSocial: solBase.razon_social,
                    regimenFiscal: solBase.regimen || '616',
                    usoCfdi: solBase.uso_cfdi || 'G03',
                    cp: solBase.cp || '45050',
                    expeditionPlace: solBase.cp || '45050',
                    formaPago: _formaPagoFinal,
                    solicitudComentario: solBase.comentario || '',
                    moneda: _solMonedaCU,
                    tipoCambio: _solTCCU,
                    ...(_retroFechaCU ? { fechaRetroactivo: _retroFechaCU } : {})
                })
            });
            const facCU = await resCU.json().catch(() => ({}));
            console.log('[CENTRO UUID RESP]', JSON.stringify(facCU));

            const cuOk = resCU.ok && (facCU.ok || facCU.success) && (facCU.cfdiId || facCU.Id || facCU.id || '').length > 3;

            if (cuOk) {
                const cfdiId = facCU.cfdiId || facCU.Id || facCU.id || '';
                const cfdiUuid = facCU.uuid || facCU.Complement?.TaxStamp?.Uuid || '';
                BO_AUTH.showAlert(`✅ CFDI de Centro timbrado exitosamente\nUUID: ${cfdiUuid||cfdiId}`, 'success');
                loadHistorialFacturas();
                if (typeof loadFacturaGlobal === 'function') loadFacturaGlobal();
                setTimeout(() => switchHistorialTab('facturas'), 600);
            } else {
                await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                    sql: `UPDATE facturas_solicitadas SET estado='solicitada' WHERE id=${id}`
                });
                BO_AUTH.showAlert(_parseFacturamaError(facCU), 'warning');
                loadHistorialFacturas();
            }
            return;
        } else {
            const resGet = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                // Calcular monto facturable = total - monto_activos (si los hay)
                // monto_activos se llena en la migración o al crear la venta.
                // Fallback: parsear del comentario o usar monto_facturable si existe.
                sql: `SELECT f.*,
                       CASE
                         WHEN v.monto_activos IS NOT NULL AND v.monto_activos::float > 0
                           THEN v.total::float - v.monto_activos::float
                         WHEN v.monto_facturable IS NOT NULL AND v.monto_facturable::float > 0
                           AND v.monto_facturable::float < v.total::float
                           THEN v.monto_facturable::float
                         ELSE v.total::float
                       END AS monto,
                       v.comentario, v.total AS venta_total,
                       COALESCE(v.monto_activos, 0) AS monto_activos_db
                       FROM facturas_solicitadas f
                       LEFT JOIN venta v ON v.id = f.numero_nota
                       WHERE f.id = ${id}` });
            sol = resGet.rows?.[0];
        }
        if (!sol) { BO_AUTH.showAlert('No se encontró la solicitud en la base de datos.', 'error'); return; }

        // Fix: Si la nota tiene ACTIVOS en el comentario, y sol.monto == sol.venta_total, restarlos del monto facturable
        // Esto previene que una nota pagada parcialmente con activos timbre por el total completo si no se guardó en BD
        if (sol && sol.comentario && Math.abs(Number(sol.monto || 0) - Number(sol.venta_total || 0)) < 1) {
            const _aMatches = [...(sol.comentario.matchAll(/ACTIVOS(?:_[A-Z_]+)?(?:\/[^\s$]+)?[^$]*\$([0-9.,]+)/gi))];
            if (_aMatches.length > 0) {
                const _mAct = _aMatches.reduce((s, m) => s + parseFloat(m[1].replace(/,/g, '')), 0);
                
                // Extraer pago en efectivo del comentario para saber si sol.venta_total ya está descontado
                let cashExplícito = null;
                const parts = sol.comentario.split(/\|\||\n/);
                for (let p of parts) {
                    if (!p.toUpperCase().includes('ACTIVOS')) {
                        const mCash = p.match(/\$([0-9.,]+)/);
                        if (mCash) {
                            cashExplícito = (cashExplícito || 0) + parseFloat(mCash[1].replace(/,/g, ''));
                        }
                    }
                }
                
                // Si el total de la venta es igual al efectivo explícito, significa que el total ya está descontado (Shopify)
                if (cashExplícito !== null && Math.abs(cashExplícito - Number(sol.venta_total)) < 1) {
                    // No restamos activos, porque sol.monto ya es el efectivo real.
                } else {
                    sol.monto = Math.max(0, Number(sol.monto) - _mAct);
                }
            }
        }

        // Verificar crédito pendiente (no aplica a CENTRO — tienen su propio flujo de pago)
        if (sol.comentario && !_isCentroAprobar) {
            const _vCheck = { comentarioRaw: sol.comentario, totalNum: Number(sol.venta_total || sol.monto || 0) };
            const _credAmt = _calcularCreditoVenta(_vCheck);
            if (_credAmt > 0) {
                BO_AUTH.showAlert('🚫 CRÉDITO PENDIENTE: Esta nota tiene $' + _credAmt.toLocaleString('es-MX',{minimumFractionDigits:2}) + ' sin liquidar. No se puede timbrar hasta cobrar el saldo completo.', 'error');
                return;
            }
        }

        const montoBase = Number(sol.monto || 0);
        // Permitir montoBase=0 cuando el pago fue 100% con activos — el subsidio se aplica en _buildFacturamaItems
        if (montoBase < 0) { BO_AUTH.showAlert('El monto facturable de la nota es negativo — verifica los datos.', 'error'); return; }
        if (montoBase === 0 && !sol.comentario?.match(/ACTIVOS/i)) { BO_AUTH.showAlert('No se pudo obtener el monto facturable de la nota.', 'error'); return; }

        // 2. Apartar como en_proceso
        await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
            sql: `UPDATE facturas_solicitadas SET estado = 'en_proceso' WHERE id = ${id}`
        });
        loadHistorialFacturas(); // <- actualiza tabla para reflejar el cambio

        // 3. Construir payload Facturama
        BO_AUTH.showAlert('⏳ Timbrando CFDI en Facturama…', 'info');
        const _pmInfo = _detectPaymentMethod(sol.comentario || '');
        const facItems = await _buildFacturamaItems(sol.numero_nota, montoBase);
        // Centro Batch → CP Matriz; Centro UUID → CP real del centro (si existe); Individual → CP del CEDIS de la venta
        const _expPlace2 = _isCentroBatch ? (sol.cp || '45050')
            : _isCentroUUID ? (sol._centro_cp || sol.cp || '45050')
            : await _getExpeditionPlace(sol.numero_nota);
        const _folioNum2 = String(sol.numero_nota).replace(/[^0-9]/g,'').slice(-6) || String(sol.id);
        const _isPublico2 = sol.rfc === 'XAXX010101000' || sol.rfc === 'XEXX010101000';
        const _solMoneda = (sol.moneda || 'MXN').toUpperCase();
        const _solTC = parseFloat(sol.tipo_cambio) || 0;

        // Retroactivo: último día del MES ANTERIOR a T23:50:00 (patrón Global/Centro)
        const _esRetro = !!window._timbradoRetroactivo;
        const _fechaVentaRaw = sol.fecha_venta || sol.creado_en || null;
        let _fechaCFDI = null;
        if (_esRetro) {
            // Mes anterior al actual
            const _ahora = new Date();
            const _lastDayPrev = new Date(_ahora.getFullYear(), _ahora.getMonth(), 0); // último día del mes anterior
            _fechaCFDI = `${_lastDayPrev.getFullYear()}-${String(_lastDayPrev.getMonth()+1).padStart(2,'0')}-${String(_lastDayPrev.getDate()).padStart(2,'0')}T23:50:00`;
        }
        // Usar el mes anterior para GlobalInformation cuando es retroactivo
        const _refDate = _esRetro ? new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1) : new Date();

        const payload = {
            Receiver: { Rfc: sol.rfc, Name: sol.razon_social, CfdiUse: sol.uso_cfdi, FiscalRegime: sol.regimen, TaxZipCode: sol.cp },
            CfdiType: 'I', NameId: '1',
            Currency: _solMoneda,
            ...(_solMoneda !== 'MXN' && _solTC > 0 ? { CurrencyExchangeRate: _solTC.toFixed(4) } : {}),
            ...(_fechaCFDI ? { Date: _fechaCFDI } : {}),
            Folio: _folioNum2,
            ExpeditionPlace: _expPlace2,
            PaymentForm: (window._timbradoMetodoPago === 'PPD') ? '99' : (_pmInfo.form || (sol.forma_pago === '99' ? '01' : (sol.forma_pago || '01'))),
            PaymentMethod: window._timbradoMetodoPago || _pmInfo.method || 'PUE',
            Items: facItems,
            ...(_isPublico2 ? { GlobalInformation: {
                Periodicity: '04',
                Months: String(_refDate.getMonth() + 1).padStart(2, '0'),
                Year: String(_refDate.getFullYear())
            } } : {}),
            _meta: { solicitudId: id, numeroNota: sol.numero_nota }
        };

        console.log('[CFDI PAYLOAD]', JSON.stringify(payload, null, 2));

        // 4. Llamar a Facturama vía n8n
        const respFac = await fetch(BO_API.BASE + '/bo/factura/emitir', {
            method: 'POST',
            headers: BO_API._headers(),
            body: JSON.stringify(payload)
        });
        const fac = await respFac.json().catch(() => ({}));
        console.log('[FACTURAMA RESP]', JSON.stringify(fac));

        // El workflow de n8n ahora se encarga del fallback y de guardar en la BD.
        const facOk = respFac.ok && fac.ok && (fac.cfdiId || fac.Id || fac.id || '').length > 3;

        if (facOk) {
            const cfdiId = fac.cfdiId || fac.Id || fac.id || '';
            const cfdiUuid = fac.uuid || fac.Complement?.TaxStamp?.Uuid || '';
            const fechaCert = fac.Complement?.TaxStamp?.Date || fac.Date || null;
            const _metodoFinal = payload.PaymentMethod || 'PUE';
            const _formaFinal = payload.PaymentForm || '01';
            const _totalFactura = +(facItems.reduce((s, i) => s + (i.Total || 0), 0)).toFixed(2) || montoBase;
            const _saldoIns = (_metodoFinal === 'PPD') ? _totalFactura : 0.00;
            const _saldoPag = (_metodoFinal === 'PPD') ? 0.00 : _totalFactura;

            // ✅ Safety net: actualizar BD desde el frontend con trazabilidad PPD.
            try {
                const _fechaCertSql = fechaCert ? `, fecha_certificacion='${fechaCert}'` : '';
                await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                    sql: `UPDATE facturas_solicitadas SET estado='facturada', cfdi_id='${cfdiId}', cfdi_uuid='${cfdiUuid}', ventas_ids='${JSON.stringify([sol.numero_nota])}', metodo_pago='${_metodoFinal}', forma_pago='${_formaFinal}', saldo_original=${_totalFactura}, saldo_pagado=${_saldoPag}, saldo_insoluto=${_saldoIns}, total_parcialidades=0${_fechaCertSql} WHERE id=${id};` +
                         `UPDATE venta SET factura_emitida=true, factura_uuid='${cfdiUuid||cfdiId}' WHERE id='${sol.numero_nota}';`
                });
            } catch(dbErr) { console.warn('[DB Safety Net]', dbErr); }

            // Marcar ventas del centro según el tipo
            if (_isCentroBatch) {
                // Batch: marcar TODAS las ventas del centro
                const centroIdPost = String(sol.numero_nota).match(/^CENTRO-(\d+)/)?.[1] || '0';
                try {
                    await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                        sql: `UPDATE venta SET factura_emitida = true, requiere_factura = false
                              WHERE centro_apoyo_id = '${centroIdPost}'
                                AND requiere_factura = false AND approved = 1
                                AND (factura_emitida = false OR factura_emitida IS NULL)`
                    });
                } catch(_) {}
            } else if (_isCentroUUID) {
                // UUID individual de centro: solo esa venta (el safety net ya la marcó arriba)
                // No hace falta nada extra — el UPDATE en el safety net es suficiente
            }
            
            BO_AUTH.showAlert(`✅ CFDI timbrado exitosamente\nUUID: ${cfdiUuid||cfdiId}`, 'success');
            loadHistorialFacturas();
            if (typeof loadFacturaGlobal === 'function') loadFacturaGlobal();
            // Auto-cambiar al tab de Facturas del Mes
            setTimeout(() => switchHistorialTab('facturas'), 600);
        } else {
            // ❌ Timbrado falló — n8n no lo guardó. Revertir a solicitada.
            await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                sql: `UPDATE facturas_solicitadas SET estado='solicitada' WHERE id=${id}`
            });
            BO_AUTH.showAlert(_parseFacturamaError(fac), 'warning');
            loadHistorialFacturas();
        }
    } catch(e) {
        // Error de red: revertir
        try { await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: `UPDATE facturas_solicitadas SET estado='solicitada' WHERE id=${id}` }); } catch(_){}
        BO_AUTH.showAlert('⚠️ Error de red al timbrar. Solicitud revertida a pendiente.\n' + e.message, 'warning');
        loadHistorialFacturas();
    }
}

// ── Facturación — Persistencia de exclusiones de notas en solicitudes pendientes ──

window._persistirExclusionesSolicitud = async function(solicitudId, excludedIds, silent = false, fallbackAllIds = null) {
    if (!excludedIds || !excludedIds.length) return { ok: true, keptIds: null };
    try {
        const resSol = await BO_API.post('/bo/sql-relay', {
            secret: 'duletia_relay_2026',
            sql: `SELECT id, ventas_ids, comentario, numero_nota, estado FROM facturas_solicitadas WHERE id = ${Number(solicitudId)}`
        });
        const solRow = resSol.rows?.[0];
        if (!solRow) {
            if (!silent) BO_AUTH.showAlert('No se encontró la solicitud para actualizar sus notas.', 'error');
            return { ok: false };
        }
        if (solRow.estado === 'facturada' || solRow.estado === 'cancelada') {
            if (!silent) BO_AUTH.showAlert('⚠️ Esta solicitud ya fue procesada; usa Sustituir para liberar notas.', 'warning');
            return { ok: false };
        }

        let currentIds = [];
        if (solRow.ventas_ids) {
            try {
                const parsed = typeof solRow.ventas_ids === 'string' ? JSON.parse(solRow.ventas_ids) : solRow.ventas_ids;
                if (Array.isArray(parsed)) currentIds = parsed.map(String);
            } catch (_) {}
        }
        if (currentIds.length === 0 && Array.isArray(fallbackAllIds) && fallbackAllIds.length > 0) {
            currentIds = fallbackAllIds.map(String);
        }

        const exclSet = new Set(excludedIds.map(String));
        const keptIds = currentIds.filter(id => !exclSet.has(String(id)));

        if (currentIds.length > 0 && keptIds.length === 0) {
            BO_AUTH.showAlert('⚠️ Debes conservar al menos 1 nota en la solicitud (o rechaza la solicitud completa con ✕).', 'warning');
            return { ok: false };
        }

        const inExcluded = excludedIds.map(id => "'" + String(id).replace(/'/g, "''") + "'").join(',');
        await BO_API.post('/bo/sql-relay', {
            secret: 'duletia_relay_2026',
            sql: `UPDATE venta SET requiere_factura = false WHERE id IN (${inExcluded})`
        });

        if (currentIds.length > 0) {
            let nuevoCom = String(solRow.comentario || '');
            if (/n=\d+/.test(nuevoCom)) {
                nuevoCom = nuevoCom.replace(/n=\d+/, 'n=' + keptIds.length);
            }
            if (typeof window._fgTotalFacturable === 'number' && /cfdi=[0-9.]+/.test(nuevoCom)) {
                nuevoCom = nuevoCom.replace(/cfdi=[0-9.]+/, 'cfdi=' + window._fgTotalFacturable);
            }
            const keptJsonEsc = JSON.stringify(keptIds).replace(/'/g, "''");
            const comEsc = nuevoCom.replace(/'/g, "''");
            await BO_API.post('/bo/sql-relay', {
                secret: 'duletia_relay_2026',
                sql: `UPDATE facturas_solicitadas SET ventas_ids = '${keptJsonEsc}', comentario = '${comEsc}' WHERE id = ${Number(solicitudId)}`
            });
        }

        window._fgExcludedIds = [];
        window._fgExcludedIdsUSD = [];

        if (!silent) {
            BO_AUTH.showAlert(`✅ ${excludedIds.length} nota(s) desvinculada(s) de la solicitud #${solicitudId}.${keptIds.length ? ' Quedan ' + keptIds.length + ' nota(s) en la solicitud.' : ''}`, 'success');
            loadHistorialFacturas();
            if (typeof loadFacturaGlobal === 'function') loadFacturaGlobal();
        }
        return { ok: true, keptIds };
    } catch (err) {
        console.error('[PERSISTIR EXCLUSIONES] Error:', err);
        if (!silent) BO_AUTH.showAlert('Error al guardar exclusiones: ' + (err.message || err), 'error');
        return { ok: false };
    }
};

window._guardarExclusionesModalGlobal = async function(solicitudId, isUSD = false) {
    const excl = isUSD ? (window._fgExcludedIdsUSD || []) : (window._fgExcludedIds || []);
    if (!excl.length) return;
    const allIds = isUSD
        ? (window._fgUsdAllVentas || []).map(v => v.id)
        : (window._fgAllVentas || []).map(v => v.id);
    const r = await window._persistirExclusionesSolicitud(solicitudId, excl, false, allIds);
    if (!r.ok) return;
    document.getElementById(isUSD ? 'modal-global-usd-desglose' : 'modal-global-desglose')?.remove();
    verSolicitudGlobal(solicitudId);
};

window._cerrarModalGlobalDesglose = async function(solicitudId, isUSD = false, canEdit = false) {
    const excl = isUSD ? (window._fgExcludedIdsUSD || []) : (window._fgExcludedIds || []);
    const modalId = isUSD ? 'modal-global-usd-desglose' : 'modal-global-desglose';
    if (canEdit && excl.length > 0) {
        const guardar = confirm(
            `Desmarcaste ${excl.length} nota(s) en este desglose.\n\n` +
            `¿Deseas guardar estos cambios y desvincularlas de la solicitud #${solicitudId} antes de cerrar?\n` +
            `(Aceptar = Guardar exclusiones en base de datos | Cancelar = Cerrar sin cambios)`
        );
        if (guardar) {
            const allIds = isUSD
                ? (window._fgUsdAllVentas || []).map(v => v.id)
                : (window._fgAllVentas || []).map(v => v.id);
            const r = await window._persistirExclusionesSolicitud(solicitudId, excl, false, allIds);
            if (!r.ok) return;
        } else {
            window._fgExcludedIds = [];
            window._fgExcludedIdsUSD = [];
        }
    }
    document.getElementById(modalId)?.remove();
};

// ── Facturación — Modal de confirmación de timbrado (con toggle retroactivo) ──

function confirmarTimbrado(id, tipo, excludedIds = [], metodoPagoPreseleccionado = 'PUE', fromModal = false) {
    if (!fromModal) {
        // Evitar fuga de montos/activos/formaPago de un modal de desglose abierto previamente
        window._fgTotalActivos = null;
        window._fgTotalFacturable = null;
        window._fgFormaPago = null;
        window._fgPeriodicidad = null;
        window._centroActivosCobrados = 0;
        window._fgExcludedIds = [];
        window._fgExcludedIdsUSD = [];
    }
    window._pendingExcludedIds = Array.isArray(excludedIds) ? excludedIds.slice() : [];
    window._pendingFallbackAllIds = fromModal
        ? (((window._fgUsdAllVentas && window._fgUsdAllVentas.length ? window._fgUsdAllVentas : window._fgAllVentas) || []).map(v => v.id))
        : null;

    const existente = document.getElementById('modalConfirmarTimbrado');
    if (existente) existente.remove();

    const isGlobal = (tipo === 'global');

    // Auto-detectar si el folio de la solicitud pertenece al mes anterior y sigue dentro de las 72h SAT
    const _solItem = (window._factPendItems || []).find(x => String(x.id) === String(id));
    const _notaRef = String(_solItem?.numero_nota || (fromModal ? (window._fgCurrentNumeroNota || '') : '') || '');
    const _mMesRef = _notaRef.match(/(?:GLOBAL|CENTRO)[^0-9]*(\d{4}-\d{2})/);
    const _ahoraConf = new Date();
    const _mesActualConf = _ahoraConf.getFullYear() + '-' + String(_ahoraConf.getMonth() + 1).padStart(2, '0');
    let _autoRetro = false;
    let _retroFechaPreview = '';
    if (_mMesRef && _mMesRef[1] < _mesActualConf) {
        const [_ry, _rm] = _mMesRef[1].split('-').map(Number);
        const _inicioSig = new Date(_ry, _rm, 1);
        const _horas = (_ahoraConf - _inicioSig) / (1000 * 60 * 60);
        const _lastD = new Date(_ry, _rm, 0);
        _retroFechaPreview = `${_lastD.getFullYear()}-${String(_lastD.getMonth() + 1).padStart(2, '0')}-${String(_lastD.getDate()).padStart(2, '0')} 23:50:00`;
        if (_horas <= 72) _autoRetro = true;
    } else {
        const _lastPrev = new Date(_ahoraConf.getFullYear(), _ahoraConf.getMonth(), 0);
        _retroFechaPreview = `${_lastPrev.getFullYear()}-${String(_lastPrev.getMonth() + 1).padStart(2, '0')}-${String(_lastPrev.getDate()).padStart(2, '0')} 23:50:00`;
    }
    const _exclCount = window._pendingExcludedIds.length;

    const modal = document.createElement('div');
    modal.id = 'modalConfirmarTimbrado';
    modal.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.75);z-index:9999;display:flex;align-items:center;justify-content:center;';
    modal.innerHTML = `
      <div style="background:#1a1a2e;border:1px solid rgba(255,255,255,.15);border-radius:16px;
                  padding:1.5rem;max-width:440px;width:92%;box-shadow:0 20px 60px rgba(0,0,0,.6);">
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:1.25rem;">
          <h3 style="margin:0;font-size:1rem;font-weight:700;color:#fff;">⚡ Confirmar Timbrado</h3>
          <button onclick="document.getElementById('modalConfirmarTimbrado').remove()"
                  style="background:none;border:none;color:rgba(255,255,255,.5);cursor:pointer;font-size:1.3rem;line-height:1;">✕</button>
        </div>

        ${_exclCount > 0 ? `
        <div style="background:rgba(249,115,22,.1);border:1px solid rgba(249,115,22,.35);border-radius:10px;padding:.7rem .85rem;margin-bottom:1rem;font-size:.76rem;color:#fdba74;line-height:1.4;">
          🙈 Se desvincularán <b>${_exclCount} nota(s)</b> excluidas en el desglose antes de timbrar ante el SAT.
        </div>` : ''}

        <!-- Selector Método de Pago PUE vs PPD -->
        ${isGlobal ? `
        <div style="background:rgba(255,255,255,.03);border:1px solid rgba(255,255,255,.1);border-radius:10px;padding:.85rem;margin-bottom:1rem;">
          <div style="display:flex;justify-content:space-between;align-items:center;">
            <span style="font-size:.78rem;font-weight:700;color:#38bdf8;">💳 Método de Pago:</span>
            <span class="badge" style="background:rgba(34,197,94,.15);color:#4ade80;font-weight:700;padding:2px 8px;border-radius:99px;font-size:.7rem;">PUE — Contado</span>
          </div>
          <p style="margin:.35rem 0 0;font-size:.68rem;color:var(--text-dim);line-height:1.35;">Obligatorio SAT Anexo 20 (Regla 2.7.1.21) para facturación global de público en general.</p>
        </div>
        ` : `
        <div style="background:rgba(255,255,255,.03);border:1px solid rgba(255,255,255,.1);border-radius:10px;padding:.85rem;margin-bottom:1rem;">
          <label style="font-weight:700;font-size:.8rem;color:#38bdf8;display:block;margin-bottom:.45rem;">
            💳 Método de Pago SAT:
          </label>
          <div style="display:flex;gap:1.2rem;align-items:center;">
            <label style="display:flex;align-items:center;gap:.35rem;font-size:.82rem;cursor:pointer;color:#fff;">
              <input type="radio" name="chk-metodo-confirm" id="rad-pue-confirm" value="PUE" ${metodoPagoPreseleccionado === 'PPD' ? '' : 'checked'} onchange="document.getElementById('aviso-ppd-confirm').style.display = this.checked ? 'none' : 'block'">
              <span><strong>PUE</strong> (Contado)</span>
            </label>
            <label style="display:flex;align-items:center;gap:.35rem;font-size:.82rem;cursor:pointer;color:#fbbf24;">
              <input type="radio" name="chk-metodo-confirm" id="rad-ppd-confirm" value="PPD" ${metodoPagoPreseleccionado === 'PPD' ? 'checked' : ''} onchange="document.getElementById('aviso-ppd-confirm').style.display = this.checked ? 'block' : 'none'">
              <span><strong>PPD</strong> (Crédito)</span>
            </label>
          </div>
          <div id="aviso-ppd-confirm" style="display:${metodoPagoPreseleccionado === 'PPD' ? 'block' : 'none'};margin-top:.45rem;font-size:.72rem;color:#fbbf24;line-height:1.4;">
            ℹ️ Se timbrará con <strong>Forma 99</strong> y pasará directo a la <strong>Cartera PPD</strong> para emitirle Complementos REP 2.0.
          </div>
        </div>
        `}

        <div style="background:rgba(234,179,8,.07);border:1px solid rgba(234,179,8,.25);
                    border-radius:10px;padding:1rem;margin-bottom:1.25rem;">
          <div style="display:flex;align-items:center;justify-content:space-between;gap:.75rem;">
            <div>
              <div style="font-weight:600;font-size:.9rem;color:var(--accent-gold);">⏰ Facturación Retroactiva</div>
              <div style="font-size:.75rem;color:var(--text-dim);margin-top:2px;">Emitir CFDI con fecha del mes anterior</div>
            </div>
            <label style="position:relative;display:inline-block;width:46px;height:24px;flex-shrink:0;cursor:pointer;">
              <input type="checkbox" id="chk-retroactivo-confirm" ${_autoRetro ? 'checked' : ''} onchange="onToggleRetroactivoConfirm()"
                     style="opacity:0;width:0;height:0;position:absolute;">
              <span id="slider-retroactivo-bg" style="position:absolute;inset:0;background:${_autoRetro ? '#f59e0b' : '#374151'};border-radius:24px;transition:.25s;display:block;"></span>
              <span id="knob-retroactivo" style="position:absolute;height:18px;width:18px;left:3px;bottom:3px;
                   background:white;border-radius:50%;transition:.25s;display:block;transform:${_autoRetro ? 'translateX(22px)' : 'translateX(0)'};"></span>
            </label>
          </div>
          <div id="warn-retroactivo" style="display:${_autoRetro ? 'block' : 'none'};margin-top:.75rem;font-size:.75rem;
               color:#fbbf24;border-top:1px solid rgba(234,179,8,.2);padding-top:.75rem;line-height:1.5;">
            ⚠️ <b>Plazo máximo 72h (Regla SAT 2.7.2.9)</b><br>
            El CFDI se timbrará con fecha de cierre <b>${_retroFechaPreview}</b>.<br>
            Si han pasado más de 72h Facturama lo rechazará.
          </div>
        </div>

        <div style="display:flex;gap:.75rem;">
          <button onclick="document.getElementById('modalConfirmarTimbrado').remove()"
                  class="btn btn-outline" style="flex:1;">Cancelar</button>
          <button class="btn btn-success" style="flex:1;background:linear-gradient(135deg,#10b981,#059669);"
                  onclick="ejecutarTimbrado(${id}, '${tipo}')">
            ⚡ Timbrar
          </button>
        </div>
      </div>
    `;
    document.body.appendChild(modal);
}

function onToggleRetroactivoConfirm() {
    const cb   = document.getElementById('chk-retroactivo-confirm');
    const warn = document.getElementById('warn-retroactivo');
    const bg   = document.getElementById('slider-retroactivo-bg');
    const knob = document.getElementById('knob-retroactivo');
    const on   = cb?.checked;
    if (warn) warn.style.display = on ? 'block' : 'none';
    if (bg)   bg.style.background = on ? '#f59e0b' : '#374151';
    if (knob) knob.style.transform = on ? 'translateX(22px)' : 'translateX(0)';
}

async function ejecutarTimbrado(id, tipo) {
    const esRetroactivo = document.getElementById('chk-retroactivo-confirm')?.checked || false;
    const radPpd = document.getElementById('rad-ppd-confirm');
    const metodoElegido = (radPpd && radPpd.checked) ? 'PPD' : 'PUE';
    const excl = window._pendingExcludedIds || [];
    const fallbackAll = window._pendingFallbackAllIds || null;
    document.getElementById('modalConfirmarTimbrado')?.remove();
    window._timbradoRetroactivo = esRetroactivo;
    window._timbradoMetodoPago = metodoElegido;
    try {
        if (tipo === 'global') {
            await aprobarSolicitudGlobal(id, excl, fallbackAll);
        } else if (tipo === 'centro') {
            await timbrarCentroDirecto(id, excl, fallbackAll);
        } else {
            await aprobarSolicitudFactura(id, excl, fallbackAll);
        }
    } finally {
        window._timbradoRetroactivo = false;
        window._timbradoMetodoPago = 'PUE';
        window._pendingExcludedIds = [];
        window._pendingFallbackAllIds = null;
    }
}

// ── TIMBRAR CENTRO DIRECTO ──────────────────────────────────────────────────
// Función dedicada que llama al webhook de centro sin pasar por aprobarSolicitudFactura.
// Así se evitan problemas de detección/routing.
async function timbrarCentroDirecto(id, excludedIds = [], fallbackAllIds = null) {
    try {
        // 0. Persistir exclusiones de notas en BD antes de consultar/timbrar
        if (excludedIds && excludedIds.length > 0 && typeof window._persistirExclusionesSolicitud === 'function') {
            const rExcl = await window._persistirExclusionesSolicitud(id, excludedIds, true, fallbackAllIds);
            if (!rExcl.ok) return;
        }

        // 1. Obtener datos de la solicitud
        const resSol = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
            sql: `SELECT f.*, v.centro_apoyo_id AS _centro_id
                  FROM facturas_solicitadas f
                  LEFT JOIN venta v ON v.id::text = f.numero_nota
                  WHERE f.id = ${id}` });
        const sol = resSol.rows?.[0];
        if (!sol) { BO_AUTH.showAlert('No se encontró la solicitud.', 'error'); return; }
        if (!sol.rfc || !sol.razon_social) {
            BO_AUTH.showAlert('⚠️ La solicitud no tiene RFC o Razón Social completos.', 'warning'); return;
        }

        const _numNota = String(sol.numero_nota || '');
        const _isBatch = _numNota.startsWith('CENTRO-');

        // Para batch (CENTRO-13-2026-07): extraer centroId y mes del numero_nota
        // Para UUID: usar el _centro_id del JOIN con venta
        const centroId = _isBatch
            ? (_numNota.match(/^CENTRO-(\d+)/)?.[1] || '0')
            : String(sol._centro_id || '0');

        // Para batch el ventaId es null (se buscan todas las ventas del centro+mes)
        // Para UUID el ventaId es el propio UUID
        const ventaIdParam = _isBatch ? null : _numNota;

        // Para batch: usar el mes del numero_nota (CENTRO-13-2026-07 → 2026-07)
        // Para UUID con retroactivo: mes anterior; sin retroactivo: mes actual
        let mesFacturacion;
        if (_isBatch) {
            mesFacturacion = _numNota.match(/^CENTRO-\d+-(\d{4}-\d{2})/)?.[1] || '';
        } else {
            const _ahora = new Date();
            const _refMes = window._timbradoRetroactivo
                ? new Date(_ahora.getFullYear(), _ahora.getMonth() - 1, 1)
                : _ahora;
            mesFacturacion = _refMes.getFullYear() + '-' + String(_refMes.getMonth()+1).padStart(2,'0');
        }

        console.log('[TIMBRAR CENTRO DIRECTO] id:', id, '_isBatch:', _isBatch, 'centroId:', centroId, 'ventaId:', ventaIdParam, 'mes:', mesFacturacion);

        // 2. Marcar en_proceso
        await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
            sql: `UPDATE facturas_solicitadas SET estado = 'en_proceso' WHERE id = ${id}`
        });
        loadHistorialFacturas();
        BO_AUTH.showAlert('⏳ Timbrando factura de Centro de Apoyo…', 'info');

        // 3. Preparar datos
        let _actFromSol = 0;
        let _esPgFromSol = false;
        const mAct = String(sol.comentario || '').match(/act=([0-9.]+)/);
        if (mAct) {
            _actFromSol = parseFloat(mAct[1]) || 0;
            _esPgFromSol = String(sol.comentario || '').includes('pg=1');
        } else {
            try {
                const metadata = JSON.parse(sol.comentario || '{}');
                _actFromSol = parseFloat(metadata.totalActivosCobrados || metadata.act) || 0;
                _esPgFromSol = metadata.esPublicoGeneral === true || metadata.pg === true;
            } catch(_) {}
        }

        const _fpModal = window._fgFormaPago;
        const _formaPagoFinal = _fpModal || sol.forma_pago || _pmInfo.form || '01';
        const _periodicidadFinal = window._fgPeriodicidad || sol.periodicidad || '04';
        if (window._fgPeriodicidad) {
            await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                sql: `UPDATE facturas_solicitadas SET periodicidad = '${_periodicidadFinal}' WHERE id = ${id}`
            }).catch(() => {});
        }
        const _totalActivosCobrados = typeof window._fgTotalActivos === 'number'
            ? window._fgTotalActivos
            : (_actFromSol || (typeof window._centroActivosCobrados === 'number' ? window._centroActivosCobrados : 0));
        const _totalFacturableFinal = typeof window._fgTotalFacturable === 'number'
            ? window._fgTotalFacturable
            : null;

        const _moneda = (sol.moneda || 'MXN').toUpperCase();
        const _tc = parseFloat(sol.tipo_cambio) || 0;
        // Solo retroactivo si el usuario lo activó explícitamente Y el mes es anterior al actual (evita fechas futuras en mes en curso)
        const _ahoraCD = new Date();
        const _mesActualCD = _ahoraCD.getFullYear() + '-' + String(_ahoraCD.getMonth() + 1).padStart(2, '0');
        const _esMesPasadoCD = mesFacturacion && mesFacturacion < _mesActualCD;
        const _retroFecha = (window._timbradoRetroactivo && _esMesPasadoCD)
            ? (()=>{ const [y,m]=mesFacturacion.split('-').map(Number); const d=new Date(y,m,0); return d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0')+'-'+String(d.getDate()).padStart(2,'0')+'T23:50:00'; })()
            : null;

        // 4. LLAMAR DIRECTO al webhook de CENTRO
        const url = BO_API.BASE + '/bo/facturacion/centro/timbrar';
        console.log('[TIMBRAR CENTRO DIRECTO] Calling:', url, 'body:', JSON.stringify({ centroId, ventaId: ventaIdParam, mesFacturacion, periodicidad: _periodicidadFinal, formaPago: _formaPagoFinal, totalActivosCobrados: _totalActivosCobrados }));
        const res = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                centroId,
                solicitudId: id,
                ventaId: ventaIdParam,
                mesFacturacion,
                periodicidad: _periodicidadFinal,
                rfc: sol.rfc,
                razonSocial: sol.razon_social,
                regimenFiscal: sol.regimen || '616',
                usoCfdi: sol.uso_cfdi || 'G03',
                cp: sol.cp || '45050',
                expeditionPlace: sol.cp || '45050',
                metodoPago: window._timbradoMetodoPago || 'PUE',
                formaPago: (window._timbradoMetodoPago === 'PPD') ? '99' : _formaPagoFinal,
                totalActivosCobrados: _totalActivosCobrados,
                esPublicoGeneral: _esPgFromSol,
                solicitudComentario: sol.comentario || '',
                ...(_totalFacturableFinal !== null ? { totalFacturable: _totalFacturableFinal } : {}),
                moneda: _moneda,
                tipoCambio: _tc,
                ...(_retroFecha ? { fechaRetroactivo: _retroFecha } : {})
            })
        });
        const fac = await res.json().catch(() => ({}));
        console.log('[TIMBRAR CENTRO DIRECTO] Response:', JSON.stringify(fac));

        // 5. Procesar resultado
        const ok = res.ok && (fac.ok || fac.success) && (fac.cfdiId || fac.Id || fac.id || '').length > 3;
        if (ok) {
            const cfdiId = fac.cfdiId || fac.Id || fac.id || '';
            const cfdiUuid = fac.uuid || fac.Complement?.TaxStamp?.Uuid || '';
            const _metodoFinalC = window._timbradoMetodoPago || 'PUE';
            const _formaFinalC = (_metodoFinalC === 'PPD') ? '99' : _formaPagoFinal;
            const _montoFinalC = _totalFacturableFinal || sol.monto || 0;
            const _saldoInsC = (_metodoFinalC === 'PPD') ? _montoFinalC : 0.00;
            const _saldoPagC = (_metodoFinalC === 'PPD') ? 0.00 : _montoFinalC;
            await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                sql: `UPDATE facturas_solicitadas SET metodo_pago='${_metodoFinalC}', forma_pago='${_formaFinalC}', saldo_original=${_montoFinalC}, saldo_pagado=${_saldoPagC}, saldo_insoluto=${_saldoInsC}, total_parcialidades=0 WHERE id=${id};`
            }).catch(() => {});
            BO_AUTH.showAlert(`✅ CFDI de Centro timbrado exitosamente\nUUID: ${cfdiUuid||cfdiId}`, 'success');
            loadHistorialFacturas();
            if (typeof loadFacturaGlobal === 'function') loadFacturaGlobal();
            setTimeout(() => switchHistorialTab('facturas'), 600);
        } else {
            await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                sql: `UPDATE facturas_solicitadas SET estado='solicitada' WHERE id=${id}`
            });
            BO_AUTH.showAlert(_parseFacturamaError(fac), 'warning');
            loadHistorialFacturas();
        }
    } catch (err) {
        console.error('[TIMBRAR CENTRO DIRECTO] Error:', err);
        await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
            sql: `UPDATE facturas_solicitadas SET estado='solicitada' WHERE id=${id}`
        }).catch(() => {});
        BO_AUTH.showAlert('Error al timbrar centro: ' + (err.message || err), 'error');
        loadHistorialFacturas();
    }
}

// ── Facturación — Rechazar solicitud (Admin/Master) ──────────────────────────

async function rechazarSolicitudFactura(id) {
    try {
        const sqlSol = `SELECT numero_nota, ventas_ids, cfdi_id, cfdi_uuid, estado FROM facturas_solicitadas WHERE id = ${id}`;
        const resSol = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlSol });
        const solData = resSol.rows?.[0];

        // 🔒 CANDADO FISCAL: Si la solicitud ya fue timbrada ante el SAT, NO se puede rechazar en BD
        if (solData?.cfdi_id || solData?.cfdi_uuid || solData?.estado === 'facturada') {
            alert('🚫 Esta solicitud ya cuenta con un CFDI emitido ante el SAT (ID: ' + (solData.cfdi_uuid || solData.cfdi_id) + ').\n\nNo se puede "Rechazar" directamente porque devolvería la nota a la Factura Global y se duplicaría ante el SAT.\n\nDebes cancelarla oficialmente ante el SAT con el botón "Cancelar SAT".');
            return;
        }

        if (!confirm('¿Rechazar esta solicitud de factura?\n\nLa nota volverá a estar disponible en el borrador global.')) return;
        const numNota = solData?.numero_nota;
        const ventasIdsStr = solData?.ventas_ids;

        // Cambiar estado a rechazada
        await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
            sql: `UPDATE facturas_solicitadas SET estado = 'cancelada' WHERE id = ${id}` });

        // Intentar revertir por ventas_ids exactas si existen
        let ids;
        try { ids = ventasIdsStr ? JSON.parse(ventasIdsStr) : null; } catch(e) { ids = null; }

        if (Array.isArray(ids) && ids.length > 0) {
            const idList = ids.map(v => `'${v}'`).join(',');
            await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                sql: `UPDATE venta SET factura_emitida = false, factura_uuid = NULL, requiere_factura = false WHERE id IN (${idList})` });
            BO_AUTH.showAlert(`Solicitud #${id} rechazada — ${ids.length} notas devueltas al borrador global`, 'warning');
        } else if (numNota && String(numNota).startsWith('GLOBAL-')) {
            // ── GLOBAL Fallback por rango de fecha
            const parts = numNota.match(/GLOBAL-(\d{4})-(\d{2})/);
            if (parts) {
                const yyyy = parts[1], mm = parts[2];
                const lastDay = new Date(parseInt(yyyy), parseInt(mm), 0).getDate();
                const mesInicio = `${yyyy}-${mm}-01`;
                const mesFin = `${yyyy}-${mm}-${String(lastDay).padStart(2,'0')}`;
                await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                    sql: `UPDATE venta SET factura_emitida = false, factura_uuid = NULL, requiere_factura = false WHERE approved = 1 AND fecha_venta BETWEEN '${mesInicio}' AND '${mesFin}' AND (factura_uuid IS NULL OR factura_uuid = '')` });
            } else {
                await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                    sql: `UPDATE venta SET factura_emitida = false, factura_uuid = NULL, requiere_factura = false WHERE approved = 1 AND (factura_uuid IS NULL OR factura_uuid = '')` });
            }
            BO_AUTH.showAlert('Solicitud GLOBAL rechazada — notas devueltas al borrador global', 'warning');
        } else if (numNota && String(numNota).startsWith('CENTRO-')) {
            // ── CENTRO-*
            const centroIdR = String(numNota).match(/^CENTRO-(\d+)/)?.[1] || '0';
            await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                sql: `UPDATE venta SET factura_emitida = false, factura_uuid = NULL, requiere_factura = false WHERE centro_apoyo_id = '${centroIdR}' AND approved = 1 AND (factura_uuid IS NULL OR factura_uuid = '')` });
            BO_AUTH.showAlert('Solicitud CENTRO rechazada — notas del centro devueltas al borrador', 'warning');
        } else if (numNota) {
            // ── Individual
            await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                sql: `UPDATE venta SET factura_emitida = false, factura_uuid = NULL, requiere_factura = false WHERE id = '${numNota}'` });
            BO_AUTH.showAlert('Solicitud rechazada — nota devuelta al borrador global', 'warning');
        }

        loadHistorialFacturas();
        if (typeof loadFacturaGlobal === 'function') loadFacturaGlobal();
        if (typeof cargarNotasSinFacturar === 'function') cargarNotasSinFacturar(_facClienteIdFilter);
    } catch(e) {
        BO_AUTH.showAlert('Error: ' + e.message, 'error');
    }
}


// ── Facturación — Modal de revisión de solicitud ─────────────────────────────
async function verSolicitudFactura(id) {
    // ── Query 1: datos de solicitud + venta + cliente (sin columnas opcionales) ──
    let sol;
    try {
        // Primero traer la solicitud sola para saber el numero_nota
        const rSol = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
            sql: `SELECT id, usuario_id, rfc, razon_social, cp, regimen, uso_cfdi, forma_pago, numero_nota, estado, moneda, tipo_cambio
                   FROM facturas_solicitadas WHERE id = ${id}`
        });
        const solBase = rSol.rows?.[0];
        if (!solBase) { BO_AUTH.showAlert('Solicitud #' + id + ' no encontrada.', 'error'); return; }

        const _isCentroSol = String(solBase.numero_nota||'').startsWith('CENTRO-');
        const _isGlobalSol = String(solBase.numero_nota||'').startsWith('GLOBAL');

        if (_isCentroSol) {
            // CENTRO-*: agregar datos de ventas vinculadas por centro_apoyo_id
            const centroIdM = String(solBase.numero_nota).match(/^CENTRO-(\d+)/);
            const centroId = centroIdM ? centroIdM[1] : '0';
            const rV = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                sql: `SELECT SUM(COALESCE(monto_facturable::float, total::float)) AS monto,
                             MIN(fecha_venta) AS fecha_venta,
                             SUM(total::float) AS venta_total,
                             STRING_AGG(COALESCE(comentario,''), ' | ') AS comentario
                      FROM venta
                      WHERE centro_apoyo_id = '${centroId}'
                        AND requiere_factura = false AND approved = 1
                        AND (factura_emitida = false OR factura_emitida IS NULL)`
            });
            const vAgg = rV.rows?.[0] || {};
            sol = { ...solBase, monto: vAgg.monto || 0, fecha_venta: vAgg.fecha_venta, venta_total: vAgg.venta_total || 0, comentario: vAgg.comentario || '', cli_nombre: '', cli_ape: '' };
        } else if (_isGlobalSol) {
            // GLOBAL-*: dejar lógica original sin JOIN venta
            sol = { ...solBase, monto: 0, fecha_venta: null, venta_total: 0, comentario: '', cli_nombre: '', cli_ape: '' };
        } else {
            // Individual: JOIN con venta + cliente
            const r = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                sql: `SELECT f.id, f.usuario_id, f.rfc, f.razon_social, f.cp, f.regimen, f.uso_cfdi, f.forma_pago, f.numero_nota, f.estado,
                             CASE WHEN v.monto_facturable IS NOT NULL AND v.monto_facturable::float > 0 THEN v.monto_facturable::float ELSE v.total::float END AS monto, v.fecha_venta, v.total AS venta_total, v.comentario,
                             c.nombre AS cli_nombre, c.ape_p AS cli_ape
                       FROM facturas_solicitadas f
                       LEFT JOIN venta v ON v.id = f.numero_nota
                       LEFT JOIN cliente c ON c.id::text = v.cliente_id::text
                       WHERE f.id = ${id}`
            });
            sol = r.rows?.[0];
        }
    } catch(e) { BO_AUTH.showAlert('Error cargando solicitud: ' + e.message, 'error'); return; }
    if (!sol) { BO_AUTH.showAlert('Solicitud #' + id + ' no encontrada. Recarga el historial e intenta de nuevo.', 'error'); return; }

    // Fix: Si la nota tiene ACTIVOS en el comentario, y sol.monto == sol.venta_total, restarlos del monto facturable
    // Esto previene que una nota pagada parcialmente con activos timbre por el total completo si no se guardó en BD
        if (sol && sol.comentario && Math.abs(Number(sol.monto || 0) - Number(sol.venta_total || 0)) < 1) {
            const _aMatches = [...(sol.comentario.matchAll(/(?:^|[^A-Z_])(?:ACTIVOS(?:_[A-Z_]+)?(?:\/[^\s$]+)?)[^$]*\$?\s*([0-9,]+(?:\.[0-9]+)?)/gi))];
            if (_aMatches.length > 0) {
                const _mAct = _aMatches.reduce((s, m) => s + parseFloat(m[1].replace(/,/g, '')), 0);
                sol.monto = Math.max(0, Number(sol.monto) - _mAct);
            }
        }

    // ── Detectar crédito pendiente dinámicamente ──
    let _facSolCredito = 0;
    if (sol.comentario) {
        const _vFake = { comentarioRaw: sol.comentario, totalNum: Number(sol.venta_total || sol.monto || 0) };
        _facSolCredito = _calcularCreditoVenta(_vFake);
    }

    // ── Query 2: piezas de la nota ──
    let productosRows = `<tr><td colspan="3" style="font-size:.75rem;color:var(--text-dim);padding:.5rem;text-align:center">Sin detalle de productos disponible</td></tr>`;
    let items = [];
    const _isCentroSol2 = String(sol.numero_nota||'').startsWith('CENTRO-');
    if (_isCentroSol2) {
        // CENTRO-*: consolidar piezas de todas las ventas del centro
        const centroIdM2 = String(sol.numero_nota).match(/^CENTRO-(\d+)/);
        const centroId2 = centroIdM2 ? centroIdM2[1] : '0';
        try {
            const rCp = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                sql: `SELECT piezas FROM venta WHERE centro_apoyo_id = '${centroId2}'
                      AND requiere_factura = false AND approved = 1
                      AND (factura_emitida = false OR factura_emitida IS NULL)`
            });
            for (const row of (rCp.rows || [])) {
                let pz = [];
                try { pz = typeof row.piezas === 'string' ? JSON.parse(row.piezas) : (row.piezas || []); } catch(_) {}
                if (Array.isArray(pz)) items.push(...pz);
            }
        } catch(_) {}
    } else {
        // Individual o GLOBAL: query directa a venta por id
        try {
            const rp = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                sql: `SELECT piezas FROM venta WHERE id = '${sol.numero_nota}'`
            });
            const row = rp.rows?.[0];
            let rawData = row?.piezas;
            try { items = typeof rawData === 'string' ? JSON.parse(rawData) : (rawData || []); } catch(_) {}
            if (!Array.isArray(items)) items = [];
        } catch(_) {}
        // Fallback: _ventasData en memoria
        if (!items.length) {
            const vMem = (_ventasData || []).find(v => v.notaFull === sol.numero_nota);
            if (vMem && vMem.piezas && vMem.piezas.length > 0) items = vMem.piezas;
        }
    }
    if (items.length) {
        // Cargar catálogo de productos + componentes de paquetes
        let catalogo = window.PRODUCTOS_CAT || [];
        let compData = [];
        try {
            const [rCat, rComp] = await Promise.all([
                BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                    sql: `SELECT id, sku, nombre, clave_sat, unidad_sat, categoria FROM productos` }),
                BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                    sql: `SELECT pc.paquete_id, pc.componente_id, pc.cantidad, p.nombre AS comp_nombre, p.clave_sat AS comp_clave_sat, p.unidad_sat AS comp_unidad_sat
                          FROM producto_componente pc JOIN productos p ON p.id = pc.componente_id` })
            ]);
            catalogo = rCat.rows || catalogo;
            compData = rComp.rows || [];
        } catch(_) {}
        
    }
    // Guardar items originales (en caso de usarlos para algo más)
    window._currentSolicitudItems = items;
    // ── Detectar PUE/PPD y ExpeditionPlace para el preview ──
    const _previewPm = _detectPaymentMethod(sol.comentario || '');
    let _previewExpPlace = '45050';
    try { _previewExpPlace = await _getExpeditionPlace(sol.numero_nota); } catch(_) {}

    // Calcular montos reales usando la lógica de timbrado unificada
    const facturamaItems = await _buildFacturamaItems(sol.numero_nota, Number(sol.monto || 0));
    
    // Generar las filas HTML de productos basándose estrictamente en lo que se va a timbrar (facturamaItems)
    if (facturamaItems && facturamaItems.length > 0) {
        productosRows = facturamaItems.map(p => {
            const nom = p.Description;
            const cSat = p.ProductCode;
            const uSat = p.UnitCode;
            const qty = p.Quantity;
            const isSimbolic = p.UnitPrice <= 0.000001;
            
            let priceLabel = '';
            if (isSimbolic) {
                priceLabel = '<span style="color:var(--accent-gold);font-size:.65rem;font-weight:700">Simbólico ($0.00)</span>';
            } else {
                const prc = p.Total / qty; // Precio comercial (incluye IVA si aplica)
                priceLabel = '$' + prc.toLocaleString('es-MX',{minimumFractionDigits:2});
            }
            
            return `<tr style="border-top:1px solid var(--border)">
                <td style="padding:.25rem .2rem;font-size:.78rem">${nom}<br><span style="font-size:.62rem;color:var(--text-dim)">SAT: ${cSat} | ${uSat}</span></td>
                <td style="padding:.25rem .2rem;font-size:.78rem;text-align:center;font-weight:600">${qty}</td>
                <td style="padding:.25rem .2rem;font-size:.78rem;text-align:right;color:var(--text-primary)">${priceLabel}</td>
            </tr>`;
        }).join('');
    }
    const total = +(facturamaItems.reduce((s, i) => s + (i.Total || 0), 0)).toFixed(2);
    const subtotal = +(facturamaItems.reduce((s, i) => s + (i.Subtotal || 0), 0)).toFixed(2);
    const iva = +(facturamaItems.reduce((s, i) => s + ((i.Taxes && i.Taxes[0] ? i.Taxes[0].Total : 0) || 0), 0)).toFixed(2);
    const fecha = sol.fecha_venta ? new Date(sol.fecha_venta).toLocaleDateString('es-MX') : '—';
    const clienteNom = [sol.cli_nombre, sol.cli_ape].filter(Boolean).join(' ') || 'Público General';
    const _solMonedaVer = (sol.moneda || 'MXN').toUpperCase();
    const _solTCver = parseFloat(sol.tipo_cambio) || 0;

    // ── Limpiar modal previo ──
    const prev = document.getElementById('modalVerSolicitud');
    if (prev) prev.remove();

    // ── Crear modal ──
    const modal = document.createElement('div');
    modal.id = 'modalVerSolicitud';
    modal.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.7);z-index:9999;display:flex;align-items:center;justify-content:center;padding:1rem;';
    modal.innerHTML = `
    <div style="background:var(--bg-card);border:1px solid var(--border);border-radius:16px;max-width:520px;width:100%;max-height:90vh;overflow-y:auto;padding:1.5rem;">
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:1.2rem;">
            <h3 style="margin:0;color:var(--text-primary);font-size:1.1rem;">📋 Solicitud #${sol.id}</h3>
            <button onclick="document.getElementById('modalVerSolicitud').remove()" style="background:none;border:none;color:var(--text-dim);font-size:1.4rem;cursor:pointer;line-height:1;">✕</button>
        </div>

        <div style="display:grid;gap:.8rem;">
            <div style="background:var(--bg-surface);border-radius:10px;padding:.9rem;">
                <p style="font-size:.7rem;color:var(--text-dim);margin:0 0 .5rem;">NOTA DE VENTA</p>
                <p style="margin:0;font-weight:700;color:var(--accent-gold);font-size:.95rem;">#${String(sol.numero_nota||'').substring(0,20)}</p>
                <p style="margin:.2rem 0 0;font-size:.78rem;color:var(--text-dim);">Fecha: ${fecha} &nbsp;|&nbsp; Cliente: <b style="color:var(--text-primary);">${clienteNom}</b></p>
            </div>

            <div style="background:var(--bg-surface);border-radius:10px;padding:.9rem;">
                <p style="font-size:.7rem;color:var(--text-dim);margin:0 0 .5rem;">DATOS FISCALES DEL RECEPTOR</p>
                <div style="display:grid;grid-template-columns:1fr 1fr;gap:.5rem;font-size:.8rem;">
                    <div><span style="color:var(--text-dim);">RFC</span><br><b>${sol.rfc||'—'}</b></div>
                    <div><span style="color:var(--text-dim);">C.P.</span><br><b>${sol.cp||'—'}</b></div>
                    <div style="grid-column:1/-1;"><span style="color:var(--text-dim);">Razón Social</span><br><b>${sol.razon_social||'—'}</b></div>
                    <div><span style="color:var(--text-dim);">Régimen</span><br><b>${{
                        '601':'601 — General de Ley Personas Morales',
                        '603':'603 — Personas Morales con Fines no Lucrativos',
                        '605':'605 — Sueldos y Salarios e Ingresos Asimilados',
                        '606':'606 — Arrendamiento',
                        '607':'607 — Régimen de Enajenación o Adquisición de Bienes',
                        '608':'608 — Demás Ingresos',
                        '610':'610 — Residentes en el Extranjero sin EP',
                        '611':'611 — Ingresos por Dividendos (socios y accionistas)',
                        '612':'612 — Personas Físicas con Actividades Empresariales y Prof.',
                        '614':'614 — Ingresos por Intereses',
                        '615':'615 — Ingresos por Obtención de Premios',
                        '616':'616 — Sin Obligaciones Fiscales',
                        '620':'620 — Sociedades Cooperativas de Producción',
                        '621':'621 — Incorporación Fiscal (RIF)*',
                        '622':'622 — Actividades Agrícolas, Ganaderas, Silvicolas y Pesqueras',
                        '623':'623 — RESICO Personas Morales',
                        '624':'624 — Coordinados',
                        '625':'625 — Actividades Empresariales con ingresos vía Plataformas Tecnológicas',
                        '626':'626 — RESICO Personas Físicas'
                    }[sol.regimen] || sol.regimen || '—'}</b></div>
                    <div><span style="color:var(--text-dim);">Uso CFDI</span><br><b>${{
                        'G01':'G01 — Adquisición de mercancías',
                        'G02':'G02 — Devoluciones, descuentos o bonificaciones',
                        'G03':'G03 — Gastos en general',
                        'I01':'I01 — Construcciones',
                        'I02':'I02 — Mobiliario y equipo de oficina',
                        'I03':'I03 — Equipo de transporte',
                        'I04':'I04 — Equipo de cómputo',
                        'I08':'I08 — Otra maquinaria y equipo',
                        'D01':'D01 — Honorarios médicos',
                        'D02':'D02 — Gastos médicos',
                        'D03':'D03 — Gastos funerales',
                        'D04':'D04 — Donativos',
                        'D10':'D10 — Pagos por servicios educativos',
                        'P01':'P01 — Por definir',
                        'S01':'S01 — Sin efectos fiscales',
                        'CP01':'CP01 — Pagos',
                        'CN01':'CN01 — Nómina'
                    }[sol.uso_cfdi] || sol.uso_cfdi || '—'}</b></div>
                    <div><span style="color:var(--text-dim);">Forma de Pago</span><br><b>${{
                        '01':'01 — Efectivo','02':'02 — Cheque nominativo',
                        '03':'03 — Transferencia electrónica de fondos','04':'04 — Tarjeta de crédito',
                        '05':'05 — Monedero electrónico','06':'06 — Dinero electrónico',
                        '08':'08 — Vales de despensa','12':'12 — Dación en pago',
                        '13':'13 — Pago por subrogación','14':'14 — Pago por consignación',
                        '15':'15 — Condonación','17':'17 — Compensación',
                        '23':'23 — Novación','24':'24 — Confusión',
                        '25':'25 — Remisión de deuda','26':'26 — Prescripción o caducidad',
                        '27':'27 — A satisfacción del acreedor','28':'28 — Tarjeta de débito',
                        '29':'29 — Tarjeta de servicios','30':'30 — Aplicación de anticipos',
                        '99':'99 — Por definir'
                    }[sol.forma_pago] || sol.forma_pago || '—'}</b></div>
                    <div><span style="color:var(--text-dim);">Método Pago</span><br><b style="color:${_previewPm.method === 'PPD' ? 'var(--accent-gold)' : 'var(--success)'}">${_previewPm.method}</b>${_previewPm.method === 'PPD' ? '<br><span style="font-size:.62rem;color:var(--text-dim)">Forma: 99 (Por definir)</span>' : ''}</div>
                    <div><span style="color:var(--text-dim);">Lugar Expedición</span><br><b>${_previewExpPlace}</b></div>
                </div>
            </div>

            <div style="background:var(--bg-surface);border-radius:10px;padding:.9rem;">
                <p style="font-size:.7rem;color:var(--text-dim);margin:0 0 .5rem;">PRODUCTOS DE LA NOTA</p>
                <table style="width:100%;border-collapse:collapse;">
                    <thead><tr style="color:var(--text-dim);font-size:.68rem;">
                        <th style="text-align:left;padding:.2rem;">Producto</th>
                        <th style="text-align:center;padding:.2rem;">Cant</th>
                        <th style="text-align:right;padding:.2rem;">Precio</th>
                    </tr></thead>
                    <tbody>${productosRows}</tbody>
                </table>
            </div>

            ${_facSolCredito > 0 ? `<div style="background:rgba(239,68,68,.1);border:1px solid rgba(239,68,68,.35);border-radius:10px;padding:.9rem;">
                <p style="font-size:.7rem;color:#ef4444;margin:0 0 .3rem;font-weight:700">🚫 ALERTA: CRÉDITO PENDIENTE</p>
                <p style="margin:0;font-size:.95rem;font-weight:800;color:#ef4444">$${_facSolCredito.toLocaleString('es-MX',{minimumFractionDigits:2})}</p>
                <p style="margin:.2rem 0 0;font-size:.72rem;color:rgba(239,68,68,.7)">Esta nota no puede ser facturada hasta liquidar el saldo pendiente.</p>
            </div>` : ''}

            ${_solMonedaVer !== 'MXN' ? `<div style="background:rgba(59,130,246,.08);border:2px solid rgba(59,130,246,.3);border-radius:10px;padding:.9rem;">
                <p style="font-size:.7rem;color:#3b82f6;margin:0 0 .3rem;font-weight:700">🇺🇸 FACTURA EN USD</p>
                <div style="display:grid;grid-template-columns:1fr 1fr;gap:.5rem;font-size:.8rem;">
                    <div><span style="color:var(--text-dim);font-size:.68rem">Moneda</span><br><b style="color:#60a5fa">${_solMonedaVer}</b></div>
                    <div><span style="color:var(--text-dim);font-size:.68rem">Tipo de Cambio DOF</span><br><b style="color:#60a5fa">${_solTCver > 0 ? _solTCver.toFixed(4) + ' MXN/USD' : '⚠️ No capturado'}</b></div>
                </div>
            </div>` : ''}

            <div style="background:var(--bg-surface);border-radius:10px;padding:.9rem;">
                <p style="font-size:.7rem;color:var(--text-dim);margin:0 0 .5rem;">DESGLOSE DEL CFDI A EMITIR</p>
                <div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:.4rem;font-size:.8rem;text-align:center;">
                    <div><span style="color:var(--text-dim);font-size:.7rem;">Subtotal</span><br><b>$${subtotal.toLocaleString('es-MX',{minimumFractionDigits:2})}</b></div>
                    <div><span style="color:var(--text-dim);font-size:.7rem;">IVA 16%</span><br><b>$${iva.toLocaleString('es-MX',{minimumFractionDigits:2})}</b></div>
                    <div><span style="color:var(--success);font-size:.7rem;">Total CFDI</span><br><b style="color:var(--success);">$${total.toLocaleString('es-MX',{minimumFractionDigits:2})}</b></div>
                </div>
                <p style="margin:.5rem 0 0;font-size:.68rem;color:var(--text-dim);text-align:center;">El CFDI se timbrará por el total de $${total.toLocaleString('es-MX',{minimumFractionDigits:2})} ${_solMonedaVer}</p>
            </div>
        </div>

        <div style="display:flex;gap:.6rem;margin-top:1.2rem;justify-content:flex-end;">
            <button class="btn btn-outline btn-sm" style="color:var(--danger);border-color:var(--danger);" onclick="document.getElementById('modalVerSolicitud').remove();rechazarSolicitudFactura(${sol.id})">✗ Rechazar</button>
            <button class="btn btn-outline btn-sm" onclick="document.getElementById('modalVerSolicitud').remove()">Cerrar</button>
            ${_facSolCredito > 0 ? '<button class="btn" style="font-size:.85rem;background:#78716c;color:#fff;cursor:not-allowed;opacity:.7" disabled>🚫 Nota con crédito pendiente</button>' : '<button class="btn btn-success" style="font-size:.85rem;" onclick="document.getElementById(\'modalVerSolicitud\').remove();confirmarTimbrado(' + sol.id + ',\'individual\')">⚡ Timbrar CFDI</button>'}
        </div>
    </div>`;
    // Cerrar al clickar el fondo
    modal.addEventListener('click', e => { if (e.target === modal) modal.remove(); });
    document.body.appendChild(modal);
}

// ── Facturación — Búsqueda por # Nota ────────────────────────────────────────
function onFacSearchInput() {
    window._factPendPage = 0;
    window._factFactPage = 0;
    renderFactPendPage();
    renderFactFactPage();
}

// ── Facturación — Paginación tabla de Pendientes (7 por página) ──────────────
function renderFactPendPage() {
    const pendBody = document.getElementById('facturasPendientesBody');
    if (!pendBody) return;
    const PAGE_SIZE = 7;
    let items    = window._factPendItems  || [];
    const searchInput = document.getElementById('facSearchInput');
    if (searchInput && searchInput.value) {
        const query = searchInput.value.toLowerCase().trim();
        items = items.filter(f => String(f.numero_nota || '').toLowerCase().includes(query) || String(f.id || '').toLowerCase().includes(query));
    }
    const page     = window._factPendPage   || 0;
    const isMaster = !!window._factPendMaster;
    const totalPages = Math.ceil(items.length / PAGE_SIZE) || 1;
    const pageItems  = items.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE);
    const _fmt = (f) => { const r=f.creado_en||f.created_at||null; if(!r) return `#${f.id}`; try{return new Date(r).toLocaleDateString('es-MX');}catch(_){return r;}};

    pendBody.innerHTML = pageItems.map(f => {
        const isGlobal = String(f.numero_nota||'').startsWith('GLOBAL-');
        // isCentro: detecta CENTRO-{id} en numero_nota, centro_apoyo_id seteado, o cliente de la venta = 'Centro de Apoyo'
        const _cliVentaNombre = String(f._cli_venta_nombre || '').toLowerCase();
        const isCentro = String(f.numero_nota||'').startsWith('CENTRO-') || !!(f._centro_id) || _cliVentaNombre.startsWith('centro');
        const centroNombre = f._centro_nombre || (isCentro ? 'Centro de Apoyo' : null);
        let pill = f.estado==='solicitada'
            ? '<span class="pill pill-warning" style="font-size:.7rem">\u23f3 Pendiente</span>'
            : f.estado==='en_proceso' ? '<span class="pill pill-primary" style="font-size:.7rem">\ud83d\udd04 En Proceso</span>' : '';
        if (isGlobal) pill += ' <span style="background:rgba(139,92,246,.25);color:#a78bfa;font-size:.6rem;padding:1px 6px;border-radius:99px;font-weight:700">GLOBAL</span>';
        if (isCentro) pill += ' <span style="background:rgba(99,102,241,.25);color:#a5b4fc;font-size:.6rem;padding:1px 6px;border-radius:99px;font-weight:700">\ud83c\udfea CENTRO</span>';
        const solNom = isMaster
            ? `<span style="color:var(--accent-gold);font-weight:600">${f.usuario_nombre||''} ${f.usuario_apellido||''}</span>`
            : '<span style="color:var(--text-dim)">T\u00fa</span>';
        
        // Nota display
        const notaDisplay = isGlobal 
            ? `<b style="color:#a78bfa">${f.numero_nota}</b>`
            : (isCentro && f._centro_id && !String(f.numero_nota||'').startsWith('CENTRO-'))
            ? `<b style="color:#a5b4fc">🏪 ${centroNombre||'Centro'}</b><br><span style="font-size:.65rem;color:var(--text-dim);font-family:monospace">${String(f.numero_nota||'').substring(0,12)}\u2026</span>`
            : isCentro
            ? `<b style="color:#a5b4fc">${f.numero_nota}</b>`
            : `<b style="color:var(--text-primary)">Nota: ${String(f.numero_nota||'').substring(0,12)||'\u2014'}\u2026</b>`;

        const btnEditar = isGlobal ? '' : `<button class="btn btn-outline btn-sm" style="font-size:.72rem;border-color:rgba(99,102,241,.5);color:#a5b4fc;" onclick="editarSolicitudFactura(${f.id})">✏️ Editar</button>`;

        let acc = '';
        if (isMaster && f.estado==='solicitada') {
            if (isGlobal) {
                acc = `<button class="btn btn-outline btn-sm" style="font-size:.72rem" onclick="verSolicitudGlobal(${f.id})">\ud83d\udc41 Ver Desglose</button>
                       <button class="btn btn-success btn-sm" style="font-size:.72rem" onclick="confirmarTimbrado(${f.id},'global')">\u26a1 Timbrar Global</button>
                       <button class="btn btn-outline btn-sm" style="color:var(--danger);border-color:var(--danger);font-size:.72rem" onclick="rechazarSolicitudFactura(${f.id})">\u2717</button>`;
            } else if (isCentro) {
                acc = `${btnEditar}
                       <button class="btn btn-outline btn-sm" style="font-size:.72rem" onclick="verSolicitudGlobal(${f.id})">\ud83c\udfea Ver Notas Centro</button>
                       <button class="btn btn-success btn-sm" style="font-size:.72rem;background:linear-gradient(135deg,#6366f1,#818cf8)" onclick="confirmarTimbrado(${f.id},'centro')">\u26a1 Timbrar Centro</button>
                       <button class="btn btn-outline btn-sm" style="color:var(--danger);border-color:var(--danger);font-size:.72rem" onclick="rechazarSolicitudFactura(${f.id})">\u2717</button>`;
            } else {
                acc = `${btnEditar}
                       <button class="btn btn-outline btn-sm" style="font-size:.72rem" onclick="verSolicitudFactura(${f.id})">\ud83d\udc41 Ver</button>
                       <button class="btn btn-success btn-sm" style="font-size:.72rem" onclick="confirmarTimbrado(${f.id},'individual')">\u26a1 Timbrar</button>
                       <button class="btn btn-outline btn-sm" style="color:var(--danger);border-color:var(--danger);font-size:.72rem" onclick="rechazarSolicitudFactura(${f.id})">\u2717</button>`;
            }
        } else if (isMaster && f.estado==='en_proceso') {
            acc = `${btnEditar}
                   <button class="btn btn-outline btn-sm" style="font-size:.72rem" onclick="${(isGlobal||isCentro) ? 'verSolicitudGlobal' : 'verSolicitudFactura'}(${f.id})">\ud83d\udc41 Ver</button>
                   <button class="btn btn-primary btn-sm" style="font-size:.72rem" onclick="confirmarTimbrado(${f.id},'${isGlobal ? 'global' : (isCentro ? 'centro' : 'individual')}')">\u26a1 Timbrar</button>`;
        } else {
            // Líderes normales: solo pueden editar sus propias solicitudes pendientes
            acc = `${btnEditar}<span style="color:var(--text-dim);font-size:12px;"> En espera\u2026</span>`;
        }
        // Row-level visual differentiation by tipo
        const rowStyle = isCentro
            ? 'border-left:3px solid #6366f1;background:rgba(99,102,241,.07);'
            : isGlobal
            ? 'border-left:3px solid #8b5cf6;background:rgba(139,92,246,.07);'
            : 'border-left:3px solid transparent;';
        const tipoBadge = isCentro
            ? `<span style="display:inline-block;background:rgba(99,102,241,.3);color:#a5b4fc;font-size:.6rem;padding:1px 6px;border-radius:4px;font-weight:700;margin-bottom:2px;">🏪 CENTRO</span><br>`
            : isGlobal
            ? `<span style="display:inline-block;background:rgba(139,92,246,.3);color:#c4b5fd;font-size:.6rem;padding:1px 6px;border-radius:4px;font-weight:700;margin-bottom:2px;">🌐 GLOBAL</span><br>`
            : '';
        return `<tr style="${rowStyle}">
            <td style="font-size:.78rem">${tipoBadge}#${f.id}<br>${notaDisplay}</td>
            <td style="font-size:.78rem">${solNom}</td>
            <td style="font-size:.78rem"><b>${f.rfc||'\u2014'}</b><br><span style="color:var(--text-dim)">${f.razon_social||''}</span></td>
            <td style="font-size:.78rem">${_fmt(f)}<br>${pill}</td>
            <td style="display:flex;gap:.3rem;align-items:center;flex-wrap:wrap;min-height:30px">${acc}</td>
        </tr>`;
    }).join('');

    // Paginación en tfoot
    const tbl = pendBody.parentElement;
    tbl.querySelectorAll('tfoot.pend-pag').forEach(t => t.remove());
    if (totalPages > 1) {
        const tfoot = document.createElement('tfoot');
        tfoot.className = 'pend-pag';
        tfoot.innerHTML = `<tr><td colspan="5" style="text-align:center;padding:.5rem;border-top:1px solid var(--border)">
            <button class="btn btn-outline btn-sm" style="font-size:.72rem" onclick="prevFactPendPage()" ${page===0?'disabled':''}>\u2190 Ant</button>
            <span style="color:var(--text-dim);font-size:.75rem;margin:0 .6rem">P\u00e1g ${page+1} / ${totalPages}</span>
            <button class="btn btn-outline btn-sm" style="font-size:.72rem" onclick="nextFactPendPage()" ${page>=totalPages-1?'disabled':''}>\u00a0Sig \u2192</button>
        </td></tr>`;
        tbl.appendChild(tfoot);
    }
}
function prevFactPendPage() { if ((window._factPendPage||0)>0) { window._factPendPage--; renderFactPendPage(); } }
function nextFactPendPage() { 
    let items = window._factPendItems || [];
    const searchInput = document.getElementById('facSearchInput');
    if (searchInput && searchInput.value) {
        const query = searchInput.value.toLowerCase().trim();
        items = items.filter(f => String(f.numero_nota || '').toLowerCase().includes(query) || String(f.id || '').toLowerCase().includes(query));
    }
    const t = Math.ceil(items.length/7); 
    if((window._factPendPage||0)<t-1){window._factPendPage++;renderFactPendPage();} 
}

// ── Facturación — Paginación tabla de Facturas del Mes (7 por página) ────────
function renderFactFactPage() {
    const factBody = document.getElementById('facturasBody');
    if (!factBody) return;
    const PAGE_SIZE = 7;
    let items    = window._factFactItems  || [];
    const searchInput = document.getElementById('facSearchInput');
    if (searchInput && searchInput.value) {
        const query = searchInput.value.toLowerCase().trim();
        items = items.filter(f => String(f.numero_nota || '').toLowerCase().includes(query) || String(f.id || '').toLowerCase().includes(query));
    }
    const page     = window._factFactPage   || 0;
    const isMaster = !!window._factFactMaster;
    const totalPages = Math.ceil(items.length / PAGE_SIZE) || 1;
    const pageItems  = items.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE);

    if (pageItems.length === 0) {
        factBody.innerHTML = '<tr><td colspan="5" style="text-align:center;color:var(--text-dim);padding:1.5rem">No hay resultados para la búsqueda</td></tr>';
    } else {
        window._cacheFacturasEmitidas = window._cacheFacturasEmitidas || {};
        factBody.innerHTML = pageItems.map((f, idx) => {
            const globalIdx = (page * PAGE_SIZE) + idx;
            const cacheKey = String(f.id !== undefined && f.id !== null && f.id !== '' ? f.id : (f.numero_nota || f.cfdi_uuid || ('item_' + globalIdx)));
            window._cacheFacturasEmitidas[cacheKey] = f;
            window._cacheFacturasEmitidas['item_' + globalIdx] = f;
            if (f.id !== undefined && f.id !== null) window._cacheFacturasEmitidas[String(f.id)] = f;
            if (f.numero_nota) window._cacheFacturasEmitidas[String(f.numero_nota)] = f;
            if (f.cfdi_uuid) window._cacheFacturasEmitidas[String(f.cfdi_uuid)] = f;

            const nombre = isMaster ? `<span style="color:var(--accent-gold);font-size:.7rem">${f.usuario_nombre || ''} ${f.usuario_apellido || ''}</span><br>` : '';
            const isGlobal  = String(f.numero_nota||'').startsWith('GLOBAL');
            const isCentro  = String(f.numero_nota||'').startsWith('CENTRO-');
            const isHuerfana = !!f._huerfana;
            const notaLabel = isGlobal  ? `<b style="color:#a78bfa">${f.numero_nota}</b>`
                : isCentro  ? `<b style="color:#a5b4fc">${f.numero_nota}</b>`
                : `<b style="color:var(--text-primary)">Nota: ${String(f.numero_nota||'').substring(0,12) || '\u2014'}\u2026</b>`;
            const typeBadge = isHuerfana
                ? ' <span style="background:rgba(251,146,60,.2);color:#fb923c;font-size:.6rem;padding:1px 6px;border-radius:99px;font-weight:700">⚠️ SIN SOLICITUD</span>'
                : isGlobal  ? ' <span style="background:rgba(139,92,246,.25);color:#a78bfa;font-size:.6rem;padding:1px 6px;border-radius:99px;font-weight:700">GLOBAL</span>'
                : isCentro  ? ' <span style="background:rgba(99,102,241,.25);color:#a5b4fc;font-size:.6rem;padding:1px 6px;border-radius:99px;font-weight:700">🏪 CENTRO</span>' : '';
            const idLabel  = f.id ? `#${f.id}` : `<span style="color:var(--text-dim);font-size:.7rem">(sin registro)</span>`;
            const cfdiShow = f.cfdi_uuid && f.cfdi_uuid !== '—' ? `<br><span style="font-size:.65rem;color:var(--accent-gold)" title="UUID: ${f.cfdi_uuid}">🔖 ${String(f.cfdi_uuid).substring(0,8)}…</span>` : '';
            return `<tr>
                <td style="font-size:.78rem">${idLabel}<br>${notaLabel}${typeBadge}${cfdiShow}</td>
                <td style="font-size:.78rem">${nombre}<b>${f.rfc||'(marcada externamente)'}</b><br><span style="color:var(--text-dim)">${f.razon_social||''}</span></td>
                <td><span class="pill pill-success" style="font-size:.7rem">${isHuerfana ? '🏷️ Ext' : '✅ Facturada'}</span></td>
                <td style="font-size:.7rem;color:var(--text-dim)">${_fmtFechaFac(f)}</td>
                <td style="display:flex;gap:.3rem;align-items:center;flex-wrap:wrap;min-height:30px;">
                    ${(isGlobal||isCentro) ? `<button class="btn btn-outline btn-sm" style="font-size:.68rem;color:${isCentro?'#a5b4fc':'var(--accent-gold)'};border-color:${isCentro?'rgba(99,102,241,.5)':'var(--accent-gold)'}" onclick="verSolicitudGlobal(${f.id})">${isCentro?'\ud83c\udfea Ver Notas':'\ud83d\udccb Ver Notas'}</button>` : ''}
                    <button class="btn btn-outline btn-sm" style="font-size:.68rem" onclick="descargarPDF('${f.cfdi_id||''}','${f.cfdi_uuid||''}','${f.id}')">\ud83d\udcc4 PDF</button>
                    <button class="btn btn-outline btn-sm" style="font-size:.68rem;color:var(--accent-green);border-color:var(--accent-green)" onclick="descargarXML('${f.cfdi_id||''}','${f.cfdi_uuid||''}','${f.id}')">\ud83d\udce5 XML</button>
                    ${isMaster ? `
                    <button class="btn btn-outline btn-sm" style="font-size:.68rem;color:#38bdf8;border-color:#38bdf8" onclick="window.abrirModalSustituirSol('${cacheKey}')" title="Emitir nueva factura con Tipo de Relación 04 y cancelar esta con Motivo 01">🔄 Sustituir</button>
                    <button class="btn btn-outline btn-sm" style="font-size:.68rem;color:var(--danger);border-color:var(--danger)" onclick="window.abrirModalCancelarSATSol('${cacheKey}')">❌ Cancelar</button>` : ''}
                </td>
            </tr>`;
        }).join('');
    }

    const tbl = factBody.parentElement;
    tbl.querySelectorAll('tfoot.fact-pag').forEach(t => t.remove());
    if (totalPages > 1) {
        const tfoot = document.createElement('tfoot');
        tfoot.className = 'fact-pag';
        tfoot.innerHTML = `<tr><td colspan="5" style="text-align:center;padding:.5rem;border-top:1px solid var(--border)">
            <button class="btn btn-outline btn-sm" style="font-size:.72rem" onclick="prevFactFactPage()" ${page===0?'disabled':''}>← Ant</button>
            <span style="color:var(--text-dim);font-size:.75rem;margin:0 .6rem">Pág ${page+1} / ${totalPages}</span>
            <button class="btn btn-outline btn-sm" style="font-size:.72rem" onclick="nextFactFactPage()" ${page>=totalPages-1?'disabled':''}> Sig →</button>
        </td></tr>`;
        tbl.appendChild(tfoot);
    }
}
function prevFactFactPage() { if ((window._factFactPage||0)>0) { window._factFactPage--; renderFactFactPage(); } }
function nextFactFactPage() { 
    let items = window._factFactItems || [];
    const searchInput = document.getElementById('facSearchInput');
    if (searchInput && searchInput.value) {
        const query = searchInput.value.toLowerCase().trim();
        items = items.filter(f => String(f.numero_nota || '').toLowerCase().includes(query) || String(f.id || '').toLowerCase().includes(query));
    }
    const t = Math.ceil(items.length/7); 
    if((window._factFactPage||0)<t-1){window._factFactPage++;renderFactFactPage();} 
}

// ── Editar Solicitud de Factura (Pendiente) ────────────────────────────────
function editarSolicitudFactura(id) {
    const f = (window._factPendItems || []).find(x => x.id == id);
    if (!f) { BO_AUTH.showAlert('No se encontraron datos de la solicitud.', 'warning'); return; }

    const regimenes = [
        { v:'601', l:'601 - Régimen General de Ley Personas Morales' },
        { v:'602', l:'602 - Régimen Simplificado de Ley Personas Morales' },
        { v:'603', l:'603 - Personas Morales con Fines no Lucrativos' },
        { v:'604', l:'604 - Régimen de Pequeños Contribuyentes' },
        { v:'605', l:'605 - Régimen de Sueldos y Salarios e Ingresos Asimilados a Salarios' },
        { v:'606', l:'606 - Régimen de Arrendamiento' },
        { v:'607', l:'607 - Régimen de Enajenación o Adquisición de Bienes' },
        { v:'608', l:'608 - Régimen de los Demás Ingresos' },
        { v:'609', l:'609 - Régimen de Consolidación' },
        { v:'610', l:'610 - Régimen Residentes en el Extranjero sin Establecimiento Permanente en México' },
        { v:'611', l:'611 - Régimen de Ingresos por Dividendos (Socios y Accionistas)' },
        { v:'612', l:'612 - Régimen de las Personas Físicas con Actividades Empresariales y Profesionales' },
        { v:'613', l:'613 - Régimen Intermedio de las Personas Físicas con Actividades Empresariales' },
        { v:'614', l:'614 - Régimen de los Ingresos por Intereses' },
        { v:'615', l:'615 - Régimen de los Ingresos por Obtención de Premios' },
        { v:'616', l:'616 - Sin Obligaciones Fiscales' },
        { v:'617', l:'617 - PEMEX' },
        { v:'618', l:'618 - Régimen Simplificado de Ley Personas Físicas' },
        { v:'619', l:'619 - Ingresos por la Obtención de Préstamos' },
        { v:'620', l:'620 - Sociedades Cooperativas de Producción que Optan por Diferir sus Ingresos' },
        { v:'621', l:'621 - Régimen de Incorporación Fiscal' },
        { v:'622', l:'622 - Régimen de Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras PM' },
        { v:'623', l:'623 - Régimen Opcional para Grupos de Sociedades' },
        { v:'624', l:'624 - Régimen de los Coordinados' },
        { v:'625', l:'625 - Régimen de las Actividades Empresariales con Ingresos a través de Plataformas Tecnológicas' },
        { v:'626', l:'626 - Régimen Simplificado de Confianza' }
    ];
    const cfdiOpts = [
        { v:'S01', l:'S01 — Sin efectos fiscales' },
        { v:'G01', l:'G01 — Adquisición de mercancías' },
        { v:'G02', l:'G02 — Devoluciones, descuentos o bonificaciones' },
        { v:'G03', l:'G03 — Gastos en general' },
        { v:'CP01', l:'CP01 — Pagos' },
        { v:'CN01', l:'CN01 — Nómina' },
    ];
    const fpOpts = [
        { v:'01', l:'01 — Efectivo' }, { v:'02', l:'02 — Cheque nominativo' },
        { v:'03', l:'03 — Transferencia electrónica de fondos' }, { v:'04', l:'04 — Tarjeta de crédito' },
        { v:'05', l:'05 — Monedero electrónico' }, { v:'06', l:'06 — Dinero electrónico' },
        { v:'08', l:'08 — Vales de despensa' }, { v:'12', l:'12 — Dación en pago' },
        { v:'13', l:'13 — Pago por subrogación' }, { v:'14', l:'14 — Pago por consignación' },
        { v:'15', l:'15 — Condonación' }, { v:'17', l:'17 — Compensación' },
        { v:'23', l:'23 — Novación' }, { v:'24', l:'24 — Confusión' },
        { v:'25', l:'25 — Remisión de deuda' }, { v:'26', l:'26 — Prescripción o caducidad' },
        { v:'27', l:'27 — A satisfacción del acreedor' }, { v:'28', l:'28 — Tarjeta de débito' },
        { v:'29', l:'29 — Tarjeta de servicios' }, { v:'30', l:'30 — Aplicación de anticipos' },
        { v:'99', l:'99 — Por definir' },
    ];
    const mkSel = (opts, current) => opts.map(o =>
        `<option value="${o.v}"${o.v === String(current||'') ? ' selected' : ''}>${o.l}</option>`
    ).join('');

    // Eliminar modal previo si existe
    const prev = document.getElementById('_modalEditFac');
    if (prev) prev.remove();

    const modal = document.createElement('div');
    modal.id = '_modalEditFac';
    modal.style.cssText = 'display:flex;position:fixed;inset:0;z-index:11500;background:rgba(0,0,0,.82);backdrop-filter:blur(8px);align-items:center;justify-content:center;padding:1rem;';
    modal.innerHTML = `
    <div style="background:linear-gradient(145deg,#0f172a,#1e1b4b);border:1px solid rgba(99,102,241,.4);border-radius:16px;width:min(560px,96vw);max-height:90vh;overflow-y:auto;box-shadow:0 30px 70px rgba(0,0,0,.8),0 0 40px rgba(99,102,241,.1);">
        <!-- Header -->
        <div style="padding:1.25rem 1.5rem;border-bottom:1px solid rgba(255,255,255,.08);display:flex;justify-content:space-between;align-items:center;background:linear-gradient(135deg,rgba(99,102,241,.15),transparent);border-radius:16px 16px 0 0;">
            <div>
                <div style="font-size:1.05rem;font-weight:700;color:#e2e8f0;">&#9999;&#65039; Editar Solicitud de Factura</div>
                <div style="font-size:.73rem;color:#a5b4fc;margin-top:2px;">Solicitud #${f.id} &mdash; Nota: <strong style="color:#fbbf24;">${f.numero_nota||'&mdash;'}</strong></div>
            </div>
            <button onclick="document.getElementById('_modalEditFac').remove();document.body.style.overflow='';" style="background:none;border:none;color:#94a3b8;font-size:1.4rem;cursor:pointer;line-height:1;">&#x2715;</button>
        </div>
        <!-- Body -->
        <div style="padding:1.5rem;display:grid;gap:1rem;">
            <!-- RFC + CP -->
            <div style="display:grid;grid-template-columns:1fr 120px;gap:.75rem;">
                <div class="form-group" style="margin:0;">
                    <label class="form-label" style="font-size:.72rem;color:#a5b4fc;">RFC *</label>
                    <input id="_ef_rfc" class="form-control" value="${f.rfc||''}" placeholder="XAXX010101000" style="text-transform:uppercase;font-family:monospace;letter-spacing:.04em;">
                </div>
                <div class="form-group" style="margin:0;">
                    <label class="form-label" style="font-size:.72rem;color:#a5b4fc;">CP *</label>
                    <input id="_ef_cp" class="form-control" value="${f.cp||''}" placeholder="44100" maxlength="5" type="number">
                </div>
            </div>
            <!-- Razón Social -->
            <div class="form-group" style="margin:0;">
                <label class="form-label" style="font-size:.72rem;color:#a5b4fc;">Razón Social *</label>
                <input id="_ef_razon" class="form-control" value="${(f.razon_social||'').replace(/"/g,'&quot;')}" placeholder="Razón social o nombre completo">
            </div>
            <!-- Régimen + CFDI -->
            <div style="display:grid;grid-template-columns:1fr 1fr;gap:.75rem;">
                <div class="form-group" style="margin:0;">
                    <label class="form-label" style="font-size:.72rem;color:#a5b4fc;">Régimen Fiscal</label>
                    <select id="_ef_regimen" class="form-control" style="font-size:.78rem;">${mkSel(regimenes, f.regimen)}</select>
                </div>
                <div class="form-group" style="margin:0;">
                    <label class="form-label" style="font-size:.72rem;color:#a5b4fc;">Uso de CFDI</label>
                    <select id="_ef_cfdi" class="form-control" style="font-size:.78rem;">${mkSel(cfdiOpts, f.uso_cfdi)}</select>
                </div>
            </div>
            <!-- Forma de Pago -->
            <div class="form-group" style="margin:0;">
                <label class="form-label" style="font-size:.72rem;color:#a5b4fc;">Forma de Pago</label>
                <select id="_ef_fp" class="form-control" style="font-size:.78rem;">${mkSel(fpOpts, f.forma_pago)}</select>
            </div>
            <!-- Banner info -->
            <div style="padding:.6rem .9rem;background:rgba(99,102,241,.08);border-radius:8px;border-left:3px solid rgba(99,102,241,.5);font-size:.75rem;color:#a5b4fc;">
                ℹ️ Solo se modifican los datos fiscales. El monto y la nota vinculada permanecen sin cambio.
            </div>
        </div>
        <!-- Footer -->
        <div style="display:flex;justify-content:flex-end;gap:.75rem;padding:1rem 1.5rem;border-top:1px solid rgba(255,255,255,.07);">
            <button class="btn btn-outline" onclick="document.getElementById('_modalEditFac').remove();document.body.style.overflow='';">Cancelar</button>
            <button class="btn btn-primary" id="_ef_btnGuardar" onclick="guardarEdicionSolicitud(${f.id})" style="background:linear-gradient(135deg,#6366f1,#818cf8);border:none;">&#128190; Guardar Cambios</button>
        </div>
    </div>`;

    document.body.appendChild(modal);
    document.body.style.overflow = 'hidden';
    // Cerrar al click en fondo
    modal.addEventListener('click', e => { if (e.target === modal) { modal.remove(); document.body.style.overflow=''; } });
}

async function guardarEdicionSolicitud(id) {
    const rfc     = document.getElementById('_ef_rfc')?.value?.trim().toUpperCase();
    const razon   = document.getElementById('_ef_razon')?.value?.trim();
    const cp      = document.getElementById('_ef_cp')?.value?.trim();
    const regimen = document.getElementById('_ef_regimen')?.value;
    const cfdi    = document.getElementById('_ef_cfdi')?.value;
    const fp      = document.getElementById('_ef_fp')?.value;

    if (!rfc || !razon || !cp) {
        BO_AUTH.showAlert('RFC, Razón Social y CP son obligatorios.', 'warning'); return;
    }
    const rfcOk = /^[A-ZÑ&]{3,4}[0-9]{6}[A-Z0-9]{3}$/.test(rfc);
    if (!rfcOk) { BO_AUTH.showAlert('RFC con formato inválido. Verifica el formato.', 'warning'); return; }

    const btn = document.getElementById('_ef_btnGuardar');
    if (btn) { btn.disabled = true; btn.textContent = '⏳ Guardando...'; }

    try {
        const razonSafe = razon.replace(/'/g, "''");
        await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql:
            `UPDATE facturas_solicitadas
             SET rfc='${rfc}', razon_social='${razonSafe}', cp='${cp}',
                 regimen='${regimen}', uso_cfdi='${cfdi}', forma_pago='${fp}'
             WHERE id=${id}`
        });
        // Cerrar modal
        const m = document.getElementById('_modalEditFac');
        if (m) { m.remove(); document.body.style.overflow = ''; }
        BO_AUTH.showAlert('✅ Solicitud #' + id + ' actualizada correctamente.', 'success', 3000);
        // Actualizar cache y re-render
        const cached = (window._factPendItems||[]).find(x => x.id == id);
        if (cached) { cached.rfc=rfc; cached.razon_social=razon; cached.cp=cp; cached.regimen=regimen; cached.uso_cfdi=cfdi; cached.forma_pago=fp; }
        renderFactPendPage();
    } catch(e) {
        if (btn) { btn.disabled = false; btn.innerHTML = '&#128190; Guardar Cambios'; }
        BO_AUTH.showAlert('Error al guardar: ' + e.message, 'danger');
    }
}

// ══ Facturación Global — Ver desglose de ventas incluidas ══════════════════
async function verSolicitudGlobal(solicitudId) {
    BO_AUTH.showAlert('⏳ Cargando desglose…', 'info');
    try {
        // 0. Obtener datos de la solicitud (cedis_id, cp) para filtrar ventas por CEDIS exacto
        const solRes = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
            sql: `SELECT f.id, f.cp, f.numero_nota, f.forma_pago, f.cedis_id, f.estado, f.cfdi_uuid, f.cfdi_id, f.ventas_ids, f.comentario, f.uuid_sustitucion, f.moneda, f.tipo_cambio,
                         v.centro_apoyo_id AS _centro_id, cv.nombre AS _cli_venta_nombre
                  FROM facturas_solicitadas f
                  LEFT JOIN venta v ON v.id::text = f.numero_nota
                  LEFT JOIN cliente cv ON cv.id::text = v.cliente_id::text
                  WHERE f.id = ${solicitudId}` });
        const solRow = (solRes.rows || [])[0];
        // IMPORTANT: usar ?? en vez de || para que cedis_id=0 (integer) no se convierta en null
        let cedisIdSol = solRow?.cedis_id ?? null;
        // Fallback: extraer CEDIS del numero_nota si la columna BD está vacía
        if (cedisIdSol === null || cedisIdSol === '') {
            const _cMatch = String(solRow?.numero_nota||'').match(/-C(\d+)/);
            if (_cMatch) cedisIdSol = _cMatch[1]; // string '0', '1', etc.
        }
        const cpSolicitud = solRow?.cp || null;
        const esFacturada = solRow?.estado === 'facturada';
        const cfdiUuidSol = solRow?.cfdi_uuid || null;

        // ── ENRUTADOR DEDICADO: FACTURACIÓN GLOBAL EN DÓLARES (USD) ──
        const _isUsdGlobal = String(cedisIdSol) === 'USD' 
                          || String(solRow?.numero_nota || '').includes('-USD') 
                          || String(solRow?.moneda || '').toUpperCase() === 'USD';
        if (_isUsdGlobal) {
            return verDesgloseGlobalUSD(solicitudId, solRow);
        }

        // isCentro: detecta CENTRO- en numero_nota, CCENTROS/CENTROS en numero_nota o cedis_id, notas con centro_apoyo_id, O cliente con nombre 'Centro%'
        const _numNotaStr = String(solRow?.numero_nota || '').toUpperCase();
        const _cedisIdStr = String(solRow?.cedis_id || '').toUpperCase();
        const _cliNombreGlobalLc = String(solRow?._cli_venta_nombre || '').toLowerCase();
        const _isCentroGlobal = _numNotaStr.startsWith('CENTRO-') 
                             || _numNotaStr.includes('CENTRO') 
                             || _numNotaStr.includes('CA_') 
                             || _cedisIdStr.includes('CENTRO') 
                             || _cedisIdStr.startsWith('CA_') 
                             || !!(solRow?._centro_id) 
                             || _cliNombreGlobalLc.startsWith('centro')
                             || String(solRow?.comentario || '').includes('act=');
        const _centroNombreGlobal = solRow?._cli_venta_nombre || solRow?._centro_nombre || (_numNotaStr.includes('CONSOLIDADO') ? 'Consolidado Centros' : 'Centro');
        // Para CENTRO- en numero_nota, extraer el id del prefijo; para UUID, usar _centro_id directo
        const _centroIdGlobal = _isCentroGlobal
            ? (String(solRow?.numero_nota||'').startsWith('CENTRO-')
                ? (String(solRow.numero_nota).match(/^CENTRO-(\d+)/)?.[1] || '0')
                : String(solRow._centro_id || '0'))
            : null;
        // ¿Es nota individual (UUID) o batch CENTRO-{id}?
        const _isCentroBatch = String(solRow?.numero_nota||'').startsWith('CENTRO-');
        const _isIndividualUUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(String(solRow?.numero_nota||''));
        const _isCentroUUID  = _isIndividualUUID; // nota individual vinculada a centro o en general

        // 1. Filtrar ventas
        let cedisClause = '';
        if (_isCentroBatch) {
            // Batch CENTRO-{id}: filtrar todas las ventas del centro pendientes de factura
            cedisClause = `AND v.centro_apoyo_id = '${_centroIdGlobal}'`;
        } else if (_isCentroUUID) {
            // Nota individual de centro: mostrar solo esa venta específica
            cedisClause = `AND v.id = '${solRow.numero_nota}'`;
            // Quitar filtro requiere_factura para que siempre encuentre la nota
            // (se sobreescribe abajo en el WHERE)
        } else if (_isUsdGlobal) {
            // USD: filtrar por moneda en vez de cedis_id (las notas USD vienen de cualquier CEDIS)
            cedisClause = `AND v.moneda IS NOT NULL AND v.moneda != 'MXN'`;
        } else if (cedisIdSol !== null && cedisIdSol !== '') {
            if (String(cedisIdSol) === '0') {
                // Matriz: ventas con cedis_id NULL, vacío, o '0'
                cedisClause = `AND (v.cedis_id IS NULL OR v.cedis_id = '' OR v.cedis_id = '0')`;
            } else if (String(cedisIdSol) === 'CENTROS' || String(cedisIdSol) === 'CCENTROS' || _numNotaStr.includes('CENTROS')) {
                cedisClause = `AND (
                    (v.centro_apoyo_id IS NOT NULL AND v.centro_apoyo_id != '0' AND v.centro_apoyo_id != 'null')
                    OR c.nombre ILIKE '%centro de apoyo%'
                    OR c.nombre ILIKE 'centro %'
                    OR v.comentario ILIKE '%centro de apoyo%'
                    OR v.comentario ILIKE '%crédito (centros)%'
                    OR v.comentario ILIKE '%credito (centros)%'
                    OR v.id ILIKE 'CENTRO-%'
                )`;
            } else {
                cedisClause = `AND v.cedis_id = '${cedisIdSol}'`;
            }
        } else if (cpSolicitud) {
            cedisClause = `AND v.cedis_id IN (SELECT id::text FROM cedis WHERE cp = '${cpSolicitud}')`;
        }
        console.log('[DESGLOSE] cedisIdSol:', cedisIdSol, 'cedisClause:', cedisClause);

        // Para facturas ya timbradas o pendientes, extraer periodo o rango del numero_nota para filtrar por fecha
        let _periodoClauseCF = '';
        let _periodoClausePend = '';
        
        const extractPeriodoClause = (numNota) => {
            const rangoMatch = String(numNota).match(/(?:GLOBAL|CENTRO)[^-]*-(\d{4}-\d{2}-\d{2})_(\d{4}-\d{2}-\d{2})/);
            if (rangoMatch) {
                const mesInicio = `${rangoMatch[1]} 00:00:00`;
                const mesFin = `${rangoMatch[2]} 23:59:59`;
                return `AND v.fecha_venta >= '${mesInicio}' AND v.fecha_venta <= '${mesFin}'`;
            }
            const periodoMatch = String(numNota).match(/(?:GLOBAL|CENTRO)[^-]*-(\d{4})-(\d{2})/);
            if (periodoMatch) {
                const [, yyyy, mm] = periodoMatch;
                const mesInicio = `${yyyy}-${mm}-01`;
                const mesNum = parseInt(mm);
                const anioNum = parseInt(yyyy);
                const nextMes = mesNum === 12 ? 1 : mesNum + 1;
                const nextAnio = mesNum === 12 ? anioNum + 1 : anioNum;
                const mesFin = `${nextAnio}-${String(nextMes).padStart(2,'0')}-01`;
                return `AND v.fecha_venta >= '${mesInicio}' AND v.fecha_venta < '${mesFin}'`;
            }
            return '';
        };

        if (esFacturada) {
            _periodoClauseCF = extractPeriodoClause(solRow?.numero_nota || '');
        }

        const _isGlobalNumNota = String(solRow?.numero_nota||'').startsWith('GLOBAL-');
        if (!esFacturada && (_isGlobalNumNota || _isCentroBatch)) {
            _periodoClausePend = extractPeriodoClause(solRow?.numero_nota || '');
        }

        // ── Parsear ventas_ids (JSON array de IDs guardados al timbrar) ──
        let _ventasIdsArr = [];
        if (solRow?.ventas_ids) {
            try { _ventasIdsArr = JSON.parse(solRow.ventas_ids); } catch(_) {}
        }
        const _hasVentasIds = Array.isArray(_ventasIdsArr) && _ventasIdsArr.length > 0;

        const sql = _isCentroUUID && !_isCentroBatch
            // Nota individual de centro: traer directamente por ID, sin filtros de factura
            ? `SELECT v.id, v.fecha_venta, v.total,
                     COALESCE(v.monto_facturable::float, v.total) AS monto_facturable,
                     v.comentario, v.piezas,
                     COALESCE(c.nombre || ' ' || COALESCE(c.ape_p,''), 'Publico General') AS cliente_nombre
                     FROM venta v LEFT JOIN cliente c ON c.id = v.cliente_id
                     WHERE v.approved=1 AND COALESCE(v.producto_id,'') != 'calificacion-mes' ${cedisClause}
                     ORDER BY v.fecha_venta DESC LIMIT 1`
            : (_hasVentasIds
                // ── NUEVA LÓGICA: usar IDs exactos guardados al crear o timbrar ──
                ? `SELECT v.id, v.fecha_venta, v.total,
                         COALESCE(v.monto_facturable::float, v.total) AS monto_facturable,
                         v.comentario, v.piezas,
                         COALESCE(c.nombre || ' ' || COALESCE(c.ape_p,''), 'Publico General') AS cliente_nombre
                         FROM venta v LEFT JOIN cliente c ON c.id = v.cliente_id
                         WHERE v.id IN (${_ventasIdsArr.map(id => `'${id}'`).join(',')})
                         ORDER BY v.fecha_venta DESC`
                // ── LÓGICA LEGACY: fallback por periodo para facturas antiguas sin ventas_ids ──
                : `SELECT v.id, v.fecha_venta, v.total,
                     COALESCE(v.monto_facturable::float, v.total) AS monto_facturable,
                     v.comentario, v.piezas,
                     COALESCE(c.nombre || ' ' || COALESCE(c.ape_p,''), 'Publico General') AS cliente_nombre
                     FROM venta v LEFT JOIN cliente c ON c.id = v.cliente_id
                     WHERE v.approved=1 AND COALESCE(v.producto_id,'') != 'calificacion-mes'
                     ${esFacturada
                       ? `AND v.factura_emitida = true ${_periodoClauseCF}`
                       : (_isGlobalNumNota
                         ? `AND v.requiere_factura = true AND (v.factura_emitida = false OR v.factura_emitida IS NULL) ${_periodoClausePend}`
                         : (_isCentroBatch
                            ? `AND v.requiere_factura = true AND (v.factura_emitida = false OR v.factura_emitida IS NULL) ${_periodoClausePend}`
                            : `AND v.requiere_factura = true AND (v.factura_emitida = false OR v.factura_emitida IS NULL)`))}
                     ${cedisClause}
                     ORDER BY v.fecha_venta DESC LIMIT 500`);
        console.log('[DESGLOSE] SQL:', sql);
        const res = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql });
        let ventas = (res.rows || []).filter(v => 
            v.producto_id !== 'calificacion-mes' && 
            !String(v.comentario || '').toLowerCase().includes('calificacion del mes')
        );
        window._fgAllVentas = ventas;
        window._fgIsCentroGlobal = typeof _isCentroGlobal !== 'undefined' ? _isCentroGlobal : false;
        console.log('[DESGLOSE] Ventas encontradas:', ventas.length);

        // 2a. Para CENTROS / CENTRO-* batch: obtener activos cobrados de centro_apoyo_pago
        let _centroActivosCobrados = 0;
        if (_isCentroGlobal) {
            // 1) Si la solicitud ya tiene el monto de activos guardado en comentario (formato act=XXXXX o JSON), usarlo directo
            const mActDirect = String(solRow?.comentario || '').match(/act=([0-9.]+)/);
            if (mActDirect && parseFloat(mActDirect[1]) >= 0) {
                _centroActivosCobrados = parseFloat(mActDirect[1]);
                console.log('[DESGLOSE] Activos exactos desde metadata de solicitud:', _centroActivosCobrados);
                if (_centroActivosCobrados > 0) {
                    isActivo = true;
                    montoActivos = _centroActivosCobrados;
                    window._centroActivosCobrados = _centroActivosCobrados;
                }
            } else {
                let sqlActivos = '';
                if (_isCentroBatch && _centroIdGlobal && _centroIdGlobal !== '0') {
                    const _mesMatchCA = String(solRow?.numero_nota||'').match(/^CENTRO-\d+-(\d{4}-\d{2})$/);
                    const _mesCA = _mesMatchCA ? _mesMatchCA[1] : '';
                    if (_mesCA) {
                        sqlActivos = `SELECT COALESCE(SUM(monto),0) as total FROM centro_apoyo_pago WHERE centro_id=${_centroIdGlobal} AND (tipo_pago='Cobro Activos' OR LOWER(tipo_pago) LIKE '%activo%') AND TO_CHAR(creado_en,'YYYY-MM')='${_mesCA}'`;
                    }
                } else if (_isGlobalNumNota && (_numNotaStr.includes('CENTRO') || _cedisIdStr.includes('CENTRO'))) {
                    const rangoMatchCA = _numNotaStr.match(/GLOBAL-(\d{4}-\d{2}-\d{2})_(\d{4}-\d{2}-\d{2})/);
                    if (rangoMatchCA) {
                        sqlActivos = `SELECT COALESCE(SUM(monto),0) as total FROM centro_apoyo_pago WHERE (tipo_pago='Cobro Activos' OR LOWER(tipo_pago) LIKE '%activo%') AND creado_en >= '${rangoMatchCA[1]} 00:00:00' AND creado_en <= '${rangoMatchCA[2]} 23:59:59'`;
                    }
                }
                if (sqlActivos) {
                    try {
                        const rActCA = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlActivos });
                        _centroActivosCobrados = Number(rActCA.rows?.[0]?.total || 0);

                        // Si es Factura Global, descontar los activos ya aplicados en facturas de centros para el periodo
                        if (_isGlobalNumNota && _centroActivosCobrados > 0) {
                            try {
                                const rUsados = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                                    sql: `SELECT comentario FROM facturas_solicitadas WHERE numero_nota LIKE 'CENTRO-%' AND estado IN ('solicitada','en_proceso','facturada')`
                                });
                                let activosUsados = 0;
                                (rUsados.rows || []).forEach(r => {
                                    const m = String(r.comentario||'').match(/act=([0-9.]+)/);
                                    if (m) activosUsados += parseFloat(m[1]) || 0;
                                });
                                _centroActivosCobrados = Math.max(0, _centroActivosCobrados - activosUsados);
                            } catch(_) {}
                        }

                        console.log('[DESGLOSE] Activos cobrados centro:', _centroActivosCobrados);
                        if (_centroActivosCobrados > 0) {
                            isActivo = true;
                            montoActivos = _centroActivosCobrados;
                            window._centroActivosCobrados = _centroActivosCobrados;
                        }
                    } catch(_e) { console.error('[DESGLOSE] Error activos centro:', _e); }
                }
            }
        }

        // 2b. Totales
        const totalBruto = ventas.reduce((s,v) => {
            let tot = Number(v.total||0);
            const allMatches = [...((v.comentario || '').matchAll(/(?:^|[^A-Z_])(?:ACTIVOS(?:_[A-Z_]+)?(?:\/[^\s$]+)?[^$]*\$([0-9.,]+))/gi))];
            if (allMatches.length > 0) {
                tot += allMatches.reduce((acc, m) => acc + parseFloat(m[1].replace(/,/g, '')), 0);
            }
            return s + tot;
        }, 0);
        const totalGravable = ventas.reduce((s,v) => s + _calcularMontoFacturableNota(v), 0);
        const formaPagoMap = {
            '01': '01 — Efectivo',
            '02': '02 — Cheque nominativo',
            '03': '03 — Transferencia electrónica de fondos',
            '04': '04 — Tarjeta de crédito',
            '28': '28 — Tarjeta de débito',
            '99': '99 — Por definir'
        };
        let fpInfo = _detectFormaPagoMayoria(ventas);
        if (solRow?.forma_pago && formaPagoMap[solRow.forma_pago]) {
            fpInfo = { code: solRow.forma_pago, label: formaPagoMap[solRow.forma_pago] };
        } else if (_isCentroGlobal && fpInfo.code === '01') {
            fpInfo = { code: '03', label: '03 — Transferencia electrónica de fondos' };
        }
        const isUsd = (solRow?.moneda === 'USD') || (ventas.some(v => v.moneda === 'USD'));
        const tcGlobal = parseFloat(solRow?.tipo_cambio) || 17.0;
        const fmt = (n) => '$' + Number(n).toLocaleString('es-MX',{minimumFractionDigits:2});

        // 3. Agregar productos de todas las ventas (expandiendo paquetes)
        // 3a. Cargar catálogo + componentes de paquetes
        let catalogo = [];
        let componentes = [];
        try {
            const [catRes, compRes] = await Promise.all([
                BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                    sql: `SELECT id, sku, nombre, precio, tasa_iva, categoria FROM productos` }),
                BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                    sql: `SELECT pc.paquete_id, pc.componente_id, pc.cantidad, p.nombre AS comp_nombre, p.precio AS comp_precio
                          FROM producto_componente pc JOIN productos p ON p.id = pc.componente_id` })
            ]);
            catalogo = catRes.rows || [];
            componentes = compRes.rows || [];
        } catch(_) {}
        window._fgCatalogo = catalogo;
        window._fgComponentes = componentes;

        // 3b. Consolidar piezas, expandiendo paquetes a componentes
        const consolidated = {};
        for (const v of ventas) {
            let piezasArr = [];
            try {
                piezasArr = Array.isArray(v.piezas) ? v.piezas :
                            (typeof v.piezas === 'string' ? JSON.parse(v.piezas || '[]') : []);
            } catch(_) {}

            for (const pieza of piezasArr) {
                const prodId = String(pieza.producto_id || pieza.sku || '');
                if (!prodId) continue;
                const qty = parseInt(pieza.cantidad) || 1;
                const precioUnit = parseFloat(pieza.precio_unitario) || 0;
                // Detectar si es paquete
                const catProd = catalogo.find(c => String(c.id) === prodId || c.sku === prodId);
                if (catProd && catProd.categoria === 'paquete') {
                    const comps = componentes.filter(c => c.paquete_id === catProd.id);
                    if (comps.length > 0) {
                        let valPaqMXN = 0;
                        comps.forEach(c => {
                            const _p = catalogo.find(cp => String(cp.id) === String(c.componente_id));
                            valPaqMXN += (parseInt(c.cantidad) || 1) * (parseFloat(c.comp_precio || _p?.precio) || 0);
                        });

                        for (const comp of comps) {
                            const compId = String(comp.componente_id);
                            const compQty = (parseInt(comp.cantidad) || 1) * qty;
                            const compNombre = (comp.comp_nombre || '').replace(/\s+(Pub|MC|Dist)$/i, '').trim();
                            let compPrecio = parseFloat(comp.comp_precio) || 0;

                            if (isUsd) {
                                if (valPaqMXN > 0 && precioUnit > 0) {
                                    const cantEnPaq = parseInt(comp.cantidad) || 1;
                                    const shareComp = (cantEnPaq * compPrecio) / valPaqMXN;
                                    compPrecio = +((precioUnit * shareComp) / cantEnPaq).toFixed(2);
                                } else {
                                    compPrecio = +(compPrecio / tcGlobal).toFixed(2);
                                }
                            }

                            const _compCat = catalogo.find(c => String(c.id) === compId);
                            const _compTasa = parseFloat(_compCat?.tasa_iva || 0);
                            if (!consolidated[compId]) consolidated[compId] = { qty: 0, precioUnit: compPrecio, nombre: compNombre, prodId: compId, tasa_iva: _compTasa };
                            consolidated[compId].qty += compQty;
                            if (compPrecio > 0 && (!consolidated[compId].precioUnit || consolidated[compId].precioUnit === 0)) consolidated[compId].precioUnit = compPrecio;
                            if (!consolidated[compId].nombre && compNombre) consolidated[compId].nombre = compNombre;
                        }
                        continue;
                    }
                }
                const _pieCat = catalogo.find(c => String(c.id) === prodId || c.sku === prodId);
                const _pieTasa = parseFloat(_pieCat?.tasa_iva || 0);
                let piePrecioUnit = precioUnit;
                if (!piePrecioUnit && _pieCat) {
                    piePrecioUnit = parseFloat(_pieCat.precio) || 0;
                    if (isUsd) piePrecioUnit = +(piePrecioUnit / tcGlobal).toFixed(2);
                }
                if (!consolidated[prodId]) consolidated[prodId] = { qty: 0, precioUnit: piePrecioUnit, nombre: pieza.nombre || pieza.producto || '', prodId, tasa_iva: _pieTasa };
                consolidated[prodId].qty += qty;
                if (piePrecioUnit > 0) {
                    if (!consolidated[prodId].precioUnit || consolidated[prodId].precioUnit === 0) {
                        consolidated[prodId].precioUnit = piePrecioUnit;
                    } else if (isUsd && consolidated[prodId].precioUnit > 50 && piePrecioUnit <= 50) {
                        consolidated[prodId].precioUnit = piePrecioUnit;
                    }
                }
            }
        }

        // 3c. Enriquecer nombres desde catálogo
        for (const [key, prod] of Object.entries(consolidated)) {
            const catProd = catalogo.find(c => String(c.id) === key || c.sku === key);
            if (catProd) {
                if (!prod.nombre || prod.nombre.match(/^(ID:|SUERO-|ESENCIA-|PROMO-)/i)) {
                    prod.nombre = (catProd.nombre || '').replace(/\s+(Pub|MC|Dist)$/i, '').trim();
                }
                if (!prod.precioUnit || prod.precioUnit === 0) {
                    let cp = parseFloat(catProd.precio) || 0;
                    if (isUsd) cp = +(cp / tcGlobal).toFixed(2);
                    prod.precioUnit = cp;
                } else if (isUsd && prod.precioUnit > 50 && (prod.nombre.toLowerCase().includes('dulet') || prod.nombre.toLowerCase().includes('suero'))) {
                    prod.precioUnit = +(prod.precioUnit / tcGlobal).toFixed(2);
                }
            }
        }

        // 4. Calcular valor REAL de productos y activos
        const totalProductValue = Object.values(consolidated).reduce((s,p) => s + (p.qty * p.precioUnit), 0);
        const totalActivosFromNotas = ventas.reduce((s, v) => {
            let a = Number(v.monto_activos) || 0;
            if (a === 0) {
                const allMatches = [...((v.comentario || '').matchAll(/(?:^|[^A-Z_])(?:ACTIVOS(?:_[A-Z_]+)?(?:\/[^\s$]+)?[^$]*\$([0-9.,]+))/gi))];
                if (allMatches.length > 0) {
                    a = allMatches.reduce((acc, m) => acc + parseFloat(m[1].replace(/,/g, '')), 0);
                }
            }
            return s + a;
        }, 0);

        let totalActivos = _centroActivosCobrados > 0 
            ? _centroActivosCobrados 
            : (totalActivosFromNotas > 0 ? totalActivosFromNotas : Math.max(0, totalProductValue - totalGravable));
        if (totalActivos < 0) totalActivos = 0;
        window._fgTotalActivos = totalActivos;

        // 5. Dividir en regulares (a facturar) vs absorbidos 100% por activos
        let activosRestante = totalActivos;
        const productosRegulares = [];
        const productosActivos = [];

        // Estrategia fiscal limpia: productos IVA 16% absorben activos primero para no generar partidas ni IVA 16%, luego 0%
        const allProdsArr = Object.values(consolidated);
        const prods16 = allProdsArr.filter(p => (p.tasa_iva || 0) > 0).sort((a,b) => b.precioUnit - a.precioUnit);
        const prods0 = allProdsArr.filter(p => (p.tasa_iva || 0) === 0).sort((a,b) => b.precioUnit - a.precioUnit);

        function _distribuirBucket(bucket) {
            for (const prod of bucket) {
                const fullPrice = prod.precioUnit;
                if (fullPrice <= 0) {
                    productosRegulares.push({ ...prod });
                    continue;
                }
                const possibleSubsidized = Math.floor(activosRestante / fullPrice);
                const toSubsidize = Math.min(prod.qty, possibleSubsidized);
                if (toSubsidize > 0) {
                    productosActivos.push({ ...prod, qty: toSubsidize, precioUnit: fullPrice, absorbido: true });
                    activosRestante -= (toSubsidize * fullPrice);
                }
                const remaining = prod.qty - toSubsidize;
                if (remaining > 0) {
                    let itemDiscount = 0;
                    if (activosRestante > 0) {
                        itemDiscount = Math.min(Math.round(activosRestante * 100) / 100, remaining * fullPrice);
                        activosRestante = Math.max(0, Math.round((activosRestante - itemDiscount) * 100) / 100);
                    }
                    productosRegulares.push({ ...prod, qty: remaining, discount: itemDiscount });
                }
            }
        }
        _distribuirBucket(prods16); // IVA 16% primero
        _distribuirBucket(prods0);  // luego 0%

        // 5. Render HTML para productos
        const renderProdRows = (prods, color) => prods.map(p => `<tr>
            <td style="font-size:.72rem;padding:.25rem .4rem">${(p.nombre || 'ID:'+p.prodId).replace(/(Pub|MC|Dist)$/i,'').trim()}${p.discount ? ` <span style="color:var(--primary);font-size:.65rem;font-weight:600;">(Desc: -$${p.discount.toLocaleString('es-MX',{minimumFractionDigits:2})})</span>` : ''}</td>
            <td style="font-size:.72rem;padding:.25rem .4rem;text-align:center;font-weight:700;color:${color}">${p.qty}</td>
            <td style="font-size:.72rem;padding:.25rem .4rem;text-align:right">${fmt(p.precioUnit)}</td>
            <td style="font-size:.72rem;padding:.25rem .4rem;text-align:right;font-weight:600;color:${color}">${fmt((p.qty * p.precioUnit) - (p.discount || 0))}</td>
        </tr>`).join('');

        const totalRegular = productosRegulares.reduce((s,p) => s + (p.qty * p.precioUnit) - (p.discount || 0), 0);
        const totalActivosAbsorbidos = productosActivos.reduce((s,p) => s + (p.qty * p.precioUnit), 0);

        const productosHtml = `
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:1rem;padding:1rem 1.5rem;border-bottom:1px solid var(--border);">
            <!-- Productos Regulares -->
            <div id="fg-productos-regulares-container">
                <div style="font-size:.7rem;font-weight:700;color:var(--success);text-transform:uppercase;letter-spacing:.04em;margin-bottom:.4rem">
                    🛒 Productos a Facturar (${productosRegulares.reduce((s,p)=>s+p.qty,0)} pzs) — ${fmt(totalRegular)}
                </div>
                <table class="bo-table" style="font-size:.72rem;margin:0">
                    <thead><tr><th>Producto</th><th style="text-align:center">Cant</th><th style="text-align:right">P.U.</th><th style="text-align:right">Subtotal</th></tr></thead>
                    <tbody>${renderProdRows(productosRegulares, 'var(--success)') || '<tr><td colspan="4" style="text-align:center;color:var(--text-dim)">—</td></tr>'}</tbody>
                </table>
            </div>
            <!-- Activos (Subsidiados al 100% en CFDI) -->
            <div id="fg-productos-activos-container">
                <div style="font-size:.7rem;font-weight:700;color:var(--accent-gold);text-transform:uppercase;letter-spacing:.04em;margin-bottom:.4rem">
                    🏷️ Subsidiados por Activos (${productosActivos.reduce((s,p)=>s+p.qty,0)} pzs) — ${fmt(totalActivosAbsorbidos)} (100% en CFDI con $0.01 y Descuento 100%)
                </div>
                <table class="bo-table" style="font-size:.72rem;margin:0">
                    <thead><tr><th>Producto</th><th style="text-align:center">Cant</th><th style="text-align:right">P.U.</th><th style="text-align:right">Valor Cubierto</th></tr></thead>
                    <tbody>${renderProdRows(productosActivos, 'var(--accent-gold)') || '<tr><td colspan="4" style="text-align:center;color:var(--text-dim)">Sin activos</td></tr>'}</tbody>
                </table>
            </div>
        </div>`;

        // 6. Tabla de notas individuales con checkboxes
        const _canEditGlobalNotas = !esFacturada && solRow?.estado !== 'cancelada';
        window._fgExcludedIds = [];
        window._fgUsdAllVentas = [];
        window._fgCurrentSolicitudId = solicitudId;
        window._fgCurrentNumeroNota = solRow?.numero_nota || '';
        window._fgAllVentas = ventas;
        let activosPorDistribuir = (_isCentroGlobal && totalActivos > 0) ? totalActivos : 0;
        const notasRows = ventas.map(v => {
            let totalReal = Number(v.total || 0);
            let facturableReal = _calcularMontoFacturableNota(v);
            
            let totalPagadoCheck = 0;
            const pagosCheck = (v.comentario || '').match(/\$[\d,]+(?:\.\d+)?/g) || [];
            pagosCheck.forEach(m => { const val = parseFloat(m.replace(/[\$,]/g, '')); if (!isNaN(val)) totalPagadoCheck += val; });
            const envioMCheck = (v.comentario || '').match(/ENVIO_EXTRA\s*\$([\d,]+(?:\.\d+)?)/i);
            if (envioMCheck) totalPagadoCheck -= parseFloat(envioMCheck[1].replace(/,/g,''));

            if (totalPagadoCheck > totalReal) {
                totalReal = totalPagadoCheck;
            }

            return `<tr>
            <td style="font-size:.7rem;padding:.2rem .4rem;text-align:center"><input type="checkbox" checked ${_canEditGlobalNotas ? '' : 'disabled'} class="fg-checkbox" data-id="${v.id}" data-total="${v.total}" data-facturable="${facturableReal}" data-real="${totalReal}" onchange="window._recalcularGlobalModal()"></td>
            <td style="font-size:.7rem;padding:.2rem .4rem">${v.id.substring(0,8)}…</td>
            <td style="font-size:.7rem;padding:.2rem .4rem">${v.cliente_nombre}</td>
            <td style="font-size:.7rem;padding:.2rem .4rem;text-align:right">${fmt(totalReal)}</td>
            <td style="font-size:.7rem;padding:.2rem .4rem;text-align:right;color:var(--success)">${fmt(facturableReal)}</td>
            <td style="font-size:.7rem;padding:.2rem .4rem;color:var(--text-dim)">${(v.comentario||'').substring(0,35)}</td>
        </tr>`;
        }).join('');

        const totalFacturableFinal = (_isCentroGlobal && totalActivos > 0) ? totalRegular : totalGravable;
        window._fgTotalFacturable = totalFacturableFinal;

        const periodicidadMap = {
            '01': '01 — Diario',
            '02': '02 — Semanal',
            '03': '03 — Quincenal',
            '04': '04 — Mensual',
            '05': '05 — Bimestral'
        };
        const curPeriodicidad = solRow?.periodicidad || '04';
        const curPeriodicidadLabel = periodicidadMap[curPeriodicidad] || '04 — Mensual';

        // 7. Construir modal
        const modal = document.createElement('div');
        modal.id = 'modal-global-desglose';
        modal.style.cssText = 'position:fixed;inset:0;z-index:9999;background:rgba(0,0,0,.85);display:flex;align-items:center;justify-content:center;';
        modal.innerHTML = `<div style="background:var(--bg-card);border:1px solid var(--border);border-radius:12px;max-width:920px;width:95%;max-height:90vh;overflow-y:auto;box-shadow:0 20px 60px rgba(0,0,0,.6);">
            <div style="padding:1rem 1.5rem;border-bottom:1px solid var(--border);display:flex;justify-content:space-between;align-items:center;">
                <h3 style="margin:0;font-size:1rem;">${_isCentroGlobal ? `🏪 Desglose Centro — ${_centroNombreGlobal}` : '📝 Desglose Factura Global'} #${solicitudId} ${isUsd ? '<span style="font-size:.75rem;background:rgba(59,130,246,.15);color:#60a5fa;border:1px solid rgba(59,130,246,.3);padding:.2rem .5rem;border-radius:6px;margin-left:.5rem;font-weight:700;">🇺🇸 Moneda USD</span>' : ''}</h3>
                <button onclick="window._cerrarModalGlobalDesglose(${solicitudId}, false, ${_canEditGlobalNotas})" style="background:none;border:none;color:var(--text-primary);font-size:1.2rem;cursor:pointer">✕</button>
            </div>
            <!-- KPI cards -->
            <div style="padding:.75rem 1.5rem;display:grid;grid-template-columns:repeat(5, minmax(0, 1fr));gap:.5rem;border-bottom:1px solid var(--border);">
                <div style="background:rgba(99,102,241,.08);border-radius:8px;padding:.5rem;text-align:center;">
                    <div style="font-size:.6rem;color:var(--text-dim)">Notas</div>
                    <div style="font-size:1.1rem;font-weight:800;color:#818cf8" id="fg-kpi-notas">${ventas.length}</div>
                </div>
                <div style="background:rgba(16,185,129,.08);border-radius:8px;padding:.5rem;text-align:center;">
                    <div style="font-size:.6rem;color:var(--text-dim)">Total Facturable ${isUsd ? '(USD)' : ''}</div>
                    <div style="font-size:.9rem;font-weight:700;color:var(--success)" id="fg-kpi-facturable">${fmt(totalFacturableFinal)}</div>
                </div>
                <div style="background:rgba(234,179,8,.08);border-radius:8px;padding:.5rem;text-align:center;">
                    <div style="font-size:.6rem;color:var(--text-dim)">Descuentos/Activos ${isUsd ? '(USD)' : ''}</div>
                    <div style="font-size:.9rem;font-weight:700;color:var(--accent-gold)" id="fg-kpi-activos">${fmt(totalActivos)}</div>
                </div>
                <div style="background:rgba(139,92,246,.08);border-radius:8px;padding:.5rem;text-align:center;position:relative;">
                    <div style="font-size:.6rem;color:var(--text-dim)">Forma Pago <span style="font-size:.6rem;cursor:pointer" onclick="document.getElementById('fg-fp-text').style.display='none'; document.getElementById('fg-fp-select').style.display='block';">✏️</span></div>
                    <div id="fg-fp-text" style="font-size:.78rem;font-weight:700;color:#a78bfa;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">${fpInfo.label}</div>
                    <select id="fg-fp-select" onchange="document.getElementById('fg-fp-text').innerText = this.options[this.selectedIndex].text; document.getElementById('fg-fp-select').style.display='none'; document.getElementById('fg-fp-text').style.display='block';" style="display:none;width:100%;font-size:.7rem;padding:.1rem;background:var(--bg-dark);color:var(--text-primary);border:1px solid var(--border);border-radius:4px;margin-top:.2rem;">
                        <option value="01" ${fpInfo.code === '01' ? 'selected' : ''}>01 — Efectivo</option>
                        <option value="03" ${fpInfo.code === '03' ? 'selected' : ''}>03 — Transferencia</option>
                        <option value="04" ${fpInfo.code === '04' ? 'selected' : ''}>04 — Tarjeta de crédito</option>
                        <option value="99" ${fpInfo.code === '99' ? 'selected' : ''}>99 — Por definir</option>
                    </select>
                </div>
                <div style="background:rgba(59,130,246,.08);border-radius:8px;padding:.5rem;text-align:center;position:relative;">
                    <div style="font-size:.6rem;color:var(--text-dim)">Periodicidad <span style="font-size:.6rem;cursor:pointer" onclick="document.getElementById('fg-per-text').style.display='none'; document.getElementById('fg-per-select').style.display='block';">✏️</span></div>
                    <div id="fg-per-text" style="font-size:.78rem;font-weight:700;color:#60a5fa;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">${curPeriodicidadLabel}</div>
                    <select id="fg-per-select" onchange="document.getElementById('fg-per-text').innerText = this.options[this.selectedIndex].text; document.getElementById('fg-per-select').style.display='none'; document.getElementById('fg-per-text').style.display='block';" style="display:none;width:100%;font-size:.7rem;padding:.1rem;background:var(--bg-dark);color:var(--text-primary);border:1px solid var(--border);border-radius:4px;margin-top:.2rem;">
                        <option value="01" ${curPeriodicidad === '01' ? 'selected' : ''}>01 — Diario</option>
                        <option value="02" ${curPeriodicidad === '02' ? 'selected' : ''}>02 — Semanal</option>
                        <option value="03" ${curPeriodicidad === '03' ? 'selected' : ''}>03 — Quincenal</option>
                        <option value="04" ${curPeriodicidad === '04' ? 'selected' : ''}>04 — Mensual</option>
                        <option value="05" ${curPeriodicidad === '05' ? 'selected' : ''}>05 — Bimestral</option>
                    </select>
                </div>
            </div>
            <!-- Productos desglosados -->
            ${productosHtml}
            <!-- Notas individuales -->
            <div style="padding:.5rem 1.5rem;">
                <div style="font-size:.68rem;font-weight:700;color:var(--text-dim);text-transform:uppercase;letter-spacing:.04em;margin-bottom:.3rem">📝 Notas Individuales (${ventas.length})</div>
                <input type="text" id="fg-search-notas" placeholder="🔍 Buscar por ID de nota, Cliente o Comentario..." oninput="window._filtrarNotasGlobalModal()" style="width:100%;padding:.4rem;margin-bottom:.5rem;border-radius:6px;border:1px solid var(--border);background:var(--bg-dark);color:var(--text-primary);font-size:.75rem;">
                <div style="max-height:25vh;overflow-y:auto;">
                    <table class="bo-table" style="font-size:.7rem" id="fg-notas-table">
                        <thead style="position:sticky;top:0;z-index:2;background:var(--bg-card)"><tr>
                            <th style="text-align:center">Incluir</th><th>Nota</th><th>Cliente</th><th>Total</th><th>Facturable</th><th>Pago</th>
                        </tr></thead>
                        <tbody>${notasRows || '<tr><td colspan="5" style="text-align:center;color:var(--text-dim)">Sin ventas</td></tr>'}</tbody>
                    </table>
                </div>
            </div>
            <div style="padding:.75rem 1.5rem;border-top:1px solid var(--border);display:flex;gap:.5rem;justify-content:space-between;" id="fg-modal-buttons">
                <div style="display:flex;gap:.5rem;">
                    <button class="btn btn-outline btn-sm" onclick="window._exportarCsvGlobal()">⬇️ CSV</button>
                    <button class="btn btn-outline btn-sm" onclick="window._exportarPdfGlobal(${solicitudId})">📄 PDF</button>
                    ${_isCentroGlobal ? `<button class="btn btn-outline btn-sm" style="border-color:#6366f1;color:#818cf8;" onclick="window._abrirCotejoEspecialCentro(${solicitudId})">🔍 Desglose Especial</button>` : ''}
                </div>
                <div style="display:flex;gap:.5rem;align-items:center;">
                    <button class="btn btn-outline btn-sm" onclick="window._cerrarModalGlobalDesglose(${solicitudId}, false, ${_canEditGlobalNotas})">✕ Cerrar</button>
                    ${_canEditGlobalNotas ? `<button id="fg-btn-save-excl" class="btn btn-outline btn-sm" style="display:none;border-color:#f59e0b;color:#fbbf24;font-weight:700;" onclick="window._guardarExclusionesModalGlobal(${solicitudId}, false)">💾 Guardar Exclusiones</button>` : ''}
                    ${esFacturada 
                        ? `<span class="badge" style="background:rgba(16,185,129,.15);color:var(--success);padding:.4rem .8rem;font-weight:700;font-size:.78rem;border-radius:6px;border:1px solid rgba(16,185,129,.3);">✅ Facturada (${cfdiUuidSol ? cfdiUuidSol.substring(0,8)+'...' : 'CFDI'})</span>`
                        : (solRow?.estado === 'cancelada'
                            ? `<span class="badge" style="background:rgba(239,68,68,.15);color:var(--danger);padding:.4rem .8rem;font-weight:700;font-size:.78rem;border-radius:6px;border:1px solid rgba(239,68,68,.3);">❌ Cancelada ${solRow?.uuid_sustitucion ? `(Sust. ${solRow.uuid_sustitucion.substring(0,8)}...)` : ''}</span>`
                            : `<button id="fg-btn-aprobar-timbrar" class="btn btn-success btn-sm" onclick="window._fgFormaPago = (document.getElementById('fg-fp-select')?.value || '${fpInfo.code || '01'}'); window._fgPeriodicidad = (document.getElementById('fg-per-select')?.value || '${curPeriodicidad || '04'}'); if (typeof window._fgTotalActivos !== 'number') window._fgTotalActivos = ${totalActivos}; if (typeof window._fgTotalFacturable !== 'number') window._fgTotalFacturable = ${totalFacturableFinal}; document.getElementById('modal-global-desglose').remove(); confirmarTimbrado(${solicitudId},'${_isCentroBatch ? 'centro' : 'global'}', window._fgExcludedIds || [], 'PUE', true)">⚡ Aprobar y Timbrar</button>`
                          )
                    }
                </div>
            </div>
        </div>`;
        document.body.appendChild(modal);
    } catch(e) {
        BO_AUTH.showAlert('Error cargando desglose: ' + e.message, 'error');
    }
}

// ══ Facturación Global Dólares (USD) — Modal Dedicado ════════════════════════
async function verDesgloseGlobalUSD(solicitudId, solRow) {
    BO_AUTH.showAlert('⏳ Cargando desglose Dólares (USD)…', 'info');
    try {
        if (!solRow) {
            const solRes = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                sql: `SELECT f.id, f.cp, f.numero_nota, f.forma_pago, f.cedis_id, f.estado, f.cfdi_uuid, f.cfdi_id, f.ventas_ids, f.comentario, f.uuid_sustitucion, f.moneda, f.tipo_cambio, f.periodicidad
                      FROM facturas_solicitadas f WHERE f.id = ${solicitudId}` });
            solRow = (solRes.rows || [])[0] || {};
        }

        // Catálogo y componentes
        let catalogo = window._fgCatalogo || [];
        let componentes = window._fgComponentes || [];
        if (!catalogo.length) {
            const [catRes, compRes] = await Promise.all([
                BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: 'SELECT id, sku, nombre, precio, precio_usd, tasa_iva, categoria FROM productos' }),
                BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: 'SELECT pc.paquete_id, pc.componente_id, pc.cantidad, p.nombre AS comp_nombre, p.precio AS comp_precio, p.precio_usd AS comp_precio_usd FROM producto_componente pc JOIN productos p ON p.id = pc.componente_id' })
            ]);
            catalogo = catRes.rows || [];
            componentes = compRes.rows || [];
            window._fgCatalogo = catalogo;
            window._fgComponentes = componentes;
        }

        // Ventas asociadas a la solicitud USD
        let ventas = [];
        if (solRow?.ventas_ids) {
            let vIds = [];
            try {
                vIds = typeof solRow.ventas_ids === 'string' ? JSON.parse(solRow.ventas_ids) : solRow.ventas_ids;
            } catch(_) {}
            if (Array.isArray(vIds) && vIds.length > 0) {
                const idsStr = vIds.map(x => `'${x}'`).join(',');
                const vRes = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                    sql: `SELECT v.id, v.total, COALESCE(v.monto_facturable, v.total) AS monto_facturable, COALESCE(v.monto_activos, 0) AS monto_activos,
                                 v.piezas, v.comentario, v.moneda, v.fecha_venta, v.centro_apoyo_id,
                                 COALESCE(c.nombre || ' ' || c.ape_p, 'Público General USA') AS cliente_nombre,
                                 ca.nombre AS centro_nombre
                          FROM venta v
                          LEFT JOIN cliente c ON c.id::text = v.cliente_id::text
                          LEFT JOIN centro_apoyo ca ON ca.id::text = v.centro_apoyo_id::text
                          WHERE v.id IN (${idsStr})
                          ORDER BY v.fecha_venta DESC` });
                ventas = vRes.rows || [];
            }
        }

        // Si no se encontraron por ventas_ids, buscar ventas con moneda USD del periodo
        if (ventas.length === 0) {
            const m = String(solRow?.numero_nota || '').match(/(\d{4})-(\d{2})/);
            if (m) {
                const yyyy = m[1], mm = m[2];
                const vRes = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                    sql: `SELECT v.id, v.total, COALESCE(v.monto_facturable, v.total) AS monto_facturable, COALESCE(v.monto_activos, 0) AS monto_activos,
                                 v.piezas, v.comentario, v.moneda, v.fecha_venta, v.centro_apoyo_id,
                                 COALESCE(c.nombre || ' ' || c.ape_p, 'Público General USA') AS cliente_nombre,
                                 ca.nombre AS centro_nombre
                          FROM venta v
                          LEFT JOIN cliente c ON c.id::text = v.cliente_id::text
                          LEFT JOIN centro_apoyo ca ON ca.id::text = v.centro_apoyo_id::text
                          WHERE (v.moneda = 'USD' OR v.cedis_id = 'USD')
                            AND TO_CHAR(v.fecha_venta, 'YYYY-MM') = '${yyyy}-${mm}'
                          ORDER BY v.fecha_venta DESC` });
                ventas = vRes.rows || [];
            }
        }

        const tcGlobal = parseFloat(solRow?.tipo_cambio) || window._dofTipoCambio || 18.50;
        const esFacturada = solRow?.estado === 'facturada';
        const cfdiUuidSol = solRow?.cfdi_uuid || null;

        // Clasificar ventas: Centros USD vs Retail USA
        const ventasCentrosUSD = [];
        const ventasRetailUSD = [];
        let totalCobradoUSD = 0;
        let totalCentrosUSD = 0;
        let totalRetailUSD = 0;

        ventas.forEach(v => {
            const tot = Number(v.total || 0);
            totalCobradoUSD += tot;
            if (v.centro_apoyo_id && v.centro_apoyo_id !== '0' && v.centro_apoyo_id !== 0) {
                ventasCentrosUSD.push(v);
                totalCentrosUSD += tot;
            } else {
                ventasRetailUSD.push(v);
                totalRetailUSD += tot;
            }
        });

        // 1. Activos de Centros USD (desde metadata de la solicitud: act=XXXX)
        let activosCentrosUSD = 0;
        const mActDirect = String(solRow?.comentario || '').match(/act=([0-9.]+)/);
        if (mActDirect && parseFloat(mActDirect[1]) >= 0) {
            activosCentrosUSD = parseFloat(mActDirect[1]) || 0;
        }

        // 2. Activos de notas Retail USA individuales (columna monto_activos o regex en comentario)
        let activosRetailUSD = 0;
        ventas.forEach(v => {
            const isCentro = v.centro_apoyo_id && v.centro_apoyo_id !== '0' && v.centro_apoyo_id !== 0;
            if (!isCentro) {
                let act = 0;
                if (v.monto_activos && Number(v.monto_activos) > 0) {
                    act = Number(v.monto_activos);
                } else {
                    const mA = (v.comentario || '').match(/(?:ACTIVOS|ACTIVO)[^$]*\$([0-9.,]+)/i);
                    if (mA) act = parseFloat(mA[1].replace(/,/g, '')) || 0;
                }
                activosRetailUSD += act;
            }
        });

        const totalActivosUSD = Math.min(totalCobradoUSD, activosCentrosUSD + activosRetailUSD);
        const totalFacturableUSD = Math.max(0, totalCobradoUSD - totalActivosUSD);
        const totalFacturableMXN = totalFacturableUSD * tcGlobal;

        window._fgTotalActivos = totalActivosUSD;
        window._fgTotalFacturable = totalFacturableUSD;

        // Consolidar productos entregados en USD
        const consolidatedUSD = {};
        for (const v of ventas) {
            let piezasArr = [];
            try { piezasArr = Array.isArray(v.piezas) ? v.piezas : JSON.parse(v.piezas || '[]'); } catch(_) {}
            for (const pieza of piezasArr) {
                const prodId = String(pieza.producto_id || pieza.sku || '');
                if (!prodId) continue;
                const qty = parseInt(pieza.cantidad) || 1;
                const precioUnit = parseFloat(pieza.precio_unitario) || 0;
                let nombreProd = pieza.nombre || pieza.producto || 'Producto';
                const catProd = catalogo.find(c => String(c.id) === prodId || c.sku === prodId);
                if (catProd) nombreProd = (catProd.nombre || '').replace(/\s+(Pub|MC|Dist)$/i, '').trim();

                if (!consolidatedUSD[prodId]) consolidatedUSD[prodId] = { qty: 0, precioUnit, nombre: nombreProd };
                consolidatedUSD[prodId].qty += qty;
                if (precioUnit > consolidatedUSD[prodId].precioUnit) consolidatedUSD[prodId].precioUnit = precioUnit;
            }
        }

        const _canEditUsdNotas = !esFacturada && solRow?.estado !== 'cancelada';
        window._fgUsdAllVentas = ventas;
        window._fgUsdSolRow = solRow;
        window._fgCurrentSolicitudId = solicitudId;
        window._fgCurrentNumeroNota = solRow?.numero_nota || '';
        window._fgExcludedIdsUSD = [];

        const fmtUSD = (n) => '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' USD';
        const fmtMXN = (n) => '$' + Number(n).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' MXN';

        // Construir HTML de productos
        let prodRowsHtml = '';
        let totPiezas = 0;
        Object.values(consolidatedUSD).forEach(p => {
            const sub = p.qty * p.precioUnit;
            totPiezas += p.qty;
            prodRowsHtml += `
                <tr>
                    <td style="font-weight:600;">${p.nombre}</td>
                    <td style="text-align:center;font-weight:700;">${p.qty}</td>
                    <td style="text-align:right;">${fmtUSD(p.precioUnit)}</td>
                    <td style="text-align:right;font-weight:700;color:#38bdf8;">${fmtUSD(sub)}</td>
                </tr>`;
        });

        // Construir HTML de notas individuales
        let notasRowsHtml = '';
        ventas.forEach(v => {
            const tot = Number(v.total || 0);
            const isCentro = v.centro_apoyo_id && v.centro_apoyo_id !== '0' && v.centro_apoyo_id !== 0;
            let vActivos = 0;
            if (isCentro) {
                vActivos = Math.min(tot, activosCentrosUSD);
            } else {
                if (v.monto_activos && Number(v.monto_activos) > 0) {
                    vActivos = Number(v.monto_activos);
                } else {
                    const mA = (v.comentario || '').match(/(?:ACTIVOS|ACTIVO)[^$]*\$([0-9.,]+)/i);
                    if (mA) vActivos = parseFloat(mA[1].replace(/,/g, '')) || 0;
                }
            }
            const originTag = isCentro 
                ? `<span style="background:rgba(56,189,248,0.2);color:#38bdf8;padding:2px 6px;border-radius:4px;font-size:0.65rem;font-weight:700;">🏢 ${v.centro_nombre || 'Centro USD'}</span>` 
                : `<span style="background:rgba(34,197,94,0.15);color:#4ade80;padding:2px 6px;border-radius:4px;font-size:0.65rem;font-weight:700;">🇺🇸 Retail USA</span>`;

            const activosBadge = vActivos > 0 
                ? `<div style="font-size:0.65rem;color:#f59e0b;font-weight:600;margin-top:2px;">Activos: -${fmtUSD(vActivos)}</div>` 
                : '';

            notasRowsHtml += `
                <tr class="fg-usd-row" data-id="${v.id}">
                    <td style="text-align:center;">
                        <input type="checkbox" checked ${_canEditUsdNotas ? '' : 'disabled'} class="fg-usd-checkbox" data-id="${v.id}" data-total="${tot}" data-activos="${vActivos}" data-is-centro="${isCentro ? '1' : '0'}" onchange="window._recalcularGlobalUSDModal()" style="accent-color:#38bdf8;cursor:pointer;transform:scale(1.15);">
                    </td>
                    <td style="font-family:monospace;font-size:0.75rem;font-weight:700;">#${v.id.length > 12 ? v.id.substring(0,8)+'…' : v.id}</td>
                    <td>
                        <div style="font-weight:600;">${v.cliente_nombre}</div>
                        <div style="margin-top:2px;">${originTag}</div>
                    </td>
                    <td style="text-align:right;font-weight:700;color:#38bdf8;">
                        <div>${fmtUSD(tot)}</div>
                        ${activosBadge}
                    </td>
                    <td style="text-align:right;font-size:0.75rem;color:var(--text-dim);">${fmtMXN(tot * tcGlobal)}</td>
                    <td style="font-size:0.7rem;color:var(--text-dim);max-width:200px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;" title="${(v.comentario||'').replace(/"/g, '&quot;')}">
                        ${(v.comentario || 'Venta USA').substring(0, 45)}
                    </td>
                </tr>`;
        });

        const periodicidadMap = {
            '01': '01 — Diario',
            '02': '02 — Semanal',
            '03': '03 — Quincenal',
            '04': '04 — Mensual',
            '05': '05 — Bimestral'
        };
        const curPeriodicidadUSD = solRow?.periodicidad || '04';
        const curPeriodicidadLabelUSD = periodicidadMap[curPeriodicidadUSD] || '04 — Mensual';

        const formaPagoMap = {
            '01': '01 — Efectivo',
            '02': '02 — Cheque nominativo',
            '03': '03 — Transferencia electrónica de fondos',
            '04': '04 — Tarjeta de crédito',
            '28': '28 — Tarjeta de débito',
            '99': '99 — Por definir'
        };
        let fpInfoUSD = (typeof _detectFormaPagoMayoria === 'function') ? _detectFormaPagoMayoria(ventas) : { code: '03', label: '03 — Transferencia electrónica de fondos' };
        if (solRow?.forma_pago && formaPagoMap[solRow.forma_pago]) {
            fpInfoUSD = { code: solRow.forma_pago, label: formaPagoMap[solRow.forma_pago] };
        } else if (fpInfoUSD.code === '01') {
            fpInfoUSD = { code: '03', label: '03 — Transferencia electrónica de fondos' };
        }

        const existente = document.getElementById('modal-global-usd-desglose');
        if (existente) existente.remove();

        const modal = document.createElement('div');
        modal.id = 'modal-global-usd-desglose';
        modal.className = 'bo-modal-backdrop';
        modal.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.75);z-index:9999;display:flex;align-items:center;justify-content:center;padding:1rem;';
        
        modal.innerHTML = `
        <div class="bo-modal" style="max-width:920px;width:100%;max-height:92vh;overflow-y:auto;background:var(--bg-card);border:1px solid rgba(56,189,248,.3);border-radius:12px;box-shadow:0 25px 50px -12px rgba(0,0,0,0.5);">
            <!-- Header Modal USD -->
            <div style="padding:1.25rem 1.5rem;border-bottom:1px solid rgba(56,189,248,.2);background:linear-gradient(135deg,rgba(2,132,199,0.15),rgba(56,189,248,0.05));display:flex;justify-content:space-between;align-items:center;">
                <div>
                    <div style="display:flex;align-items:center;gap:.6rem;">
                        <span style="font-size:1.4rem;">🇺🇸</span>
                        <h3 style="margin:0;font-size:1.15rem;font-weight:800;color:#fff;">Factura Global Dólares (USD) — #${solicitudId}</h3>
                        <span class="badge" style="background:linear-gradient(135deg,#0284c7,#0ea5e9);color:#fff;font-weight:700;font-size:.7rem;padding:.2rem .6rem;border-radius:6px;">USD CFDI 4.0</span>
                    </div>
                    <div style="font-size:.75rem;color:#94a3b8;margin-top:4px;display:flex;align-items:center;gap:1rem;">
                        <span><b>Folio:</b> ${solRow.numero_nota || 'GLOBAL-USD'}</span>
                        <span><b>Tipo de Cambio DOF:</b> <b style="color:#38bdf8;">$${tcGlobal.toFixed(4)} MXN</b></span>
                        <span><b>Régimen Receptor:</b> 616 (Extranjero) / XEXX010101000</span>
                    </div>
                </div>
                <button onclick="window._cerrarModalGlobalDesglose(${solicitudId}, true, ${_canEditUsdNotas})" style="background:none;border:none;color:#94a3b8;font-size:1.4rem;cursor:pointer;">✕</button>
            </div>

            <!-- KPIs Cards USD -->
            <div style="padding:1rem 1.5rem .65rem;display:grid;grid-template-columns:repeat(5,1fr);gap:.75rem;">
                <div style="background:rgba(255,255,255,0.03);border:1px solid rgba(255,255,255,0.08);padding:.85rem 1rem;border-radius:10px;">
                    <div style="font-size:.68rem;font-weight:700;color:#94a3b8;text-transform:uppercase;">Total Cobrado USD</div>
                    <div style="font-size:1.15rem;font-weight:800;color:#38bdf8;margin-top:.2rem;" id="fg-usd-kpi-cobrado">${fmtUSD(totalCobradoUSD)}</div>
                    <div style="font-size:.68rem;color:#64748b;margin-top:2px;">${ventas.length} ventas en periodo</div>
                </div>
                <div style="background:rgba(255,255,255,0.03);border:1px solid rgba(255,255,255,0.08);padding:.85rem 1rem;border-radius:10px;">
                    <div style="font-size:.68rem;font-weight:700;color:#94a3b8;text-transform:uppercase;">Centros USD</div>
                    <div style="font-size:1.15rem;font-weight:800;color:#e2e8f0;margin-top:.2rem;" id="fg-usd-kpi-centros">${fmtUSD(totalCentrosUSD)}</div>
                    <div style="font-size:.68rem;color:#64748b;margin-top:2px;">${ventasCentrosUSD.length} notas centros</div>
                </div>
                <div style="background:rgba(245,158,11,0.06);border:1px solid rgba(245,158,11,0.25);padding:.85rem 1rem;border-radius:10px;">
                    <div style="font-size:.68rem;font-weight:700;color:#f59e0b;text-transform:uppercase;">Descuento / Activos</div>
                    <div style="font-size:1.15rem;font-weight:800;color:#fbbf24;margin-top:.2rem;" id="fg-usd-kpi-activos">${fmtUSD(totalActivosUSD)}</div>
                    <div style="font-size:.68rem;color:#d97706;margin-top:2px;" id="fg-usd-kpi-activos-sub">Centros: ${fmtUSD(activosCentrosUSD)} | Retail: ${fmtUSD(activosRetailUSD)}</div>
                </div>
                <div style="background:rgba(16,185,129,0.06);border:1px solid rgba(16,185,129,0.25);padding:.85rem 1rem;border-radius:10px;">
                    <div style="font-size:.68rem;font-weight:700;color:#34d399;text-transform:uppercase;">Facturable SAT (USD)</div>
                    <div style="font-size:1.15rem;font-weight:800;color:#34d399;margin-top:.2rem;" id="fg-usd-kpi-facturable">${fmtUSD(totalFacturableUSD)}</div>
                    <div style="font-size:.68rem;color:#059669;margin-top:2px;">Total neto a timbrar</div>
                </div>
                <div style="background:rgba(255,255,255,0.03);border:1px solid rgba(255,255,255,0.08);padding:.85rem 1rem;border-radius:10px;">
                    <div style="font-size:.68rem;font-weight:700;color:#94a3b8;text-transform:uppercase;">Equivalente MXN</div>
                    <div style="font-size:1.15rem;font-weight:800;color:#fbbf24;margin-top:.2rem;" id="fg-usd-kpi-mxn">${fmtMXN(totalFacturableMXN)}</div>
                    <div style="font-size:.68rem;color:#64748b;margin-top:2px;">DOF x $${tcGlobal.toFixed(4)}</div>
                </div>
            </div>

            <!-- Configuración Fiscal SAT USD: Forma de Pago y Periodicidad -->
            <div style="padding:0 1.5rem .75rem;display:grid;grid-template-columns:1fr 1fr;gap:.75rem;">
                <!-- Forma de Pago SAT -->
                <div style="background:rgba(139,92,246,0.08);border:1px solid rgba(139,92,246,0.3);border-radius:10px;padding:.65rem 1rem;position:relative;">
                    <div style="display:flex;justify-content:space-between;align-items:center;">
                        <div style="font-size:.68rem;font-weight:700;color:#c084fc;text-transform:uppercase;display:flex;align-items:center;gap:.35rem;">
                            💳 Forma de Pago SAT <span style="font-size:.75rem;cursor:pointer;" onclick="document.getElementById('fg-usd-fp-text').style.display='none';document.getElementById('fg-usd-fp-select').style.display='block';document.getElementById('fg-usd-fp-select').focus();" title="Editar Forma de Pago">✏️</span>
                        </div>
                        <span style="font-size:.65rem;color:#c084fc;background:rgba(168,85,247,0.18);padding:1px 6px;border-radius:4px;font-weight:700;">CFDI 4.0</span>
                    </div>
                    <div id="fg-usd-fp-text" style="font-size:.85rem;font-weight:700;color:#f3e8ff;margin-top:.3rem;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;cursor:pointer;" onclick="this.style.display='none';document.getElementById('fg-usd-fp-select').style.display='block';document.getElementById('fg-usd-fp-select').focus();" title="Clic para editar forma de pago">
                        ${fpInfoUSD.label}
                    </div>
                    <select id="fg-usd-fp-select" onchange="document.getElementById('fg-usd-fp-text').innerText = this.options[this.selectedIndex].text; document.getElementById('fg-usd-fp-select').style.display='none'; document.getElementById('fg-usd-fp-text').style.display='block';" onblur="this.style.display='none';document.getElementById('fg-usd-fp-text').style.display='block';" style="display:none;width:100%;font-size:.75rem;padding:.35rem .5rem;background:#09090b;color:#fff;border:1px solid rgba(168,85,247,0.5);border-radius:6px;margin-top:.25rem;">
                        <option value="03" ${fpInfoUSD.code === '03' ? 'selected' : ''}>03 — Transferencia electrónica de fondos</option>
                        <option value="04" ${fpInfoUSD.code === '04' ? 'selected' : ''}>04 — Tarjeta de crédito</option>
                        <option value="28" ${fpInfoUSD.code === '28' ? 'selected' : ''}>28 — Tarjeta de débito</option>
                        <option value="01" ${fpInfoUSD.code === '01' ? 'selected' : ''}>01 — Efectivo</option>
                        <option value="99" ${fpInfoUSD.code === '99' ? 'selected' : ''}>99 — Por definir</option>
                    </select>
                </div>

                <!-- Periodicidad SAT -->
                <div style="background:rgba(59,130,246,0.08);border:1px solid rgba(59,130,246,0.3);border-radius:10px;padding:.65rem 1rem;position:relative;">
                    <div style="display:flex;justify-content:space-between;align-items:center;">
                        <div style="font-size:.68rem;font-weight:700;color:#60a5fa;text-transform:uppercase;display:flex;align-items:center;gap:.35rem;">
                            📅 Periodicidad SAT <span style="font-size:.75rem;cursor:pointer;" onclick="document.getElementById('fg-usd-per-text').style.display='none';document.getElementById('fg-usd-per-select').style.display='block';document.getElementById('fg-usd-per-select').focus();" title="Editar Periodicidad">✏️</span>
                        </div>
                        <span style="font-size:.65rem;color:#38bdf8;background:rgba(56,189,248,0.18);padding:1px 6px;border-radius:4px;font-weight:700;">Global</span>
                    </div>
                    <div id="fg-usd-per-text" style="font-size:.85rem;font-weight:700;color:#e0f2fe;margin-top:.3rem;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;cursor:pointer;" onclick="this.style.display='none';document.getElementById('fg-usd-per-select').style.display='block';document.getElementById('fg-usd-per-select').focus();" title="Clic para editar periodicidad">
                        ${curPeriodicidadLabelUSD}
                    </div>
                    <select id="fg-usd-per-select" onchange="document.getElementById('fg-usd-per-text').innerText = this.options[this.selectedIndex].text; document.getElementById('fg-usd-per-select').style.display='none'; document.getElementById('fg-usd-per-text').style.display='block';" onblur="this.style.display='none';document.getElementById('fg-usd-per-text').style.display='block';" style="display:none;width:100%;font-size:.75rem;padding:.35rem .5rem;background:#09090b;color:#fff;border:1px solid rgba(56,189,248,0.5);border-radius:6px;margin-top:.25rem;">
                        <option value="01" ${curPeriodicidadUSD === '01' ? 'selected' : ''}>01 — Diario</option>
                        <option value="02" ${curPeriodicidadUSD === '02' ? 'selected' : ''}>02 — Semanal</option>
                        <option value="03" ${curPeriodicidadUSD === '03' ? 'selected' : ''}>03 — Quincenal</option>
                        <option value="04" ${curPeriodicidadUSD === '04' ? 'selected' : ''}>04 — Mensual</option>
                        <option value="05" ${curPeriodicidadUSD === '05' ? 'selected' : ''}>05 — Bimestral</option>
                    </select>
                </div>
            </div>

            <!-- Notice Banner Smart USD -->
            <div style="margin:0 1.5rem .75rem;padding:.65rem 1rem;background:rgba(56,189,248,.08);border:1px solid rgba(56,189,248,.25);border-radius:8px;font-size:.75rem;color:#bae6fd;display:flex;align-items:center;gap:.6rem;">
                <span style="font-size:1.1rem;">💡</span>
                <div>
                    <b>Consolidado USD Inteligente:</b> Agrupa compras en dólares sin mezclar lógicas de pesos. 
                    ${ventasCentrosUSD.length > 0 ? `Incluye ${ventasCentrosUSD.length} nota(s) de Centros de Apoyo USD (con ${fmtUSD(activosCentrosUSD)} de activos amortizados directo a su cuenta de centro).` : '100% de las ventas corresponden a clientes directos en EE.UU.'}
                </div>
            </div>

            <!-- Desglose de Productos USD -->
            <div style="padding:0 1.5rem;margin-bottom:1rem;">
                <div style="font-size:.72rem;font-weight:700;color:#94a3b8;text-transform:uppercase;margin-bottom:.4rem;">📦 Resumen de Productos Entregados (${totPiezas} piezas)</div>
                <table class="bo-table" style="font-size:.75rem;width:100%;">
                    <thead>
                        <tr><th>Producto</th><th style="text-align:center;">Piezas</th><th style="text-align:right;">Precio Unitario USD</th><th style="text-align:right;">Subtotal USD</th></tr>
                    </thead>
                    <tbody>
                        ${prodRowsHtml || '<tr><td colspan="4" style="text-align:center;color:#64748b;">Sin productos registrados</td></tr>'}
                    </tbody>
                </table>
            </div>

            <!-- Tabla de Notas USD -->
            <div style="padding:0 1.5rem 1rem;">
                <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:.4rem;">
                    <div style="font-size:.72rem;font-weight:700;color:#94a3b8;text-transform:uppercase;">📝 Remisiones y Ventas USD (${ventas.length})</div>
                    <input type="text" id="fg-usd-search-notas" placeholder="🔍 Filtrar por ID, Cliente..." oninput="window._filtrarNotasUSDModal()" style="width:240px;padding:.3rem .5rem;border-radius:6px;border:1px solid rgba(255,255,255,0.12);background:#09090b;color:#fff;font-size:.72rem;">
                </div>
                <div style="max-height:26vh;overflow-y:auto;border:1px solid rgba(255,255,255,0.08);border-radius:8px;">
                    <table class="bo-table" style="font-size:.72rem;width:100%;margin:0;" id="fg-usd-notas-table">
                        <thead style="position:sticky;top:0;background:#18181b;z-index:2;">
                            <tr>
                                <th style="text-align:center;width:40px;">Incluir</th>
                                <th>Nota</th>
                                <th>Cliente / Tipo</th>
                                <th style="text-align:right;">Total USD</th>
                                <th style="text-align:right;">Equiv. MXN</th>
                                <th>Comentario</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${notasRowsHtml || '<tr><td colspan="6" style="text-align:center;color:#64748b;">Sin ventas disponibles</td></tr>'}
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- Footer con Acciones -->
            <div style="padding:.85rem 1.5rem;border-top:1px solid rgba(255,255,255,0.08);display:flex;justify-content:space-between;align-items:center;background:rgba(0,0,0,0.2);">
                <div style="display:flex;gap:.5rem;">
                    <button class="btn btn-outline btn-sm" onclick="window._exportarCsvGlobalUSD()">⬇️ CSV USD</button>
                    <button class="btn btn-outline btn-sm" onclick="window._exportarPdfGlobalUSD(${solicitudId})">📄 PDF USD</button>
                </div>
                <div style="display:flex;gap:.6rem;align-items:center;">
                    <button class="btn btn-outline btn-sm" onclick="window._cerrarModalGlobalDesglose(${solicitudId}, true, ${_canEditUsdNotas})">✕ Cerrar</button>
                    ${_canEditUsdNotas ? `<button id="fg-usd-btn-save-excl" class="btn btn-outline btn-sm" style="display:none;border-color:#f59e0b;color:#fbbf24;font-weight:700;" onclick="window._guardarExclusionesModalGlobal(${solicitudId}, true)">💾 Guardar Exclusiones</button>` : ''}
                    ${esFacturada 
                        ? `<span class="badge" style="background:rgba(16,185,129,.15);color:#34d399;padding:.4rem .8rem;font-weight:700;font-size:.78rem;border-radius:6px;border:1px solid rgba(16,185,129,.3);">✅ Facturada (${cfdiUuidSol ? cfdiUuidSol.substring(0,8)+'...' : 'CFDI'})</span>
                           <button class="btn btn-sm" style="background:linear-gradient(135deg,#0284c7,#0369a1);color:#fff;border:none;font-weight:700;padding:.45rem 1rem;border-radius:6px;cursor:pointer;" onclick="document.getElementById('modal-global-usd-desglose').remove(); abrirModalSustituirLote(window._fgUsdSolRow, ${solicitudId});">🔄 Sustituir Factura USD</button>`
                        : (solRow?.estado === 'cancelada'
                            ? `<span class="badge" style="background:rgba(239,68,68,.15);color:var(--danger);padding:.4rem .8rem;font-weight:700;font-size:.78rem;border-radius:6px;border:1px solid rgba(239,68,68,.3);">❌ Cancelada ${solRow?.uuid_sustitucion ? `(Sust. ${solRow.uuid_sustitucion.substring(0,8)}...)` : ''}</span>`
                            : `<button id="fg-usd-btn-aprobar-timbrar" class="btn btn-success btn-sm" style="background:linear-gradient(135deg,#0284c7,#0369a1);border:none;font-weight:700;padding:.45rem 1.1rem;border-radius:6px;" onclick="window._fgFormaPago = (document.getElementById('fg-usd-fp-select')?.value || '${fpInfoUSD.code || '03'}'); window._fgPeriodicidad = (document.getElementById('fg-usd-per-select')?.value || '${curPeriodicidadUSD || '04'}'); if (typeof window._fgTotalActivos !== 'number') window._fgTotalActivos = ${totalActivosUSD}; if (typeof window._fgTotalFacturable !== 'number') window._fgTotalFacturable = ${totalFacturableUSD}; document.getElementById('modal-global-usd-desglose').remove(); confirmarTimbrado(${solicitudId}, 'global', window._fgExcludedIdsUSD || [], 'PUE', true)">⚡ Aprobar y Timbrar USD</button>`
                          )
                    }
                </div>
            </div>
        </div>`;
        document.body.appendChild(modal);
    } catch(e) {
        console.error('[VER DESGLOSE GLOBAL USD] Error:', e);
        BO_AUTH.showAlert('Error cargando desglose USD: ' + e.message, 'error');
    }
}

window.verDesgloseGlobalUSD = verDesgloseGlobalUSD;

window._filtrarNotasUSDModal = function() {
    const q = (document.getElementById('fg-usd-search-notas')?.value || '').toLowerCase();
    const rows = document.querySelectorAll('#fg-usd-notas-table tbody tr');
    rows.forEach(tr => {
        const text = tr.innerText.toLowerCase();
        tr.style.display = text.includes(q) ? '' : 'none';
    });
};

window._recalcularGlobalUSDModal = function() {
    const checkboxes = document.querySelectorAll('.fg-usd-checkbox');
    let includedCount = 0;
    let includedUSD = 0;
    let includedCentrosUSD = 0;
    let includedRetailActivos = 0;
    let includedCentroCount = 0;
    window._fgExcludedIdsUSD = [];
    const tc = parseFloat(window._fgUsdSolRow?.tipo_cambio) || window._dofTipoCambio || 18.50;

    checkboxes.forEach(cb => {
        const tot = parseFloat(cb.dataset.total || 0);
        const act = parseFloat(cb.dataset.activos || 0);
        const isCentro = cb.dataset.isCentro === '1';
        if (cb.checked) {
            includedCount++;
            includedUSD += tot;
            if (isCentro) {
                includedCentrosUSD += tot;
                includedCentroCount++;
            } else {
                includedRetailActivos += act;
            }
        } else {
            window._fgExcludedIdsUSD.push(cb.dataset.id);
        }
    });

    // Activos de Centros: solo si hay al menos una nota de centro incluida
    let actCentros = 0;
    if (includedCentroCount > 0) {
        const mAct = String(window._fgUsdSolRow?.comentario || '').match(/act=([0-9.]+)/);
        if (mAct) actCentros = parseFloat(mAct[1]) || 0;
    }

    const totalActivos = Math.min(includedUSD, actCentros + includedRetailActivos);
    const facturable = Math.max(0, includedUSD - totalActivos);

    window._fgTotalActivos = totalActivos;
    window._fgTotalFacturable = facturable;

    const fmtUSD = (n) => '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' USD';
    const fmtMXN = (n) => '$' + Number(n).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' MXN';

    const elCobrado = document.getElementById('fg-usd-kpi-cobrado');
    if (elCobrado) elCobrado.textContent = fmtUSD(includedUSD);

    const elCentros = document.getElementById('fg-usd-kpi-centros');
    if (elCentros) elCentros.textContent = fmtUSD(includedCentrosUSD);

    const elActivos = document.getElementById('fg-usd-kpi-activos');
    if (elActivos) elActivos.textContent = fmtUSD(totalActivos);

    const elActivosSub = document.getElementById('fg-usd-kpi-activos-sub');
    if (elActivosSub) elActivosSub.textContent = `Centros: ${fmtUSD(actCentros)} | Retail: ${fmtUSD(includedRetailActivos)}`;

    const elFacturable = document.getElementById('fg-usd-kpi-facturable');
    if (elFacturable) elFacturable.textContent = fmtUSD(facturable);

    const elMxn = document.getElementById('fg-usd-kpi-mxn');
    if (elMxn) elMxn.textContent = fmtMXN(facturable * tc);

    const btnSaveUsd = document.getElementById('fg-usd-btn-save-excl');
    if (btnSaveUsd) {
        const nExcl = window._fgExcludedIdsUSD.length;
        btnSaveUsd.style.display = nExcl > 0 ? 'inline-flex' : 'none';
        btnSaveUsd.textContent = `💾 Guardar Exclusiones (${nExcl})`;
    }
    const btnAprUsd = document.getElementById('fg-usd-btn-aprobar-timbrar');
    if (btnAprUsd) {
        btnAprUsd.disabled = includedCount === 0;
        btnAprUsd.style.opacity = includedCount === 0 ? '0.5' : '1';
    }
};

// ══ Facturación Global — Aprobar y timbrar al SAT ═══════════════════════════

// ══ Facturación Global — Recalcular y CSV ══════════════════════════════════
window._filtrarNotasGlobalModal = function() {
    const q = (document.getElementById('fg-search-notas').value || '').toLowerCase();
    const rows = document.querySelectorAll('#fg-notas-table tbody tr');
    rows.forEach(tr => {
        const text = tr.innerText.toLowerCase();
        tr.style.display = text.includes(q) ? '' : 'none';
    });
};

window._recalcularGlobalModal = function() {
    const checkboxes = document.querySelectorAll('.fg-checkbox');
    let includedCount = 0;
    let includedFacturable = 0;
    let includedReal = 0;
    window._fgExcludedIds = [];
    
    checkboxes.forEach(cb => {
        if (cb.checked) {
            includedCount++;
            includedFacturable += parseFloat(cb.dataset.facturable || 0);
            includedReal += parseFloat(cb.dataset.real || 0);
        } else {
            window._fgExcludedIds.push(cb.dataset.id);
        }
    });
    
    let totalActivos = includedReal - includedFacturable;
    if (totalActivos < 0) totalActivos = 0;
    // Para CENTRO-*: usar activos cobrados si la fórmula da 0 (solo si quedan notas incluidas)
    if (includedCount > 0 && totalActivos === 0 && window._centroActivosCobrados > 0) {
        totalActivos = window._centroActivosCobrados;
    }
    totalActivos = includedCount > 0 ? Math.min(includedReal, totalActivos) : 0;
    
    const fmt = (n) => '$' + Number(n).toLocaleString('es-MX',{minimumFractionDigits:2});
    
    document.getElementById('fg-kpi-notas').textContent = includedCount;
    const kpiFacturableFinal = includedCount > 0
        ? (totalActivos > 0 ? Math.max(0, Math.round((includedReal - totalActivos) * 100) / 100) : Math.round(includedFacturable * 100) / 100)
        : 0;
    document.getElementById('fg-kpi-facturable').textContent = fmt(kpiFacturableFinal);
    document.getElementById('fg-kpi-activos').textContent = fmt(totalActivos);

    // Actualizar montos globales para que Aprobar y Timbrar envíe el neto real tras desmarcar notas
    window._fgTotalActivos = totalActivos;
    window._fgTotalFacturable = kpiFacturableFinal;

    const btnSaveExcl = document.getElementById('fg-btn-save-excl');
    if (btnSaveExcl) {
        const nExcl = window._fgExcludedIds.length;
        btnSaveExcl.style.display = nExcl > 0 ? 'inline-flex' : 'none';
        btnSaveExcl.textContent = `💾 Guardar Exclusiones (${nExcl})`;
    }
    const btnApr = document.getElementById('fg-btn-aprobar-timbrar');
    if (btnApr) {
        btnApr.disabled = includedCount === 0;
        btnApr.style.opacity = includedCount === 0 ? '0.5' : '1';
    }

    // -- Recalcular tablas de productos dinámicamente --
    const activeVentas = window._fgAllVentas.filter(v => !window._fgExcludedIds.includes(v.id));
    const catalogo = window._fgCatalogo || [];
    const componentes = window._fgComponentes || [];
    
    const consolidated = {};
    for (const v of activeVentas) {
        let piezasArr = [];
        try { piezasArr = Array.isArray(v.piezas) ? v.piezas : JSON.parse(v.piezas || '[]'); } catch(_) {}
        for (const pieza of piezasArr) {
            const prodId = String(pieza.producto_id || pieza.sku || '');
            if (!prodId) continue;
            const qty = parseInt(pieza.cantidad) || 1;
            const precioUnit = parseFloat(pieza.precio_unitario) || 0;
            const catProd = catalogo.find(c => String(c.id) === prodId || c.sku === prodId);
            if (catProd && catProd.categoria === 'paquete') {
                const comps = componentes.filter(c => c.paquete_id === catProd.id);
                if (comps.length > 0) {
                    for (const comp of comps) {
                        const compId = String(comp.componente_id);
                        const compQty = (parseInt(comp.cantidad) || 1) * qty;
                        const compNombre = (comp.comp_nombre || '').replace(/\s+(Pub|MC|Dist)$/i, '').trim();
                        const compPrecio = parseFloat(comp.comp_precio) || 0;
                        const _cc2 = catalogo.find(c => String(c.id) === compId);
                        const _ct2 = parseFloat(_cc2?.tasa_iva || 0);
                        if (!consolidated[compId]) consolidated[compId] = { qty: 0, precioUnit: compPrecio, nombre: compNombre, prodId: compId, tasa_iva: _ct2 };
                        consolidated[compId].qty += compQty;
                        if (!consolidated[compId].nombre && compNombre) consolidated[compId].nombre = compNombre;
                    }
                    continue;
                }
            }
            const _pc2 = catalogo.find(c => String(c.id) === prodId || c.sku === prodId);
            const _pt2 = parseFloat(_pc2?.tasa_iva || 0);
            if (!consolidated[prodId]) consolidated[prodId] = { qty: 0, precioUnit, nombre: pieza.nombre || pieza.producto || '', prodId, tasa_iva: _pt2 };
            consolidated[prodId].qty += qty;
            if (precioUnit > consolidated[prodId].precioUnit) consolidated[prodId].precioUnit = precioUnit;
        }
    }

    for (const [key, prod] of Object.entries(consolidated)) {
        if (!prod.nombre || prod.nombre.match(/^(ID:|SUERO-|ESENCIA-|PROMO-)/i)) {
            const catProd = catalogo.find(c => String(c.id) === key || c.sku === key);
            if (catProd) {
                prod.nombre = (catProd.nombre || '').replace(/\s+(Pub|MC|Dist)$/i, '').trim();
                if (!prod.precioUnit) prod.precioUnit = parseFloat(catProd.precio) || 0;
            }
        }
    }

    let activosRestante = totalActivos;
    const productosRegulares = [];
    const productosActivos = [];

    // Estrategia fiscal: subsidiar productos IVA 16% primero, luego 0%
    const _allP2 = Object.values(consolidated);
    const _p16 = _allP2.filter(p => (p.tasa_iva || 0) > 0).sort((a,b) => b.precioUnit - a.precioUnit);
    const _p0 = _allP2.filter(p => (p.tasa_iva || 0) === 0).sort((a,b) => b.precioUnit - a.precioUnit);

    function _dist2(bucket) {
        for (const prod of bucket) {
            const fullPrice = prod.precioUnit;
            if (fullPrice <= 0) { productosRegulares.push({ ...prod }); continue; }
            const possibleSubsidized = Math.floor(activosRestante / fullPrice);
            const toSubsidize = Math.min(prod.qty, possibleSubsidized);
            if (toSubsidize > 0) {
                productosActivos.push({ ...prod, qty: toSubsidize, precioUnit: 0.01 });
                activosRestante -= (toSubsidize * fullPrice);
            }
            const remaining = prod.qty - toSubsidize;
            if (remaining > 0) { productosRegulares.push({ ...prod, qty: remaining }); }
        }
    }
    _dist2(_p16);
    _dist2(_p0);

    const renderProdRows = (prods, color) => prods.map(p => `<tr>
        <td style="font-size:.72rem;padding:.25rem .4rem">${(p.nombre || 'ID:'+p.prodId).replace(/(Pub|MC|Dist)$/i,'').trim()}</td>
        <td style="font-size:.72rem;padding:.25rem .4rem;text-align:center;font-weight:700;color:${color}">${p.qty}</td>
        <td style="font-size:.72rem;padding:.25rem .4rem;text-align:right">${fmt(p.precioUnit)}</td>
        <td style="font-size:.72rem;padding:.25rem .4rem;text-align:right;font-weight:600;color:${color}">${fmt(p.qty * p.precioUnit)}</td>
    </tr>`).join('');

    const totalRegular = productosRegulares.reduce((s,p) => s + (p.qty * p.precioUnit), 0);
    const totalActivosSimbolic = productosActivos.reduce((s,p) => s + (p.qty * p.precioUnit), 0);

    const contRegulares = document.getElementById('fg-productos-regulares-container');
    if (contRegulares) {
        contRegulares.innerHTML = `
            <div style="font-size:.7rem;font-weight:700;color:var(--success);text-transform:uppercase;letter-spacing:.04em;margin-bottom:.4rem">
                🛒 Productos Regulares (${productosRegulares.reduce((s,p)=>s+p.qty,0)} pzs) — ${fmt(totalRegular)}
            </div>
            <table class="bo-table" style="font-size:.72rem;margin:0">
                <thead><tr><th>Producto</th><th style="text-align:center">Cant</th><th style="text-align:right">P.U.</th><th style="text-align:right">Subtotal</th></tr></thead>
                <tbody>${renderProdRows(productosRegulares, 'var(--success)') || '<tr><td colspan="4" style="text-align:center;color:var(--text-dim)">—</td></tr>'}</tbody>
            </table>
        `;
    }

    const contActivos = document.getElementById('fg-productos-activos-container');
    if (contActivos) {
        contActivos.innerHTML = `
            <div style="font-size:.7rem;font-weight:700;color:var(--accent-gold);text-transform:uppercase;letter-spacing:.04em;margin-bottom:.4rem">
                🏷️ Activos — Precio Simbólico (${productosActivos.reduce((s,p)=>s+p.qty,0)} pzs) — ${fmt(totalActivosSimbolic)}
            </div>
            <table class="bo-table" style="font-size:.72rem;margin:0">
                <thead><tr><th>Producto</th><th style="text-align:center">Cant</th><th style="text-align:right">P.U.</th><th style="text-align:right">Subtotal</th></tr></thead>
                <tbody>${renderProdRows(productosActivos, 'var(--accent-gold)') || '<tr><td colspan="4" style="text-align:center;color:var(--text-dim)">Sin activos</td></tr>'}</tbody>
            </table>
        `;
    }
};


window._exportarPdfGlobal = async function(solicitudId) {
    BO_AUTH.showAlert('⏳ Generando PDF, por favor espera...', 'info');

    if (typeof html2pdf !== 'function') {
        try {
            await new Promise((resolve, reject) => {
                const s = document.createElement('script');
                s.src = 'https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js';
                s.onload = resolve;
                s.onerror = reject;
                document.head.appendChild(s);
            });
        } catch(_) {
            BO_AUTH.showAlert('Error cargando librería de PDF. Por favor intenta de nuevo.', 'error');
            return;
        }
    }

    const fmt = (n) => '$' + Number(n).toLocaleString('es-MX',{minimumFractionDigits:2});
    const fecha = new Date().toLocaleDateString('es-MX', {year:'numeric',month:'long',day:'numeric'});

    // Read KPIs
    const kpiNotas = document.getElementById('fg-kpi-notas')?.textContent || '0';
    const kpiFacturable = document.getElementById('fg-kpi-facturable')?.textContent || '$0.00';
    const kpiActivos = document.getElementById('fg-kpi-activos')?.textContent || '$0.00';
    const fpText = document.getElementById('fg-fp-text')?.textContent || '';
    const fpSelect = document.getElementById('fg-fp-select');
    const formaPago = (fpSelect && fpSelect.style.display !== 'none') ? fpSelect.options[fpSelect.selectedIndex]?.text : fpText;

    // Read product tables
    const readTableRows = (containerId) => {
        const cont = document.getElementById(containerId);
        if (!cont) return [];
        const rows = cont.querySelectorAll('tbody tr');
        return Array.from(rows).map(tr => Array.from(tr.querySelectorAll('td')).map(c => c.textContent.trim()));
    };
    const prodRegLabel = document.getElementById('fg-productos-regulares-container')?.querySelector('div')?.textContent?.trim() || '';
    const prodActLabel = document.getElementById('fg-productos-activos-container')?.querySelector('div')?.textContent?.trim() || '';
    const prodRegRows = readTableRows('fg-productos-regulares-container');
    const prodActRows = readTableRows('fg-productos-activos-container');

    // Read notas
    const cbs = document.querySelectorAll('.fg-checkbox');
    const notasData = [];
    cbs.forEach(cb => {
        const tr = cb.closest('tr');
        notasData.push({
            inc: cb.checked,
            nota: tr.cells[1]?.textContent?.trim() || '',
            cliente: tr.cells[2]?.textContent?.trim() || '',
            total: tr.cells[3]?.textContent?.trim() || '',
            facturable: tr.cells[4]?.textContent?.trim() || '',
            pago: tr.cells[5]?.textContent?.trim() || ''
        });
    });

    const prodRowsHtml = (rows, color) => rows.map(r => `<tr>
        <td style="border:1px solid #ddd;padding:2px 4px;">${r[0]||''}</td>
        <td style="border:1px solid #ddd;padding:2px 4px;text-align:center;font-weight:700;color:${color};">${r[1]||''}</td>
        <td style="border:1px solid #ddd;padding:2px 4px;text-align:right;">${r[2]||''}</td>
        <td style="border:1px solid #ddd;padding:2px 4px;text-align:right;font-weight:600;">${r[3]||''}</td>
    </tr>`).join('');

    const notasRowsHtml = notasData.map(n => `<tr style="${!n.inc ? 'opacity:.35;' : ''}">
        <td style="border:1px solid #ddd;padding:1px 3px;text-align:center;">${n.inc ? '✓' : '✗'}</td>
        <td style="border:1px solid #ddd;padding:1px 3px;">${n.nota}</td>
        <td style="border:1px solid #ddd;padding:1px 3px;">${n.cliente}</td>
        <td style="border:1px solid #ddd;padding:1px 3px;text-align:right;">${n.total}</td>
        <td style="border:1px solid #ddd;padding:1px 3px;text-align:right;color:#059669;">${n.facturable}</td>
        <td style="border:1px solid #ddd;padding:1px 3px;font-size:6px;">${n.pago}</td>
    </tr>`).join('');

    const html = `
    <div style="font-family:Arial,Helvetica,sans-serif;color:#111;padding:10px;max-width:100%;box-sizing:border-box;">
        <h2 style="margin:0 0 2px;font-size:13px;color:#111;">${window._fgIsCentroGlobal ? 'Desglose Factura Centro' : 'Desglose Factura Global'} #${solicitudId}</h2>
        <div style="font-size:8px;color:#888;margin-bottom:8px;">${fecha}</div>

        <table style="width:100%;border-collapse:collapse;margin-bottom:10px;">
            <tr>
                <td style="border:1px solid #bbb;padding:5px;text-align:center;width:25%;">
                    <div style="font-size:7px;color:#888;text-transform:uppercase;">Notas</div>
                    <div style="font-size:15px;font-weight:800;color:#4338ca;">${kpiNotas}</div>
                </td>
                <td style="border:1px solid #bbb;padding:5px;text-align:center;width:25%;">
                    <div style="font-size:7px;color:#888;text-transform:uppercase;">Total Facturable</div>
                    <div style="font-size:11px;font-weight:700;color:#059669;">${kpiFacturable}</div>
                </td>
                <td style="border:1px solid #bbb;padding:5px;text-align:center;width:25%;">
                    <div style="font-size:7px;color:#888;text-transform:uppercase;">Activos Deducidos</div>
                    <div style="font-size:11px;font-weight:700;color:#b45309;">${kpiActivos}</div>
                </td>
                <td style="border:1px solid #bbb;padding:5px;text-align:center;width:25%;">
                    <div style="font-size:7px;color:#888;text-transform:uppercase;">Forma de Pago</div>
                    <div style="font-size:9px;font-weight:700;color:#6d28d9;">${formaPago}</div>
                </td>
            </tr>
        </table>

        <table style="width:100%;border-collapse:collapse;margin-bottom:10px;">
            <tr style="vertical-align:top;">
                <td style="width:50%;padding-right:5px;">
                    <div style="font-size:7px;font-weight:700;color:#059669;text-transform:uppercase;margin-bottom:2px;">${prodRegLabel}</div>
                    <table style="width:100%;border-collapse:collapse;font-size:7.5px;">
                        <thead><tr style="background:#f0f0f0;">
                            <th style="border:1px solid #ccc;padding:2px 3px;text-align:left;">Producto</th>
                            <th style="border:1px solid #ccc;padding:2px 3px;text-align:center;">Cant</th>
                            <th style="border:1px solid #ccc;padding:2px 3px;text-align:right;">P.U.</th>
                            <th style="border:1px solid #ccc;padding:2px 3px;text-align:right;">Subtotal</th>
                        </tr></thead>
                        <tbody>${prodRowsHtml(prodRegRows, '#059669')}</tbody>
                    </table>
                </td>
                <td style="width:50%;padding-left:5px;">
                    <div style="font-size:7px;font-weight:700;color:#b45309;text-transform:uppercase;margin-bottom:2px;">${prodActLabel}</div>
                    <table style="width:100%;border-collapse:collapse;font-size:7.5px;">
                        <thead><tr style="background:#f0f0f0;">
                            <th style="border:1px solid #ccc;padding:2px 3px;text-align:left;">Producto</th>
                            <th style="border:1px solid #ccc;padding:2px 3px;text-align:center;">Cant</th>
                            <th style="border:1px solid #ccc;padding:2px 3px;text-align:right;">P.U.</th>
                            <th style="border:1px solid #ccc;padding:2px 3px;text-align:right;">Subtotal</th>
                        </tr></thead>
                        <tbody>${prodRowsHtml(prodActRows, '#b45309')}</tbody>
                    </table>
                </td>
            </tr>
        </table>

        <div style="font-size:7px;font-weight:700;color:#888;text-transform:uppercase;margin-bottom:2px;">Notas Individuales (${notasData.length})</div>
        <table style="width:100%;border-collapse:collapse;font-size:6.5px;">
            <thead><tr style="background:#f0f0f0;">
                <th style="border:1px solid #ccc;padding:2px;text-align:center;">Incl.</th>
                <th style="border:1px solid #ccc;padding:2px;">Nota</th>
                <th style="border:1px solid #ccc;padding:2px;">Cliente</th>
                <th style="border:1px solid #ccc;padding:2px;text-align:right;">Total</th>
                <th style="border:1px solid #ccc;padding:2px;text-align:right;">Facturable</th>
                <th style="border:1px solid #ccc;padding:2px;">Pago</th>
            </tr></thead>
            <tbody>${notasRowsHtml}</tbody>
        </table>
    </div>`;

    const wrapper = document.createElement('div');
    wrapper.style.cssText = 'position:absolute;left:-9999px;top:0;background:#fff;';
    wrapper.innerHTML = html;
    document.body.appendChild(wrapper);

    const opt = {
        margin:       [0.25, 0.25, 0.25, 0.25],
        filename:     `Factura_Global_${solicitudId}_Desglose.pdf`,
        image:        { type: 'jpeg', quality: 0.95 },
        html2canvas:  { scale: 2, useCORS: true, logging: false, backgroundColor: '#ffffff' },
        jsPDF:        { unit: 'in', format: 'letter', orientation: 'portrait' }
    };

    html2pdf().set(opt).from(wrapper.firstElementChild).save().then(() => {
        wrapper.remove();
        BO_AUTH.showAlert('\u2705 PDF generado correctamente.', 'success');
    }).catch(err => {
        wrapper.remove();
        BO_AUTH.showAlert('Error generando PDF: ' + err.message, 'error');
    });
};

window._exportarCsvGlobal = function() {
    const checkboxes = document.querySelectorAll('.fg-checkbox');
    const includeMap = {};
    checkboxes.forEach(cb => { includeMap[cb.dataset.id] = cb.checked; });
    
    const ventas = (window._fgAllVentas || []).filter(v => 
        v.producto_id !== 'calificacion-mes' && 
        !String(v.comentario || '').toLowerCase().includes('calificacion del mes')
    );
    const catalogo = window._fgCatalogo || [];
    const componentes = window._fgComponentes || [];
    const isCentro = window._fgIsCentroGlobal || false;
    const centroActivos = window._centroActivosCobrados || 0;

    let csv = "\uFEFFsep=,\n";
    csv += `=====================================================================\n`;
    csv += `REPORTE FISCAL Y FINANCIERO — FACTURA GLOBAL\n`;
    csv += `=====================================================================\n\n`;

    // ════════════════════════════════════════════════════════════════════════
    // BLOQUE 1: RESUMEN FINANCIERO Y FORMAS DE PAGO
    // ════════════════════════════════════════════════════════════════════════
    csv += `1. RESUMEN FINANCIERO Y FORMAS DE PAGO\n`;
    csv += `Método / Banco,Monto Cobrado / Facturable,Notas Incluidas\n`;

    const KNOWN_BANKS = ['BBVA', 'SANTANDER', 'BANAMEX', 'MERCADOPAGO', 'PAYPAL', 'CLIP', 'STRIPE', 'BANORTE', 'HSBC', 'EFECTIVO'];
    const summaryMap = {};
    let totalCobradoFinal = 0;
    let totalActivosTotal = 0;

    ventas.forEach(v => {
        if (includeMap[v.id] === false) return; // solo notas marcadas para incluir
        const totalReal = Number(v.total || 0);
        const facturable = (typeof _calcularMontoFacturableNota === 'function')
            ? _calcularMontoFacturableNota(v)
            : Number(v.monto_facturable || v.total || 0);
        const activos = Math.max(0, totalReal - facturable);
        totalActivosTotal += activos;
        totalCobradoFinal += facturable;

        let banco = 'Transferencia / Banco';
        const cmt = String(v.comentario || '').trim().toUpperCase();
        for (let b of KNOWN_BANKS) {
            if (cmt.includes(b)) { banco = b; break; }
        }
        if (!summaryMap[banco]) summaryMap[banco] = { monto: 0, count: 0 };
        summaryMap[banco].monto += facturable;
        summaryMap[banco].count++;
    });

    Object.entries(summaryMap).forEach(([banco, data]) => {
        csv += `"${banco}",${data.monto.toFixed(2)},${data.count}\n`;
    });
    if (isCentro && centroActivos > 0) {
        csv += `"Activos Centros de Apoyo (Subsidio Red)",${centroActivos.toFixed(2)},-\n`;
    } else if (totalActivosTotal > 0) {
        csv += `"Activos Red Deducidos",${totalActivosTotal.toFixed(2)},-\n`;
    }
    csv += `TOTAL BANCOS / FACTURABLE NETO,${totalCobradoFinal.toFixed(2)},\n\n`;

    // ════════════════════════════════════════════════════════════════════════
    // BLOQUE 2: RESUMEN CONSOLIDADO DE PRODUCTOS ENTREGADOS
    // ════════════════════════════════════════════════════════════════════════
    csv += `2. RESUMEN CONSOLIDADO DE PRODUCTOS ENTREGADOS\n`;
    csv += `Producto,Cantidad Piezas,Precio Unitario,Subtotal Estimado\n`;

    const consolidated = {};
    for (const v of ventas) {
        if (includeMap[v.id] === false) continue;
        let piezasArr = [];
        try {
            piezasArr = Array.isArray(v.piezas) ? v.piezas :
                        (typeof v.piezas === 'string' ? JSON.parse(v.piezas || '[]') : []);
        } catch(_) {}

        for (const pieza of piezasArr) {
            const prodId = String(pieza.producto_id || pieza.sku || '');
            if (!prodId) continue;
            const qty = parseInt(pieza.cantidad) || 1;
            const precioUnit = parseFloat(pieza.precio_unitario) || 0;

            const catProd = catalogo.find(c => String(c.id) === prodId || c.sku === prodId);
            if (catProd && catProd.categoria === 'paquete') {
                const comps = componentes.filter(c => c.paquete_id === catProd.id);
                if (comps.length > 0) {
                    for (const comp of comps) {
                        const compId = String(comp.componente_id);
                        const compQty = (parseInt(comp.cantidad) || 1) * qty;
                        const compNombre = (comp.comp_nombre || '').replace(/\s+(Pub|MC|Dist)$/i, '').trim();
                        const compPrecio = parseFloat(comp.comp_precio) || 0;
                        if (!consolidated[compId]) consolidated[compId] = { qty: 0, precioUnit: compPrecio, nombre: compNombre };
                        consolidated[compId].qty += compQty;
                        if (!consolidated[compId].nombre && compNombre) consolidated[compId].nombre = compNombre;
                    }
                    continue;
                }
            }
            let nombreProd = pieza.nombre || pieza.producto || '';
            if (catProd) nombreProd = (catProd.nombre || '').replace(/\s+(Pub|MC|Dist)$/i, '').trim();
            if (!consolidated[prodId]) consolidated[prodId] = { qty: 0, precioUnit, nombre: nombreProd };
            consolidated[prodId].qty += qty;
            if (precioUnit > consolidated[prodId].precioUnit) consolidated[prodId].precioUnit = precioUnit;
        }
    }

    let totPiezas = 0;
    let totValorProd = 0;
    Object.values(consolidated).forEach(p => {
        const sub = p.qty * p.precioUnit;
        totPiezas += p.qty;
        totValorProd += sub;
        csv += `"${p.nombre || 'Producto'}",${p.qty},${p.precioUnit.toFixed(2)},${sub.toFixed(2)}\n`;
    });
    csv += `TOTAL PRODUCTOS ENTREGADOS,${totPiezas} PIEZAS,,${totValorProd.toFixed(2)}\n\n`;

    // ════════════════════════════════════════════════════════════════════════
    // BLOQUE 3: DETALLE INDIVIDUAL DE REMISIONES / VENTAS
    // ════════════════════════════════════════════════════════════════════════
    csv += `3. DETALLE INDIVIDUAL DE REMISIONES / VENTAS\n`;
    csv += `Incluir,ID Nota,Cliente,Fecha,Total Original,Monto Facturable,Activos Deducidos,Banco / Origen,Comentario\n`;

    const quote = (str) => `"${String(str || '').replace(/"/g, '""')}"`;

    ventas.forEach(v => {
        const include = (includeMap[v.id] !== false) ? "Sí" : "No";
        const cliente = v.cliente_nombre || 'Público General';
        const totalReal = Number(v.total || 0);
        const facturable = (typeof _calcularMontoFacturableNota === 'function')
            ? _calcularMontoFacturableNota(v)
            : Number(v.monto_facturable || v.total || 0);
        const activos = Math.max(0, totalReal - facturable);
        const fechaStr = v.fecha_venta ? new Date(v.fecha_venta).toLocaleDateString('es-MX') : '';
        const cmt = (v.comentario || '').replace(/[\r\n]+/g, ' ').replace(/\s+/g, ' ').trim();

        let banco = 'Efectivo / Transferencia';
        for (let b of KNOWN_BANKS) {
            if (cmt.toUpperCase().includes(b)) { banco = b; break; }
        }

        csv += `${quote(include)},${quote(v.id)},${quote(cliente)},${quote(fechaStr)},${totalReal.toFixed(2)},${facturable.toFixed(2)},${activos.toFixed(2)},${quote(banco)},${quote(cmt)}\n`;
    });

    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Desglose_Factura_Global_${new Date().getTime()}.csv`;
    a.click();
    URL.revokeObjectURL(url);
};

window._exportarCsvGlobalUSD = function() {
    const checkboxes = document.querySelectorAll('.fg-usd-checkbox');
    const includeMap = {};
    checkboxes.forEach(cb => { includeMap[cb.dataset.id] = cb.checked; });
    
    const ventas = window._fgUsdAllVentas || [];
    const solRow = window._fgUsdSolRow || {};
    const tc = parseFloat(solRow.tipo_cambio) || window._dofTipoCambio || 18.50;

    let csv = "\uFEFFsep=,\n";
    csv += `=====================================================================\n`;
    csv += `REPORTE FISCAL Y FINANCIERO — FACTURA GLOBAL DÓLARES (USD)\n`;
    csv += `Tipo de Cambio DOF Aplicado: $${tc.toFixed(4)} MXN/USD\n`;
    csv += `=====================================================================\n\n`;

    // BLOQUE 1: RESUMEN FINANCIERO USD
    csv += `1. RESUMEN FINANCIERO EN DÓLARES (USD)\n`;
    csv += `Origen / Método,Monto USD,Equivalente MXN (DOF)\n`;

    let totalUsd = 0;
    let centrosUsd = 0;
    let retailUsd = 0;
    let retailActivosUsd = 0;
    let centroCount = 0;

    ventas.forEach(v => {
        if (includeMap[v.id] === false) return;
        const tot = Number(v.total || 0);
        totalUsd += tot;
        if (v.centro_apoyo_id && v.centro_apoyo_id !== '0' && v.centro_apoyo_id !== 0) {
            centrosUsd += tot;
            centroCount++;
        } else {
            retailUsd += tot;
            let act = Number(v.monto_activos || 0);
            if (!act) {
                const mA = (v.comentario || '').match(/(?:ACTIVOS|ACTIVO)[^$]*\$([0-9.,]+)/i);
                if (mA) act = parseFloat(mA[1].replace(/,/g, '')) || 0;
            }
            retailActivosUsd += act;
        }
    });

    let actCentrosUsd = 0;
    if (centroCount > 0) {
        const mAct = String(solRow?.comentario || '').match(/act=([0-9.]+)/);
        if (mAct) actCentrosUsd = parseFloat(mAct[1]) || 0;
    }
    const totActivosUsd = Math.min(totalUsd, actCentrosUsd + retailActivosUsd);
    const facturableUsd = Math.max(0, totalUsd - totActivosUsd);

    csv += `"Total Ventas Cobradas (Bruto)",${totalUsd.toFixed(2)},${(totalUsd * tc).toFixed(2)}\n`;
    csv += `"Ventas Directas Clientes USA",${retailUsd.toFixed(2)},${(retailUsd * tc).toFixed(2)}\n`;
    if (centrosUsd > 0) {
        csv += `"Centros de Apoyo en USD",${centrosUsd.toFixed(2)},${(centrosUsd * tc).toFixed(2)}\n`;
    }
    csv += `"Descuentos / Activos Aplicados (Centros $${actCentrosUsd.toFixed(2)} + Retail $${retailActivosUsd.toFixed(2)})",-${totActivosUsd.toFixed(2)},-${(totActivosUsd * tc).toFixed(2)}\n`;
    csv += `TOTAL FACTURABLE SAT (USD),${facturableUsd.toFixed(2)},${(facturableUsd * tc).toFixed(2)}\n\n`;

    // BLOQUE 2: PRODUCTOS USD
    csv += `2. PRODUCTOS ENTREGADOS EN DÓLARES (USD)\n`;
    csv += `Producto,Cantidad Piezas,Precio Unitario USD,Subtotal USD\n`;

    const consolidated = {};
    for (const v of ventas) {
        if (includeMap[v.id] === false) continue;
        let piezasArr = [];
        try { piezasArr = Array.isArray(v.piezas) ? v.piezas : JSON.parse(v.piezas || '[]'); } catch(_) {}
        for (const pieza of piezasArr) {
            const prodId = String(pieza.producto_id || pieza.sku || '');
            if (!prodId) continue;
            const qty = parseInt(pieza.cantidad) || 1;
            const precioUSD = parseFloat(pieza.precio_unitario) || 0;
            let nombre = pieza.nombre || pieza.producto || 'Producto';
            if (!consolidated[prodId]) consolidated[prodId] = { qty: 0, precioUnit: precioUSD, nombre };
            consolidated[prodId].qty += qty;
            if (precioUSD > consolidated[prodId].precioUnit) consolidated[prodId].precioUnit = precioUSD;
        }
    }

    let totPzUsd = 0;
    let totValUsd = 0;
    Object.values(consolidated).forEach(p => {
        const sub = p.qty * p.precioUnit;
        totPzUsd += p.qty;
        totValUsd += sub;
        csv += `"${p.nombre}",${p.qty},${p.precioUnit.toFixed(2)},${sub.toFixed(2)}\n`;
    });
    csv += `TOTAL PRODUCTOS USD,${totPzUsd} PIEZAS,,${totValUsd.toFixed(2)}\n\n`;

    // BLOQUE 3: REMISIONES USA
    csv += `3. DETALLE INDIVIDUAL DE REMISIONES / VENTAS USA (USD)\n`;
    csv += `Incluir,ID Nota,Cliente / Centro,Fecha,Total USD,TC DOF,Total MXN,Comentario\n`;
    const quote = (str) => `"${String(str || '').replace(/"/g, '""')}"`;

    ventas.forEach(v => {
        const inc = (includeMap[v.id] !== false) ? "Sí" : "No";
        const cliente = v.cliente_nombre || (v.centro_apoyo_id ? 'Centro USD' : 'Cliente USA');
        const tot = Number(v.total || 0);
        const totMxn = tot * tc;
        const fecha = v.fecha_venta ? new Date(v.fecha_venta).toLocaleDateString('es-MX') : '';
        const cmt = (v.comentario || '').replace(/[\r\n]+/g, ' ').replace(/\s+/g, ' ').trim();
        csv += `${quote(inc)},${quote(v.id)},${quote(cliente)},${quote(fecha)},${tot.toFixed(2)},${tc.toFixed(4)},${totMxn.toFixed(2)},${quote(cmt)}\n`;
    });

    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Desglose_Factura_Global_USD_${new Date().getTime()}.csv`;
    a.click();
    URL.revokeObjectURL(url);
};

window._exportarPdfGlobalUSD = function(solicitudId) {
    if (typeof html2pdf === 'undefined') {
        BO_AUTH.showAlert('Librería de PDF cargando, intenta en un momento…', 'warning');
        return;
    }
    const sol = window._fgUsdSolRow || {};
    const ventas = (window._fgUsdAllVentas || []).filter(v => !(window._fgExcludedIdsUSD || []).includes(v.id));
    const tc = parseFloat(sol?.tipo_cambio) || window._dofTipoCambio || 18.50;
    const fmtUSD = (n) => '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' USD';
    const fmtMXN = (n) => '$' + Number(n).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' MXN';

    let totalCobradoUSD = 0;
    let centrosUSD = 0;
    let retailUSD = 0;
    let retailActivos = 0;
    let centroCount = 0;

    ventas.forEach(v => {
        const tot = Number(v.total || 0);
        totalCobradoUSD += tot;
        if (v.centro_apoyo_id && v.centro_apoyo_id !== '0' && v.centro_apoyo_id !== 0) {
            centrosUSD += tot;
            centroCount++;
        } else {
            retailUSD += tot;
            let act = Number(v.monto_activos || 0);
            if (!act) {
                const mA = (v.comentario || '').match(/(?:ACTIVOS|ACTIVO)[^$]*\$([0-9.,]+)/i);
                if (mA) act = parseFloat(mA[1].replace(/,/g, '')) || 0;
            }
            retailActivos += act;
        }
    });

    let actCentros = 0;
    if (centroCount > 0) {
        const mAct = String(sol?.comentario || '').match(/act=([0-9.]+)/);
        if (mAct) actCentros = parseFloat(mAct[1]) || 0;
    }
    const totalActivosUSD = Math.min(totalCobradoUSD, actCentros + retailActivos);
    const totalFacturableUSD = Math.max(0, totalCobradoUSD - totalActivosUSD);
    const totalMXN = totalFacturableUSD * tc;

    let rowsHtml = '';
    ventas.forEach(v => {
        const tot = Number(v.total || 0);
        const cli = v.cliente_nombre || (v.centro_apoyo_id ? 'Centro USD' : 'Cliente USA');
        const fch = v.fecha_venta ? new Date(v.fecha_venta).toLocaleDateString('es-MX') : '';
        rowsHtml += `
            <tr>
                <td style="border:1px solid #ccc;padding:2px 3px;">#${v.id}</td>
                <td style="border:1px solid #ccc;padding:2px 3px;">${cli}</td>
                <td style="border:1px solid #ccc;padding:2px 3px;text-align:center;">${fch}</td>
                <td style="border:1px solid #ccc;padding:2px 3px;text-align:right;font-weight:700;">${fmtUSD(tot)}</td>
                <td style="border:1px solid #ccc;padding:2px 3px;text-align:right;">${fmtMXN(tot * tc)}</td>
            </tr>`;
    });

    const html = `
    <div style="font-family:Arial,sans-serif;font-size:8px;color:#111;padding:10px;">
        <div style="display:flex;justify-content:space-between;align-items:center;border-bottom:2px solid #0284c7;padding-bottom:5px;margin-bottom:8px;">
            <div>
                <div style="font-size:13px;font-weight:bold;color:#0284c7;">DULETIA — REPORTE FISCAL FACTURA GLOBAL USD</div>
                <div style="font-size:8px;color:#555;">Solicitud #${solicitudId} · Folio: ${sol.numero_nota || 'GLOBAL-USD'} · Moneda: USD</div>
            </div>
            <div style="text-align:right;font-size:8px;">
                <div><b>Tipo de Cambio DOF:</b> $${tc.toFixed(4)} MXN</div>
                <div><b>Generado:</b> ${new Date().toLocaleDateString('es-MX')}</div>
            </div>
        </div>

        <table style="width:100%;border-collapse:collapse;margin-bottom:8px;font-size:8px;">
            <tr style="background:#f0f9ff;">
                <td style="border:1px solid #bae6fd;padding:4px;"><b>Notas:</b> ${ventas.length}</td>
                <td style="border:1px solid #bae6fd;padding:4px;text-align:right;"><b>Total Cobrado:</b> ${fmtUSD(totalCobradoUSD)}</td>
                <td style="border:1px solid #bae6fd;padding:4px;text-align:right;"><b>Activos:</b> <span style="color:#d97706;font-weight:bold;">-${fmtUSD(totalActivosUSD)}</span></td>
                <td style="border:1px solid #bae6fd;padding:4px;text-align:right;"><b>Facturable SAT:</b> <span style="color:#0284c7;font-weight:bold;">${fmtUSD(totalFacturableUSD)}</span></td>
                <td style="border:1px solid #bae6fd;padding:4px;text-align:right;"><b>Equivalente MXN:</b> <span style="color:#16a34a;font-weight:bold;">${fmtMXN(totalMXN)}</span></td>
            </tr>
            <tr style="background:#f8fafc;">
                <td colspan="2" style="border:1px solid #bae6fd;padding:4px;"><b>Forma de Pago SAT:</b> ${document.getElementById('fg-usd-fp-text')?.textContent?.trim() || sol.forma_pago || '03 — Transferencia electrónica de fondos'}</td>
                <td colspan="3" style="border:1px solid #bae6fd;padding:4px;text-align:right;"><b>Periodicidad SAT:</b> ${document.getElementById('fg-usd-per-text')?.textContent?.trim() || '04 — Mensual'}</td>
            </tr>
        </table>

        <div style="font-size:8px;font-weight:bold;color:#333;margin-bottom:4px;text-transform:uppercase;">Detalle de Ventas Dólares (USA)</div>
        <table style="width:100%;border-collapse:collapse;font-size:7.5px;">
            <thead>
                <tr style="background:#f1f5f9;">
                    <th style="border:1px solid #cbd5e1;padding:3px;text-align:left;">Nota</th>
                    <th style="border:1px solid #cbd5e1;padding:3px;text-align:left;">Cliente / Destino</th>
                    <th style="border:1px solid #cbd5e1;padding:3px;text-align:center;">Fecha</th>
                    <th style="border:1px solid #cbd5e1;padding:3px;text-align:right;">Total USD</th>
                    <th style="border:1px solid #cbd5e1;padding:3px;text-align:right;">Equivalente MXN</th>
                </tr>
            </thead>
            <tbody>${rowsHtml}</tbody>
        </table>
    </div>`;

    const wrapper = document.createElement('div');
    wrapper.style.cssText = 'position:absolute;left:-9999px;top:0;background:#fff;';
    wrapper.innerHTML = html;
    document.body.appendChild(wrapper);

    const opt = {
        margin:       [0.25, 0.25, 0.25, 0.25],
        filename:     `Factura_Global_USD_${solicitudId}_Desglose.pdf`,
        image:        { type: 'jpeg', quality: 0.95 },
        html2canvas:  { scale: 2, useCORS: true, logging: false, backgroundColor: '#ffffff' },
        jsPDF:        { unit: 'in', format: 'letter', orientation: 'portrait' }
    };

    html2pdf().set(opt).from(wrapper.firstElementChild).save().then(() => {
        wrapper.remove();
        BO_AUTH.showAlert('✅ PDF USD generado correctamente.', 'success');
    }).catch(err => {
        wrapper.remove();
        BO_AUTH.showAlert('Error generando PDF: ' + err.message, 'error');
    });
};

window._exportarCsvCotejoEspecialCentro = function(numNota) {
    const ventas = (window._fgAllVentas || []).filter(v => 
        v.producto_id !== 'calificacion-mes' && 
        !String(v.comentario || '').toLowerCase().includes('calificacion del mes')
    );
    const catalogo = window._fgCatalogo || [];
    const componentes = window._fgComponentes || [];

    const getCentroNombre = (v) => {
        if (v.centro_nombre && v.centro_nombre.trim()) return v.centro_nombre.trim();
        const cmt = String(v.comentario || '');
        const m = cmt.match(/Centro\s+de\s+Apoyo\s+([^||\n\r]+)/i) || cmt.match(/Para:\s*([^||\n\r]+)/i);
        if (m) return m[1].trim();
        if (v.centro_apoyo_id && v.centro_apoyo_id !== '0') return `Centro #${v.centro_apoyo_id}`;
        return 'Centro de Apoyo';
    };
    
    let csv = `\uFEFFCOTEJO ESPECIAL DE PAGOS Y PRODUCTOS — ${numNota}\n\n`;
    
    // ════════════════════════════════════════════════════════════════════════
    // SECCIÓN 1: ORIGEN DE PAGOS Y BANCOS
    // ════════════════════════════════════════════════════════════════════════
    csv += `=====================================================================\n`;
    csv += `1. ORIGEN DE PAGOS Y BANCOS (RESUMEN FINANCIERO)\n`;
    csv += `=====================================================================\n`;
    csv += `Origen / Fecha,Banco / Método,Referencia,Monto Facturable / Abono\n`;

    const KNOWN_BANKS = ['BBVA', 'SANTANDER', 'BANAMEX', 'MERCADOPAGO', 'PAYPAL', 'CLIP', 'STRIPE', 'BANORTE', 'HSBC'];
    const summaryMap = {};
    let totalActivosDeducidos = 0;

    ventas.forEach(v => {
        const totalReal = Number(v.total || 0);
        const facturable = (typeof _calcularMontoFacturableNota === 'function')
            ? _calcularMontoFacturableNota(v)
            : Number(v.monto_facturable || v.total || 0);
        const activos = Math.max(0, totalReal - facturable);
        totalActivosDeducidos += activos;

        let banco = 'Transferencia / Efectivo';
        const cmt = String(v.comentario || '').trim();
        for (let b of KNOWN_BANKS) {
            if (cmt.toUpperCase().includes(b)) { banco = b; break; }
        }
        if (!summaryMap[banco]) summaryMap[banco] = 0;
        summaryMap[banco] += facturable;
    });

    let totalPagosFin = 0;
    Object.entries(summaryMap).forEach(([banco, monto]) => {
        totalPagosFin += monto;
        csv += `"Notas periodo","${banco}","Desglose remisiones",${monto.toFixed(2)}\n`;
    });
    if (totalActivosDeducidos > 0) {
        csv += `"Activos Red","Cobro Activos Deducidos","Descuento en remisiones",${totalActivosDeducidos.toFixed(2)}\n`;
    }
    csv += `TOTAL BANCOS / ABONOS,,,$${totalPagosFin.toFixed(2)}\n\n\n`;

    // ════════════════════════════════════════════════════════════════════════
    // SECCIÓN 2: PRODUCTOS Y REMISIONES ENTREGADAS
    // ════════════════════════════════════════════════════════════════════════
    csv += `=====================================================================\n`;
    csv += `2. DESGLOSE DE PRODUCTOS ENTREGADOS (${ventas.length} REMISIONES REALES)\n`;
    csv += `=====================================================================\n`;
    
    // 2A: CONSOLIDADO DE PRODUCTOS (Piezas, DULET, EUCAMENT, ETC)
    csv += `2A. RESUMEN CONSOLIDADO DE PRODUCTOS (PIEZAS ENTREGADAS)\n`;
    csv += `Producto,Cantidad Piezas,Precio Unitario,Subtotal Estimado\n`;

    const consolidated = {};
    for (const v of ventas) {
        let piezasArr = [];
        try {
            piezasArr = Array.isArray(v.piezas) ? v.piezas :
                        (typeof v.piezas === 'string' ? JSON.parse(v.piezas || '[]') : []);
        } catch(_) {}

        for (const pieza of piezasArr) {
            const prodId = String(pieza.producto_id || pieza.sku || '');
            if (!prodId) continue;
            const qty = parseInt(pieza.cantidad) || 1;
            const precioUnit = parseFloat(pieza.precio_unitario) || 0;

            const catProd = catalogo.find(c => String(c.id) === prodId || c.sku === prodId);
            if (catProd && catProd.categoria === 'paquete') {
                const comps = componentes.filter(c => c.paquete_id === catProd.id);
                if (comps.length > 0) {
                    for (const comp of comps) {
                        const compId = String(comp.componente_id);
                        const compQty = (parseInt(comp.cantidad) || 1) * qty;
                        const compNombre = (comp.comp_nombre || '').replace(/\s+(Pub|MC|Dist)$/i, '').trim();
                        const compPrecio = parseFloat(comp.comp_precio) || 0;
                        if (!consolidated[compId]) consolidated[compId] = { qty: 0, precioUnit: compPrecio, nombre: compNombre };
                        consolidated[compId].qty += compQty;
                        if (!consolidated[compId].nombre && compNombre) consolidated[compId].nombre = compNombre;
                    }
                    continue;
                }
            }
            let nombreProd = pieza.nombre || pieza.producto || '';
            if (catProd) nombreProd = (catProd.nombre || '').replace(/\s+(Pub|MC|Dist)$/i, '').trim();
            if (!consolidated[prodId]) consolidated[prodId] = { qty: 0, precioUnit, nombre: nombreProd };
            consolidated[prodId].qty += qty;
            if (precioUnit > consolidated[prodId].precioUnit) consolidated[prodId].precioUnit = precioUnit;
        }
    }

    let totPiezas = 0;
    let totValorProd = 0;
    Object.values(consolidated).forEach(p => {
        const sub = p.qty * p.precioUnit;
        totPiezas += p.qty;
        totValorProd += sub;
        csv += `"${p.nombre || 'Producto'}",${p.qty},${p.precioUnit.toFixed(2)},${sub.toFixed(2)}\n`;
    });
    csv += `TOTAL PRODUCTOS,${totPiezas} PIEZAS,,${totValorProd.toFixed(2)}\n\n`;

    // 2B: DETALLE POR REMISIÓN INDIVIDUAL
    csv += `2B. DETALLE INDIVIDUAL DE REMISIONES ENTREGADAS\n`;
    csv += `ID Nota,Centro de Apoyo,Cliente,Total Remisión,Monto Facturable,Activos Deducidos,Comentario / Banco / Origen\n`;

    let totalRemisiones = 0;
    let totalFacturable = 0;
    let totalActivos = 0;

    ventas.forEach(v => {
        const tot = Number(v.total || 0);
        const fact = (typeof _calcularMontoFacturableNota === 'function')
            ? _calcularMontoFacturableNota(v)
            : Number(v.monto_facturable || v.total || 0);
        const act = Math.max(0, tot - fact);
        
        totalRemisiones += tot;
        totalFacturable += fact;
        totalActivos += act;

        const centro = String(getCentroNombre(v)).replace(/"/g, '""');
        const client = String(v.cliente_nombre || 'Público General').replace(/"/g, '""');
        const cmt = String(v.comentario || '').replace(/[\r\n]+/g, ' ').replace(/"/g, '""');
        
        csv += `"${v.id}","${centro}","${client}",${tot.toFixed(2)},${fact.toFixed(2)},${act.toFixed(2)},"${cmt}"\n`;
    });

    csv += `TOTALES REMISIONES,${ventas.length} NOTAS,${totalRemisiones.toFixed(2)},${totalFacturable.toFixed(2)},${totalActivos.toFixed(2)},\n`;

    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Cotejo_Especial_${numNota.replace(/[^a-zA-Z0-9_-]/g,'_')}.csv`;
    a.click();
    URL.revokeObjectURL(url);
};

window._abrirCotejoEspecialCentro = async function(solicitudId) {
    BO_AUTH.showAlert('⏳ Cargando cotejo especial de pagos y productos…', 'info');
    try {
        const solRes = await BO_API.post('/bo/sql-relay', {
            secret: 'duletia_relay_2026',
            sql: `SELECT * FROM facturas_solicitadas WHERE id = ${solicitudId}`
        });
        const sol = solRes.rows?.[0];
        if (!sol) throw new Error('Solicitud no encontrada');

        const numNota = sol.numero_nota || '';
        const centroIdMatch = numNota.match(/^CENTRO-(\d+)/);
        const centroId = centroIdMatch ? centroIdMatch[1] : null;

        // Extraer rango de fechas
        const rangoMatch = numNota.match(/(?:GLOBAL|CENTRO)[^-]*-(\d{4}-\d{2}-\d{2})_(\d{4}-\d{2}-\d{2})/);
        const mesMatch = numNota.match(/(?:GLOBAL|CENTRO)[^-]*-(\d{4})-(\d{2})/);

        let fechaIni = '', fechaFin = '';
        if (rangoMatch) {
            fechaIni = `${rangoMatch[1]} 00:00:00`;
            fechaFin = `${rangoMatch[2]} 23:59:59`;
        } else if (mesMatch) {
            fechaIni = `${mesMatch[1]}-${mesMatch[2]}-01 00:00:00`;
            const mesNum = parseInt(mesMatch[2]);
            const anioNum = parseInt(mesMatch[1]);
            const nextMes = mesNum === 12 ? 1 : mesNum + 1;
            const nextAnio = mesNum === 12 ? anioNum + 1 : anioNum;
            fechaFin = `${nextAnio}-${String(nextMes).padStart(2,'0')}-01 00:00:00`;
        }

        // 1. Obtener ventas (si tenemos window._fgAllVentas del modal abierto, usarlas directamente)
        let ventas = window._fgAllVentas || [];
        if (!ventas.length) {
            let sqlVentas = '';
            if (centroId) {
                sqlVentas = `SELECT v.id, v.fecha_venta, v.total, COALESCE(v.monto_facturable::float, v.total) as monto_facturable, v.comentario, v.centro_apoyo_id, COALESCE(ca.nombre,'') as centro_nombre, COALESCE(c.nombre||' '||COALESCE(c.ape_p,''),'Público General') as cliente_nombre FROM venta v LEFT JOIN cliente c ON c.id = v.cliente_id LEFT JOIN centro_apoyo ca ON ca.id::text = v.centro_apoyo_id::text WHERE v.centro_apoyo_id = ${centroId} AND v.approved = 1 AND COALESCE(v.producto_id,'') != 'calificacion-mes' ${fechaIni ? `AND v.fecha_venta >= '${fechaIni}' AND v.fecha_venta <= '${fechaFin}'` : ''} ORDER BY v.fecha_venta DESC`;
            } else {
                sqlVentas = `SELECT v.id, v.fecha_venta, v.total, COALESCE(v.monto_facturable::float, v.total) as monto_facturable, v.comentario, v.centro_apoyo_id, COALESCE(ca.nombre,'') as centro_nombre, COALESCE(c.nombre||' '||COALESCE(c.ape_p,''),'Público General') as cliente_nombre FROM venta v LEFT JOIN cliente c ON c.id = v.cliente_id LEFT JOIN centro_apoyo ca ON ca.id::text = v.centro_apoyo_id::text WHERE v.approved = 1 AND COALESCE(v.producto_id,'') != 'calificacion-mes' AND (v.centro_apoyo_id IS NOT NULL OR c.nombre ILIKE '%centro%') ${fechaIni ? `AND v.fecha_venta >= '${fechaIni}' AND v.fecha_venta <= '${fechaFin}'` : ''} ORDER BY v.fecha_venta DESC LIMIT 200`;
            }
            const rV = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlVentas });
            ventas = rV.rows || [];
        }

        const getCentroNombre = (v) => {
            if (v.centro_nombre && v.centro_nombre.trim()) return v.centro_nombre.trim();
            const cmt = String(v.comentario || '');
            const m = cmt.match(/Centro\s+de\s+Apoyo\s+([^||\n\r]+)/i) || cmt.match(/Para:\s*([^||\n\r]+)/i);
            if (m) return m[1].trim();
            if (v.centro_apoyo_id && v.centro_apoyo_id !== '0') return `Centro #${v.centro_apoyo_id}`;
            return 'Centro de Apoyo';
        };

        // 2. Obtener abonos de centro_apoyo_pago
        let sqlPagos = centroId
            ? `SELECT id, monto, tipo_pago, referencia, banco, creado_en FROM centro_apoyo_pago WHERE centro_id = ${centroId} ${fechaIni ? `AND creado_en >= '${fechaIni}' AND creado_en <= '${fechaFin}'` : ''} ORDER BY creado_en DESC`
            : `SELECT id, monto, tipo_pago, referencia, banco, creado_en FROM centro_apoyo_pago WHERE 1=1 ${fechaIni ? `AND creado_en >= '${fechaIni}' AND creado_en <= '${fechaFin}'` : ''} ORDER BY creado_en DESC LIMIT 100`;
        
        const rP = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlPagos });
        let pagos = rP.rows || [];

        // 3. Generar desglose financiero
        const fmt = (n) => '$' + Number(n || 0).toLocaleString('es-MX', { minimumFractionDigits: 2 });
        let totalPagos = pagos.reduce((s, p) => s + Number(p.monto || 0), 0);
        let totalActivosDeducidos = 0;

        let pagosRows = '';
        if (pagos.length > 0) {
            pagosRows = pagos.map(p => `<tr>
                <td style="font-size:.72rem;padding:.3rem">${p.creado_en ? new Date(p.creado_en).toLocaleDateString('es-MX') : '—'}</td>
                <td style="font-size:.72rem;padding:.3rem;font-weight:700;color:#818cf8">${p.banco || p.tipo_pago || 'Abono'}</td>
                <td style="font-size:.72rem;padding:.3rem">${p.referencia || '—'}</td>
                <td style="font-size:.72rem;padding:.3rem;text-align:right;font-weight:700;color:#22c55e">${fmt(p.monto)}</td>
            </tr>`).join('');
        } else {
            // Generar desde comentarios de las notas cargadas en la solicitud
            const KNOWN_BANKS = ['BBVA', 'SANTANDER', 'BANAMEX', 'MERCADOPAGO', 'PAYPAL', 'CLIP', 'STRIPE', 'BANORTE', 'HSBC'];
            const summaryMap = {};
            ventas.forEach(v => {
                const totalReal = Number(v.total || 0);
                const facturable = (typeof _calcularMontoFacturableNota === 'function')
                    ? _calcularMontoFacturableNota(v)
                    : Number(v.monto_facturable || v.total || 0);
                const activos = Math.max(0, totalReal - facturable);
                totalActivosDeducidos += activos;

                let banco = 'Transferencia / Efectivo';
                const cmt = String(v.comentario || '').trim();
                for (let b of KNOWN_BANKS) {
                    if (cmt.toUpperCase().includes(b)) { banco = b; break; }
                }
                if (!summaryMap[banco]) summaryMap[banco] = 0;
                summaryMap[banco] += facturable;
            });
            totalPagos = Object.values(summaryMap).reduce((a, b) => a + b, 0);
            pagosRows = Object.entries(summaryMap).map(([banco, monto]) => `<tr>
                <td style="font-size:.72rem;padding:.3rem">Notas periodo</td>
                <td style="font-size:.72rem;padding:.3rem;font-weight:700;color:#818cf8">${banco}</td>
                <td style="font-size:.72rem;padding:.3rem;color:var(--text-dim)">Desglose remisiones</td>
                <td style="font-size:.72rem;padding:.3rem;text-align:right;font-weight:700;color:#22c55e">${fmt(monto)}</td>
            </tr>`).join('');
            if (totalActivosDeducidos > 0) {
                pagosRows += `<tr style="background:rgba(234,179,8,.1)">
                    <td style="font-size:.72rem;padding:.3rem">Activos Red</td>
                    <td style="font-size:.72rem;padding:.3rem;font-weight:700;color:#eab308">Cobro Activos Deducidos</td>
                    <td style="font-size:.72rem;padding:.3rem;color:var(--text-dim)">Descuento en remisiones</td>
                    <td style="font-size:.72rem;padding:.3rem;text-align:right;font-weight:700;color:#eab308">${fmt(totalActivosDeducidos)}</td>
                </tr>`;
            }
        }

        const totalVentas = ventas.reduce((s, v) => s + Number(v.total || 0), 0);
        const ventasRows = ventas.map(v => {
            const tot = Number(v.total || 0);
            const fact = (typeof _calcularMontoFacturableNota === 'function')
                ? _calcularMontoFacturableNota(v)
                : Number(v.monto_facturable || v.total || 0);
            const act = Math.max(0, tot - fact);
            const centro = getCentroNombre(v);
            return `<tr>
                <td style="font-size:.72rem;padding:.3rem">${v.id.substring(0, 8)}…</td>
                <td style="font-size:.72rem;padding:.3rem;font-weight:700;color:#818cf8">${centro}</td>
                <td style="font-size:.72rem;padding:.3rem">${v.cliente_nombre || 'Público General'}</td>
                <td style="font-size:.72rem;padding:.3rem;text-align:right;font-weight:600">${fmt(tot)}</td>
                <td style="font-size:.72rem;padding:.3rem;text-align:right;font-weight:700;color:#22c55e">${fmt(fact)}</td>
                <td style="font-size:.72rem;padding:.3rem;text-align:right;color:#eab308">${act > 0 ? fmt(act) : '—'}</td>
            </tr>`;
        }).join('');

        const modal = document.createElement('div');
        modal.id = 'modal-cotejo-especial-centro';
        modal.style.cssText = 'position:fixed;inset:0;z-index:10000;background:rgba(0,0,0,.85);display:flex;align-items:center;justify-content:center;';
        modal.innerHTML = `
        <div style="background:var(--bg-card);border:1px solid var(--border);border-radius:12px;max-width:980px;width:95%;max-height:85vh;overflow-y:auto;padding:1.5rem;box-shadow:0 20px 60px rgba(0,0,0,.7);">
            <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:1rem;border-bottom:1px solid var(--border);padding-bottom:.5rem;">
                <h3 style="margin:0;font-size:1.1rem;color:#818cf8;">🔍 Desglose Especial de Cotejo — ${numNota}</h3>
                <button onclick="document.getElementById('modal-cotejo-especial-centro').remove()" style="background:none;border:none;color:var(--text-primary);font-size:1.2rem;cursor:pointer">✕</button>
            </div>
            <div style="display:grid;grid-template-columns:1fr 1.3fr;gap:1rem;margin-bottom:1rem;">
                <div style="background:rgba(99,102,241,.08);padding:1rem;border-radius:8px;border:1px solid rgba(99,102,241,.2)">
                    <h4 style="margin:0 0 .5rem;font-size:.85rem;color:#818cf8">💳 Origen de Pagos y Bancos</h4>
                    <div style="font-size:1.1rem;font-weight:800;color:#22c55e;margin-bottom:.5rem">Total Abonos: ${fmt(totalPagos)}</div>
                    <div style="max-height:260px;overflow-y:auto">
                        <table class="bo-table" style="font-size:.7rem;width:100%">
                            <thead><tr><th>Fecha</th><th>Banco/Origen</th><th>Ref</th><th style="text-align:right">Facturable</th></tr></thead>
                            <tbody>${pagosRows || '<tr><td colspan="4" style="text-align:center">Sin pagos en periodo</td></tr>'}</tbody>
                        </table>
                    </div>
                </div>
                <div style="background:rgba(245,158,11,.08);padding:1rem;border-radius:8px;border:1px solid rgba(245,158,11,.2)">
                    <h4 style="margin:0 0 .5rem;font-size:.85rem;color:#fbbf24">📦 Remisiones y Productos Entregados (${ventas.length})</h4>
                    <div style="font-size:1.1rem;font-weight:800;color:#fbbf24;margin-bottom:.5rem">Total Remisiones: ${fmt(totalVentas)}</div>
                    <div style="max-height:260px;overflow-y:auto">
                        <table class="bo-table" style="font-size:.7rem;width:100%">
                            <thead><tr><th>Nota</th><th>Centro</th><th>Cliente</th><th style="text-align:right">Total</th><th style="text-align:right">Fact.</th><th style="text-align:right">Activos</th></tr></thead>
                            <tbody>${ventasRows || '<tr><td colspan="6" style="text-align:center">Sin ventas vinculadas</td></tr>'}</tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div style="display:flex;justify-content:space-between;align-items:center;">
                <button class="btn btn-sm" onclick="window._exportarCsvCotejoEspecialCentro('${numNota}')" style="background:#22c55e;color:#fff;border:none;font-weight:700;padding:.4rem 1rem;border-radius:6px;cursor:pointer;display:flex;align-items:center;gap:.4rem;">📥 Exportar CSV Cotejo</button>
                <button class="btn btn-outline btn-sm" onclick="document.getElementById('modal-cotejo-especial-centro').remove()">✕ Cerrar Cotejo</button>
            </div>
        </div>`;
        document.body.appendChild(modal);
    } catch(e) {
        BO_AUTH.showAlert('Error en cotejo especial: ' + e.message, 'error');
    }
};

async function aprobarSolicitudGlobal(solicitudId, excludedIds = [], fallbackAllIds = null) {
    if (!confirm('\u26a0\ufe0f \u00bfTimbrar esta factura global ante el SAT?\\n\\nEsta acci\u00f3n no se puede deshacer.')) return;
    BO_AUTH.showAlert('\u23f3 Timbrando factura global ante el SAT…', 'info');
    try {
        // 0. Excluir notas desmarcadas: actualizar requiere_factura = false Y remover de facturas_solicitadas.ventas_ids
        if (excludedIds && excludedIds.length > 0) {
            if (typeof window._persistirExclusionesSolicitud === 'function') {
                const rExcl = await window._persistirExclusionesSolicitud(solicitudId, excludedIds, true, fallbackAllIds);
                if (!rExcl.ok) return;
            } else {
                const inClause = excludedIds.map(id => `'${id}'`).join(',');
                await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                    sql: `UPDATE venta SET requiere_factura = false WHERE id IN (${inClause})`
                });
            }
        }
        
        // Leer nueva forma de pago (si el usuario la editó)
        let overrideFormaPagoQuery = '';
        const selectFp = document.getElementById('fg-fp-select');
        const nuevaFp = window._fgFormaPago || (selectFp && selectFp.value ? selectFp.value : null);
        if (nuevaFp) {
            overrideFormaPagoQuery = `, forma_pago = '${nuevaFp}'`;
        }
        let overridePeriodicidadQuery = '';
        const selectPer = document.getElementById('fg-per-select');
        const nuevaPeriodicidad = window._fgPeriodicidad || (selectPer && selectPer.value ? selectPer.value : null);
        if (nuevaPeriodicidad) {
            overridePeriodicidadQuery = `, periodicidad = '${nuevaPeriodicidad}'`;
        }

        // 1. Marcar como en_proceso y actualizar forma de pago y periodicidad
        await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
            sql: `UPDATE facturas_solicitadas SET estado = 'en_proceso'${overrideFormaPagoQuery}${overridePeriodicidadQuery} WHERE id = ${solicitudId}`
        });

        // 2. Obtener el cedisId, periodicidad y datos de moneda de la solicitud
        const solRes = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
            sql: `SELECT numero_nota, forma_pago, moneda, tipo_cambio, cedis_id, periodicidad, comentario FROM facturas_solicitadas WHERE id = ${solicitudId}`
        });
        const sol = solRes.rows?.[0];
        const _isUsdGlobalAprobar = String(sol?.cedis_id) === 'USD' || String(sol?.numero_nota||'').includes('-USD');
        // Para USD, cedisId no aplica como filtro — se usa moneda
        let cedisId = 0;
        if (!_isUsdGlobalAprobar) {
            const cedisMatch = (sol?.numero_nota || '').match(/C(\d+)/);
            cedisId = cedisMatch ? parseInt(cedisMatch[1]) : 0;
        }
        const _solMonedaGlobal = _isUsdGlobalAprobar ? 'USD' : (sol?.moneda || 'MXN');
        const _solTCGlobal = parseFloat(sol?.tipo_cambio) || 0;
        const _solPeriodicidad = nuevaPeriodicidad || sol?.periodicidad || '04';

        // Extraer rango de fechas: soporta GLOBAL-YYYY-MM-DD_YYYY-MM-DD-C# y GLOBAL-YYYY-MM-C#
        const _nota = sol?.numero_nota || '';
        const rangoMatch = _nota.match(/GLOBAL-(\d{4}-\d{2}-\d{2})_(\d{4}-\d{2}-\d{2})/);
        // Regex flexible: captura YYYY-MM en notas tipo 'GLOBAL-2026-06-C1' O 'GLOBAL-237-2026-06'
        const mesMatch = _nota.match(/GLOBAL-(?:\d+-)?(\d{4}-\d{2})/);

        let mesFacturacion = '';
        let fechaInicio = '';
        let fechaFin = '';
        if (rangoMatch) {
            fechaInicio = rangoMatch[1];
            fechaFin = rangoMatch[2];
            mesFacturacion = rangoMatch[1].substring(0, 7); // YYYY-MM for GlobalInformation.Months
        } else if (mesMatch) {
            mesFacturacion = mesMatch[1];
        }

        // Fallback cuando el nota no tiene formato GLOBAL-YYYY-MM:
        // Si retroactivo está activo → mes anterior; si no → mes actual
        if (!mesFacturacion) {
            const _ahora = new Date();
            const _refDate = window._timbradoRetroactivo
                ? new Date(_ahora.getFullYear(), _ahora.getMonth() - 1, 1)  // mes anterior
                : _ahora;
            mesFacturacion = `${_refDate.getFullYear()}-${String(_refDate.getMonth()+1).padStart(2,'0')}`;
        }

        // Validar ventana de 72 horas del SAT si es mes anterior
        if (mesFacturacion) {
            const [yyyy, mm] = mesFacturacion.split('-').map(Number);
            const inicioMesSiguiente = new Date(yyyy, mm, 1);
            const ahora = new Date();
            const horasTranscurridas = (ahora - inicioMesSiguiente) / (1000 * 60 * 60);
            if (horasTranscurridas > 72) {
                await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                    sql: `UPDATE facturas_solicitadas SET estado = 'solicitada' WHERE id = ${solicitudId}`
                });
                BO_AUTH.showAlert('⛔ Han pasado más de 72 horas desde el cierre del periodo ' + mesFacturacion + '.\nEl SAT ya no permite timbrar facturas globales de ese mes.', 'error');
                loadHistorialFacturas();
                return;
            }
        }

        // 3. Obtener forma de pago y periodicidad (respetando lo seleccionado en el modal o fallback según moneda)
        const defaultFp = _isUsdGlobalAprobar ? '03' : '01';
        const formaPagoFinal = window._fgFormaPago || sol?.forma_pago || defaultFp;
        const periodicidadFinal = window._fgPeriodicidad || _solPeriodicidad || sol?.periodicidad || '04';

        // 4. Llamar al workflow de timbrado n8n con datos completos
        // Retroactivo: usar el último día del mes de facturación solo si es mes pasado y el usuario activó retroactivo
        const _ahoraG = new Date();
        const _mesActualG = _ahoraG.getFullYear() + '-' + String(_ahoraG.getMonth() + 1).padStart(2, '0');
        const _esMesPasadoG = mesFacturacion && mesFacturacion < _mesActualG;
        const _retroFechaGlobal = (window._timbradoRetroactivo && _esMesPasadoG)
            ? (()=>{ const [y,m]=mesFacturacion.split('-').map(Number); const d=new Date(y,m,0); return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}T23:50:00`; })()
            : null;
        const mActG = String(sol?.comentario || '').match(/act=([0-9.]+)/);
        const _actFromSolG = mActG ? parseFloat(mActG[1]) || 0 : 0;
        const _totalActivosToSend = typeof window._fgTotalActivos === 'number' ? window._fgTotalActivos : _actFromSolG;

        const globalEndpoint = _isUsdGlobalAprobar
            ? (BO_API.BASE + '/bo/timbrar-global-usd')
            : (BO_API.BASE + '/bo/facturacion/global/timbrar');

        const res = await fetch(globalEndpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                cedisId,
                solicitudId,
                formaPago: formaPagoFinal,
                mesFacturacion,
                fechaInicio,
                fechaFin,
                periodicidad: periodicidadFinal,
                moneda: _solMonedaGlobal,
                tipoCambio: _solTCGlobal,
                isUSD: _isUsdGlobalAprobar,
                totalActivos: _totalActivosToSend,
                totalActivosCobrados: _totalActivosToSend,
                totalFacturable: typeof window._fgTotalFacturable === 'number' ? window._fgTotalFacturable : undefined,
                excludedIds: excludedIds || [],
                ...(_retroFechaGlobal ? { fechaRetroactivo: _retroFechaGlobal } : {})
            })
        });

        if (!res.ok) {
            const errText = await res.text().catch(() => 'Sin respuesta');
            await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                sql: `UPDATE facturas_solicitadas SET estado = 'solicitada' WHERE id = ${solicitudId}`
            });
            BO_AUTH.showAlert('Error del servidor (' + res.status + '): ' + errText.substring(0, 300), 'error');
            loadHistorialFacturas();
            return;
        }

        const data = await res.json().catch(() => ({}));

        if (data.error || data.Message) {
            await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                sql: `UPDATE facturas_solicitadas SET estado = 'solicitada' WHERE id = ${solicitudId}`
            });
            BO_AUTH.showAlert('\u26a0\ufe0f Timbrado rechazado: ' + (data.error || data.Message || JSON.stringify(data).substring(0,200)), 'warning');
            loadHistorialFacturas();
            return;
        }

        // 5. El workflow de n8n ya marcó ventas y solicitud como facturada.
        //    Facturama v3 POST no devuelve UUID/Id del CFDI en la respuesta,
        //    así que confiamos en success:true del workflow.
        if (data.success) {
            window._fgFormaPago = null;
            window._fgPeriodicidad = null;
            window._fgTotalActivos = null;
            window._fgTotalFacturable = null;
            BO_AUTH.showAlert('\u2705 Factura global timbrada exitosamente.\nSolicitud #' + solicitudId + ' marcada como facturada.', 'success');
            loadHistorialFacturas();
            if (typeof loadFacturaGlobal === 'function') loadFacturaGlobal();
            setTimeout(() => switchHistorialTab('facturas'), 600);
        } else {
            // Respuesta inesperada sin error ni success
            BO_AUTH.showAlert('\u26a0\ufe0f Respuesta inesperada del servidor: ' + JSON.stringify(data).substring(0,300), 'warning');
            loadHistorialFacturas();
        }
    } catch(e) {
        try { await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: `UPDATE facturas_solicitadas SET estado='solicitada' WHERE id=${solicitudId}` }); } catch(_){}
        BO_AUTH.showAlert('\u26a0\ufe0f Error de red al timbrar: ' + e.message, 'warning');
        loadHistorialFacturas();
    }
}

async function cambiarEstadoFactura(id, estado) {
    if(!confirm('¿Deseas cambiar el estado a "' + estado + '"?')) return;
    try {
        const sql = `UPDATE facturas_solicitadas SET estado = '${estado}' WHERE id = ${id}`;
        await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql });
        
        // Si se marca como facturada, marcar las ventas asociadas
        if (estado === 'facturada') {
            const sqlSol = `SELECT numero_nota, ventas_ids FROM facturas_solicitadas WHERE id = ${id}`;
            const resSol = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlSol });
            const numNota = resSol.rows?.[0]?.numero_nota || '';
            const rawIds = resSol.rows?.[0]?.ventas_ids || '';

            // ── Intentar marcar por ventas_ids (método preciso) ──
            let markedByIds = false;
            if (rawIds && rawIds !== '[]' && rawIds !== 'null') {
                try {
                    const idsArr = typeof rawIds === 'string' ? JSON.parse(rawIds) : rawIds;
                    if (Array.isArray(idsArr) && idsArr.length > 0) {
                        // Marcar en batches de 200 para evitar queries gigantes
                        for (let i = 0; i < idsArr.length; i += 200) {
                            const batch = idsArr.slice(i, i + 200);
                            const inClause = batch.map(vid => `'${vid}'`).join(',');
                            await BO_API.post('/bo/sql-relay', {
                                secret: 'duletia_relay_2026',
                                sql: `UPDATE venta SET factura_emitida = true WHERE id IN (${inClause})`
                            });
                        }
                        markedByIds = true;
                        console.log(`[FACTURACIÓN] ✅ ${idsArr.length} notas marcadas por ventas_ids para solicitud #${id}`);
                    }
                } catch (parseErr) {
                    console.warn('[FACTURACIÓN] Error parseando ventas_ids, usando fallback:', parseErr);
                }
            }

            // ── Fallback: método legacy por mes+CEDIS (solo si no hay ventas_ids) ──
            if (!markedByIds) {
                if (numNota.startsWith('GLOBAL-')) {
                    const mesM = (numNota || '').match(/GLOBAL-(\d{4}-\d{2})/);
                    const mesF = mesM ? mesM[1] : '';
                    const cedisM = (numNota || '').match(/C(\d+)/);
                    const cedisF = cedisM ? cedisM[1] : '0';
                    let sqlG;
                    if (cedisF === '0') {
                        sqlG = `UPDATE venta SET factura_emitida = true WHERE requiere_factura = false AND (factura_emitida = false OR factura_emitida IS NULL) AND (cedis_id IS NULL OR cedis_id = '' OR cedis_id = '0') ${mesF ? `AND DATE_TRUNC('month', fecha_venta) = DATE_TRUNC('month', DATE '${mesF}-01')` : ''}`;
                    } else {
                        sqlG = `UPDATE venta SET factura_emitida = true WHERE requiere_factura = false AND (factura_emitida = false OR factura_emitida IS NULL) AND cedis_id = '${cedisF}' ${mesF ? `AND DATE_TRUNC('month', fecha_venta) = DATE_TRUNC('month', DATE '${mesF}-01')` : ''}`;
                    }
                    await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlG });
                    console.warn(`[FACTURACIÓN] ⚠️ Fallback legacy: marcado por mes+CEDIS para ${numNota}`);
                } else if (numNota) {
                    const sqlVenta = `UPDATE venta SET factura_emitida = true WHERE id = '${numNota}'`;
                    await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlVenta });
                }
            }
        }
        
        BO_AUTH.showAlert('Estado actualizado a: ' + estado, 'success');
        loadHistorialFacturas();
        if (typeof loadFacturaGlobal === 'function') loadFacturaGlobal();
    } catch(e) {
        BO_AUTH.showAlert('Error: ' + e.message, 'error');
    }
}


async function _descargarArchivo(cfdiId, cfdiUuid, solicitudId, tipo) {
    // 1. Si no tenemos cfdiId, intentar refrescar desde la base de datos
    let idFinal = (cfdiId && cfdiId.length > 3) ? cfdiId : null;
    console.log('[DESCARGA] Inicio:', { cfdiId, cfdiUuid, solicitudId, tipo, idFinal });

    // Fallback 1: Buscar en facturas_solicitadas
    if (!idFinal && solicitudId) {
        try {
            const r = await BO_API.post('/bo/sql-relay', {
                secret: 'duletia_relay_2026',
                sql: `SELECT cfdi_id, cfdi_uuid, numero_nota FROM facturas_solicitadas WHERE id = ${solicitudId}`
            });
            const row = r.rows?.[0];
            console.log('[DESCARGA] DB fallback row:', row);
            if (row?.cfdi_id && row.cfdi_id.length > 3) {
                idFinal = row.cfdi_id;
            } else if (row?.numero_nota) {
                // Fallback 2: Si Motor de Facturacion timbró vía n8n, el cfdi_id quedó en venta.factura_uuid
                try {
                    const rv = await BO_API.post('/bo/sql-relay', {
                        secret: 'duletia_relay_2026',
                        sql: `SELECT factura_uuid FROM venta WHERE id = '${row.numero_nota}' AND factura_emitida = true`
                    });
                    const vRow = rv.rows?.[0];
                    console.log('[DESCARGA] Venta fallback row:', vRow);
                    if (vRow?.factura_uuid && vRow.factura_uuid.length > 3 && !vRow.factura_uuid.startsWith('EXT-')) {
                        idFinal = vRow.factura_uuid;
                    }
                } catch(e) { console.warn('[DESCARGA] Venta fallback error:', e.message); }
            }
        } catch(e) { console.warn('[DESCARGA] DB fallback error:', e.message); }
    }

    if (!idFinal) {
        BO_AUTH.showAlert(
            '⚠️ Esta factura aún no tiene CFDI vinculado.\n' +
            'Esto puede ocurrir si el timbrado está pendiente o falló.\n' +
            'Contacta al administrador para verificar el estado.',
            'warning'
        );
        return;
    }

    // 2. Descargar el archivo
    try {
        BO_AUTH.showAlert(`⏳ Descargando ${tipo.toUpperCase()}…`, 'info');
        const resp = await fetch(BO_API.BASE + '/bo/factura/descargar', {
            method: 'POST',
            headers: BO_API._headers(),
            body: JSON.stringify({ cfdiId: idFinal, tipo })
        });
        if (!resp.ok) throw new Error('Error del servidor (' + resp.status + ')');
        const data = await resp.json();
        console.log('[DESCARGA] Resp:', { cfdiId: idFinal, tipo, hasContent: !!data?.content, keys: Object.keys(data||{}) });
        if (data?.ok === false) throw new Error(data.error || 'Error desconocido de Facturama');
        if (!data?.content) throw new Error('El servidor no devolvió el archivo. Verifica que el CFDI exista en Facturama.');

        // Decodificar base64 y forzar descarga
        const bytes = Uint8Array.from(atob(data.content), c => c.charCodeAt(0));
        const blob = new Blob([bytes], { type: data.contentType || (tipo === 'xml' ? 'application/xml' : 'application/pdf') });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url; a.download = data.filename || `factura.${tipo}`;
        document.body.appendChild(a); a.click();
        setTimeout(() => { URL.revokeObjectURL(url); a.remove(); }, 2000);
        BO_AUTH.showAlert(`✅ ${tipo.toUpperCase()} descargado correctamente`, 'success');
    } catch(e) {
        BO_AUTH.showAlert('❌ No se pudo descargar: ' + e.message, 'error');
    }
}

async function descargarPDF(cfdiId, cfdiUuid, solicitudId) {
    await _descargarArchivo(cfdiId, cfdiUuid, solicitudId, 'pdf');
}

async function descargarXML(cfdiId, cfdiUuid, solicitudId) {
    await _descargarArchivo(cfdiId, cfdiUuid, solicitudId, 'xml');
}

// ── Facturación — Cancelación SAT (Modos A, B, C) ───────────────────────────

function _ensureModalCancelarDOM() {
    let modal = document.getElementById('modalCancelarFacturaSAT');
    if (modal) {
        if (modal.parentElement !== document.body) {
            document.body.appendChild(modal);
        }
        return modal;
    }
    const div = document.createElement('div');
    div.innerHTML = `
    <div id="modalCancelarFacturaSAT" class="modal-overlay" style="display:none;backdrop-filter:blur(8px);background:rgba(0,0,0,0.8);z-index:999999;position:fixed;inset:0;align-items:center;justify-content:center;"
        onclick="if(event.target===this)cerrarModalCancelarSAT()">
        <div class="modal-box" style="max-width:620px;width:90%;background:#18181b;border:1px solid rgba(239,68,68,0.35);box-shadow:0 25px 50px -12px rgba(0,0,0,0.85);border-radius:14px;padding:1.5rem;color:#fff;">
            <div class="modal-header" style="border-bottom:1px solid rgba(255,255,255,0.08);padding-bottom:.85rem;display:flex;justify-content:space-between;align-items:center;">
                <div style="display:flex;align-items:center;gap:.6rem;">
                    <span style="font-size:1.4rem;">❌</span>
                    <div>
                        <span class="modal-title" style="color:#ef4444;font-size:1.15rem;font-weight:700;">Cancelación de Factura ante el SAT</span>
                        <div style="font-size:.72rem;color:#a1a1aa;">Trazabilidad fiscal y gestión de motivos (CFDI 4.0)</div>
                    </div>
                </div>
                <button class="modal-close" onclick="cerrarModalCancelarSAT()" style="background:none;border:none;color:#94a3b8;font-size:1.2rem;cursor:pointer;">✕</button>
            </div>
            <div class="modal-body" style="padding:1.1rem 0;display:flex;flex-direction:column;gap:.9rem;">
                <div style="background:rgba(255,255,255,0.03);border:1px solid rgba(255,255,255,0.08);border-radius:10px;padding:.85rem 1rem;">
                    <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:.3rem;">
                        <span id="canFac-folio" style="font-weight:700;color:#fff;font-size:.9rem;">Folio: #—</span>
                        <span id="canFac-total" style="font-weight:800;color:#f59e0b;font-size:1rem;">$0.00 MXN</span>
                    </div>
                    <div style="font-size:.8rem;color:#fff;"><b id="canFac-receptor">—</b> (<span id="canFac-rfc" style="color:#f59e0b;font-family:monospace;">—</span>)</div>
                    <div style="font-size:.72rem;color:#a1a1aa;margin-top:.25rem;word-break:break-all;">
                        UUID: <span id="canFac-uuid" style="font-family:monospace;color:#93c5fd;">—</span>
                    </div>
                </div>
                <div>
                    <label style="display:block;font-size:.8rem;font-weight:600;margin-bottom:.35rem;color:#fff;">
                        📋 Motivo de Cancelación SAT:
                    </label>
                    <select id="canFac-motivo" class="form-control" style="width:100%;font-size:.82rem;padding:.5rem .75rem;background:rgba(0,0,0,0.5);border:1px solid rgba(255,255,255,0.15);border-radius:8px;color:#fff;" onchange="onCanFacMotivoChange()">
                        <option value="02">02 - Comprobante emitido con errores sin relación (Modo A - Estándar)</option>
                        <option value="01">01 - Comprobante emitido con errores con relación (Modo C - Ingresar UUID)</option>
                        <option value="03">03 - No se llevó a cabo la operación (Modo A - Venta cancelada / Devuelta)</option>
                        <option value="04">04 - Operación nominativa relacionada en una factura global</option>
                    </select>
                </div>
                <div id="canFac-sustitutoWrap" style="display:none;background:rgba(56,189,248,0.06);border:1px dashed rgba(56,189,248,0.35);border-radius:10px;padding:.85rem 1rem;">
                    <label style="display:block;font-size:.78rem;font-weight:600;color:#38bdf8;margin-bottom:.3rem;">
                        🔗 UUID de la Factura Sustituta (Nueva Factura):
                    </label>
                    <input type="text" id="canFac-uuidReplacement" class="form-control" placeholder="Ej: 11AB9A9D-FD36-4502-A868-682B7A827A81" style="font-family:monospace;font-size:.8rem;width:100%;padding:.45rem .65rem;background:rgba(0,0,0,0.5);border:1px solid rgba(56,189,248,0.4);color:#fff;">
                    <div style="font-size:.68rem;color:#a1a1aa;margin-top:.35rem;">
                        ℹ️ Ingrese el folio fiscal (UUID) de la nueva factura que reemplaza a esta.
                    </div>
                </div>
                <div style="background:rgba(245,158,11,0.08);border:1px solid rgba(245,158,11,0.25);border-radius:8px;padding:.6rem .8rem;display:flex;gap:.5rem;align-items:flex-start;">
                    <span style="font-size:1.05rem;">⚠️</span>
                    <div style="font-size:.72rem;color:#fff;line-height:1.35;">
                        <b style="color:#f59e0b;">Aviso Fiscal SAT:</b> Comprobantes mayores a $1,000 MXN o con más de 24h de emisión podrían requerir aceptación del cliente en su Buzón Tributario (72h / Positiva Ficta).
                    </div>
                </div>
                <label style="display:flex;align-items:center;gap:.55rem;font-size:.8rem;cursor:pointer;user-select:none;color:#fff;">
                    <input type="checkbox" id="canFac-revertirVenta" checked style="width:16px;height:16px;accent-color:#f59e0b;">
                    <span>Devolver la nota de venta al estado <b>"Pendiente"</b> para poder refacturar</span>
                </label>
            </div>
            <div class="modal-footer" style="border-top:1px solid rgba(255,255,255,0.08);padding-top:.9rem;display:flex;justify-content:flex-end;gap:.65rem;">
                <button class="btn btn-outline btn-sm" onclick="cerrarModalCancelarSAT()">Cerrar</button>
                <button class="btn btn-sm" id="canFac-btnConfirmar" onclick="confirmarCancelacionSAT()" style="background:#ef4444;border-color:#ef4444;color:#fff;font-weight:700;">
                    🗑️ Confirmar Cancelación en SAT
                </button>
            </div>
        </div>
    </div>`;
    document.body.appendChild(div.firstElementChild);
    return document.getElementById('modalCancelarFacturaSAT');
}

function _ensureModalSustituirDOM() {
    let modal = document.getElementById('modalSustituirFactura');
    if (modal) {
        if (modal.parentElement !== document.body) {
            document.body.appendChild(modal);
        }
        return modal;
    }
    const div = document.createElement('div');
    div.innerHTML = `
    <div id="modalSustituirFactura" class="modal-overlay" style="display:none;backdrop-filter:blur(8px);background:rgba(0,0,0,0.8);z-index:999999;position:fixed;inset:0;align-items:center;justify-content:center;"
        onclick="if(event.target===this)cerrarModalSustituir()">
        <div class="modal-box" style="max-width:680px;width:92%;background:#18181b;border:1px solid rgba(56,189,248,0.35);box-shadow:0 25px 50px -12px rgba(0,0,0,0.85);border-radius:14px;padding:1.5rem;color:#fff;">
            <div class="modal-header" style="border-bottom:1px solid rgba(255,255,255,0.08);padding-bottom:.85rem;display:flex;justify-content:space-between;align-items:center;">
                <div style="display:flex;align-items:center;gap:.6rem;">
                    <span style="font-size:1.4rem;">🔄</span>
                    <div>
                        <span class="modal-title" style="color:#38bdf8;font-size:1.15rem;font-weight:700;">Asistente de Corrección y Sustitución (Modo B)</span>
                        <div style="font-size:.72rem;color:#a1a1aa;">Emite la nueva factura con Tipo Relación 04 y cancela la anterior con Motivo 01 en 1 solo clic</div>
                    </div>
                </div>
                <button class="modal-close" onclick="cerrarModalSustituir()" style="background:none;border:none;color:#94a3b8;font-size:1.2rem;cursor:pointer;">✕</button>
            </div>
            <div class="modal-body" style="padding:1.1rem 0;display:flex;flex-direction:column;gap:.9rem;max-height:68vh;overflow-y:auto;">
                <div style="background:rgba(56,189,248,0.05);border:1px solid rgba(56,189,248,0.2);border-radius:10px;padding:.85rem 1rem;">
                    <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:.3rem;">
                        <span id="susFac-folio" style="font-weight:700;color:#38bdf8;font-size:.85rem;">Factura Previa: #—</span>
                        <span id="susFac-total" style="font-weight:800;color:#f59e0b;font-size:.95rem;">$0.00 MXN</span>
                    </div>
                    <div style="font-size:.72rem;color:#a1a1aa;word-break:break-all;">
                        UUID a sustituir: <span id="susFac-uuid" style="font-family:monospace;color:#fff;">—</span>
                    </div>
                </div>
                <div style="display:grid;grid-template-columns:1fr 1fr;gap:.75rem;">
                    <div>
                        <label style="display:block;font-size:.75rem;font-weight:600;margin-bottom:.25rem;color:#fff;">RFC Receptor:</label>
                        <input type="text" id="susFac-rfc" class="form-control" style="text-transform:uppercase;font-size:.8rem;background:rgba(0,0,0,0.5);color:#fff;" placeholder="RFC">
                    </div>
                    <div>
                        <label style="display:block;font-size:.75rem;font-weight:600;margin-bottom:.25rem;color:#fff;">Razón Social / Nombre:</label>
                        <input type="text" id="susFac-razon" class="form-control" style="text-transform:uppercase;font-size:.8rem;background:rgba(0,0,0,0.5);color:#fff;" placeholder="Nombre completo">
                    </div>
                    <div>
                        <label style="display:block;font-size:.75rem;font-weight:600;margin-bottom:.25rem;color:#fff;">Régimen Fiscal:</label>
                        <select id="susFac-regimen" class="form-control" style="font-size:.78rem;background:rgba(0,0,0,0.5);color:#fff;">
                            <option value="601">601 - General de Ley Personas Morales</option>
                            <option value="603">603 - Personas Morales con Fines no Lucrativos</option>
                            <option value="605">605 - Sueldos y Salarios</option>
                            <option value="606">606 - Arrendamiento</option>
                            <option value="612">612 - Personas Físicas con Actividades Empresariales</option>
                            <option value="616">616 - Sin obligaciones fiscales</option>
                            <option value="621">621 - Incorporación Fiscal</option>
                            <option value="625">625 - Régimen Actividades Empresariales Plataformas Tecnológicas</option>
                            <option value="626">626 - Régimen Simplificado de Confianza (RESICO)</option>
                        </select>
                    </div>
                    <div>
                        <label style="display:block;font-size:.75rem;font-weight:600;margin-bottom:.25rem;color:#fff;">Código Postal:</label>
                        <input type="text" id="susFac-cp" class="form-control" maxlength="5" style="font-size:.8rem;background:rgba(0,0,0,0.5);color:#fff;" placeholder="CP Fiscal">
                    </div>
                    <div>
                        <label style="display:block;font-size:.75rem;font-weight:600;margin-bottom:.25rem;color:#fff;">Uso de CFDI:</label>
                        <select id="susFac-uso" class="form-control" style="font-size:.78rem;background:rgba(0,0,0,0.5);color:#fff;">
                            <option value="G01">G01 - Adquisición de mercancías</option>
                            <option value="G02">G02 - Devoluciones, descuentos o bonificaciones</option>
                            <option value="G03">G03 - Gastos en general</option>
                            <option value="I01">I01 - Construcciones</option>
                            <option value="I02">I02 - Mobilario y equipo de oficina</option>
                            <option value="I03">I03 - Equipo de transporte</option>
                            <option value="I04">I04 - Equipo de computo y accesorios</option>
                            <option value="D01">D01 - Honorarios médicos, dentales y gastos hospitalarios</option>
                            <option value="D02">D02 - Gastos médicos por incapacidad o discapacidad</option>
                            <option value="D04">D04 - Donativos</option>
                            <option value="D07">D07 - Primas por seguros de gastos médicos</option>
                            <option value="D10">D10 - Pagos por servicios educativos (colegiaturas)</option>
                            <option value="S01">S01 - Sin efectos fiscales</option>
                            <option value="CP01">CP01 - Pagos</option>
                        </select>
                    </div>
                    <div>
                        <label style="display:block;font-size:.75rem;font-weight:600;margin-bottom:.25rem;color:#fff;">Forma de Pago:</label>
                        <select id="susFac-formaPago" class="form-control" style="font-size:.78rem;background:rgba(0,0,0,0.5);color:#fff;">
                            <option value="01">01 - Efectivo</option>
                            <option value="02">02 - Cheque nominativo</option>
                            <option value="03">03 - Transferencia electrónica de fondos</option>
                            <option value="04">04 - Tarjeta de crédito</option>
                            <option value="28">28 - Tarjeta de débito</option>
                            <option value="99">99 - Por definir</option>
                        </select>
                    </div>
                </div>
                <div style="background:rgba(34,197,94,0.06);border:1px solid rgba(34,197,94,0.25);border-radius:8px;padding:.75rem .9rem;">
                    <div style="font-size:.75rem;color:#4ade80;font-weight:700;margin-bottom:.25rem;">⚡ Proceso Automatizado del SAT:</div>
                    <div style="font-size:.72rem;color:#a1a1aa;line-height:1.4;">
                        1. Se emitirá la nueva factura vinculando el UUID previo con <b>Tipo de Relación 04</b>.<br>
                        2. Inmediatamente se cancelará la factura anterior ante el SAT enviando <b>Motivo 01</b> y el nuevo UUID.<br>
                        3. La venta y el historial quedarán actualizados con trazabilidad completa.
                    </div>
                </div>
            </div>
            <div class="modal-footer" style="border-top:1px solid rgba(255,255,255,0.08);padding-top:.9rem;display:flex;justify-content:flex-end;gap:.65rem;">
                <button class="btn btn-outline btn-sm" onclick="cerrarModalSustituir()">Cerrar</button>
                <button class="btn btn-sm" id="susFac-btnConfirmar" onclick="confirmarSustitucionSAT()" style="background:#38bdf8;border-color:#38bdf8;color:#000;font-weight:700;">
                    ⚡ Emitir Sustitución y Cancelar Previa
                </button>
            </div>
        </div>
    </div>`;
    document.body.appendChild(div.firstElementChild);
    return document.getElementById('modalSustituirFactura');
}

function abrirModalCancelarSAT(cfdiId, cfdiUuid, solicitudId, numeroNota, rfcEnc, razonEnc, total) {
    try {
        let rfc = '';
        try { rfc = rfcEnc ? decodeURIComponent(rfcEnc) : ''; } catch(_) { rfc = rfcEnc || ''; }
        let razonSocial = '';
        try { razonSocial = razonEnc ? decodeURIComponent(razonEnc) : ''; } catch(_) { razonSocial = razonEnc || ''; }

        window._cancelandoFactura = {
            cfdiId: (cfdiId && String(cfdiId).length > 3 && cfdiId !== '—') ? cfdiId : (cfdiUuid || ''),
            cfdiUuid: (cfdiUuid && cfdiUuid !== '—') ? cfdiUuid : (cfdiId || ''),
            solicitudId: (solicitudId && String(solicitudId) !== 'null' && String(solicitudId) !== 'undefined') ? solicitudId : '',
            numeroNota: numeroNota || '',
            rfc: rfc,
            razonSocial: razonSocial,
            total: total || 0
        };

        const modal = _ensureModalCancelarDOM();

        const folLabel = window._cancelandoFactura.solicitudId ? `Solicitud: #${window._cancelandoFactura.solicitudId}` : (numeroNota ? `Nota: #${String(numeroNota).substring(0, 16)}` : 'Factura');
        const totLabel = Number(total) > 0 ? `$${Number(total).toLocaleString('es-MX', { minimumFractionDigits: 2 })} MXN` : '$0.00 MXN';
        const rfcLabel = rfc || 'XAXX010101000';
        const recLabel = razonSocial || 'Público en General';
        const uuidLabel = window._cancelandoFactura.cfdiUuid || window._cancelandoFactura.cfdiId || '—';

        document.querySelectorAll('#canFac-folio').forEach(el => el.textContent = folLabel);
        document.querySelectorAll('#canFac-total').forEach(el => el.textContent = totLabel);
        document.querySelectorAll('#canFac-rfc').forEach(el => el.textContent = rfcLabel);
        document.querySelectorAll('#canFac-receptor').forEach(el => el.textContent = recLabel);
        document.querySelectorAll('#canFac-uuid').forEach(el => el.textContent = uuidLabel);
        document.querySelectorAll('#canFac-motivo').forEach(el => el.value = '02');
        document.querySelectorAll('#canFac-uuidReplacement').forEach(el => el.value = '');
        document.querySelectorAll('#canFac-sustitutoWrap').forEach(el => el.style.display = 'none');

        document.querySelectorAll('#modalCancelarFacturaSAT').forEach(m => {
            m.style.position = 'fixed';
            m.style.inset = '0';
            m.style.zIndex = '999999';
            m.style.background = 'rgba(0,0,0,0.85)';
            m.style.backdropFilter = 'blur(8px)';
            m.style.alignItems = 'center';
            m.style.justifyContent = 'center';
            m.style.setProperty('display', 'flex', 'important');
        });
        document.body.style.overflow = 'hidden';
    } catch(err) {
        console.error('[ERROR abrirModalCancelarSAT]:', err);
        if (typeof BO_AUTH !== 'undefined' && BO_AUTH.showAlert) {
            BO_AUTH.showAlert('Error al abrir modal de cancelación: ' + err.message, 'error');
        } else {
            alert('Error al abrir modal de cancelación: ' + err.message);
        }
    }
}

function onCanFacMotivoChange() {
    const mot = document.getElementById('canFac-motivo')?.value;
    document.querySelectorAll('#canFac-sustitutoWrap').forEach(wrap => {
        wrap.style.display = (mot === '01') ? 'block' : 'none';
    });
}

function cerrarModalCancelarSAT() {
    document.querySelectorAll('#modalCancelarFacturaSAT').forEach(m => {
        m.style.setProperty('display', 'none', 'important');
        m.style.display = 'none';
    });
    document.body.style.overflow = '';
}

async function confirmarCancelacionSAT() {
    const info = window._cancelandoFactura;
    if (!info || (!info.cfdiId && !info.solicitudId)) {
        BO_AUTH.showAlert('⚠️ No hay información de CFDI seleccionada.', 'warning');
        return;
    }

    const motivo = document.getElementById('canFac-motivo')?.value || '02';
    const uuidRep = document.getElementById('canFac-uuidReplacement')?.value?.trim() || '';
    const revertir = document.getElementById('canFac-revertirVenta')?.checked !== false;

    if (motivo === '01') {
        if (!uuidRep || uuidRep.length < 20) {
            BO_AUTH.showAlert('⚠️ Para el Motivo 01 debe ingresar el UUID de la factura sustituta.', 'warning');
            document.getElementById('canFac-uuidReplacement')?.focus();
            return;
        }
    }

    const btn = document.getElementById('canFac-btnConfirmar');
    if (btn) {
        btn.disabled = true;
        btn.textContent = '⏳ Cancelando ante SAT…';
    }

    try {
        BO_AUTH.showAlert('⏳ Enviando solicitud de cancelación a Facturama y SAT…', 'info');
        
        let cfdiIdFinal = info.cfdiId;
        if (!cfdiIdFinal && info.solicitudId) {
            const r = await BO_API.post('/bo/sql-relay', {
                secret: 'duletia_relay_2026',
                sql: `SELECT cfdi_id, cfdi_uuid FROM facturas_solicitadas WHERE id = ${info.solicitudId}`
            });
            cfdiIdFinal = r.rows?.[0]?.cfdi_id || r.rows?.[0]?.cfdi_uuid;
        }

        const resp = await fetch(BO_API.BASE + '/bo/factura/cancelar', {
            method: 'POST',
            headers: BO_API._headers(),
            body: JSON.stringify({
                cfdiId: cfdiIdFinal,
                motivo: motivo,
                uuidReplacement: (motivo === '01' ? uuidRep : '')
            })
        });

        const data = await resp.json().catch(() => ({}));
        if (!resp.ok || data.ok === false) {
            const err = data.error || data.Message || data.message || `Error HTTP ${resp.status}`;
            throw new Error(err);
        }

        const isPending = !!data.pending;
        const nuevoEstado = isPending ? 'en_cancelacion' : 'cancelada';

        if (info.solicitudId) {
            await BO_API.post('/bo/sql-relay', {
                secret: 'duletia_relay_2026',
                sql: `UPDATE facturas_solicitadas 
                      SET estado = '${nuevoEstado}', 
                          motivo_cancelacion = '${motivo}', 
                          uuid_sustitucion = ${uuidRep ? `'${uuidRep}'` : 'NULL'},
                          fecha_cancelacion = NOW()
                      WHERE id = ${info.solicitudId}`
            });
        }

        if (revertir && !isPending) {
            await _revertirVentasCancelacion(info.numeroNota, info.solicitudId, cfdiIdFinal);
        }

        cerrarModalCancelarSAT();

        if (isPending) {
            BO_AUTH.showAlert('⏳ Solicitud de cancelación enviada al SAT. En espera de autorización del receptor en su Buzón Tributario (plazo 72h).', 'info');
        } else {
            BO_AUTH.showAlert('✅ Factura cancelada exitosamente ante el SAT.', 'success');
        }

        loadHistorialFacturas();
        if (typeof loadFacturaGlobal === 'function') loadFacturaGlobal();
    } catch(e) {
        console.error('[CONFIRMAR CANCELAR] Error:', e);
        BO_AUTH.showAlert('❌ Error al cancelar CFDI: ' + e.message, 'error');
    } finally {
        if (btn) {
            btn.disabled = false;
            btn.textContent = '🗑️ Confirmar Cancelación en SAT';
        }
    }
}

// ── Facturación — Asistente de Sustitución en 1 Clic (Modo B) ────────────────
function abrirModalSustituir(cfdiId, cfdiUuid, solicitudId, numeroNota, rfcEnc, razonEnc, regimen, cp, uso, formaPago, total) {
    try {
        let rfc = '';
        try { rfc = rfcEnc ? decodeURIComponent(rfcEnc) : ''; } catch(_) { rfc = rfcEnc || ''; }
        let razonSocial = '';
        try { razonSocial = razonEnc ? decodeURIComponent(razonEnc) : ''; } catch(_) { razonSocial = razonEnc || ''; }

        window._sustituyendoFactura = {
            cfdiId: (cfdiId && String(cfdiId).length > 3 && cfdiId !== '—') ? cfdiId : (cfdiUuid || ''),
            cfdiUuid: (cfdiUuid && cfdiUuid !== '—') ? cfdiUuid : (cfdiId || ''),
            solicitudId: (solicitudId && String(solicitudId) !== 'null' && String(solicitudId) !== 'undefined') ? solicitudId : '',
            numeroNota: numeroNota || '',
            rfc: rfc,
            razonSocial: razonSocial,
            regimen: regimen || '612',
            cp: cp || '',
            uso_cfdi: uso || 'G01',
            forma_pago: formaPago || '03',
            total: total || 0
        };

        const modal = _ensureModalSustituirDOM();

        const folLabel = window._sustituyendoFactura.solicitudId ? `Factura Previa: #${window._sustituyendoFactura.solicitudId}` : (numeroNota ? `Nota: #${String(numeroNota).substring(0,16)}` : 'Factura Previa');
        const totLabel = Number(total) > 0 ? `$${Number(total).toLocaleString('es-MX', { minimumFractionDigits: 2 })} MXN` : '$0.00 MXN';
        const uuidLabel = window._sustituyendoFactura.cfdiUuid || window._sustituyendoFactura.cfdiId || '—';

        document.querySelectorAll('#susFac-folio').forEach(el => el.textContent = folLabel);
        document.querySelectorAll('#susFac-total').forEach(el => el.textContent = totLabel);
        document.querySelectorAll('#susFac-uuid').forEach(el => el.textContent = uuidLabel);
        document.querySelectorAll('#susFac-rfc').forEach(el => el.value = rfc);
        document.querySelectorAll('#susFac-razon').forEach(el => el.value = razonSocial);
        document.querySelectorAll('#susFac-regimen').forEach(el => el.value = regimen || '612');
        document.querySelectorAll('#susFac-cp').forEach(el => el.value = cp || '');
        document.querySelectorAll('#susFac-uso').forEach(el => el.value = uso || 'G01');
        document.querySelectorAll('#susFac-formaPago').forEach(el => el.value = formaPago || '03');

        document.querySelectorAll('#modalSustituirFactura').forEach(m => {
            m.style.position = 'fixed';
            m.style.inset = '0';
            m.style.zIndex = '999999';
            m.style.background = 'rgba(0,0,0,0.85)';
            m.style.backdropFilter = 'blur(8px)';
            m.style.alignItems = 'center';
            m.style.justifyContent = 'center';
            m.style.setProperty('display', 'flex', 'important');
        });
        document.body.style.overflow = 'hidden';
    } catch(err) {
        console.error('[ERROR abrirModalSustituir]:', err);
        if (typeof BO_AUTH !== 'undefined' && BO_AUTH.showAlert) {
            BO_AUTH.showAlert('Error al abrir modal de sustitución: ' + err.message, 'error');
        } else {
            alert('Error al abrir modal de sustitución: ' + err.message);
        }
    }
}

function cerrarModalSustituir() {
    document.querySelectorAll('#modalSustituirFactura').forEach(m => {
        m.style.setProperty('display', 'none', 'important');
        m.style.display = 'none';
    });
    document.body.style.overflow = '';
}

async function confirmarSustitucionSAT() {
    const info = window._sustituyendoFactura;
    if (!info || !info.cfdiUuid) {
        BO_AUTH.showAlert('⚠️ No hay información de factura original para sustituir.', 'warning');
        return;
    }

    const rfc = document.getElementById('susFac-rfc')?.value?.trim().toUpperCase();
    const razonSocial = document.getElementById('susFac-razon')?.value?.trim();
    const regimen = document.getElementById('susFac-regimen')?.value;
    const cp = document.getElementById('susFac-cp')?.value?.trim();
    const usoCfdi = document.getElementById('susFac-uso')?.value;
    const formaPago = document.getElementById('susFac-formaPago')?.value;

    if (!rfc || rfc.length < 12) {
        BO_AUTH.showAlert('⚠️ Ingrese un RFC válido (12 o 13 caracteres).', 'warning');
        return;
    }
    if (!razonSocial) {
        BO_AUTH.showAlert('⚠️ Ingrese la Razón Social o Nombre del receptor.', 'warning');
        return;
    }
    if (!cp || cp.length !== 5) {
        BO_AUTH.showAlert('⚠️ Ingrese un Código Postal fiscal de 5 dígitos.', 'warning');
        return;
    }

    if (!confirm(`¿Emitir nueva factura con Tipo de Relación 04 y cancelar la factura previa (${info.cfdiUuid.substring(0,8)}...) ante el SAT?`)) return;

    const btn = document.getElementById('susFac-btnConfirmar');
    if (btn) {
        btn.disabled = true;
        btn.textContent = '⏳ Procesando sustitución ante el SAT…';
    }

    try {
        BO_AUTH.showAlert('⏳ Paso 1/2: Timbrando nueva factura con Tipo Relación 04...', 'info');

        // Construir payload de emisión con Relations
        const payloadEmision = {
            Receiver: {
                Rfc: rfc,
                Name: razonSocial,
                CfdiUse: usoCfdi,
                FiscalRegime: regimen,
                TaxZipCode: cp
            },
            PaymentForm: formaPago,
            Relations: {
                Type: '04',
                Cfdis: [{ Uuid: info.cfdiUuid }]
            },
            _meta: {
                solicitudId: info.solicitudId,
                numeroNota: info.numeroNota
            }
        };

        const respEmit = await fetch(BO_API.BASE + '/bo/factura/emitir', {
            method: 'POST',
            headers: BO_API._headers(),
            body: JSON.stringify(payloadEmision)
        });

        const emitData = await respEmit.json().catch(() => ({}));
        const newCfdiId = emitData.cfdiId || emitData.Id || emitData.id;
        const newUuid = emitData.uuid || emitData.Uuid || emitData.Complement?.TaxStamp?.Uuid;

        if (!newCfdiId && !newUuid) {
            throw new Error(emitData.message || emitData.error || 'No se pudo emitir la factura sustituta.');
        }

        BO_AUTH.showAlert('⏳ Paso 2/2: Cancelando factura previa con Motivo 01 ante el SAT...', 'info');

        await fetch(BO_API.BASE + '/bo/factura/cancelar', {
            method: 'POST',
            headers: BO_API._headers(),
            body: JSON.stringify({
                cfdiId: info.cfdiId,
                motivo: '01',
                uuidReplacement: newUuid || newCfdiId
            })
        });

        if (info.solicitudId) {
            await BO_API.post('/bo/sql-relay', {
                secret: 'duletia_relay_2026',
                sql: `UPDATE facturas_solicitadas 
                      SET estado = 'cancelada', 
                          motivo_cancelacion = '01', 
                          uuid_sustitucion = '${newUuid || newCfdiId}',
                          fecha_cancelacion = NOW()
                      WHERE id = ${info.solicitudId}`
            });
        }

        cerrarModalSustituir();
        BO_AUTH.showAlert('✅ Sustitución completada: Nueva factura emitida y factura previa cancelada con Motivo 01 ante el SAT.', 'success');
        loadHistorialFacturas();
    } catch(e) {
        console.error('[SUSTITUCION] Error:', e);
        BO_AUTH.showAlert('❌ Error en el proceso de sustitución: ' + e.message, 'error');
    } finally {
        if (btn) {
            btn.disabled = false;
            btn.textContent = '⚡ Emitir Sustitución y Cancelar Previa';
        }
    }
}

// Helpers de cálculo seguro para Facturable y Activos por nota
function _calcMontoFacturable(v) {
    if (!v) return 0;
    const tt = Number(v.total || 0);
    if (v._activosCentro !== undefined && v._activosCentro > 0) {
        return Math.max(0, tt - v._activosCentro);
    }
    const isCentro = Boolean(v.centro_apoyo_id || (v.comentario && /PROYECTO|CREDITO/i.test(v.comentario)));
    if (isCentro) {
        const mCred = String(v.comentario || '').match(/CREDITO\s*\$?([0-9.,]+)/i);
        if (mCred) {
            const credVal = parseFloat(mCred[1].replace(/,/g, '')) || 0;
            return Math.max(0, tt - credVal);
        }
    }
    if (v.monto_facturable !== undefined && v.monto_facturable !== null && Number(v.monto_facturable) >= 0 && Number(v.monto_facturable) !== tt) {
        return Number(v.monto_facturable);
    }
    const reAct = new RegExp('(?:^|[^A-Z_])(?:ACTIVOS(?:_[A-Z_]+)?(?:/[^\\s$]+)?[^$]*\\$([0-9.,]+))', 'gi');
    let act = 0, m;
    while ((m = reAct.exec(v.comentario || '')) !== null) {
        const val = parseFloat(m[1].replace(/,/g, ''));
        if (!isNaN(val)) act += val;
    }
    return Math.max(0, tt - act);
}

function _calcMontoActivos(v) {
    if (!v) return 0;
    const tt = Number(v.total || 0);
    if (v._activosCentro !== undefined && v._activosCentro > 0) {
        return Math.min(tt, v._activosCentro);
    }
    const isCentro = Boolean(v.centro_apoyo_id || (v.comentario && /PROYECTO|CREDITO/i.test(v.comentario)));
    if (isCentro) {
        const mCred = String(v.comentario || '').match(/CREDITO\s*\$?([0-9.,]+)/i);
        if (mCred) {
            const credVal = parseFloat(mCred[1].replace(/,/g, '')) || 0;
            return Math.min(tt, credVal);
        }
    }
    if (v.monto_activos !== undefined && v.monto_activos !== null && Number(v.monto_activos) > 0) {
        return Number(v.monto_activos);
    }
    const f = _calcMontoFacturable(v);
    return Math.max(0, tt - f);
}

// ── Facturación — Asistente Universal de Sustitución de Lotes (Globales, Centros y USD) ──
async function abrirModalSustituirLote(f, solicitudId) {
    BO_AUTH.showAlert('⏳ Cargando notas y activos para sustitución del lote...', 'info');

    const solId = parseInt(solicitudId || f?.id) || 0;
    let solRow = f || {};
    try {
        const rSol = await BO_API.post('/bo/sql-relay', {
            secret: 'duletia_relay_2026',
            sql: `SELECT id, numero_nota, cfdi_id, cfdi_uuid, moneda, tipo_cambio, cedis_id, forma_pago, periodicidad, comentario, total, usuario_id, rfc, razon_social, cp, regimen, uso_cfdi, creado_en FROM facturas_solicitadas WHERE id = ${solId}`
        });
        if (rSol?.rows?.[0]) {
            solRow = { ...f, ...rSol.rows[0] };
        }
    } catch(e) {
        console.warn('[SUSTITUIR LOTE] Fallback a f local:', e);
    }

    let ventas = [];
    try {
        const rV = await BO_API.post('/bo/sql-relay', {
            secret: 'duletia_relay_2026',
            sql: `SELECT v.id, v.cliente_id, v.centro_apoyo_id, v.total, COALESCE(v.monto_facturable, v.total) AS monto_facturable, COALESCE(v.monto_activos, 0) AS monto_activos, v.piezas, v.comentario, v.moneda, v.cedis_id, v.fecha_venta,
                         COALESCE(c.nombre || ' ' || c.ape_p, 'Centro de Apoyo') AS cliente_nombre
                  FROM venta v
                  LEFT JOIN cliente c ON c.id::text = v.cliente_id::text
                  WHERE v.id = ANY(SELECT jsonb_array_elements_text(ventas_ids::jsonb) FROM facturas_solicitadas WHERE id = ${solId})
                  ORDER BY v.fecha_venta DESC`
        });
        ventas = rV.rows || [];
    } catch(e) {
        console.error('[SUSTITUIR LOTE] Error cargando ventas:', e);
        BO_AUTH.showAlert('❌ Error consultando notas de la factura: ' + e.message, 'error');
        return;
    }

    if (ventas.length === 0) {
        BO_AUTH.showAlert('⚠️ No se encontraron notas de venta asociadas en esta factura.', 'warning');
        return;
    }

    let catalogo = window._fgCatalogo || [];
    let componentes = window._fgComponentes || [];
    if (!catalogo.length) {
        try {
            const [catRes, compRes] = await Promise.all([
                BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: 'SELECT id, sku, nombre, precio, tasa_iva, categoria FROM productos' }),
                BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: 'SELECT pc.paquete_id, pc.componente_id, pc.cantidad, p.nombre AS comp_nombre, p.precio AS comp_precio FROM producto_componente pc JOIN productos p ON p.id = pc.componente_id' })
            ]);
            catalogo = catRes.rows || [];
            componentes = compRes.rows || [];
            window._fgCatalogo = catalogo;
            window._fgComponentes = componentes;
        } catch(_) {}
    }

    const isUSD = (solRow.moneda || f.moneda || '').toUpperCase() === 'USD' || 
                  String(solRow.cedis_id || f.cedis_id) === 'USD' || 
                  String(solRow.numero_nota || f.numero_nota || '').includes('-USD') || 
                  (ventas.some(v => (v.moneda || '').toUpperCase() === 'USD'));
    const tipoCambio = parseFloat(solRow.tipo_cambio || f.tipo_cambio) || 17.0147;

    // Activos directos de Centros USD (desde comentario de la solicitud)
    let activosCentrosUSD = 0;
    const mActDirect = String(solRow.comentario || f.comentario || '').match(/act=([0-9.]+)/);
    if (mActDirect) {
        activosCentrosUSD = parseFloat(mActDirect[1]) || 0;
    }

    // Asociar a cada nota de Centro de Apoyo su monto de activos correspondiente
    for (const v of ventas) {
        const isCentro = Boolean(v.centro_apoyo_id || (v.comentario && /PROYECTO|CREDITO/i.test(v.comentario)));
        if (isCentro) {
            let credVal = 0;
            const mCred = String(v.comentario || '').match(/CREDITO\s*\$?([0-9.,]+)/i);
            if (mCred) {
                credVal = parseFloat(mCred[1].replace(/,/g, '')) || 0;
            }
            if (credVal === 0 && activosCentrosUSD > 0) {
                credVal = Math.min(Number(v.total || 0), activosCentrosUSD);
            }
            if (credVal > 0) {
                v._activosCentro = credVal;
            }
        }
    }

    let totalActivos = ventas.reduce((s, v) => s + _calcMontoActivos(v), 0);
    if (totalActivos === 0 && activosCentrosUSD > 0) {
        totalActivos = activosCentrosUSD;
    }

    // Detección de mes de facturación y retroactivo
    const mMes = String(solRow.numero_nota || f.numero_nota || '').match(/(\d{4})-(\d{2})/);
    let mesFacturacion = mMes ? `${mMes[1]}-${mMes[2]}` : null;
    if (!mesFacturacion && ventas.length > 0 && ventas[0].fecha_venta) {
        const dV = new Date(ventas[0].fecha_venta);
        if (!isNaN(dV.getTime())) {
            mesFacturacion = `${dV.getFullYear()}-${String(dV.getMonth()+1).padStart(2,'0')}`;
        }
    }
    const _ahora = new Date();
    const _mesActual = _ahora.getFullYear() + '-' + String(_ahora.getMonth() + 1).padStart(2, '0');
    const esMesPasado = Boolean(mesFacturacion && mesFacturacion < _mesActual);
    const retroFecha = esMesPasado
        ? (()=>{
            const [y, m] = mesFacturacion.split('-').map(Number);
            const d = new Date(y, m, 0);
            return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}T23:50:00`;
          })()
        : null;

    window._sustitucionLoteState = {
        solicitudId: solRow.id || solId,
        numeroNota: solRow.numero_nota || '',
        uuidPrevio: (solRow.cfdi_uuid || '').trim(),
        cfdiIdPrevio: (solRow.cfdi_id || '').trim(),
        ventas: ventas,
        totalActivos: totalActivos,
        isUSD: isUSD,
        tipoCambio: tipoCambio,
        catalogo: catalogo,
        componentes: componentes,
        mesFacturacion: mesFacturacion,
        esMesPasado: esMesPasado,
        retroFecha: retroFecha,
        formaPago: solRow.forma_pago || f.forma_pago || '03',
        periodicidad: solRow.periodicidad || f.periodicidad || '04',
        excludedIds: []
    };

    if (!window._sustitucionLoteState.uuidPrevio && window._sustitucionLoteState.cfdiIdPrevio) {
        try {
            const rXml = await fetch(BO_API.BASE + '/bo/factura/descargar', {
                method: 'POST',
                headers: BO_API._headers(),
                body: JSON.stringify({ cfdiId: window._sustitucionLoteState.cfdiIdPrevio, tipo: 'xml' })
            });
            const dXml = await rXml.json();
            if (dXml?.content) {
                const xmlStr = atob(dXml.content);
                const mU = xmlStr.match(/UUID="([0-9a-fA-F-]+)"/);
                if (mU) window._sustitucionLoteState.uuidPrevio = mU[1];
            }
        } catch(_) {}
    }

    _renderModalSustituirLoteDOM();
}

function _calcularSustitucionLote() {
    const s = window._sustitucionLoteState;
    if (!s) return { countConservadas: 0, countExcluidas: 0, totalBruto: 0, totalActivos: 0, nuevoFacturable: 0, montoExcluidas: 0 };

    const conservadas = s.ventas.filter(v => !s.excludedIds.includes(String(v.id)));
    const excluidas = s.ventas.filter(v => s.excludedIds.includes(String(v.id)));
    const montoExcluidas = excluidas.reduce((sum, v) => sum + Number(v.total || 0), 0);

    if (s.isUSD) {
        const nuevoFacturableCalc = conservadas.reduce((sum, v) => sum + _calcMontoFacturable(v), 0);
        let totalActivos = conservadas.reduce((sum, v) => sum + _calcMontoActivos(v), 0);
        if (s.activosManualOverride !== undefined && s.activosManualOverride !== null) {
            totalActivos = Math.max(0, Number(s.activosManualOverride) || 0);
        }
        const totalBruto = Math.round((nuevoFacturableCalc + conservadas.reduce((sum, v) => sum + _calcMontoActivos(v), 0)) * 100) / 100;
        const nuevoFacturable = Math.max(0, Math.round((totalBruto - totalActivos) * 100) / 100);
        return {
            countConservadas: conservadas.length,
            countExcluidas: excluidas.length,
            totalBruto,
            totalActivos,
            nuevoFacturable,
            montoExcluidas
        };
    }

    const consolidated = {};
    const cat = s.catalogo || [];
    const comps = s.componentes || [];

    for (const v of conservadas) {
        let piezasArr = [];
        try {
            piezasArr = Array.isArray(v.piezas) ? v.piezas :
                        (typeof v.piezas === 'string' ? JSON.parse(v.piezas || '[]') : []);
        } catch(_) {}

        for (const p of piezasArr) {
            const prodId = String(p.producto_id || p.sku || '');
            if (!prodId) continue;
            const qty = parseInt(p.cantidad) || 1;
            const pu = parseFloat(p.precio_unitario) || null;

            const catProd = cat.find(c => String(c.id) === prodId || c.sku === prodId);
            if (catProd && catProd.categoria === 'paquete') {
                const pkComps = comps.filter(c => String(c.paquete_id) === String(catProd.id));
                if (pkComps.length > 0) {
                    for (const c of pkComps) {
                        const ck = String(c.componente_id);
                        const compQty = (parseInt(c.cantidad) || 1) * qty;
                        const compProd = cat.find(x => String(x.id) === ck);
                        const compPu = compProd ? parseFloat(compProd.precio || 0) : 0;
                        if (!consolidated[ck]) consolidated[ck] = { qty: 0, pu: compPu };
                        consolidated[ck].qty += compQty;
                        if (compPu && !consolidated[ck].pu) consolidated[ck].pu = compPu;
                    }
                    continue;
                }
            }

            if (!consolidated[prodId]) consolidated[prodId] = { qty: 0, pu: null };
            consolidated[prodId].qty += qty;
            if (pu && !consolidated[prodId].pu) consolidated[prodId].pu = pu;
        }
    }

    let totalBruto = 0;
    for (const [key, d] of Object.entries(consolidated)) {
        if (!d.pu || d.pu <= 0) {
            const p = cat.find(x => String(x.id) === key || x.sku === key);
            if (p) d.pu = parseFloat(p.precio || 0);
        }
        totalBruto += d.qty * (d.pu || 0);
    }

    let totalActivos = conservadas.reduce((sum, v) => sum + _calcMontoActivos(v), 0) || (s.totalActivos || 0);
    if (s.activosManualOverride !== undefined && s.activosManualOverride !== null) {
        totalActivos = Math.max(0, Number(s.activosManualOverride) || 0);
    }
    const nuevoFacturable = Math.max(0, Math.round((totalBruto - totalActivos) * 100) / 100);

    return {
        countConservadas: conservadas.length,
        countExcluidas: excluidas.length,
        totalBruto,
        totalActivos,
        nuevoFacturable,
        montoExcluidas
    };
}

function _renderSustitucionNotasRows() {
    const s = window._sustitucionLoteState;
    if (!s || !s.ventas.length) {
        return '<tr><td colspan="6" style="text-align:center;color:#94a3b8;padding:1rem;">Sin notas disponibles</td></tr>';
    }
    const curMoneda = s.isUSD ? 'USD' : 'MXN';
    const fmt = (n) => '$' + Number(n).toLocaleString('es-MX', { minimumFractionDigits: 2 }) + (s.isUSD ? ' USD' : '');
    return s.ventas.map(v => {
        const isExcluded = s.excludedIds.includes(String(v.id));
        const checked = !isExcluded;
        const totalVenta = Number(v.total || 0);
        const shortId = String(v.id).substring(0, 8);
        const nFact = _calcMontoFacturable(v);
        const nAct = _calcMontoActivos(v);
        return `
        <tr class="sl-nota-row" data-id="${v.id}" style="${isExcluded ? 'background:rgba(249,115,22,0.08);' : ''}">
            <td style="text-align:center;padding:.4rem;">
                <input type="checkbox" ${checked ? 'checked' : ''} onchange="_toggleNotaExcluida('${v.id}', this.checked)" style="accent-color:#38bdf8;cursor:pointer;transform:scale(1.15);">
            </td>
            <td style="font-family:monospace;font-size:.7rem;padding:.4rem;color:#e2e8f0;">
                <span title="${v.id}">${shortId}…</span>
            </td>
            <td style="padding:.4rem;color:#fff;font-weight:600;">
                ${v.cliente_nombre || 'Centro de Apoyo'}
            </td>
            <td style="text-align:right;padding:.4rem;font-weight:700;">
                <div style="color:#38bdf8;">${fmt(totalVenta)}</div>
                ${(nAct > 0) ? `
                <div style="font-size:0.65rem;color:#f59e0b;font-weight:600;margin-top:2px;" title="Monto de activos subsidiado">
                    Activos: -${fmt(nAct)}
                </div>
                <div style="font-size:0.65rem;color:#34d399;font-weight:600;" title="Monto neto a facturar">
                    Fact: ${fmt(nFact)}
                </div>` : ''}
            </td>
            <td style="padding:.4rem;color:#a1a1aa;font-size:.68rem;max-width:280px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;" title="${(v.comentario||'').replace(/"/g, '&quot;')}">
                ${v.comentario || '—'}
            </td>
            <td style="text-align:center;padding:.4rem;" id="sl-badge-${v.id}">
                ${checked 
                    ? '<span style="background:rgba(16,185,129,.15);color:#34d399;border-radius:4px;padding:2px 8px;font-size:.65rem;font-weight:600;">En Nueva Factura</span>'
                    : '<span style="background:rgba(249,115,22,.18);color:#fb923c;border-radius:4px;padding:2px 8px;font-size:.65rem;font-weight:700;">🔓 Se Liberará</span>'
                }
            </td>
        </tr>
        `;
    }).join('');
}

function _renderModalSustituirLoteDOM() {
    const s = window._sustitucionLoteState;
    if (!s) return;

    let modal = document.getElementById('modalSustituirLoteSAT');
    if (!modal) {
        modal = document.createElement('div');
        modal.id = 'modalSustituirLoteSAT';
        modal.className = 'modal-overlay';
        modal.style.cssText = 'display:flex;backdrop-filter:blur(8px);background:rgba(0,0,0,0.85);z-index:999999;position:fixed;inset:0;align-items:center;justify-content:center;';
        modal.onclick = function(e) { if (e.target === this) cerrarModalSustituirLote(); };
        document.body.appendChild(modal);
    } else {
        modal.style.display = 'flex';
    }

    const curMoneda = s.isUSD ? 'USD' : 'MXN';
    const fmt = (n) => '$' + Number(n).toLocaleString('es-MX', { minimumFractionDigits: 2 }) + (s.isUSD ? ' USD' : '');
    const calc = _calcularSustitucionLote();

    modal.innerHTML = `
    <div class="modal-box" style="max-width:920px;width:95%;max-height:90vh;overflow-y:auto;background:#18181b;border:1px solid rgba(56,189,248,0.4);box-shadow:0 25px 50px -12px rgba(0,0,0,0.85);border-radius:14px;padding:1.4rem;color:#fff;">
        <div style="border-bottom:1px solid rgba(255,255,255,0.08);padding-bottom:.85rem;display:flex;justify-content:space-between;align-items:center;">
            <div style="display:flex;align-items:center;gap:.6rem;">
                <span style="font-size:1.4rem;">🔄</span>
                <div>
                    <div style="display:flex;align-items:center;gap:6px;">
                        <span style="color:#38bdf8;font-size:1.15rem;font-weight:700;">Asistente de Sustitución — Factura Consolidada #${s.solicitudId}</span>
                        ${s.isUSD ? '<span style="background:rgba(56,189,248,.18);color:#38bdf8;border:1px solid rgba(56,189,248,.4);padding:2px 8px;border-radius:4px;font-size:.7rem;font-weight:700;">🇺🇸 Moneda USD</span>' : ''}
                    </div>
                    <div style="font-size:.72rem;color:#a1a1aa;margin-top:2px;">
                        Folio: <span style="color:#fff;font-weight:600;">${s.numeroNota}</span> · UUID SAT: <span style="color:#93c5fd;font-family:monospace;">${s.uuidPrevio || 'Consultando...'}</span>
                    </div>
                </div>
            </div>
            <button onclick="cerrarModalSustituirLote()" style="background:none;border:none;color:#94a3b8;font-size:1.2rem;cursor:pointer;">✕</button>
        </div>

        <div style="padding:1rem 0;display:grid;grid-template-columns:repeat(5, minmax(0, 1fr));gap:.5rem;border-bottom:1px solid rgba(255,255,255,0.08);">
            <div style="background:rgba(99,102,241,.08);border:1px solid rgba(99,102,241,.2);border-radius:8px;padding:.55rem;text-align:center;">
                <div style="font-size:.62rem;color:#94a3b8;text-transform:uppercase;">Notas a Conservar</div>
                <div style="font-size:1.1rem;font-weight:800;color:#818cf8;" id="sl-kpi-notas">${calc.countConservadas} de ${s.ventas.length}</div>
            </div>
            <div style="background:rgba(255,255,255,.04);border:1px solid rgba(255,255,255,.08);border-radius:8px;padding:.55rem;text-align:center;">
                <div style="font-size:.62rem;color:#94a3b8;text-transform:uppercase;">Total Bruto</div>
                <div style="font-size:.92rem;font-weight:700;color:#e2e8f0;" id="sl-kpi-bruto">${fmt(calc.totalBruto)}</div>
            </div>
            <div style="background:rgba(245,158,11,.08);border:1px solid rgba(245,158,11,.3);border-radius:8px;padding:.5rem .4rem;text-align:center;">
                <div style="font-size:.62rem;color:#f59e0b;text-transform:uppercase;font-weight:700;display:flex;align-items:center;justify-content:center;gap:3px;">
                    <span>✏️ Activos / Descuento</span>
                </div>
                <div style="display:flex;align-items:center;justify-content:center;gap:2px;margin-top:3px;">
                    <span style="color:#f59e0b;font-weight:800;font-size:.9rem;">-</span>
                    <input type="number" id="sl-input-activos-override" step="any" min="0" 
                           value="${calc.totalActivos}" 
                           oninput="_onCambiarActivosLote(this.value)"
                           placeholder="0.00"
                           title="Haz clic para escribir o editar la cantidad de activos para la nueva factura"
                           style="width:90px;background:#09090b;color:#f59e0b;border:1px solid rgba(245,158,11,.5);border-radius:6px;padding:2px 4px;font-size:.85rem;font-weight:800;text-align:center;">
                    <span style="font-size:.65rem;color:#94a3b8;font-weight:600;">${curMoneda}</span>
                </div>
                <div id="sl-activos-hint" style="font-size:.58rem;color:#a1a1aa;margin-top:2px;">
                    ${s.activosManualOverride !== null && s.activosManualOverride !== undefined ? '<span style="color:#fcd34d;">⚡ Manual</span>' : 'Automático'}
                </div>
            </div>
            <div style="background:rgba(16,185,129,.1);border:1px solid rgba(16,185,129,.3);border-radius:8px;padding:.55rem;text-align:center;">
                <div style="font-size:.62rem;color:#10b981;text-transform:uppercase;font-weight:700;">NUEVO NETO SAT</div>
                <div style="font-size:1.15rem;font-weight:900;color:#34d399;" id="sl-kpi-facturable">${fmt(calc.nuevoFacturable)}</div>
            </div>
            <div style="background:rgba(249,115,22,.08);border:1px solid rgba(249,115,22,.2);border-radius:8px;padding:.55rem;text-align:center;">
                <div style="font-size:.62rem;color:#f97316;text-transform:uppercase;">Notas a Liberar</div>
                <div style="font-size:.92rem;font-weight:700;color:#fb923c;" id="sl-kpi-liberar">${calc.countExcluidas} (${fmt(calc.montoExcluidas)})</div>
            </div>
        </div>

        <div style="margin: .85rem 0; padding: .65rem .85rem; background: rgba(56,189,248,.07); border: 1px solid rgba(56,189,248,.2); border-radius: 8px; font-size: .75rem; color: #bae6fd; display: flex; align-items: center; gap: .5rem;">
            <span>ℹ️</span>
            <div>
                <b>Proceso Oficial SAT:</b> Desmarca las notas que deseas retirar. Al confirmar, el sistema timbrará una nueva Factura por el <b>Neto Facturable (<span id="sl-banner-total">${fmt(calc.nuevoFacturable)}</span>)</b> con <b>TipoRelacion 04</b> enlazada a la actual, cancelará la anterior con <b>Motivo 01</b> y dejará las notas excluidas <b>liberadas en el Backoffice</b> para facturarse individualmente.
            </div>
        </div>

        <!-- Selector de Forma de Pago y Periodicidad -->
        <div style="margin: .85rem 0; display: grid; grid-template-columns: 1fr 1fr; gap: .75rem;">
            <div style="padding: .75rem 1rem; background: rgba(139,92,246,.08); border: 1px solid rgba(139,92,246,.25); border-radius: 10px;">
                <div style="display:flex;align-items:center;gap:.4rem;margin-bottom:.35rem;">
                    <span style="font-size:1rem;">💳</span>
                    <span style="font-weight:700;font-size:.82rem;color:#c084fc;">Forma de Pago del Nuevo CFDI</span>
                </div>
                <select id="sl-select-forma-pago" style="width:100%;background:#09090b;color:#fff;border:1px solid rgba(139,92,246,.4);border-radius:6px;padding:.4rem .6rem;font-size:.78rem;font-weight:600;cursor:pointer;">
                    <option value="03" ${(s.formaPago === '03' || !s.formaPago || s.formaPago === '01') ? 'selected' : ''}>03 — Transferencia electrónica</option>
                    <option value="01" ${s.formaPago === '01' ? '' : ''}>01 — Efectivo</option>
                    <option value="04" ${s.formaPago === '04' ? 'selected' : ''}>04 — Tarjeta de crédito</option>
                    <option value="28" ${s.formaPago === '28' ? 'selected' : ''}>28 — Tarjeta de débito</option>
                    <option value="99" ${s.formaPago === '99' ? 'selected' : ''}>99 — Por definir</option>
                </select>
            </div>

            <div style="padding: .75rem 1rem; background: rgba(59,130,246,.08); border: 1px solid rgba(59,130,246,.25); border-radius: 10px;">
                <div style="display:flex;align-items:center;gap:.4rem;margin-bottom:.35rem;">
                    <span style="font-size:1rem;">📅</span>
                    <span style="font-weight:700;font-size:.82rem;color:#60a5fa;">Periodicidad Global (SAT)</span>
                </div>
                <select id="sl-select-periodicidad" style="width:100%;background:#09090b;color:#fff;border:1px solid rgba(59,130,246,.4);border-radius:6px;padding:.4rem .6rem;font-size:.78rem;font-weight:600;cursor:pointer;">
                    <option value="01" ${s.periodicidad === '01' ? 'selected' : ''}>01 — Diario</option>
                    <option value="02" ${s.periodicidad === '02' ? '' : ''}>02 — Semanal</option>
                    <option value="03" ${s.periodicidad === '03' ? 'selected' : ''}>03 — Quincenal</option>
                    <option value="04" ${(s.periodicidad === '04' || !s.periodicidad || s.periodicidad === '02') ? 'selected' : ''}>04 — Mensual</option>
                    <option value="05" ${s.periodicidad === '05' ? 'selected' : ''}>05 — Bimestral</option>
                </select>
            </div>
        </div>

        <!-- Selector de Facturación Retroactiva -->
        <div style="margin: .85rem 0; padding: .85rem 1rem; background: rgba(234,179,8,.08); border: 1px solid rgba(234,179,8,.3); border-radius: 10px;">
            <div style="display:flex;align-items:center;justify-content:space-between;gap:.75rem;">
                <div>
                    <div style="font-weight:700;font-size:.88rem;color:#fbbf24;display:flex;align-items:center;gap:.4rem;">
                        <span>⏰ Facturación Retroactiva</span>
                        ${s.esMesPasado ? `<span style="background:rgba(245,158,11,.2);color:#f59e0b;font-size:.65rem;padding:2px 7px;border-radius:4px;font-weight:700;">Mes Anterior (${s.mesFacturacion})</span>` : ''}
                    </div>
                    <div style="font-size:.73rem;color:#cbd5e1;margin-top:2px;">
                        ${s.esMesPasado 
                            ? `Emitir CFDI sustituto con fecha del último día de ${s.mesFacturacion} (<b>${s.retroFecha ? s.retroFecha.substring(0,10) : ''} 23:50</b>)`
                            : 'Emitir con fecha retroactiva (último día del mes anterior)'}
                    </div>
                </div>
                <label style="position:relative;display:inline-block;width:46px;height:24px;flex-shrink:0;cursor:pointer;">
                    <input type="checkbox" id="chk-retroactivo-sustitucion" onchange="_onToggleRetroactivoSustitucion()" ${s.esMesPasado ? 'checked' : ''} style="opacity:0;width:0;height:0;position:absolute;">
                    <span id="slider-retro-sust-bg" style="position:absolute;inset:0;background:${s.esMesPasado ? '#f59e0b' : '#374151'};border-radius:24px;transition:.25s;display:block;"></span>
                    <span id="knob-retro-sust" style="position:absolute;height:18px;width:18px;left:3px;bottom:3px;background:white;border-radius:50%;transition:.25s;display:block;transform:${s.esMesPasado ? 'translateX(22px)' : 'translateX(0)'};"></span>
                </label>
            </div>
            <div id="warn-retro-sust" style="display:${s.esMesPasado ? 'block' : 'none'};margin-top:.6rem;font-size:.72rem;color:#fef08a;border-top:1px solid rgba(234,179,8,.2);padding-top:.5rem;line-height:1.45;">
                ⚠️ <b>Plazo máximo 72h (Regla SAT 2.7.2.9):</b> Al estar activo, el nuevo CFDI se timbrará con fecha oficial <b>${s.retroFecha ? s.retroFecha.substring(0,10) : ''} 23:50:00</b>.<br>
                Si lo desactivas, se timbrará con la fecha de hoy conservando el período fiscal de ${s.mesFacturacion || 'agosto'} en Información Global.
            </div>
        </div>

        <div style="margin-bottom:.5rem;">
            <input type="text" id="sl-search-notas" placeholder="🔍 Buscar por Folio de venta, Cliente o Comentario..." oninput="_filtrarNotasSustitucion(this.value)" style="width:100%;padding:.45rem .65rem;border-radius:6px;border:1px solid rgba(255,255,255,0.12);background:#09090b;color:#fff;font-size:.75rem;">
        </div>

        <div style="max-height:30vh;overflow-y:auto;border:1px solid rgba(255,255,255,0.08);border-radius:8px;">
            <table class="bo-table" style="font-size:.72rem;margin:0;width:100%;">
                <thead style="position:sticky;top:0;z-index:2;background:#18181b;">
                    <tr>
                        <th style="text-align:center;width:60px;">Conservar</th>
                        <th>Folio / Nota</th>
                        <th>Cliente</th>
                        <th style="text-align:right;">Total Venta</th>
                        <th>Comentario / Destinatario</th>
                        <th style="text-align:center;">Acción / Destino</th>
                    </tr>
                </thead>
                <tbody id="sl-notas-tbody">
                    ${_renderSustitucionNotasRows()}
                </tbody>
            </table>
        </div>

        <div style="margin-top:1.1rem;padding-top:.85rem;border-top:1px solid rgba(255,255,255,0.08);display:flex;justify-content:space-between;align-items:center;">
            <button class="btn btn-outline btn-sm" onclick="cerrarModalSustituirLote()" style="color:#94a3b8;border-color:rgba(255,255,255,0.15);">✕ Cancelar</button>
            <button id="btnConfirmarSustitucionLote" class="btn btn-primary btn-sm" onclick="confirmarSustitucionLoteSAT()" style="background:linear-gradient(135deg,#0284c7,#0369a1);border:none;font-weight:700;padding:.5rem 1.2rem;font-size:.82rem;">
                ⚡ Sustituir ante el SAT y Liberar (<span id="sl-btn-facturable">${fmt(calc.nuevoFacturable)}</span>)
            </button>
        </div>
    </div>
    `;
}

function _onToggleRetroactivoSustitucion() {
    const cb = document.getElementById('chk-retroactivo-sustitucion');
    const warn = document.getElementById('warn-retro-sust');
    const bg = document.getElementById('slider-retro-sust-bg');
    const knob = document.getElementById('knob-retro-sust');
    const on = cb?.checked;
    if (warn) warn.style.display = on ? 'block' : 'none';
    if (bg) bg.style.background = on ? '#f59e0b' : '#374151';
    if (knob) knob.style.transform = on ? 'translateX(22px)' : 'translateX(0)';
}

function _onCambiarActivosLote(val) {
    const s = window._sustitucionLoteState;
    if (!s) return;
    const vTrim = String(val).trim();
    s.activosManualOverride = vTrim === '' ? null : Math.max(0, parseFloat(vTrim) || 0);
    _actualizarKPIsSustitucionModal(true);
}
window._onCambiarActivosLote = _onCambiarActivosLote;

function _actualizarKPIsSustitucionModal(isFromInput = false) {
    const s = window._sustitucionLoteState;
    if (!s) return;
    const calc = _calcularSustitucionLote();
    const curMoneda = s.isUSD ? 'USD' : 'MXN';
    const fmt = (n) => '$' + Number(n).toLocaleString('es-MX', { minimumFractionDigits: 2 }) + (s.isUSD ? ' USD' : '');

    const elNotas = document.getElementById('sl-kpi-notas');
    if (elNotas) elNotas.textContent = `${calc.countConservadas} de ${s.ventas.length}`;

    const elBruto = document.getElementById('sl-kpi-bruto');
    if (elBruto) elBruto.textContent = fmt(calc.totalBruto);

    const elActivosInput = document.getElementById('sl-input-activos-override');
    if (elActivosInput && !isFromInput && (s.activosManualOverride === null || s.activosManualOverride === undefined)) {
        elActivosInput.value = calc.totalActivos;
    }

    const elActivosHint = document.getElementById('sl-activos-hint');
    if (elActivosHint) {
        elActivosHint.innerHTML = (s.activosManualOverride !== null && s.activosManualOverride !== undefined)
            ? '<span style="color:#fcd34d;">⚡ Manual</span>'
            : 'Automático';
    }

    const elFacturable = document.getElementById('sl-kpi-facturable');
    if (elFacturable) elFacturable.textContent = fmt(calc.nuevoFacturable);

    const elLiberar = document.getElementById('sl-kpi-liberar');
    if (elLiberar) elLiberar.textContent = `${calc.countExcluidas} (${fmt(calc.montoExcluidas)})`;

    const elBanner = document.getElementById('sl-banner-total');
    if (elBanner) elBanner.textContent = fmt(calc.nuevoFacturable);

    const elBtn = document.getElementById('sl-btn-facturable');
    if (elBtn) elBtn.textContent = fmt(calc.nuevoFacturable);
}

function _toggleNotaExcluida(notaId, checked) {
    const s = window._sustitucionLoteState;
    if (!s) return;
    const idStr = String(notaId);
    if (checked) {
        s.excludedIds = s.excludedIds.filter(x => x !== idStr);
    } else {
        if (!s.excludedIds.includes(idStr)) s.excludedIds.push(idStr);
    }
    _actualizarKPIsSustitucionModal();

    const badge = document.getElementById(`sl-badge-${idStr}`);
    if (badge) {
        badge.innerHTML = checked
            ? '<span style="background:rgba(16,185,129,.15);color:#34d399;border-radius:4px;padding:2px 8px;font-size:.65rem;font-weight:600;">En Nueva Factura</span>'
            : '<span style="background:rgba(249,115,22,.18);color:#fb923c;border-radius:4px;padding:2px 8px;font-size:.65rem;font-weight:700;">🔓 Se Liberará</span>';
    }

    const row = document.querySelector(`.sl-nota-row[data-id="${idStr}"]`);
    if (row) {
        row.style.background = checked ? '' : 'rgba(249,115,22,0.08)';
    }
}

function _filtrarNotasSustitucion(q) {
    const query = (q || '').toLowerCase().trim();
    const rows = document.querySelectorAll('#sl-notas-tbody tr');
    rows.forEach(r => {
        const text = r.textContent.toLowerCase();
        r.style.display = (!query || text.includes(query)) ? '' : 'none';
    });
}

function cerrarModalSustituirLote() {
    const modal = document.getElementById('modalSustituirLoteSAT');
    if (modal) modal.style.display = 'none';
}

async function confirmarSustitucionLoteSAT() {
    const s = window._sustitucionLoteState;
    if (!s) return;

    const calc = _calcularSustitucionLote();
    if (calc.countConservadas === 0) {
        BO_AUTH.showAlert('⚠️ Debes conservar al menos 1 nota en la factura sustituta.', 'warning');
        return;
    }

    if (!s.uuidPrevio) {
        BO_AUTH.showAlert('⚠️ Falta el UUID de la factura previa para relacionarla ante el SAT.', 'warning');
        return;
    }

    const chkRetro = document.getElementById('chk-retroactivo-sustitucion');
    const esRetro = chkRetro ? chkRetro.checked : false;
    const fechaRetroactivo = esRetro ? s.retroFecha : null;
    const formaPagoSel = document.getElementById('sl-select-forma-pago')?.value || s.formaPago || '03';
    const formaPagoLabels = { '01': '01 — Efectivo', '03': '03 — Transferencia', '04': '04 — Tarjeta crédito', '28': '28 — Tarjeta débito', '99': '99 — Por definir' };
    const periodicidadSel = document.getElementById('sl-select-periodicidad')?.value || s.periodicidad || '04';
    const periodicidadLabels = { '01': '01 — Diario', '02': '02 — Semanal', '03': '03 — Quincenal', '04': '04 — Mensual', '05': '05 — Bimestral' };

    const curMoneda = s.isUSD ? 'USD' : 'MXN';
    const fmt = (n) => '$' + Number(n).toLocaleString('es-MX', { minimumFractionDigits: 2 }) + (s.isUSD ? ' USD' : '');
    const confirmMsg = `¿Confirmas la sustitución oficial ante el SAT?\\n\\n` +
        `• Factura Previa a Cancelar: #${s.solicitudId} (${s.numeroNota})\\n` +
        `• Nueva Factura Sustituta: ${calc.countConservadas} notas por ${fmt(calc.nuevoFacturable)} (Neto SAT)\\n` +
        `• Forma de Pago: ${formaPagoLabels[formaPagoSel] || formaPagoSel}\\n` +
        `• Periodicidad: ${periodicidadLabels[periodicidadSel] || periodicidadSel}\\n` +
        `• Activos Conservados: ${fmt(calc.totalActivos)} MXN\\n` +
        `• Fecha del Nuevo CFDI: ${fechaRetroactivo ? fechaRetroactivo.substring(0, 10) + ' 23:50:00 (Retroactivo)' : 'Fecha actual de hoy'}\\n` +
        `• Notas que quedarán LIBERADAS: ${calc.countExcluidas} nota(s) por ${fmt(calc.montoExcluidas)} MXN\\n\\n` +
        `Se emitirá el nuevo CFDI con TipoRelacion 04 y se cancelará la anterior con Motivo 01.`;

    if (!confirm(confirmMsg)) return;

    const btn = document.getElementById('btnConfirmarSustitucionLote');
    if (btn) {
        btn.disabled = true;
        btn.textContent = '⏳ Timbrando ante el SAT y cancelando previa...';
    }

    try {
        BO_AUTH.showAlert('⏳ Ejecutando sustitución y timbrado ante el SAT...', 'info');

        const endpointUrl = s.isUSD
            ? 'https://n8n.duletias3rver.com/webhook/bo/factura/sustituir-lote-usd'
            : 'https://n8n.duletias3rver.com/webhook/bo/factura/sustituir-lote';

        const resp = await fetch(endpointUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                solicitudId: s.solicitudId,
                uuidPrevio: s.uuidPrevio,
                cfdiIdPrevio: s.cfdiIdPrevio,
                notasExcluidas: s.excludedIds,
                fechaRetroactivo: fechaRetroactivo,
                formaPago: formaPagoSel,
                periodicidad: periodicidadSel,
                totalActivos: calc.totalActivos,
                totalFacturable: calc.nuevoFacturable,
                totalBruto: calc.totalBruto,
                isUSD: Boolean(s.isUSD),
                moneda: curMoneda,
                tipoCambio: s.tipoCambio || 17.0147,
                dryRun: false
            })
        });

        const data = await resp.json();
        if (!data.ok || data.dryRun) {
            throw new Error(data.error || 'El servidor devolvió una simulación en lugar de emitir el timbrado.');
        }

        cerrarModalSustituirLote();
        BO_AUTH.showAlert(
            `✅ ¡Sustitución exitosa ante el SAT!\n\n` +
            `• Nueva Factura emitida: UUID ${data.nuevoCfdiUuid?.substring(0,8)}… por ${fmt(data.nuevoTotalFacturable)} ${s.isUSD ? 'USD' : 'MXN'}\n` +
            `• Factura previa #${s.solicitudId} programada en cola de cancelación (Motivo 01 ante el SAT en ~7 min tras réplica)\n` +
            `• ${data.notasLiberadas?.length || 0} nota(s) liberada(s) en PostgreSQL para facturarse individualmente.`,
            'success'
        );

        if (typeof loadHistorialFacturas === 'function') loadHistorialFacturas();
        if (typeof loadFacturaGlobal === 'function') loadFacturaGlobal();
    } catch(err) {
        console.error('[CONFIRMAR SUSTITUCION LOTE] Error:', err);
        BO_AUTH.showAlert('❌ Error al sustituir lote: ' + err.message, 'error');
    } finally {
        if (btn) {
            btn.disabled = false;
            btn.textContent = `⚡ Sustituir ante el SAT y Liberar (${fmt(calc.nuevoFacturable)})`;
        }
    }
}

// ── Wrappers globales seguros por ID de Solicitud ───────────────────────────
window.abrirModalCancelarSATSol = function(solicitudId) {
    const f = (window._cacheFacturasEmitidas && (window._cacheFacturasEmitidas[String(solicitudId)] || window._cacheFacturasEmitidas[solicitudId])) 
           || (window._factFactItems && window._factFactItems.find(x => String(x.id) === String(solicitudId) || String(x.numero_nota) === String(solicitudId) || String(x.cfdi_uuid) === String(solicitudId) || String(x.cfdi_id) === String(solicitudId)))
           || {};
    abrirModalCancelarSAT(f.cfdi_id || '', f.cfdi_uuid || '', f.id || (String(solicitudId).startsWith('item_') ? '' : solicitudId), f.numero_nota || '', f.rfc || '', f.razon_social || '', f.total || f.monto_facturable || 0);
};

window.abrirModalSustituirSol = function(solicitudId) {
    const f = (window._cacheFacturasEmitidas && (window._cacheFacturasEmitidas[String(solicitudId)] || window._cacheFacturasEmitidas[solicitudId])) 
           || (window._factFactItems && window._factFactItems.find(x => String(x.id) === String(solicitudId) || String(x.numero_nota) === String(solicitudId) || String(x.cfdi_uuid) === String(solicitudId) || String(x.cfdi_id) === String(solicitudId)))
           || {};

    const isGlobal = String(f.numero_nota || '').startsWith('GLOBAL-');
    const isCentro = String(f.numero_nota || '').startsWith('CENTRO-') || String(f.cedis_id || '').includes('CENTRO') || String(f.cedis_id || '').startsWith('CA_');
    const hasMultipleVentas = f.ventas_ids && (f.ventas_ids.startsWith('[') && f.ventas_ids.length > 5);

    if (isGlobal || isCentro || hasMultipleVentas) {
        return abrirModalSustituirLote(f, f.id || solicitudId);
    }

    abrirModalSustituir(f.cfdi_id || '', f.cfdi_uuid || '', f.id || (String(solicitudId).startsWith('item_') ? '' : solicitudId), f.numero_nota || '', f.rfc || '', f.razon_social || '', f.regimen || '612', f.cp || '', f.uso_cfdi || 'G01', f.forma_pago || '03', f.total || f.monto_facturable || 0);
};

function abrirModalCancelarSATSol(solicitudId) {
    return window.abrirModalCancelarSATSol(solicitudId);
}

function abrirModalSustituirSol(solicitudId) {
    return window.abrirModalSustituirSol(solicitudId);
}

window.abrirModalCancelarSAT = abrirModalCancelarSAT;
window.abrirModalCancelarSATSol = abrirModalCancelarSATSol;
window.onCanFacMotivoChange = onCanFacMotivoChange;
window.cerrarModalCancelarSAT = cerrarModalCancelarSAT;
window.confirmarCancelacionSAT = confirmarCancelacionSAT;
window.abrirModalSustituir = abrirModalSustituir;
window.abrirModalSustituirSol = abrirModalSustituirSol;
window.cerrarModalSustituir = cerrarModalSustituir;
window.confirmarSustitucionSAT = confirmarSustitucionSAT;
window.abrirModalSustituirLote = abrirModalSustituirLote;
window.cerrarModalSustituirLote = cerrarModalSustituirLote;
window.confirmarSustitucionLoteSAT = confirmarSustitucionLoteSAT;
window._toggleNotaExcluida = _toggleNotaExcluida;
window._filtrarNotasSustitucion = _filtrarNotasSustitucion;

document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
        cerrarModalCancelarSAT();
        cerrarModalSustituir();
        cerrarModalSustituirLote();
    }
});
window.abrirModalSustituir = abrirModalSustituir;
window.abrirModalSustituirSol = abrirModalSustituirSol;
window.cerrarModalSustituir = cerrarModalSustituir;
window.confirmarSustitucionSAT = confirmarSustitucionSAT;

async function _revertirVentasCancelacion(numeroNota, solicitudId, idFinal) {
    const _isGlobalCancelar = String(numeroNota || '').startsWith('GLOBAL-');
    const _isCentroCancelar = String(numeroNota || '').startsWith('CENTRO-');
    const _centroIdCancel = _isCentroCancelar ? (numeroNota.match(/^CENTRO-(\d+)/)?.[1] || '0') : null;

    if (_isGlobalCancelar && solicitudId) {
        const solRow = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
            sql: `SELECT ventas_ids FROM facturas_solicitadas WHERE id = ${solicitudId}`
        });
        const ventasIds = solRow?.rows?.[0]?.ventas_ids;
        let ids;
        try { ids = ventasIds ? JSON.parse(ventasIds) : null; } catch(e) { ids = null; }

        if (Array.isArray(ids) && ids.length > 0) {
            const idList = ids.map(id => `'${id}'`).join(',');
            await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                sql: `UPDATE venta SET factura_emitida = false, factura_uuid = NULL, requiere_factura = false WHERE id IN (${idList})` });
        } else {
            const mesMatch = numeroNota.match(/GLOBAL-(\d{4})-(\d{2})/);
            if (mesMatch) {
                const [, yyyy, mm] = mesMatch;
                const mesInicio = `${yyyy}-${mm}-01`;
                const lastDay = new Date(parseInt(yyyy), parseInt(mm), 0).getDate();
                const mesFin = `${yyyy}-${mm}-${String(lastDay).padStart(2,'0')}`;
                await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                    sql: `UPDATE venta SET factura_emitida = false, factura_uuid = NULL, requiere_factura = false WHERE approved=1 AND fecha_venta BETWEEN '${mesInicio}' AND '${mesFin}' AND (factura_uuid = '${idFinal}' OR factura_uuid IS NULL)`
                });
            }
        }
    } else if (_isCentroCancelar) {
        await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
            sql: `UPDATE venta SET factura_emitida = false, factura_uuid = NULL, requiere_factura = false WHERE centro_apoyo_id = '${_centroIdCancel}' AND (factura_uuid = '${idFinal}' OR factura_uuid IS NULL)`
        });
    } else if (numeroNota) {
        await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
            sql: `UPDATE venta SET factura_emitida = false, factura_uuid = NULL, requiere_factura = true WHERE id = '${numeroNota}'`
        });
    }
}

async function cancelarFactura(cfdiId, solicitudId, numeroNota) {
    return abrirModalCancelarSAT(cfdiId, '', solicitudId, numeroNota, '', '', 0);
}

async function _cancelarFacturaLegacy(cfdiId, solicitudId, numeroNota) {
    if (!confirm('¿Cancelar esta factura ante el SAT?')) return;
    try {
        await fetch(BO_API.BASE + '/bo/factura/cancelar', {
            method: 'POST',
            headers: BO_API._headers(),
            body: JSON.stringify({ cfdiId: cfdiId, motivo: '02' })
        });
        if (solicitudId) {
            await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                sql: `UPDATE facturas_solicitadas SET estado = 'cancelada', fecha_cancelacion = NOW() WHERE id = ${solicitudId}` });
        }
        await _revertirVentasCancelacion(numeroNota, solicitudId, cfdiId);
        loadHistorialFacturas();
    } catch(e) {
        BO_AUTH.showAlert('❌ Error al cancelar: ' + e.message, 'error');
    }
}



// ══ Diagnóstico de Notas Duplicadas y Auditoría Fiscal ══════════════════════
let _diagActiveTab = 'all';
let _diagSearchQuery = '';
let _diagSelectedMonth = 'all';
let _diagCurrentPage = 0;
const _DIAG_PAGE_SIZE = 25;

async function diagnosticoDuplicadosPendientes() {
    const prevModal = document.getElementById('modal-diag-duplicados');
    if (prevModal) prevModal.remove();

    const overlay = document.createElement('div');
    overlay.id = 'modal-diag-duplicados';
    overlay.style.cssText = 'position:fixed;inset:0;background:rgba(10,15,29,.85);backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);z-index:99999;display:flex;align-items:center;justify-content:center;padding:1.2rem;overflow:hidden;';
    overlay.innerHTML = `
        <div style="background:linear-gradient(145deg, #131d31 0%, #0d1527 100%);border-radius:18px;border:1px solid rgba(245,158,11,.35);box-shadow:0 30px 70px rgba(0,0,0,.7),0 0 30px rgba(245,158,11,.1);width:100%;max-width:1100px;max-height:92vh;display:flex;flex-direction:column;overflow:hidden;animation:diagFadeIn .22s ease-out;color:#e2e8f0;font-family:system-ui,-apple-system,sans-serif;">
            
            <!-- Header -->
            <div style="display:flex;justify-content:space-between;align-items:center;padding:1.2rem 1.6rem;border-bottom:1px solid rgba(255,255,255,.08);background:rgba(255,255,255,.02);">
                <div>
                    <div style="display:flex;align-items:center;gap:.6rem;">
                        <h3 style="margin:0;color:#fbbf24;font-size:1.15rem;font-weight:700;display:flex;align-items:center;gap:.5rem;">
                            <span>🔍</span> Auditoría Fiscal & Diagnóstico de Duplicados
                        </h3>
                        <span style="background:rgba(245,158,11,.15);color:#fbbf24;font-size:.65rem;font-weight:700;padding:2px 8px;border-radius:12px;border:1px solid rgba(245,158,11,.3);">SAT / Facturama</span>
                    </div>
                    <div style="font-size:.74rem;color:#94a3b8;margin-top:3px;">Detección inteligente de notas en riesgo, dobles facturas históricas y CFDIs activos huérfanos.</div>
                </div>
                <button onclick="document.getElementById('modal-diag-duplicados').remove()" style="background:rgba(255,255,255,.06);border:1px solid rgba(255,255,255,.12);color:#94a3b8;cursor:pointer;font-size:1.1rem;width:34px;height:34px;border-radius:50%;display:flex;align-items:center;justify-content:center;transition:all .15s ease;" onmouseover="this.style.color='#fff';this.style.background='rgba(239,68,68,.25)'" onmouseout="this.style.color='#94a3b8';this.style.background='rgba(255,255,255,.06)'">✕</button>
            </div>

            <!-- Modal Content (Scrollable) -->
            <div id="diag-dup-body" style="padding:1.4rem;overflow-y:auto;flex:1;display:flex;flex-direction:column;gap:1.1rem;">
                <div style="text-align:center;padding:3rem 1rem;color:#94a3b8;font-size:.9rem;">
                    <div style="font-size:2rem;margin-bottom:.8rem;animation:spin 1s linear infinite;display:inline-block;">⏳</div>
                    <div>Analizando solicitudes y cotejando con histórico SAT...</div>
                </div>
            </div>
        </div>`;
    document.body.appendChild(overlay);

    try {
        // 1. Cargar solicitudes pendientes, solicitudes timbradas y solicitudes con cfdi_id pero marcadas canceladas (huérfanas)
        const [resPend, resSolFact, resHuerfanas] = await Promise.all([
            BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                sql: `SELECT id, numero_nota, ventas_ids, estado FROM facturas_solicitadas WHERE estado IN ('solicitada','en_proceso') ORDER BY id DESC`
            }),
            BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                sql: `SELECT fs.id AS sol_id, fs.numero_nota, fs.ventas_ids, fs.estado, fs.creado_en, fs.cfdi_id, fs.cfdi_uuid
                      FROM facturas_solicitadas fs
                      WHERE fs.estado = 'facturada' AND fs.ventas_ids IS NOT NULL AND fs.ventas_ids <> '[]' AND fs.ventas_ids <> 'null'
                      ORDER BY fs.id ASC`
            }),
            BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                sql: `SELECT fs.id AS sol_id, fs.numero_nota, fs.ventas_ids, fs.estado, fs.creado_en, fs.cfdi_id, fs.cfdi_uuid, fs.rfc, fs.razon_social
                      FROM facturas_solicitadas fs
                      WHERE fs.estado = 'cancelada' AND fs.cfdi_id IS NOT NULL AND fs.cfdi_id <> '' AND fs.fecha_cancelacion IS NULL
                      ORDER BY fs.id DESC`
            })
        ]);

        const pendientes = resPend.rows || [];
        const solsYaTimbradas = resSolFact.rows || [];
        const solsHuerfanas = resHuerfanas.rows || [];

        // Helper para extraer IDs de notas de una solicitud
        const extraerIds = (sol) => {
            const ids = new Set();
            if (sol.ventas_ids) {
                try { JSON.parse(sol.ventas_ids).forEach(id => id && ids.add(String(id).trim())); } catch(_) {}
            }
            if (sol.numero_nota && /^[0-9a-f-]{36}$/i.test(sol.numero_nota)) {
                ids.add(String(sol.numero_nota).trim());
            }
            return ids;
        };

        // Mapeo de notas en pendientes
        const notaToPendSols = new Map();
        for (const sol of pendientes) {
            for (const nid of extraerIds(sol)) {
                if (!notaToPendSols.has(nid)) notaToPendSols.set(nid, []);
                notaToPendSols.get(nid).push({ sol_id: sol.id, estado: sol.estado, numero_nota: sol.numero_nota });
            }
        }

        // Mapeo de notas en timbradas históricas
        const timbradasNoteMap = new Map();
        for (const solFact of solsYaTimbradas) {
            let ids = [];
            try { ids = JSON.parse(solFact.ventas_ids); } catch(_) {}
            for (const nid of ids) {
                const snid = String(nid).trim();
                if (!snid) continue;
                if (!timbradasNoteMap.has(snid)) timbradasNoteMap.set(snid, []);
                timbradasNoteMap.get(snid).push({
                    sol_id: solFact.sol_id,
                    numero_nota: solFact.numero_nota,
                    creado_en: solFact.creado_en,
                    cfdi_uuid: solFact.cfdi_uuid || solFact.cfdi_id
                });
            }
        }

        // Mapeo de notas huérfanas (con CFDI emitido pero canceladas en BD local sin cancelar en SAT)
        const huerfanasNoteMap = new Map();
        for (const solH of solsHuerfanas) {
            for (const nid of extraerIds(solH)) {
                if (!huerfanasNoteMap.has(nid)) huerfanasNoteMap.set(nid, []);
                huerfanasNoteMap.get(nid).push({
                    sol_id: solH.sol_id,
                    numero_nota: solH.numero_nota,
                    cfdi_id: solH.cfdi_id,
                    cfdi_uuid: solH.cfdi_uuid,
                    rfc: solH.rfc,
                    razon_social: solH.razon_social,
                    creado_en: solH.creado_en
                });
            }
        }

        // ── Detección Grupo 1: CFDIs Huérfanos re-facturados (ej. Nota 9e2918fd) ──
        const dupsHuerfanas = [];
        for (const [nid, solsH] of huerfanasNoteMap.entries()) {
            const timbSols = timbradasNoteMap.get(nid) || [];
            const pendSols = notaToPendSols.get(nid) || [];
            if (timbSols.length > 0 || pendSols.length > 0) {
                dupsHuerfanas.push({
                    notaId: nid,
                    solsHuerfanas: solsH,
                    solsTimbradas: timbSols,
                    solsPendientes: pendSols
                });
            }
        }

        // ── Detección Grupo 2: Pendientes vs Facturadas antes ──
        const dupsPendFact = [];
        for (const [nid, pendSols] of notaToPendSols.entries()) {
            const timbSols = timbradasNoteMap.get(nid) || [];
            if (timbSols.length > 0) {
                dupsPendFact.push({ notaId: nid, pendSols, timbSols });
            }
        }

        // ── Detección Grupo 3: En >=2 Pendientes ──
        const dupsPendPend = [];
        for (const [nid, pendSols] of notaToPendSols.entries()) {
            if (pendSols.length >= 2) {
                dupsPendPend.push({ notaId: nid, pendSols });
            }
        }

        // ── Detección Grupo 4: Históricas en >=2 Facturas ──
        const dupsHistorico = [];
        for (const [nid, sols] of timbradasNoteMap.entries()) {
            const uniqueSols = [...new Map(sols.map(s => [s.sol_id, s])).values()];
            if (uniqueSols.length >= 2) {
                dupsHistorico.push({ noteId: nid, sols: uniqueSols });
            }
        }

        // Recolectar todos los IDs para traer info de venta
        const allNoteIds = new Set();
        dupsHuerfanas.forEach(d => allNoteIds.add(d.notaId));
        dupsPendFact.forEach(d => allNoteIds.add(d.notaId));
        dupsPendPend.forEach(d => allNoteIds.add(d.notaId));
        dupsHistorico.forEach(d => allNoteIds.add(d.noteId));

        let ventaDetalles = {};
        if (allNoteIds.size > 0) {
            const idsList = [...allNoteIds].map(id => `'${id}'`).join(',');
            try {
                const vRes = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                    sql: `SELECT v.id, v.fecha_venta, v.total, v.factura_uuid, v.comentario,
                                 COALESCE(c.nombre || ' ' || COALESCE(c.ape_p,''), 'Público General') AS cliente
                          FROM venta v LEFT JOIN cliente c ON c.id = v.cliente_id
                          WHERE v.id::text IN (${idsList})`
                });
                for (const r of (vRes.rows || [])) ventaDetalles[r.id] = r;
            } catch(ve) { console.warn('[DIAG VENTA DETALLES]', ve); }
        }

        // ── Unificar datos en una colección maestra para búsqueda y filtros rápidos en cliente ──
        const masterItems = [];
        const seenKeys = new Set();

        // 1. Huérfanas
        for (const item of dupsHuerfanas) {
            const vd = ventaDetalles[item.notaId];
            const fechaStr = vd?.fecha_venta ? String(vd.fecha_venta).slice(0,10) : '';
            const mesStr = fechaStr ? fechaStr.slice(0,7) : 'Sin fecha';
            const totalNum = Number(vd?.total || 0);
            const clienteStr = vd?.cliente || 'Público General';
            const key = `huerfana_${item.notaId}`;
            if (!seenKeys.has(key)) {
                seenKeys.add(key);
                masterItems.push({
                    key,
                    notaId: item.notaId,
                    tipo: 'huerfana',
                    tipoLabel: '⚡ CFDI Activo vs Global',
                    tipoColor: '#ec4899',
                    cliente: clienteStr,
                    fecha: fechaStr,
                    mes: mesStr,
                    total: totalNum,
                    itemData: item,
                    searchText: `${item.notaId} ${clienteStr} ${fechaStr} ${item.solsHuerfanas.map(s=>'sol #'+s.sol_id+' '+s.numero_nota+' '+s.cfdi_id).join(' ')} ${item.solsTimbradas.map(s=>'sol #'+s.sol_id+' '+s.numero_nota).join(' ')}`.toLowerCase()
                });
            }
        }

        // 2. Pend vs Fact
        for (const item of dupsPendFact) {
            const vd = ventaDetalles[item.notaId];
            const fechaStr = vd?.fecha_venta ? String(vd.fecha_venta).slice(0,10) : '';
            const mesStr = fechaStr ? fechaStr.slice(0,7) : 'Sin fecha';
            const totalNum = Number(vd?.total || 0);
            const clienteStr = vd?.cliente || 'Público General';
            const key = `pendfact_${item.notaId}`;
            if (!seenKeys.has(key)) {
                seenKeys.add(key);
                masterItems.push({
                    key,
                    notaId: item.notaId,
                    tipo: 'pendFact',
                    tipoLabel: '🚨 Pendiente vs Facturada',
                    tipoColor: '#f87171',
                    cliente: clienteStr,
                    fecha: fechaStr,
                    mes: mesStr,
                    total: totalNum,
                    itemData: item,
                    searchText: `${item.notaId} ${clienteStr} ${fechaStr} ${item.pendSols.map(s=>'sol #'+s.sol_id).join(' ')} ${item.timbSols.map(s=>'sol #'+s.sol_id).join(' ')}`.toLowerCase()
                });
            }
        }

        // 3. Pend vs Pend
        for (const item of dupsPendPend) {
            const vd = ventaDetalles[item.notaId];
            const fechaStr = vd?.fecha_venta ? String(vd.fecha_venta).slice(0,10) : '';
            const mesStr = fechaStr ? fechaStr.slice(0,7) : 'Sin fecha';
            const totalNum = Number(vd?.total || 0);
            const clienteStr = vd?.cliente || 'Múltiples pendientes';
            const key = `pendpend_${item.notaId}`;
            if (!seenKeys.has(key)) {
                seenKeys.add(key);
                masterItems.push({
                    key,
                    notaId: item.notaId,
                    tipo: 'pendPend',
                    tipoLabel: '⚠️ En ≥2 Pendientes',
                    tipoColor: '#fbbf24',
                    cliente: clienteStr,
                    fecha: fechaStr,
                    mes: mesStr,
                    total: totalNum,
                    itemData: item,
                    searchText: `${item.notaId} ${clienteStr} ${fechaStr} ${item.pendSols.map(s=>'sol #'+s.sol_id).join(' ')}`.toLowerCase()
                });
            }
        }

        // 4. Históricas
        for (const item of dupsHistorico) {
            const vd = ventaDetalles[item.noteId];
            const fechaStr = vd?.fecha_venta ? String(vd.fecha_venta).slice(0,10) : '';
            const mesStr = fechaStr ? fechaStr.slice(0,7) : 'Sin fecha';
            const totalNum = Number(vd?.total || 0);
            const clienteStr = vd?.cliente || 'Público General';
            const key = `hist_${item.noteId}`;
            if (!seenKeys.has(key)) {
                seenKeys.add(key);
                masterItems.push({
                    key,
                    notaId: item.noteId,
                    tipo: 'historico',
                    tipoLabel: '🔴 Histórica Duplicada',
                    tipoColor: '#fb923c',
                    cliente: clienteStr,
                    fecha: fechaStr,
                    mes: mesStr,
                    total: totalNum,
                    itemData: item,
                    searchText: `${item.noteId} ${clienteStr} ${fechaStr} ${item.sols.map(s=>'sol #'+s.sol_id+' '+s.numero_nota).join(' ')}`.toLowerCase()
                });
            }
        }

        // Extraer lista única de meses ordenados descendente
        const monthCounts = {};
        masterItems.forEach(item => {
            if (item.mes && item.mes !== 'Sin fecha') {
                monthCounts[item.mes] = (monthCounts[item.mes] || 0) + 1;
            }
        });
        const sortedMonths = Object.keys(monthCounts).sort().reverse();

        window._diagMaster = {
            masterItems,
            dupsHuerfanas,
            dupsPendFact,
            dupsPendPend,
            dupsHistorico,
            pendientes,
            solsYaTimbradas,
            sortedMonths,
            monthCounts,
            ventaDetalles
        };

        // Resetear filtros
        _diagActiveTab = 'all';
        _diagSearchQuery = '';
        _diagSelectedMonth = 'all';
        _diagCurrentPage = 0;

        _diagRenderFullUI();

    } catch(e) {
        console.error('[DIAGNOSTICO ERROR]', e);
        const body = document.getElementById('diag-dup-body');
        if (body) body.innerHTML = `<div style="padding:1.5rem;background:rgba(239,68,68,.12);border:1px solid rgba(239,68,68,.3);border-radius:10px;color:#fca5a5;">❌ Error al generar diagnóstico: ${e.message}</div>`;
    }
}

// ── Render de toda la interfaz del diagnóstico ──
function _diagRenderFullUI() {
    const d = window._diagMaster;
    if (!d) return;

    const body = document.getElementById('diag-dup-body');
    if (!body) return;

    // Mes selector options
    const monthOptions = [
        `<option value="all">📅 Todos los meses (${d.masterItems.length} registros)</option>`,
        ...d.sortedMonths.map(m => {
            const [y, mm] = m.split('-');
            const dateObj = new Date(parseInt(y), parseInt(mm) - 1, 1);
            const mName = dateObj.toLocaleDateString('es-MX', { month: 'long', year: 'numeric' });
            return `<option value="${m}">${m} — ${mName.charAt(0).toUpperCase() + mName.slice(1)} (${d.monthCounts[m]})</option>`;
        })
    ].join('');

    body.innerHTML = `
        <!-- KPI Cards -->
        <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(180px,1fr));gap:.8rem;">
            <div onclick="_diagSelectTab('huerfana')" style="background:rgba(236,72,153,.08);border:1px solid rgba(236,72,153,.35);padding:.9rem;border-radius:12px;cursor:pointer;transition:transform .15s ease;" onmouseover="this.style.transform='translateY(-2px)'" onmouseout="this.style.transform='translateY(0)'">
                <div style="display:flex;justify-content:space-between;align-items:flex-start;">
                    <span style="font-size:1.8rem;font-weight:800;color:#f472b6;">${d.dupsHuerfanas.length}</span>
                    <span style="background:rgba(236,72,153,.2);color:#f472b6;font-size:.65rem;padding:2px 6px;border-radius:6px;font-weight:700;">Crítico SAT</span>
                </div>
                <div style="font-size:.74rem;color:#fed7aa;font-weight:600;margin-top:4px;">⚡ CFDI Activo vs Global</div>
                <div style="font-size:.68rem;color:#94a3b8;margin-top:2px;">Rechazadas en BD con CFDI timbrado en SAT</div>
            </div>

            <div onclick="_diagSelectTab('pendFact')" style="background:rgba(239,68,68,.08);border:1px solid rgba(239,68,68,.35);padding:.9rem;border-radius:12px;cursor:pointer;transition:transform .15s ease;" onmouseover="this.style.transform='translateY(-2px)'" onmouseout="this.style.transform='translateY(0)'">
                <div style="display:flex;justify-content:space-between;align-items:flex-start;">
                    <span style="font-size:1.8rem;font-weight:800;color:#f87171;">${d.dupsPendFact.length}</span>
                    <span style="background:rgba(239,68,68,.2);color:#f87171;font-size:.65rem;padding:2px 6px;border-radius:6px;font-weight:700;">Riesgo Inminente</span>
                </div>
                <div style="font-size:.74rem;color:#fca5a5;font-weight:600;margin-top:4px;">🚨 Pendientes ya Facturadas</div>
                <div style="font-size:.68rem;color:#94a3b8;margin-top:2px;">Se facturarían 2 veces si se aprueban</div>
            </div>

            <div onclick="_diagSelectTab('pendPend')" style="background:rgba(245,158,11,.08);border:1px solid rgba(245,158,11,.35);padding:.9rem;border-radius:12px;cursor:pointer;transition:transform .15s ease;" onmouseover="this.style.transform='translateY(-2px)'" onmouseout="this.style.transform='translateY(0)'">
                <div style="display:flex;justify-content:space-between;align-items:flex-start;">
                    <span style="font-size:1.8rem;font-weight:800;color:#fbbf24;">${d.dupsPendPend.length}</span>
                    <span style="background:rgba(245,158,11,.2);color:#fbbf24;font-size:.65rem;padding:2px 6px;border-radius:6px;font-weight:700;">Conflicto</span>
                </div>
                <div style="font-size:.74rem;color:#fde68a;font-weight:600;margin-top:4px;">⚠️ En ≥2 Solicitudes Pendientes</div>
                <div style="font-size:.68rem;color:#94a3b8;margin-top:2px;">Misma venta en múltiples borradores</div>
            </div>

            <div onclick="_diagSelectTab('historico')" style="background:rgba(251,146,60,.08);border:1px solid rgba(251,146,60,.35);padding:.9rem;border-radius:12px;cursor:pointer;transition:transform .15s ease;" onmouseover="this.style.transform='translateY(-2px)'" onmouseout="this.style.transform='translateY(0)'">
                <div style="display:flex;justify-content:space-between;align-items:flex-start;">
                    <span style="font-size:1.8rem;font-weight:800;color:#fb923c;">${d.dupsHistorico.length}</span>
                    <span style="background:rgba(251,146,60,.2);color:#fb923c;font-size:.65rem;padding:2px 6px;border-radius:6px;font-weight:700;">Histórico</span>
                </div>
                <div style="font-size:.74rem;color:#fed7aa;font-weight:600;margin-top:4px;">🔴 En ≥2 Facturas Timbradas</div>
                <div style="font-size:.68rem;color:#94a3b8;margin-top:2px;">Duplicados detectados en el Excel SAT</div>
            </div>
        </div>

        <!-- Toolbar con Buscador y Filtros -->
        <div style="background:rgba(255,255,255,.03);border:1px solid rgba(255,255,255,.08);border-radius:12px;padding:.9rem;display:flex;flex-direction:column;gap:.75rem;">
            <div style="display:flex;gap:.75rem;flex-wrap:wrap;align-items:center;">
                <!-- Buscador -->
                <div style="flex:2;min-width:240px;position:relative;">
                    <span style="position:absolute;left:10px;top:50%;transform:translateY(-50%);font-size:.85rem;color:#64748b;">🔍</span>
                    <input id="diag-search-input" type="text" placeholder="Buscar por ID Nota (ej. 9e2918fd), Cliente, Solicitud (#635, #599), Folio..."
                           value="${_diagSearchQuery}"
                           oninput="_diagOnSearch(this.value)"
                           style="width:100%;background:#090d16;border:1px solid rgba(255,255,255,.14);border-radius:8px;padding:.5rem .75rem .5rem 2.1rem;color:#fff;font-size:.82rem;outline:none;" />
                    ${_diagSearchQuery ? `<button onclick="_diagClearSearch()" style="position:absolute;right:8px;top:50%;transform:translateY(-50%);background:none;border:none;color:#94a3b8;cursor:pointer;font-size:.8rem;">✕</button>` : ''}
                </div>

                <!-- Filtro por Mes -->
                <div style="flex:1;min-width:180px;">
                    <select id="diag-month-select" onchange="_diagOnMonthChange(this.value)"
                            style="width:100%;background:#090d16;border:1px solid rgba(245,158,11,.3);border-radius:8px;padding:.5rem .75rem;color:#fbbf24;font-size:.82rem;font-weight:600;outline:none;cursor:pointer;">
                        ${monthOptions}
                    </select>
                </div>

                <!-- Botones de Exportar -->
                <div style="display:flex;gap:.5rem;align-items:center;">
                    <button onclick="_diagExportFilteredCSV()" class="btn btn-sm" style="background:linear-gradient(135deg, #059669 0%, #10b981 100%);color:#fff;border:none;padding:.45rem .85rem;border-radius:8px;font-size:.74rem;font-weight:700;display:flex;align-items:center;gap:.35rem;cursor:pointer;">
                        📥 CSV Filtrado
                    </button>
                    <button onclick="_diagExportCSV('all')" class="btn btn-outline btn-sm" style="border-color:rgba(255,255,255,.2);color:#94a3b8;padding:.45rem .75rem;border-radius:8px;font-size:.74rem;cursor:pointer;">
                        📥 CSV Todo
                    </button>
                </div>
            </div>

            <!-- Tabs de Tipo de Conflicto -->
            <div style="display:flex;gap:.4rem;flex-wrap:wrap;border-top:1px solid rgba(255,255,255,.06);padding-top:.6rem;">
                ${_diagRenderTabBtn('all', `Todas (${d.masterItems.length})`)}
                ${_diagRenderTabBtn('huerfana', `⚡ CFDI Activo vs Global (${d.dupsHuerfanas.length})`, '#ec4899')}
                ${_diagRenderTabBtn('pendFact', `🚨 Pendientes en Riesgo (${d.dupsPendFact.length})`, '#f87171')}
                ${_diagRenderTabBtn('pendPend', `⚠️ En ≥2 Pendientes (${d.dupsPendPend.length})`, '#fbbf24')}
                ${_diagRenderTabBtn('historico', `🔴 Históricas (${d.dupsHistorico.length})`, '#fb923c')}
            </div>
        </div>

        <!-- Tabla de Resultados -->
        <div id="diag-results-container"></div>
    `;

    // Sincronizar selección de mes si ya había uno seleccionado
    const mSel = document.getElementById('diag-month-select');
    if (mSel && _diagSelectedMonth) mSel.value = _diagSelectedMonth;

    _diagRenderTable();
}

function _diagRenderTabBtn(tabId, label, accentColor = '#38bdf8') {
    const isActive = _diagActiveTab === tabId;
    const bg = isActive ? (tabId === 'all' ? '#3b82f6' : accentColor) : 'rgba(255,255,255,.05)';
    const color = isActive ? '#fff' : '#94a3b8';
    const border = isActive ? 'transparent' : 'rgba(255,255,255,.08)';
    return `<button onclick="_diagSelectTab('${tabId}')" style="background:${bg};color:${color};border:1px solid ${border};padding:.3rem .75rem;border-radius:20px;font-size:.72rem;font-weight:${isActive?700:500};cursor:pointer;transition:all .15s ease;">${label}</button>`;
}

function _diagSelectTab(tabId) {
    _diagActiveTab = tabId;
    _diagCurrentPage = 0;
    _diagRenderFullUI();
}

function _diagOnSearch(val) {
    _diagSearchQuery = (val || '').trim().toLowerCase();
    _diagCurrentPage = 0;
    _diagRenderTable();
}

function _diagClearSearch() {
    _diagSearchQuery = '';
    const inp = document.getElementById('diag-search-input');
    if (inp) inp.value = '';
    _diagCurrentPage = 0;
    _diagRenderTable();
}

function _diagOnMonthChange(val) {
    _diagSelectedMonth = val || 'all';
    _diagCurrentPage = 0;
    _diagRenderTable();
}

// ── Filtrado y renderizado reactivo de la tabla ──
function _diagGetFilteredItems() {
    const d = window._diagMaster;
    if (!d) return [];

    return d.masterItems.filter(item => {
        // 1. Filtro por Tab
        if (_diagActiveTab !== 'all' && item.tipo !== _diagActiveTab) return false;

        // 2. Filtro por Mes
        if (_diagSelectedMonth !== 'all' && item.mes !== _diagSelectedMonth) return false;

        // 3. Filtro por Buscador
        if (_diagSearchQuery && !item.searchText.includes(_diagSearchQuery)) return false;

        return true;
    });
}

function _diagRenderTable() {
    const container = document.getElementById('diag-results-container');
    if (!container) return;

    const filtered = _diagGetFilteredItems();
    window._diagCurrentFiltered = filtered;

    if (!filtered.length) {
        container.innerHTML = `
            <div style="text-align:center;padding:2.5rem 1rem;background:rgba(255,255,255,.02);border:1px dashed rgba(255,255,255,.1);border-radius:12px;color:#94a3b8;font-size:.82rem;">
                <div style="font-size:1.8rem;margin-bottom:.5rem;">🔍</div>
                <div style="font-weight:600;color:#e2e8f0;">No se encontraron notas con los filtros actuales</div>
                <div style="font-size:.74rem;color:#64748b;margin-top:3px;">Prueba ajustando el mes o limpiando el texto de búsqueda.</div>
            </div>`;
        return;
    }

    const totalPages = Math.ceil(filtered.length / _DIAG_PAGE_SIZE) || 1;
    if (_diagCurrentPage >= totalPages) _diagCurrentPage = totalPages - 1;
    if (_diagCurrentPage < 0) _diagCurrentPage = 0;

    const pageItems = filtered.slice(_diagCurrentPage * _DIAG_PAGE_SIZE, (_diagCurrentPage + 1) * _DIAG_PAGE_SIZE);

    const fmtBadgeSol = (sol_id, nn, labelExtra, color = '251,146,60') => {
        return `<span style="background:rgba(${color},.15);color:rgba(${color.replace(/\d+/g,m=>Math.min(255,+m+60))},1);border:1px solid rgba(${color},.35);font-size:.65rem;padding:2px 7px;border-radius:6px;font-weight:700;white-space:nowrap;display:inline-block;margin:1px;">
            Sol #${sol_id}${nn ? ' · ' + String(nn).substring(0,25) : ''}${labelExtra ? ' · ' + labelExtra : ''}
        </span>`;
    };

    let rowsHtml = '';
    for (const item of pageItems) {
        const fechaFmt = item.fecha ? item.fecha.split('-').reverse().join('/') : '—';
        const totalFmt = '$' + item.total.toLocaleString('es-MX', { minimumFractionDigits: 2 });
        
        let badges = '';
        if (item.tipo === 'huerfana') {
            const h = item.itemData;
            badges = h.solsHuerfanas.map(s => fmtBadgeSol(s.sol_id, s.numero_nota, 'CFDI ACTIVO SAT', '236,72,153')).join(' ') + ' ' +
                     h.solsTimbradas.map(s => fmtBadgeSol(s.sol_id, s.numero_nota, 'GLOBAL TIMBRADA', '251,146,60')).join(' ');
        } else if (item.tipo === 'pendFact') {
            const pf = item.itemData;
            badges = pf.pendSols.map(s => fmtBadgeSol(s.sol_id, s.numero_nota, 'PENDIENTE', '239,68,68')).join(' ') + ' ' +
                     pf.timbSols.map(s => fmtBadgeSol(s.sol_id, s.numero_nota, 'YA FACTURADA', '245,158,11')).join(' ');
        } else if (item.tipo === 'pendPend') {
            badges = item.itemData.pendSols.map(s => fmtBadgeSol(s.sol_id, s.numero_nota, 'PENDIENTE', '245,158,11')).join(' ');
        } else {
            badges = item.itemData.sols.map(s => fmtBadgeSol(s.sol_id, s.numero_nota, '', '251,146,60')).join(' ');
        }

        rowsHtml += `
            <tr style="border-bottom:1px solid rgba(255,255,255,.05);transition:background .15s ease;" onmouseover="this.style.background='rgba(255,255,255,.03)'" onmouseout="this.style.background='transparent'">
                <td style="padding:.6rem .65rem;font-family:monospace;font-size:.74rem;">
                    <div style="display:flex;align-items:center;gap:.4rem;">
                        <span style="color:#a5b4fc;cursor:pointer;font-weight:600;" onclick="_diagCopyId('${item.notaId}')" title="Clic para copiar ID completo">
                            ${item.notaId.substring(0,18)}… 📋
                        </span>
                    </div>
                </td>
                <td style="padding:.6rem .65rem;font-size:.78rem;color:#f1f5f9;font-weight:500;">
                    ${item.cliente}
                </td>
                <td style="padding:.6rem .65rem;font-size:.74rem;color:#94a3b8;white-space:nowrap;">
                    ${fechaFmt}
                </td>
                <td style="padding:.6rem .65rem;font-size:.78rem;font-weight:700;color:#34d399;text-align:right;white-space:nowrap;">
                    ${totalFmt}
                </td>
                <td style="padding:.6rem .65rem;">
                    <span style="font-size:.65rem;font-weight:700;color:${item.tipoColor};background:rgba(255,255,255,.04);padding:2px 6px;border-radius:4px;border:1px solid rgba(255,255,255,.08);margin-right:4px;">
                        ${item.tipoLabel}
                    </span>
                    <div style="margin-top:3px;">${badges}</div>
                </td>
                <td style="padding:.6rem .65rem;text-align:center;white-space:nowrap;">
                    <button onclick="_diagVerDetalles('${item.key}')" class="btn btn-sm" style="background:rgba(99,102,241,.2);color:#c7d2fe;border:1px solid rgba(99,102,241,.4);padding:.3rem .75rem;border-radius:7px;font-size:.72rem;font-weight:600;cursor:pointer;display:inline-flex;align-items:center;gap:.35rem;transition:all .15s ease;" onmouseover="this.style.background='rgba(99,102,241,.35)';this.style.color='#fff';" onmouseout="this.style.background='rgba(99,102,241,.2)';this.style.color='#c7d2fe';" title="Ver comparativa completa de la venta vs solicitudes fiscales">
                        🔍 Ver Detalles
                    </button>
                </td>
            </tr>`;
    }

    container.innerHTML = `
        <div style="background:rgba(15,23,42,.6);border:1px solid rgba(255,255,255,.08);border-radius:12px;overflow:hidden;">
            <div style="overflow-x:auto;">
                <table style="width:100%;border-collapse:collapse;text-align:left;">
                    <thead>
                        <tr style="background:rgba(255,255,255,.03);color:#94a3b8;font-size:.72rem;text-transform:uppercase;letter-spacing:.03em;border-bottom:1px solid rgba(255,255,255,.08);">
                            <th style="padding:.6rem .65rem;">ID Nota</th>
                            <th style="padding:.6rem .65rem;">Cliente</th>
                            <th style="padding:.6rem .65rem;">Fecha</th>
                            <th style="padding:.6rem .65rem;text-align:right;">Total</th>
                            <th style="padding:.6rem .65rem;">Aparece en / Conflicto</th>
                            <th style="padding:.6rem .65rem;text-align:center;">Acción</th>
                        </tr>
                    </thead>
                    <tbody>${rowsHtml}</tbody>
                </table>
            </div>

            <!-- Paginación -->
            <div style="display:flex;justify-content:space-between;align-items:center;padding:.7rem 1rem;background:rgba(255,255,255,.02);border-top:1px solid rgba(255,255,255,.06);font-size:.74rem;">
                <button onclick="_diagNavPage(-1)" ${_diagCurrentPage === 0 ? 'disabled' : ''} class="btn btn-outline btn-sm" style="font-size:.7rem;padding:.25rem .7rem;border-radius:6px;color:#cbd5e1;cursor:${_diagCurrentPage === 0 ? 'not-allowed' : 'pointer'};opacity:${_diagCurrentPage === 0 ? '.4' : '1'};">
                    ◀ Anterior
                </button>
                <span style="color:#94a3b8;">
                    Página <b style="color:#fbbf24;">${_diagCurrentPage + 1}</b> de <b>${totalPages}</b> — <b style="color:#fff;">${filtered.length}</b> registros encontrados
                </span>
                <button onclick="_diagNavPage(1)" ${_diagCurrentPage >= totalPages - 1 ? 'disabled' : ''} class="btn btn-outline btn-sm" style="font-size:.7rem;padding:.25rem .7rem;border-radius:6px;color:#cbd5e1;cursor:${_diagCurrentPage >= totalPages - 1 ? 'not-allowed' : 'pointer'};opacity:${_diagCurrentPage >= totalPages - 1 ? '.4' : '1'};">
                    Siguiente ▶
                </button>
            </div>
        </div>`;
}

function _diagNavPage(delta) {
    _diagCurrentPage += delta;
    _diagRenderTable();
}

function _diagCopyId(id) {
    navigator.clipboard.writeText(id).then(() => {
        if (typeof BO_AUTH !== 'undefined' && BO_AUTH.showAlert) {
            BO_AUTH.showAlert(`📋 ID copiado al portapapeles: ${id}`, 'info');
        } else {
            alert(`📋 ID copiado: ${id}`);
        }
    });
}

async function _diagVerDetalles(itemKey) {
    const prevModal = document.getElementById('modal-diag-comparativa');
    if (prevModal) prevModal.remove();

    const master = window._diagMaster;
    let item = (master?.masterItems || []).find(it => it.key === itemKey);
    if (!item) {
        item = (master?.masterItems || []).find(it => it.notaId === itemKey);
    }
    if (!item) {
        alert('No se encontró la información de esta nota en el diagnóstico.');
        return;
    }

    const overlay = document.createElement('div');
    overlay.id = 'modal-diag-comparativa';
    overlay.style.cssText = 'position:fixed;inset:0;background:rgba(5,8,22,.88);backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px);z-index:100010;display:flex;align-items:center;justify-content:center;padding:1.2rem;overflow:hidden;';
    overlay.onclick = (e) => { if (e.target === overlay) overlay.remove(); };

    overlay.innerHTML = `
        <div style="background:linear-gradient(145deg, #131d31 0%, #0d1527 100%);border-radius:18px;border:1px solid rgba(99,102,241,.4);box-shadow:0 35px 80px rgba(0,0,0,.85), 0 0 35px rgba(99,102,241,.2);width:100%;max-width:1150px;height:90vh;max-height:90vh;display:flex;flex-direction:column;overflow:hidden;animation:diagFadeIn .2s ease-out;color:#e2e8f0;font-family:system-ui,-apple-system,sans-serif;">
            <!-- Header -->
            <div style="display:flex;justify-content:space-between;align-items:center;padding:1.1rem 1.6rem;border-bottom:1px solid rgba(255,255,255,.08);background:rgba(255,255,255,.02);flex-shrink:0;">
                <div style="display:flex;align-items:center;gap:.75rem;">
                    <div style="width:38px;height:38px;border-radius:10px;background:rgba(99,102,241,.2);border:1px solid rgba(99,102,241,.35);display:flex;align-items:center;justify-content:center;font-size:1.2rem;">
                        ⚖️
                    </div>
                    <div>
                        <div style="display:flex;align-items:center;gap:.6rem;flex-wrap:wrap;">
                            <h3 style="margin:0;color:#fff;font-size:1.15rem;font-weight:700;">Comparativa & Auditoría Fiscal de Nota</h3>
                            <span style="background:${item.tipoColor}22;color:${item.tipoColor};border:1px solid ${item.tipoColor}55;font-size:.68rem;padding:2px 8px;border-radius:12px;font-weight:700;">
                                ${item.tipoLabel}
                            </span>
                        </div>
                        <div style="font-size:.74rem;color:#94a3b8;margin-top:2px;">
                            Cotejo entre la venta original registrada en el sistema y las facturas/CFDIs emitidos o solicitados ante el SAT.
                        </div>
                    </div>
                </div>
                <button onclick="document.getElementById('modal-diag-comparativa').remove()" style="background:rgba(255,255,255,.06);border:1px solid rgba(255,255,255,.12);color:#94a3b8;cursor:pointer;font-size:1.1rem;width:34px;height:34px;border-radius:50%;display:flex;align-items:center;justify-content:center;transition:all .15s ease;" onmouseover="this.style.color='#fff';this.style.background='rgba(239,68,68,.25)'" onmouseout="this.style.color='#94a3b8';this.style.background='rgba(255,255,255,.06)'">✕</button>
            </div>

            <!-- Body (Scrollable Container) -->
            <div id="diag-comp-body" style="padding:1.4rem;overflow-y:auto;overflow-x:hidden;flex:1;min-height:0;box-sizing:border-box;width:100%;display:block;">
                <div style="padding:3.5rem 1rem;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:1rem;color:#94a3b8;">
                    <div style="font-size:2.2rem;animation:spin 1s linear infinite;">⏳</div>
                    <div style="font-size:.88rem;color:#cbd5e1;">Consultando venta original, desglose de piezas y expedientes en SAT/Facturama...</div>
                </div>
            </div>

            <!-- Footer (Fixed) -->
            <div style="padding:.75rem 1.4rem;background:rgba(10,15,28,.95);border-top:1px solid rgba(255,255,255,.08);display:flex;justify-content:space-between;align-items:center;flex-shrink:0;">
                <span style="font-size:.74rem;color:#94a3b8;">
                    💡 Desplaza hacia abajo para revisar todos los datos de la nota y las solicitudes encontradas.
                </span>
                <button onclick="document.getElementById('modal-diag-comparativa').remove()" class="btn btn-outline btn-sm" style="padding:.35rem 1.1rem;border-radius:8px;font-size:.75rem;font-weight:600;color:#cbd5e1;cursor:pointer;">
                    ✕ Cerrar
                </button>
            </div>
        </div>
    `;

    document.body.appendChild(overlay);

    const onEsc = (e) => {
        if (e.key === 'Escape') {
            const m = document.getElementById('modal-diag-comparativa');
            if (m) m.remove();
            document.removeEventListener('keydown', onEsc);
        }
    };
    document.addEventListener('keydown', onEsc);

    try {
        const solIds = new Set();
        if (item.tipo === 'huerfana') {
            (item.itemData.solsHuerfanas || []).forEach(s => s.sol_id && solIds.add(Number(s.sol_id)));
            (item.itemData.solsTimbradas || []).forEach(s => s.sol_id && solIds.add(Number(s.sol_id)));
            (item.itemData.solsPendientes || []).forEach(s => s.sol_id && solIds.add(Number(s.sol_id)));
        } else if (item.tipo === 'pendFact') {
            (item.itemData.pendSols || []).forEach(s => s.sol_id && solIds.add(Number(s.sol_id)));
            (item.itemData.timbSols || []).forEach(s => s.sol_id && solIds.add(Number(s.sol_id)));
        } else if (item.tipo === 'pendPend') {
            (item.itemData.pendSols || []).forEach(s => s.sol_id && solIds.add(Number(s.sol_id)));
        } else if (item.tipo === 'historico') {
            (item.itemData.sols || []).forEach(s => s.sol_id && solIds.add(Number(s.sol_id)));
        }

        const solIdsList = [...solIds].filter(Boolean).map(id => Number(id)).filter(id => !isNaN(id)).join(',');

        let venta = null;
        try {
            const vRes = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                sql: `SELECT v.*,
                             c.registro AS cliente_registro,
                             COALESCE(c.nombre || ' ' || COALESCE(c.ape_p,''), 'Público General') AS cliente_nombre,
                             c.telefono AS cliente_tel,
                             c.email AS cliente_email,
                             c.rfc AS cliente_rfc,
                             c.razon_social AS cliente_rs
                      FROM venta v
                      LEFT JOIN cliente c ON c.id::text = v.cliente_id::text
                      WHERE v.id::text = '${item.notaId}'
                      LIMIT 1`
            });
            venta = vRes.rows && vRes.rows[0] ? vRes.rows[0] : null;
        } catch(ve) {
            console.warn('[DIAG VENTA QUERY WITH JOIN]', ve);
        }

        if (!venta) {
            try {
                const vResSimple = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                    sql: `SELECT v.* FROM venta v WHERE v.id::text = '${item.notaId}' LIMIT 1`
                });
                venta = vResSimple.rows && vResSimple.rows[0] ? vResSimple.rows[0] : null;
                if (venta) {
                    venta.cliente_nombre = item.cliente || 'Público General';
                }
            } catch(ve2) {
                console.warn('[DIAG VENTA SIMPLE QUERY]', ve2);
            }
        }

        if (!venta) {
            venta = {
                id: item.notaId,
                cliente_nombre: item.cliente || 'Público General',
                fecha_venta: item.fecha,
                total: item.total,
                piezas: [],
                comentario: ''
            };
        }

        let sols = [];
        try {
            const sRes = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                sql: `SELECT f.*
                      FROM facturas_solicitadas f
                      WHERE (${solIdsList ? `f.id IN (${solIdsList}) OR ` : ''}
                             f.numero_nota = '${item.notaId}'
                             OR (f.ventas_ids IS NOT NULL AND f.ventas_ids::text LIKE '%${item.notaId}%'))
                      ORDER BY f.id ASC`
            });
            sols = sRes.rows || [];
        } catch(se) {
            console.warn('[DIAG SOLS QUERY]', se);
        }

        // Fallback de solicitudes desde itemData si la consulta directa no trajo filas
        if (sols.length === 0 && item.itemData) {
            const listH = item.itemData.solsHuerfanas || [];
            const listT = item.itemData.solsTimbradas || [];
            const listP = item.itemData.pendSols || [];
            const listS = item.itemData.sols || [];
            const combined = [...listH, ...listT, ...listP, ...listS];
            if (combined.length > 0) {
                const unique = [...new Map(combined.map(s => [s.sol_id, s])).values()];
                sols = unique.map(s => ({
                    id: s.sol_id,
                    numero_nota: s.numero_nota,
                    cfdi_id: s.cfdi_id || s.cfdi_uuid,
                    cfdi_uuid: s.cfdi_uuid || s.cfdi_id,
                    estado: s.estado || 'facturada',
                    rfc: s.rfc,
                    razon_social: s.razon_social,
                    creado_en: s.creado_en
                }));
            }
        }

        // Cargar catálogo de productos de BD si no está en caché
        if (!window._diagProductosCatalog || window._diagProductosCatalog.length === 0) {
            try {
                const prodRes = await BO_API.post('/bo/sql-relay', {
                    secret: 'duletia_relay_2026',
                    sql: 'SELECT id, sku, nombre FROM productos ORDER BY id ASC'
                });
                if (prodRes && prodRes.rows) {
                    window._diagProductosCatalog = prodRes.rows;
                }
            } catch(pe) {
                console.warn('[DIAG PROD CATALOG QUERY]', pe);
            }
        }

        // Función para resolver el nombre amigable del producto
        const _diagResolverNombreProducto = (pz) => {
            const sSku = String(pz.sku || '').trim().toUpperCase();
            const sPid = String(pz.producto_id || '').trim();
            const sNom = String(pz.nombre || pz.producto || '').trim();

            const limpiar = (txt) => String(txt || '').replace(/[\s-]+(Pub|MC|Dist)\b/gi, '').trim();

            // 1. Mapeo directo en el catálogo de base de datos
            const dbList = window._diagProductosCatalog || window.PRODUCTOS_DB_CACHE || [];
            if (dbList.length > 0) {
                const match = dbList.find(p => 
                    (sSku && String(p.sku || '').trim().toUpperCase() === sSku) ||
                    (sPid && String(p.id || '').trim() === sPid) ||
                    (sNom && String(p.sku || '').trim().toUpperCase() === sNom.toUpperCase())
                );
                if (match && match.nombre) {
                    return limpiar(match.nombre);
                }
            }

            // 2. Diccionario canónico de SKUs oficiales de Duletia
            const skuMap = {
                'SUERO-MNT9XH1Q-NBF': 'Dulet Fresa',
                'SUERO-MNTA7VLE-D54': 'Dulet Vainilla',
                'SUERO-MNJ2LPS3-5XP': 'Dulet Natural',
                'SUERO-MNTA8DF4-7Q9': 'Dulet Chocolate',
                'SUERO-MNTAGQ1K-OM2': 'Dulet Chocolate',
                'SUERO-MNJGOA4R-MWL': 'Dulet Natural',
                'ESENCIA-EUCAMENT-DIST': 'Eucament',
                'ESENCIA-EUCAMENT-PUB': 'Eucament',
                'ESENCIA-EUCAMENT-MC': 'Eucament',
                'EUCAMENT': 'Eucament',
                'FRESA': 'Dulet Fresa',
                'VAINILLA': 'Dulet Vainilla',
                'CHOCO': 'Dulet Chocolate',
                'NATURAL': 'Dulet Natural'
            };
            if (skuMap[sSku]) return skuMap[sSku];
            if (skuMap[sNom.toUpperCase()]) return skuMap[sNom.toUpperCase()];

            // 3. INV_PRODUCTOS o PRODUCTOS_CAT si existen en el entorno
            if (typeof INV_PRODUCTOS !== 'undefined' && Array.isArray(INV_PRODUCTOS)) {
                const invMatch = INV_PRODUCTOS.find(p => 
                    (sSku && (p.sku === sSku || p.id === sSku.toLowerCase())) ||
                    (sPid && (String(p.id) === sPid || String(p.producto_id) === sPid))
                );
                if (invMatch && invMatch.nombre) return limpiar(invMatch.nombre);
            }

            // 4. Si el nombre existente no parece un SKU en código crudo
            if (sNom && !sNom.startsWith('SUERO-') && !sNom.startsWith('ESENCIA-') && sNom.length > 2) {
                return limpiar(sNom);
            }

            // 5. Inferencia por palabras clave
            const lower = (sNom + ' ' + sSku).toLowerCase();
            if (lower.includes('eucament')) return 'Eucament';
            if (lower.includes('fresa')) return 'Dulet Fresa';
            if (lower.includes('vainilla')) return 'Dulet Vainilla';
            if (lower.includes('choco')) return 'Dulet Chocolate';
            if (lower.includes('natural')) return 'Dulet Natural';

            return sNom || sSku || 'Producto Duletia';
        };

        const bodyEl = document.getElementById('diag-comp-body');
        if (!bodyEl) return;

        let piezasArr = [];
        if (venta.piezas) {
            if (typeof venta.piezas === 'string') {
                try { piezasArr = JSON.parse(venta.piezas); } catch(_) { piezasArr = []; }
            } else if (Array.isArray(venta.piezas)) {
                piezasArr = venta.piezas;
            }
        }

        const fechaVentaStr = venta.fecha_venta ? String(venta.fecha_venta).slice(0, 10).split('-').reverse().join('/') : '—';
        const totalVentaFmt = '$' + Number(venta.total || 0).toLocaleString('es-MX', { minimumFractionDigits: 2 });

        const comentRaw = String(venta.comentario || '');
        const comentClean = comentRaw.split('||').map(s => s.trim()).filter(s => s && !s.startsWith('[RESTORE-UUID')).join(' · ');

        let alertaConflictoHtml = '';
        if (item.tipo === 'huerfana') {
            alertaConflictoHtml = `
                <div style="background:rgba(236,72,153,.1);border:1px solid rgba(236,72,153,.35);border-radius:12px;padding:1rem 1.2rem;display:flex;gap:.9rem;align-items:flex-start;">
                    <span style="font-size:1.6rem;line-height:1;">⚡</span>
                    <div style="font-size:.82rem;line-height:1.45;">
                        <div style="font-weight:700;color:#f472b6;font-size:.88rem;margin-bottom:.2rem;">
                            DOBLE TIMBRADO FISCAL ACTIVO ANTE EL SAT (CFDI Huérfano vs Factura Global)
                        </div>
                        <div style="color:#fbcfe8;">
                            Esta nota cuenta con un <b>CFDI Individual emitido y timbrado ante el SAT</b> que continúa <b>VIGENTE</b> (aunque en la base local figure como cancelada porque no se solicitó la cancelación ante el SAT al rechazarla), y posteriormente fue absorbida y timbrada de nuevo dentro de la <b>Factura Global</b>.
                        </div>
                        <div style="margin-top:.45rem;color:#fdf2f8;font-weight:600;font-size:.76rem;">
                            ⚠️ Acción requerida: Se debe cancelar ante el SAT uno de los dos CFDIs para evitar duplicidad de ingresos acumulables ante Hacienda.
                        </div>
                    </div>
                </div>`;
        } else if (item.tipo === 'pendFact') {
            alertaConflictoHtml = `
                <div style="background:rgba(239,68,68,.1);border:1px solid rgba(239,68,68,.35);border-radius:12px;padding:1rem 1.2rem;display:flex;gap:.9rem;align-items:flex-start;">
                    <span style="font-size:1.6rem;line-height:1;">🚨</span>
                    <div style="font-size:.82rem;line-height:1.45;">
                        <div style="font-weight:700;color:#f87171;font-size:.88rem;margin-bottom:.2rem;">
                            RIESGO INMINENTE DE DUPLICIDAD: NOTA YA FACTURADA ASIGNADA A SOLICITUD PENDIENTE
                        </div>
                        <div style="color:#fecaca;">
                            Esta nota ya fue timbrada previamente ante el SAT. Sin embargo, actualmente se encuentra asignada a una solicitud pendiente de timbrar. Si se aprueba o timbra dicha solicitud, se generará una doble factura ante el SAT.
                        </div>
                    </div>
                </div>`;
        } else if (item.tipo === 'pendPend') {
            alertaConflictoHtml = `
                <div style="background:rgba(245,158,11,.1);border:1px solid rgba(245,158,11,.35);border-radius:12px;padding:1rem 1.2rem;display:flex;gap:.9rem;align-items:flex-start;">
                    <span style="font-size:1.6rem;line-height:1;">⚠️</span>
                    <div style="font-size:.82rem;line-height:1.45;">
                        <div style="font-weight:700;color:#fbbf24;font-size:.88rem;margin-bottom:.2rem;">
                            DUPLICIDAD EN SOLICITUDES PENDIENTES
                        </div>
                        <div style="color:#fef3c7;">
                            La nota aparece vinculada a dos o más solicitudes pendientes simultáneas. Debe depurarse o rechazarse una antes de procesar el timbrado.
                        </div>
                    </div>
                </div>`;
        } else {
            alertaConflictoHtml = `
                <div style="background:rgba(251,146,60,.1);border:1px solid rgba(251,146,60,.35);border-radius:12px;padding:1rem 1.2rem;display:flex;gap:.9rem;align-items:flex-start;">
                    <span style="font-size:1.6rem;line-height:1;">🔴</span>
                    <div style="font-size:.82rem;line-height:1.45;">
                        <div style="font-weight:700;color:#fb923c;font-size:.88rem;margin-bottom:.2rem;">
                            DOBLE FACTURACIÓN HISTÓRICA DETECTADA
                        </div>
                        <div style="color:#ffedd5;">
                            Esta nota se encuentra vinculada a dos o más solicitudes fiscales históricas timbradas en el sistema.
                        </div>
                    </div>
                </div>`;
        }

        let piezasRows = '';
        if (piezasArr.length > 0) {
            piezasRows = piezasArr.map(pz => {
                const cant = pz.cantidad || pz.cant || 1;
                const nombre = _diagResolverNombreProducto(pz);
                const pUnit = Number(pz.precio || pz.precio_unitario || 0);
                const sub = Number(pz.subtotal || pz.importe || (cant * pUnit) || 0);
                return `
                    <tr style="border-bottom:1px solid rgba(255,255,255,.05);font-size:.76rem;">
                        <td style="padding:.4rem .5rem;color:#cbd5e1;font-weight:600;text-align:center;">${cant}</td>
                        <td style="padding:.4rem .5rem;color:#fff;">
                            <span style="font-weight:600;color:#f1f5f9;">${nombre}</span>
                            ${pz.sku && pz.sku !== nombre ? `<span style="font-size:.64rem;color:#64748b;font-family:monospace;display:block;margin-top:1px;">${pz.sku}</span>` : ''}
                        </td>
                        <td style="padding:.4rem .5rem;color:#94a3b8;text-align:right;">$${pUnit.toLocaleString('es-MX', { minimumFractionDigits: 2 })}</td>
                        <td style="padding:.4rem .5rem;color:#34d399;font-weight:700;text-align:right;">$${sub.toLocaleString('es-MX', { minimumFractionDigits: 2 })}</td>
                    </tr>`;
            }).join('');
        } else {
            piezasRows = `<tr><td colspan="4" style="text-align:center;padding:.8rem;color:#64748b;font-size:.74rem;">Sin desglose de productos registrado</td></tr>`;
        }

        let solsCardsHtml = '';
        if (sols.length === 0) {
            solsCardsHtml = `
                <div style="background:rgba(255,255,255,.02);border:1px dashed rgba(255,255,255,.1);border-radius:12px;padding:1.5rem;text-align:center;color:#94a3b8;font-size:.8rem;">
                    No se encontraron registros en <code>facturas_solicitadas</code> asociados a esta nota.
                </div>`;
        } else {
            solsCardsHtml = sols.map(sol => {
                const isGlobal = sol.tipo_factura === 'global' || String(sol.numero_nota || '').startsWith('GLOBAL');
                const tieneCfdi = Boolean(sol.cfdi_id || sol.cfdi_uuid);
                const tieneCancelacion = Boolean(sol.fecha_cancelacion);
                const rawTotal = Number(sol.total || sol.monto_facturable || 0);
                const solTotalFmt = rawTotal > 0 
                    ? '$' + rawTotal.toLocaleString('es-MX', { minimumFractionDigits: 2 }) 
                    : (!isGlobal && Number(venta?.total || 0) > 0 
                        ? '$' + Number(venta.total).toLocaleString('es-MX', { minimumFractionDigits: 2 }) + ' (Monto de la nota)' 
                        : (isGlobal ? 'Monto acumulado del periodo' : '$0.00'));
                const fechaTimbre = sol.facturado_en || sol.creado_en ? String(sol.facturado_en || sol.creado_en).replace('T', ' ').slice(0, 19) : '—';
                const uuidDisplay = sol.cfdi_uuid || (sol.cfdi_id && String(sol.cfdi_id).length > 20 ? sol.cfdi_id : '') || sol.uuid || '';

                let satStatusBadge = '';
                if (tieneCfdi && !tieneCancelacion) {
                    if (sol.estado === 'cancelada') {
                        if (sol.uuid_sustitucion) {
                            satStatusBadge = `
                                <span style="background:rgba(59,130,246,.18);color:#93c5fd;border:1px solid rgba(59,130,246,.4);padding:3px 9px;border-radius:12px;font-size:.68rem;font-weight:700;display:inline-flex;align-items:center;gap:.3rem;">
                                    ⏳ CANCELACIÓN EN COLA SAT (Esperando réplica ~7m)
                                </span>`;
                        } else {
                            satStatusBadge = `
                                <span style="background:rgba(239,68,68,.18);color:#fca5a5;border:1px solid rgba(239,68,68,.4);padding:3px 9px;border-radius:12px;font-size:.68rem;font-weight:700;display:inline-flex;align-items:center;gap:.3rem;">
                                    ⚠️ CFDI VIGENTE EN SAT (Cancelada en BD local)
                                </span>`;
                        }
                    } else if (sol.estado === 'facturada') {
                        satStatusBadge = `
                            <span style="background:rgba(16,185,129,.18);color:#6ee7b7;border:1px solid rgba(16,185,129,.4);padding:3px 9px;border-radius:12px;font-size:.68rem;font-weight:700;display:inline-flex;align-items:center;gap:.3rem;">
                                ✅ CFDI VIGENTE EN SAT
                            </span>`;
                    } else {
                        satStatusBadge = `
                            <span style="background:rgba(245,158,11,.18);color:#fcd34d;border:1px solid rgba(245,158,11,.4);padding:3px 9px;border-radius:12px;font-size:.68rem;font-weight:700;">
                                ⚠️ CFDI EMITIDO (Estado: ${sol.estado})
                            </span>`;
                    }
                } else if (tieneCancelacion) {
                    satStatusBadge = `
                        <span style="background:rgba(148,163,184,.15);color:#cbd5e1;border:1px solid rgba(148,163,184,.3);padding:3px 9px;border-radius:12px;font-size:.68rem;">
                            🚫 CANCELADA ANTE EL SAT (${String(sol.fecha_cancelacion).slice(0,10)})
                        </span>`;
                } else {
                    satStatusBadge = `
                        <span style="background:rgba(245,158,11,.15);color:#fcd34d;border:1px solid rgba(245,158,11,.3);padding:3px 9px;border-radius:12px;font-size:.68rem;font-weight:700;">
                            ⏳ PENDIENTE DE TIMBRAR
                        </span>`;
                }

                let notasGlobalInfo = '';
                if (isGlobal && sol.ventas_ids) {
                    try {
                        const arrIds = JSON.parse(sol.ventas_ids);
                        notasGlobalInfo = `<span style="font-size:.7rem;color:#94a3b8;display:block;margin-top:2px;">(Factura global concentrada con ${arrIds.length} notas del periodo)</span>`;
                    } catch(_) {}
                }

                return `
                    <div style="background:rgba(15,23,42,.7);border:1px solid ${tieneCfdi && !tieneCancelacion ? 'rgba(99,102,241,.35)' : 'rgba(255,255,255,.08)'};border-radius:14px;padding:1.1rem;display:flex;flex-direction:column;gap:.75rem;box-shadow:0 8px 20px rgba(0,0,0,.35);">
                        <div style="display:flex;justify-content:space-between;align-items:flex-start;flex-wrap:wrap;gap:.5rem;border-bottom:1px solid rgba(255,255,255,.06);padding-bottom:.65rem;">
                            <div>
                                <div style="display:flex;align-items:center;gap:.5rem;">
                                    <span style="font-weight:800;font-size:.95rem;color:#f8fafc;">Solicitud #${sol.id}</span>
                                    <span style="background:${isGlobal ? 'rgba(251,146,60,.15)' : 'rgba(99,102,241,.15)'};color:${isGlobal ? '#fb923c' : '#a5b4fc'};border:1px solid ${isGlobal ? 'rgba(251,146,60,.3)' : 'rgba(99,102,241,.3)'};font-size:.68rem;font-weight:700;padding:2px 7px;border-radius:6px;">
                                        ${isGlobal ? '🌐 FACTURA GLOBAL' : '👤 INDIVIDUAL'}
                                    </span>
                                </div>
                                <div style="font-size:.74rem;color:#94a3b8;margin-top:2px;">
                                    Folio: <b style="color:#fff;">${sol.cfdi_serie ? sol.cfdi_serie + ' ' : ''}${sol.cfdi_folio || sol.numero_nota || '—'}</b>
                                </div>
                            </div>
                            <div>${satStatusBadge}</div>
                        </div>

                        <div style="display:grid;grid-template-columns:1fr 1fr;gap:.6rem;font-size:.76rem;">
                            <div>
                                <span style="color:#64748b;display:block;font-size:.68rem;text-transform:uppercase;">Receptor</span>
                                <b style="color:#e2e8f0;">${sol.razon_social || 'PÚBLICO EN GENERAL'}</b>
                            </div>
                            <div>
                                <span style="color:#64748b;display:block;font-size:.68rem;text-transform:uppercase;">RFC</span>
                                <span style="font-family:monospace;color:#fbbf24;font-weight:700;">${sol.rfc || 'XAXX010101000'}</span>
                            </div>
                            <div>
                                <span style="color:#64748b;display:block;font-size:.68rem;text-transform:uppercase;">Régimen / Uso CFDI</span>
                                <span style="color:#cbd5e1;">${sol.regimen || sol.regimen_fiscal || '—'} · ${sol.uso_cfdi || '—'}</span>
                            </div>
                            <div>
                                <span style="color:#64748b;display:block;font-size:.68rem;text-transform:uppercase;">Total Solicitud</span>
                                <b style="color:#38bdf8;font-size:.86rem;">${solTotalFmt}</b>
                                ${notasGlobalInfo}
                            </div>
                        </div>

                        <div style="background:rgba(0,0,0,.25);border:1px solid rgba(255,255,255,.05);padding:.5rem .75rem;border-radius:8px;">
                            <div style="display:flex;justify-content:space-between;align-items:center;">
                                <span style="color:#64748b;font-size:.68rem;text-transform:uppercase;">UUID SAT (Folio Fiscal)</span>
                                ${uuidDisplay ? `<button onclick="_diagCopyId('${uuidDisplay}')" style="background:transparent;border:none;color:#94a3b8;cursor:pointer;font-size:.72rem;padding:0;" title="Copiar UUID">📋 Copiar</button>` : ''}
                            </div>
                            <div style="font-family:monospace;font-size:.74rem;color:#93c5fd;word-break:break-all;margin-top:2px;">
                                ${uuidDisplay || '<span style="color:#64748b;">Consultar UUID en Facturama (ID: ' + (sol.cfdi_id || sol.id) + ')</span>'}
                            </div>
                        </div>

                        <div style="display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:.5rem;margin-top:.2rem;">
                            <span style="font-size:.7rem;color:#64748b;">Fecha: ${fechaTimbre}</span>
                            <div style="display:flex;gap:.4rem;flex-wrap:wrap;">
                                ${tieneCfdi ? `
                                    <button onclick="descargarPDF('${sol.cfdi_id||''}','${sol.cfdi_uuid||''}','${sol.id}')" class="btn btn-sm" style="background:rgba(59,130,246,.2);color:#93c5fd;border:1px solid rgba(59,130,246,.4);padding:.28rem .7rem;border-radius:6px;font-size:.72rem;font-weight:600;cursor:pointer;display:inline-flex;align-items:center;gap:.3rem;">
                                        📄 Descargar PDF
                                    </button>
                                    <button onclick="descargarXML('${sol.cfdi_id||''}','${sol.cfdi_uuid||''}','${sol.id}')" class="btn btn-sm" style="background:rgba(16,185,129,.2);color:#6ee7b7;border:1px solid rgba(16,185,129,.4);padding:.28rem .7rem;border-radius:6px;font-size:.72rem;font-weight:600;cursor:pointer;display:inline-flex;align-items:center;gap:.3rem;">
                                        📥 Descargar XML
                                    </button>
                                ` : ''}
                            </div>
                        </div>
                    </div>`;
            }).join('');
        }

        bodyEl.innerHTML = `
            <div style="width:100%;display:flex;flex-direction:column;gap:1.2rem;box-sizing:border-box;">
                <!-- 1. Alerta de Diagnóstico del Conflicto -->
                ${alertaConflictoHtml}

                <!-- 2. Grid Comparativo: Venta Original vs Expediente Fiscal -->
                <div style="width:100%;display:grid;grid-template-columns: minmax(320px, 1fr) minmax(340px, 1.25fr);gap:1.2rem;align-items:start;box-sizing:border-box;">
                    
                    <!-- LADO IZQUIERDO: Venta Original (Nota Interna) -->
                    <div style="background:rgba(15,23,42,.6);border:1px solid rgba(255,255,255,.08);border-radius:14px;padding:1.2rem;display:flex;flex-direction:column;gap:1rem;">
                        <div style="display:flex;justify-content:space-between;align-items:center;border-bottom:1px solid rgba(255,255,255,.06);padding-bottom:.65rem;">
                            <div style="display:flex;align-items:center;gap:.5rem;">
                                <span style="font-size:1.1rem;">📦</span>
                                <div>
                                    <h4 style="margin:0;color:#fff;font-size:.95rem;font-weight:700;">Venta Original (Nota Interna)</h4>
                                    <div style="font-size:.7rem;color:#94a3b8;">Registro en base de datos del Backoffice</div>
                                </div>
                            </div>
                            <span style="font-family:monospace;font-size:.72rem;background:rgba(255,255,255,.05);padding:2px 6px;border-radius:4px;color:#a5b4fc;cursor:pointer;" onclick="_diagCopyId('${venta.id}')" title="Copiar ID completo">
                                ${venta.id.slice(0, 13)}… 📋
                            </span>
                        </div>

                        <!-- Info General de la Venta -->
                        <div style="display:grid;grid-template-columns:1fr 1fr;gap:.65rem;font-size:.76rem;">
                            <div>
                                <span style="color:#64748b;display:block;font-size:.68rem;text-transform:uppercase;">Cliente</span>
                                <b style="color:#f1f5f9;">${venta.cliente_nombre}</b>
                                <span style="font-size:.68rem;color:#94a3b8;display:block;">Reg #${venta.cliente_registro || '—'}</span>
                            </div>
                            <div>
                                <span style="color:#64748b;display:block;font-size:.68rem;text-transform:uppercase;">Total Nota</span>
                                <span style="color:#34d399;font-weight:800;font-size:1.1rem;">${totalVentaFmt}</span>
                            </div>
                            <div>
                                <span style="color:#64748b;display:block;font-size:.68rem;text-transform:uppercase;">Fecha Venta</span>
                                <span style="color:#cbd5e1;">${fechaVentaStr}</span>
                            </div>
                            <div>
                                <span style="color:#64748b;display:block;font-size:.68rem;text-transform:uppercase;">Método de Pago</span>
                                <span style="color:#cbd5e1;">${venta.metodo_pago || '—'}</span>
                            </div>
                            <div>
                                <span style="color:#64748b;display:block;font-size:.68rem;text-transform:uppercase;">Estado Venta</span>
                                <span style="color:#e2e8f0;font-weight:600;">${venta.estado || '—'}</span>
                            </div>
                            <div>
                                <span style="color:#64748b;display:block;font-size:.68rem;text-transform:uppercase;">Flags en BD</span>
                                <span style="font-size:.7rem;color:${venta.factura_emitida ? '#34d399' : '#94a3b8'};">
                                    Emitida: <b>${venta.factura_emitida ? 'Sí' : 'No'}</b>
                                </span>
                                <span style="font-size:.7rem;color:${venta.requiere_factura ? '#fbbf24' : '#64748b'};display:block;">
                                    Requiere Fac: <b>${venta.requiere_factura ? 'Sí' : 'No'}</b>
                                </span>
                            </div>
                        </div>

                        ${venta.cliente_rfc ? `
                            <div style="background:rgba(255,255,255,.02);border:1px solid rgba(255,255,255,.05);padding:.45rem .7rem;border-radius:6px;font-size:.74rem;">
                                <span style="color:#64748b;font-size:.68rem;text-transform:uppercase;display:block;">RFC en Perfil de Cliente</span>
                                <span style="font-family:monospace;color:#fbbf24;font-weight:700;">${venta.cliente_rfc}</span> — <span style="color:#cbd5e1;">${venta.cliente_rs || ''}</span>
                            </div>
                        ` : ''}

                        <!-- Desglose de Productos (Piezas) -->
                        <div>
                            <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:.4rem;">
                                <span style="font-weight:700;font-size:.76rem;color:#cbd5e1;text-transform:uppercase;letter-spacing:.02em;">
                                    📦 Desglose de Productos (${piezasArr.length} items)
                                </span>
                            </div>
                            <div style="background:rgba(0,0,0,.25);border:1px solid rgba(255,255,255,.05);border-radius:8px;overflow:hidden;">
                                <table style="width:100%;border-collapse:collapse;text-align:left;">
                                    <thead>
                                        <tr style="background:rgba(255,255,255,.04);color:#94a3b8;font-size:.68rem;text-transform:uppercase;">
                                            <th style="padding:.4rem .5rem;text-align:center;">Cant</th>
                                            <th style="padding:.4rem .5rem;">Producto</th>
                                            <th style="padding:.4rem .5rem;text-align:right;">P.Unit</th>
                                            <th style="padding:.4rem .5rem;text-align:right;">Importe</th>
                                        </tr>
                                    </thead>
                                    <tbody>${piezasRows}</tbody>
                                </table>
                            </div>
                        </div>

                        ${comentClean ? `
                            <div style="background:rgba(255,255,255,.02);border:1px solid rgba(255,255,255,.05);padding:.5rem .75rem;border-radius:8px;font-size:.73rem;color:#cbd5e1;">
                                <span style="color:#64748b;font-size:.66rem;text-transform:uppercase;display:block;margin-bottom:2px;">Comentario / Observaciones</span>
                                ${comentClean}
                            </div>
                        ` : ''}
                    </div>

                    <!-- LADO DERECHO: Solicitudes Fiscales (CFDIs emitidos o solicitados) -->
                    <div style="display:flex;flex-direction:column;gap:1rem;">
                        <div style="display:flex;justify-content:space-between;align-items:center;background:rgba(15,23,42,.6);border:1px solid rgba(255,255,255,.08);padding:.8rem 1.1rem;border-radius:12px;">
                            <div style="display:flex;align-items:center;gap:.5rem;">
                                <span style="font-size:1.1rem;">🏛️</span>
                                <div>
                                    <h4 style="margin:0;color:#fff;font-size:.95rem;font-weight:700;">Expediente Fiscal ante el SAT (${sols.length} registros)</h4>
                                    <div style="font-size:.7rem;color:#94a3b8;">Facturas generadas o pendientes en Facturama</div>
                                </div>
                            </div>
                        </div>

                        <!-- Lista de Tarjetas de Solicitudes -->
                        <div style="display:flex;flex-direction:column;gap:1rem;">
                            ${solsCardsHtml}
                        </div>
                    </div>

                </div>

            </div>
        `;

    } catch(err) {
        console.error('[DIAG VER DETALLES ERROR]', err);
        const bodyEl = document.getElementById('diag-comp-body');
        if (bodyEl) {
            bodyEl.innerHTML = `<div style="padding:1.5rem;color:#fca5a5;background:rgba(239,68,68,.12);border-radius:10px;border:1px solid rgba(239,68,68,.3);text-align:center;">
                ❌ Ocurrió un error al cargar la comparativa: ${err.message}
            </div>`;
        }
    }
}

// Compatibilidad con llamados anteriores
async function _diagVerNota(notaId) {
    return _diagVerDetalles(notaId);
}

window._diagVerDetalles = _diagVerDetalles;
window._diagVerNota = _diagVerNota;

// ── Exportaciones a CSV ──
function _diagExportFilteredCSV() {
    const filtered = window._diagCurrentFiltered || [];
    if (!filtered.length) {
        alert('No hay registros en la vista actual para exportar.');
        return;
    }

    const esc = (v) => `"${String(v ?? '').replace(/"/g, '""')}"`;
    const rows = [];
    rows.push(['Tipo_Conflicto','ID_Nota','Cliente','Fecha','Mes','Total','Aparece_En'].join(','));

    for (const item of filtered) {
        let solsStr = '';
        if (item.tipo === 'huerfana') {
            solsStr = item.itemData.solsHuerfanas.map(s => `CFDI_Activo: Sol #${s.sol_id} (${s.cfdi_id})`).join(' | ') + ' ; ' +
                      item.itemData.solsTimbradas.map(s => `Global: Sol #${s.sol_id} (${s.numero_nota})`).join(' | ');
        } else if (item.tipo === 'pendFact') {
            solsStr = item.itemData.pendSols.map(s => `Pend: Sol #${s.sol_id}`).join(' | ') + ' ; ' +
                      item.itemData.timbSols.map(s => `Fact: Sol #${s.sol_id} (${s.numero_nota})`).join(' | ');
        } else if (item.tipo === 'pendPend') {
            solsStr = item.itemData.pendSols.map(s => `Sol #${s.sol_id}`).join(' | ');
        } else {
            solsStr = item.itemData.sols.map(s => `Sol #${s.sol_id} (${s.numero_nota || ''})`).join(' | ');
        }

        rows.push([
            esc(item.tipoLabel),
            esc(item.notaId),
            esc(item.cliente),
            esc(item.fecha),
            esc(item.mes),
            item.total.toFixed(2),
            esc(solsStr)
        ].join(','));
    }

    const blob = new Blob(['\uFEFF' + rows.join('\n')], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `auditoria_fiscal_duplicados_filtrado_${new Date().toISOString().slice(0,10)}.csv`;
    a.click();
    URL.revokeObjectURL(url);
}

function _diagExportCSV(type) {
    const d = window._diagMaster;
    if (!d) return;

    const esc = (v) => `"${String(v ?? '').replace(/"/g, '""')}"`;
    const rows = [];
    rows.push(['Tipo','ID Nota','Cliente','Fecha','Total','Solicitud(es)'].join(','));

    for (const item of d.masterItems) {
        let solsStr = '';
        if (item.tipo === 'huerfana') {
            solsStr = item.itemData.solsHuerfanas.map(s => `CFDI_Activo: Sol #${s.sol_id}`).join(' | ') + ' ; ' +
                      item.itemData.solsTimbradas.map(s => `Global: Sol #${s.sol_id}`).join(' | ');
        } else if (item.tipo === 'pendFact') {
            solsStr = item.itemData.pendSols.map(s => `Pend: Sol #${s.sol_id}`).join(' | ') + ' ; ' +
                      item.itemData.timbSols.map(s => `Fact: Sol #${s.sol_id}`).join(' | ');
        } else if (item.tipo === 'pendPend') {
            solsStr = item.itemData.pendSols.map(s => `Sol #${s.sol_id}`).join(' | ');
        } else {
            solsStr = item.itemData.sols.map(s => `Sol #${s.sol_id} (${s.numero_nota || ''})`).join(' | ');
        }

        rows.push([
            esc(item.tipoLabel),
            esc(item.notaId),
            esc(item.cliente),
            esc(item.fecha),
            item.total.toFixed(2),
            esc(solsStr)
        ].join(','));
    }

    const blob = new Blob(['\uFEFF' + rows.join('\n')], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `auditoria_fiscal_duplicados_completo_${new Date().toISOString().slice(0,10)}.csv`;
    a.click();
    URL.revokeObjectURL(url);
}

// ── Exportar CSV de Notas Pendientes de Facturación Global (Master y Contabilidad) ──
function _esRolPermitidoCsvGlobal() {
    const user = (typeof BO_AUTH !== 'undefined' && BO_AUTH.getUser ? BO_AUTH.getUser() : null) || window.CURRENT_USER;
    const r = (user?.rol || '').toLowerCase().replace(/ /g, '_').trim();
    const normalizedRol = r === 'administrador' ? 'admin' : r;
    return normalizedRol === 'master' || normalizedRol === 'contabilidad' || normalizedRol === 'admin';
}

function _actualizarVisibilidadBotonCsvGlobal() {
    const btn = document.getElementById('btnExportarCsvGlobal');
    if (btn) {
        btn.style.display = _esRolPermitidoCsvGlobal() ? 'inline-flex' : 'none';
    }
}
window._actualizarVisibilidadBotonCsvGlobal = _actualizarVisibilidadBotonCsvGlobal;

async function exportarCsvFacturaGlobal() {
    if (!_esRolPermitidoCsvGlobal()) {
        if (typeof BO_AUTH !== 'undefined' && BO_AUTH.showAlert) {
            BO_AUTH.showAlert('🚫 Permiso denegado: Esta función es exclusiva para Contabilidad y Dirección Máster.', 'warning');
        } else {
            alert('Permiso denegado: Función exclusiva para Contabilidad y Máster.');
        }
        return;
    }

    if (!window._borradorData || window._borradorData.length === 0) {
        if (typeof loadFacturaGlobal === 'function') {
            if (typeof BO_AUTH !== 'undefined' && BO_AUTH.showAlert) {
                BO_AUTH.showAlert('⏳ Cargando notas pendientes para exportar...', 'info');
            }
            await loadFacturaGlobal();
        }
    }

    const allNotas = window._borradorData || [];
    if (allNotas.length === 0) {
        if (typeof BO_AUTH !== 'undefined' && BO_AUTH.showAlert) {
            BO_AUTH.showAlert('ℹ️ No hay notas pendientes por facturar en este periodo.', 'info');
        }
        return;
    }

    // Si hay búsqueda activa en el input, filtrar según la búsqueda
    const _normAccent = s => (s||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const q = (document.getElementById('fg-search')?.value || '').trim();
    const qNorm = _normAccent(q);
    const notas = qNorm
        ? allNotas.filter(t => {
            const idMatch = _normAccent(t.id).includes(qNorm);
            const clienteMatch = _normAccent(t.cliente_nombre).includes(qNorm);
            const fechaMatch = (t.fecha_venta || '').includes(qNorm);
            const totalMatch = String(t.total || '').includes(qNorm);
            const comentMatch = _normAccent(t.comentario).includes(qNorm);
            const regLeaderMatch = String(t.registro_id || '').includes(qNorm);
            const regClientMatch = String(t.cliente_registro || '').includes(qNorm);
            return idMatch || clienteMatch || fechaMatch || totalMatch || comentMatch || regLeaderMatch || regClientMatch;
        })
        : allNotas;

    if (notas.length === 0) {
        if (typeof BO_AUTH !== 'undefined' && BO_AUTH.showAlert) {
            BO_AUTH.showAlert('ℹ️ Ninguna nota coincide con el filtro de búsqueda actual.', 'warning');
        }
        return;
    }

    if (typeof BO_AUTH !== 'undefined' && BO_AUTH.showAlert) {
        BO_AUTH.showAlert(`⏳ Generando CSV con ${notas.length} notas pendientes...`, 'info');
    }

    const headers = [
        'Folio / ID Nota',
        'Fecha Venta',
        'Registro Cliente',
        'Nombre del Cliente',
        'ID Cliente (UUID)',
        'Registro Vendedor',
        'Vendedor / Registrado Por',
        'CEDIS ID',
        'Centro de Apoyo ID',
        'Moneda',
        'Total Venta (Bruto)',
        'Monto Facturable (Neto)',
        'Descuento / Activos',
        'Saldo Credito Pendiente',
        'Estatus Facturacion',
        'Cantidad Total Piezas',
        'Detalle Productos / Piezas',
        'Comentarios y Desglose Pago'
    ];

    const escapeCsv = (val) => {
        if (val === null || val === undefined) return '""';
        const str = String(val).replace(/"/g, '""');
        return `"${str}"`;
    };

    const rows = [headers.map(escapeCsv).join(',')];

    for (const t of notas) {
        // Desglose de piezas
        let totalPiezas = 0;
        let detallePiezas = [];
        try {
            let piezasArr = t.piezas;
            if (typeof piezasArr === 'string') piezasArr = JSON.parse(piezasArr || '[]');
            if (Array.isArray(piezasArr)) {
                for (const p of piezasArr) {
                    const cant = parseInt(p.cantidad) || 1;
                    totalPiezas += cant;
                    const nom = p.nombre || p.producto_nombre || p.sku || p.producto_id || 'Producto';
                    const pu = parseFloat(p.precio_unitario || p.precio) || null;
                    detallePiezas.push(`${cant}x ${nom}${pu ? ' ($' + pu.toFixed(2) + ')' : ''}`);
                }
            }
        } catch(_) {}

        // Desglose de activos
        let montoActivos = 0;
        if (t.comentario) {
            const aMatches = [...(t.comentario.matchAll(/ACTIVOS(?:_[A-Z_]+)?(?:\/[^\s$]+)?[^$]*\$([0-9.,]+)/gi))];
            if (aMatches.length > 0) {
                montoActivos = aMatches.reduce((s, m) => s + parseFloat(m[1].replace(/,/g, '')), 0);
            }
        }

        // Crédito
        let credAmt = t._creditoPendiente !== undefined ? t._creditoPendiente : null;
        if (credAmt === null && typeof _calcularCreditoVenta === 'function') {
            credAmt = _calcularCreditoVenta({ comentarioRaw: t.comentario || '', totalNum: Number(t.total || 0) });
        }
        credAmt = Number(credAmt || 0);

        const totalVenta = Number(t.total || 0);
        const montoFac = Number(t.monto_facturable || totalVenta);
        const estatus = credAmt > 0
            ? `Credito Pendiente ($${credAmt.toFixed(2)})`
            : 'Lista para Facturar';

        const row = [
            t.id || '',
            t.fecha_venta || '',
            t.cliente_registro || '',
            t.cliente_nombre || 'Publico General',
            t.cliente_id || '',
            t.registro_id || '',
            t.registrador_nombre || '',
            t.cedis_id || '',
            t.centro_apoyo_id || '',
            t.moneda || 'MXN',
            totalVenta.toFixed(2),
            montoFac.toFixed(2),
            montoActivos.toFixed(2),
            credAmt.toFixed(2),
            estatus,
            totalPiezas,
            detallePiezas.join(' | '),
            (t.comentario || '').replace(/\r?\n/g, ' ')
        ];

        rows.push(row.map(escapeCsv).join(','));
    }

    const csvString = '\uFEFF' + rows.join('\r\n');
    const startVal = document.getElementById('fg-date-start')?.value || 'inicio';
    const endVal = document.getElementById('fg-date-end')?.value || 'fin';
    const filename = `Notas_Pendientes_Facturar_${startVal}_a_${endVal}.csv`;

    const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);

    if (typeof BO_AUTH !== 'undefined' && BO_AUTH.showAlert) {
        BO_AUTH.showAlert(`✅ Reporte CSV exportado con éxito (${notas.length} notas).`, 'success');
    }
}
window.exportarCsvFacturaGlobal = exportarCsvFacturaGlobal;


